import './style.css';
import yr, { createContext as Xe, useContext as Ze, useRef as ne, useState as re, useMemo as W, useCallback as q, useEffect as Q, memo as xc, useId as fd, forwardRef as hd, useLayoutEffect as ta } from "react";
import N from "prop-types";
import us from "lodash.debounce";
import md from "bowser";
import { v4 as Wa } from "uuid";
import { GifReader as vd } from "omggif";
import St from "clsx";
import { connect as Rc, disconnect as Ic, getSocket as gd } from "@technomiam/wsapi-client";
import { Rnd as yd } from "react-rnd";
import { Button as bd } from "reactstrap";
import Ti from "hls.js";
import { useTranslation as ds } from "react-i18next";
const Pc = Xe(
  /** @type {IInputsContext | undefined} */
  void 0
), ha = () => {
  const o = Ze(Pc);
  if (!o)
    throw new Error("useInputs must be used within a Inputs");
  return o;
};
var Qi = { exports: {} }, Kn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Os;
function _d() {
  if (Os) return Kn;
  Os = 1;
  var o = yr, a = Symbol.for("react.element"), i = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, e = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, t = { key: !0, ref: !0, __self: !0, __source: !0 };
  function r(s, c, l) {
    var u, d = {}, f = null, p = null;
    l !== void 0 && (f = "" + l), c.key !== void 0 && (f = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (u in c) n.call(c, u) && !t.hasOwnProperty(u) && (d[u] = c[u]);
    if (s && s.defaultProps) for (u in c = s.defaultProps, c) d[u] === void 0 && (d[u] = c[u]);
    return { $$typeof: a, type: s, key: f, ref: p, props: d, _owner: e.current };
  }
  return Kn.Fragment = i, Kn.jsx = r, Kn.jsxs = r, Kn;
}
var Hn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ms;
function wd() {
  return Ms || (Ms = 1, process.env.NODE_ENV !== "production" && function() {
    var o = yr, a = Symbol.for("react.element"), i = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), t = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m = Symbol.iterator, b = "@@iterator";
    function h(L) {
      if (L === null || typeof L != "object")
        return null;
      var G = m && L[m] || L[b];
      return typeof G == "function" ? G : null;
    }
    var g = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function w(L) {
      {
        for (var G = arguments.length, X = new Array(G > 1 ? G - 1 : 0), J = 1; J < G; J++)
          X[J - 1] = arguments[J];
        _("error", L, X);
      }
    }
    function _(L, G, X) {
      {
        var J = g.ReactDebugCurrentFrame, fe = J.getStackAddendum();
        fe !== "" && (G += "%s", X = X.concat([fe]));
        var le = X.map(function(ie) {
          return String(ie);
        });
        le.unshift("Warning: " + G), Function.prototype.apply.call(console[L], console, le);
      }
    }
    var y = !1, C = !1, S = !1, P = !1, T = !1, I;
    I = Symbol.for("react.module.reference");
    function k(L) {
      return !!(typeof L == "string" || typeof L == "function" || L === n || L === t || T || L === e || L === l || L === u || P || L === p || y || C || S || typeof L == "object" && L !== null && (L.$$typeof === f || L.$$typeof === d || L.$$typeof === r || L.$$typeof === s || L.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      L.$$typeof === I || L.getModuleId !== void 0));
    }
    function x(L, G, X) {
      var J = L.displayName;
      if (J)
        return J;
      var fe = G.displayName || G.name || "";
      return fe !== "" ? X + "(" + fe + ")" : X;
    }
    function O(L) {
      return L.displayName || "Context";
    }
    function D(L) {
      if (L == null)
        return null;
      if (typeof L.tag == "number" && w("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof L == "function")
        return L.displayName || L.name || null;
      if (typeof L == "string")
        return L;
      switch (L) {
        case n:
          return "Fragment";
        case i:
          return "Portal";
        case t:
          return "Profiler";
        case e:
          return "StrictMode";
        case l:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case s:
            var G = L;
            return O(G) + ".Consumer";
          case r:
            var X = L;
            return O(X._context) + ".Provider";
          case c:
            return x(L, L.render, "ForwardRef");
          case d:
            var J = L.displayName || null;
            return J !== null ? J : D(L.type) || "Memo";
          case f: {
            var fe = L, le = fe._payload, ie = fe._init;
            try {
              return D(ie(le));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var A = Object.assign, E = 0, F, B, $, M, j, z, te;
    function ee() {
    }
    ee.__reactDisabledLog = !0;
    function Y() {
      {
        if (E === 0) {
          F = console.log, B = console.info, $ = console.warn, M = console.error, j = console.group, z = console.groupCollapsed, te = console.groupEnd;
          var L = {
            configurable: !0,
            enumerable: !0,
            value: ee,
            writable: !0
          };
          Object.defineProperties(console, {
            info: L,
            log: L,
            warn: L,
            error: L,
            group: L,
            groupCollapsed: L,
            groupEnd: L
          });
        }
        E++;
      }
    }
    function Z() {
      {
        if (E--, E === 0) {
          var L = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: A({}, L, {
              value: F
            }),
            info: A({}, L, {
              value: B
            }),
            warn: A({}, L, {
              value: $
            }),
            error: A({}, L, {
              value: M
            }),
            group: A({}, L, {
              value: j
            }),
            groupCollapsed: A({}, L, {
              value: z
            }),
            groupEnd: A({}, L, {
              value: te
            })
          });
        }
        E < 0 && w("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ae = g.ReactCurrentDispatcher, oe;
    function ce(L, G, X) {
      {
        if (oe === void 0)
          try {
            throw Error();
          } catch (fe) {
            var J = fe.stack.trim().match(/\n( *(at )?)/);
            oe = J && J[1] || "";
          }
        return `
` + oe + L;
      }
    }
    var ke = !1, Oe;
    {
      var nt = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new nt();
    }
    function et(L, G) {
      if (!L || ke)
        return "";
      {
        var X = Oe.get(L);
        if (X !== void 0)
          return X;
      }
      var J;
      ke = !0;
      var fe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var le;
      le = ae.current, ae.current = null, Y();
      try {
        if (G) {
          var ie = function() {
            throw Error();
          };
          if (Object.defineProperty(ie.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ie, []);
            } catch (Ht) {
              J = Ht;
            }
            Reflect.construct(L, [], ie);
          } else {
            try {
              ie.call();
            } catch (Ht) {
              J = Ht;
            }
            L.call(ie.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ht) {
            J = Ht;
          }
          L();
        }
      } catch (Ht) {
        if (Ht && J && typeof Ht.stack == "string") {
          for (var me = Ht.stack.split(`
`), ze = J.stack.split(`
`), De = me.length - 1, je = ze.length - 1; De >= 1 && je >= 0 && me[De] !== ze[je]; )
            je--;
          for (; De >= 1 && je >= 0; De--, je--)
            if (me[De] !== ze[je]) {
              if (De !== 1 || je !== 1)
                do
                  if (De--, je--, je < 0 || me[De] !== ze[je]) {
                    var lt = `
` + me[De].replace(" at new ", " at ");
                    return L.displayName && lt.includes("<anonymous>") && (lt = lt.replace("<anonymous>", L.displayName)), typeof L == "function" && Oe.set(L, lt), lt;
                  }
                while (De >= 1 && je >= 0);
              break;
            }
        }
      } finally {
        ke = !1, ae.current = le, Z(), Error.prepareStackTrace = fe;
      }
      var bt = L ? L.displayName || L.name : "", tn = bt ? ce(bt) : "";
      return typeof L == "function" && Oe.set(L, tn), tn;
    }
    function Fe(L, G, X) {
      return et(L, !1);
    }
    function $e(L) {
      var G = L.prototype;
      return !!(G && G.isReactComponent);
    }
    function at(L, G, X) {
      if (L == null)
        return "";
      if (typeof L == "function")
        return et(L, $e(L));
      if (typeof L == "string")
        return ce(L);
      switch (L) {
        case l:
          return ce("Suspense");
        case u:
          return ce("SuspenseList");
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case c:
            return Fe(L.render);
          case d:
            return at(L.type, G, X);
          case f: {
            var J = L, fe = J._payload, le = J._init;
            try {
              return at(le(fe), G, X);
            } catch {
            }
          }
        }
      return "";
    }
    var vt = Object.prototype.hasOwnProperty, gt = {}, it = g.ReactDebugCurrentFrame;
    function Ie(L) {
      if (L) {
        var G = L._owner, X = at(L.type, L._source, G ? G.type : null);
        it.setExtraStackFrame(X);
      } else
        it.setExtraStackFrame(null);
    }
    function ut(L, G, X, J, fe) {
      {
        var le = Function.call.bind(vt);
        for (var ie in L)
          if (le(L, ie)) {
            var me = void 0;
            try {
              if (typeof L[ie] != "function") {
                var ze = Error((J || "React class") + ": " + X + " type `" + ie + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof L[ie] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ze.name = "Invariant Violation", ze;
              }
              me = L[ie](G, ie, J, X, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (De) {
              me = De;
            }
            me && !(me instanceof Error) && (Ie(fe), w("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", J || "React class", X, ie, typeof me), Ie(null)), me instanceof Error && !(me.message in gt) && (gt[me.message] = !0, Ie(fe), w("Failed %s type: %s", X, me.message), Ie(null));
          }
      }
    }
    var qe = Array.isArray;
    function H(L) {
      return qe(L);
    }
    function ue(L) {
      {
        var G = typeof Symbol == "function" && Symbol.toStringTag, X = G && L[Symbol.toStringTag] || L.constructor.name || "Object";
        return X;
      }
    }
    function Ve(L) {
      try {
        return Tt(L), !1;
      } catch {
        return !0;
      }
    }
    function Tt(L) {
      return "" + L;
    }
    function It(L) {
      if (Ve(L))
        return w("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ue(L)), Tt(L);
    }
    var Ct = g.ReactCurrentOwner, br = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, dt, kt, zt;
    zt = {};
    function _r(L) {
      if (vt.call(L, "ref")) {
        var G = Object.getOwnPropertyDescriptor(L, "ref").get;
        if (G && G.isReactWarning)
          return !1;
      }
      return L.ref !== void 0;
    }
    function wr(L) {
      if (vt.call(L, "key")) {
        var G = Object.getOwnPropertyDescriptor(L, "key").get;
        if (G && G.isReactWarning)
          return !1;
      }
      return L.key !== void 0;
    }
    function Gt(L, G) {
      if (typeof L.ref == "string" && Ct.current && G && Ct.current.stateNode !== G) {
        var X = D(Ct.current.type);
        zt[X] || (w('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(Ct.current.type), L.ref), zt[X] = !0);
      }
    }
    function Sr(L, G) {
      {
        var X = function() {
          dt || (dt = !0, w("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
        };
        X.isReactWarning = !0, Object.defineProperty(L, "key", {
          get: X,
          configurable: !0
        });
      }
    }
    function Dt(L, G) {
      {
        var X = function() {
          kt || (kt = !0, w("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
        };
        X.isReactWarning = !0, Object.defineProperty(L, "ref", {
          get: X,
          configurable: !0
        });
      }
    }
    var jr = function(L, G, X, J, fe, le, ie) {
      var me = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: a,
        // Built-in properties that belong on the element
        type: L,
        key: G,
        ref: X,
        props: ie,
        // Record the component responsible for creating this element.
        _owner: le
      };
      return me._store = {}, Object.defineProperty(me._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(me, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: J
      }), Object.defineProperty(me, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: fe
      }), Object.freeze && (Object.freeze(me.props), Object.freeze(me)), me;
    };
    function jt(L, G, X, J, fe) {
      {
        var le, ie = {}, me = null, ze = null;
        X !== void 0 && (It(X), me = "" + X), wr(G) && (It(G.key), me = "" + G.key), _r(G) && (ze = G.ref, Gt(G, fe));
        for (le in G)
          vt.call(G, le) && !br.hasOwnProperty(le) && (ie[le] = G[le]);
        if (L && L.defaultProps) {
          var De = L.defaultProps;
          for (le in De)
            ie[le] === void 0 && (ie[le] = De[le]);
        }
        if (me || ze) {
          var je = typeof L == "function" ? L.displayName || L.name || "Unknown" : L;
          me && Sr(ie, je), ze && Dt(ie, je);
        }
        return jr(L, me, ze, fe, J, Ct.current, ie);
      }
    }
    var Nt = g.ReactCurrentOwner, qt = g.ReactDebugCurrentFrame;
    function Et(L) {
      if (L) {
        var G = L._owner, X = at(L.type, L._source, G ? G.type : null);
        qt.setExtraStackFrame(X);
      } else
        qt.setExtraStackFrame(null);
    }
    var pr;
    pr = !1;
    function At(L) {
      return typeof L == "object" && L !== null && L.$$typeof === a;
    }
    function Nr() {
      {
        if (Nt.current) {
          var L = D(Nt.current.type);
          if (L)
            return `

Check the render method of \`` + L + "`.";
        }
        return "";
      }
    }
    function Fr(L) {
      return "";
    }
    var Cr = {};
    function fr(L) {
      {
        var G = Nr();
        if (!G) {
          var X = typeof L == "string" ? L : L.displayName || L.name;
          X && (G = `

Check the top-level render call using <` + X + ">.");
        }
        return G;
      }
    }
    function $r(L, G) {
      {
        if (!L._store || L._store.validated || L.key != null)
          return;
        L._store.validated = !0;
        var X = fr(G);
        if (Cr[X])
          return;
        Cr[X] = !0;
        var J = "";
        L && L._owner && L._owner !== Nt.current && (J = " It was passed a child from " + D(L._owner.type) + "."), Et(L), w('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', X, J), Et(null);
      }
    }
    function kr(L, G) {
      {
        if (typeof L != "object")
          return;
        if (H(L))
          for (var X = 0; X < L.length; X++) {
            var J = L[X];
            At(J) && $r(J, G);
          }
        else if (At(L))
          L._store && (L._store.validated = !0);
        else if (L) {
          var fe = h(L);
          if (typeof fe == "function" && fe !== L.entries)
            for (var le = fe.call(L), ie; !(ie = le.next()).done; )
              At(ie.value) && $r(ie.value, G);
        }
      }
    }
    function Br(L) {
      {
        var G = L.type;
        if (G == null || typeof G == "string")
          return;
        var X;
        if (typeof G == "function")
          X = G.propTypes;
        else if (typeof G == "object" && (G.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        G.$$typeof === d))
          X = G.propTypes;
        else
          return;
        if (X) {
          var J = D(G);
          ut(X, L.props, "prop", J, L);
        } else if (G.PropTypes !== void 0 && !pr) {
          pr = !0;
          var fe = D(G);
          w("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", fe || "Unknown");
        }
        typeof G.getDefaultProps == "function" && !G.getDefaultProps.isReactClassApproved && w("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function he(L) {
      {
        for (var G = Object.keys(L.props), X = 0; X < G.length; X++) {
          var J = G[X];
          if (J !== "children" && J !== "key") {
            Et(L), w("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", J), Et(null);
            break;
          }
        }
        L.ref !== null && (Et(L), w("Invalid attribute `ref` supplied to `React.Fragment`."), Et(null));
      }
    }
    function Ue(L, G, X, J, fe, le) {
      {
        var ie = k(L);
        if (!ie) {
          var me = "";
          (L === void 0 || typeof L == "object" && L !== null && Object.keys(L).length === 0) && (me += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ze = Fr();
          ze ? me += ze : me += Nr();
          var De;
          L === null ? De = "null" : H(L) ? De = "array" : L !== void 0 && L.$$typeof === a ? (De = "<" + (D(L.type) || "Unknown") + " />", me = " Did you accidentally export a JSX literal instead of a component?") : De = typeof L, w("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", De, me);
        }
        var je = jt(L, G, X, fe, le);
        if (je == null)
          return je;
        if (ie) {
          var lt = G.children;
          if (lt !== void 0)
            if (J)
              if (H(lt)) {
                for (var bt = 0; bt < lt.length; bt++)
                  kr(lt[bt], L);
                Object.freeze && Object.freeze(lt);
              } else
                w("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kr(lt, L);
        }
        return L === n ? he(je) : Br(je), je;
      }
    }
    function Kt(L, G, X) {
      return Ue(L, G, X, !0);
    }
    function ve(L, G, X) {
      return Ue(L, G, X, !1);
    }
    var se = ve, de = Kt;
    Hn.Fragment = n, Hn.jsx = se, Hn.jsxs = de;
  }()), Hn;
}
process.env.NODE_ENV === "production" ? Qi.exports = _d() : Qi.exports = wd();
var V = Qi.exports;
const _i = md.getParser(window.navigator.userAgent), Sd = _i.is("desktop");
_i.getOSName();
const Pt = !Sd;
_i.is("safari");
const Cd = Pt && _i.getOSName() === "iOS", kd = /Macintosh/i.test(window.navigator.userAgent) && window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 1, Xa = Pt || kd;
async function wi(o) {
  return typeof navigator == "object" && typeof navigator.mediaDevices == "object" && typeof navigator.mediaDevices.getUserMedia == "function" ? (o = o || { audio: !0, video: !0 }, navigator.mediaDevices.getUserMedia(o)) : Promise.reject(new Error("getUserMedia is not supported"));
}
const Tc = () => {
  const { rollbar: o } = (
    /** @type {GlobalWithRollbar} */
    window
  );
  return o;
}, Dc = "beeyou_virtualDevices", Ec = 1, xd = () => {
  const o = localStorage.getItem(Dc);
  if (o)
    try {
      const a = JSON.parse(o);
      return a.__version !== Ec ? void 0 : a.virtualDevices;
    } catch (a) {
      console.error("Error parsing local storage value", a);
      return;
    }
}, Si = (o) => {
  localStorage.setItem(Dc, JSON.stringify({ virtualDevices: o, __version: Ec }));
}, Rd = () => [{ isDefault: !0, kind: (
  /** @type {MediaDeviceKind}*/
  "videoinput"
), label: "Default Camera", physicalDeviceId: void 0, virtualDeviceId: Wa() }, { isDefault: !0, kind: (
  /** @type {MediaDeviceKind}*/
  "audioinput"
), label: "Default Microphone", physicalDeviceId: void 0, virtualDeviceId: Wa() }], Id = () => {
  let o = xd();
  return o || (o = Rd(), Si(o)), o;
};
let Lt = Id();
const ls = (o, a) => o.label === a.label && o.kind === a.kind, Pd = (o) => {
  if (!o.deviceId)
    throw new Error("Cannot create virtual device without physical device ID");
  const a = { kind: o.kind, isBack: o.isBack, isDefault: o.isDefault, isFront: o.isFront, label: o.label, physicalDeviceId: o.deviceId || void 0, virtualDeviceId: Wa() };
  return Lt = [...Lt, a], Si(Lt), a;
}, Td = (o, a) => (o = {
  ...o,
  isBack: a.isBack,
  // Don't update isDefault because in case the isDefault
  // value is false (when the permission are not granted)
  // then it will override the isDefault value of the default virtual devices.
  // See comment in updateDefaultVirtualDevice function.
  // isDefault: physicalDevice.isDefault,
  isFront: a.isFront,
  label: a.label,
  physicalDeviceId: a.deviceId || void 0
}, Lt = Lt.map((i) => ls(i, o) ? o : i), Si(Lt), o), Dd = (o) => {
  let a = Lt.find((i) => ls(i, o));
  return a ? a = Td(a, o) : a = Pd(o), a;
}, Ed = (o) => {
  if (!o.isDefault)
    throw new Error("Cannot update default virtual device with non-default physical device");
  let a = Lt.find((i) => i.isDefault && o.kind === i.kind);
  if (!a)
    throw new Error(`Cannot find default virtual device of kind ${o.kind}`);
  return a = { ...a, isBack: o.isBack, isFront: o.isFront, label: o.label, physicalDeviceId: o.deviceId || void 0 }, Lt = Lt.map((i) => i.isDefault === a.isDefault && i.kind === a.kind ? a : i).filter((i) => !(ls(i, a) && !i.isDefault)), Si(Lt), a;
}, Ad = (o) => (o.forEach((a) => {
  a.isDefault ? Ed(a) : Dd(a);
}), Lt), Zg = (o) => Lt.find((a) => a.virtualDeviceId === o), Ac = (o) => Lt.find((a) => a.isDefault && a.kind === o), js = Tc(), Lc = "beeyou_inputDevices", ps = 0, Ld = `Source ${ps + 1}`, Oc = 12, Od = () => {
  const o = localStorage.getItem(Lc);
  if (o) {
    const a = JSON.parse(o);
    return a.__version !== Oc ? void 0 : Cd ? a.inputsConfig.filter((i) => i.id === ps) : a.inputsConfig;
  }
}, Md = (o) => localStorage.setItem(Lc, JSON.stringify({ inputsConfig: o, __version: Oc })), Wt = { FRONT: "user", BACK: "environment" }, Di = Ac("audioinput"), Ei = Ac("videoinput"), jd = { label: Ld, id: ps, audioInputOff: !1, videoInputOff: !1, audioInputId: Di == null ? void 0 : Di.virtualDeviceId, videoInputId: Ei == null ? void 0 : Ei.virtualDeviceId }, Nd = async (o) => {
  let a, i, n;
  try {
    a = await wi(o), a.getTracks().forEach((e) => {
      e.kind === "audio" ? i = e.getSettings().deviceId : e.kind === "video" && (n = e.getSettings().deviceId), e.stop();
    });
  } catch (e) {
    throw console.warn(e), e;
  } finally {
    a && a.getTracks().forEach((e) => e.stop());
  }
  return { audioDeviceId: i, videoDeviceId: n };
}, Ns = async (o) => {
  var e;
  const a = { video: { facingMode: o } };
  let i, n;
  try {
    i = await wi(a), n = (e = i == null ? void 0 : i.getVideoTracks()[0]) == null ? void 0 : e.getSettings().deviceId;
  } catch (t) {
    console.warn(t);
  } finally {
    i && i.getTracks().forEach((t) => t.stop());
  }
  return n;
}, Fd = async () => {
  const o = await Ns(Wt.FRONT), a = await Ns(Wt.BACK);
  return { frontDeviceId: o, backDeviceId: a };
}, $d = ({ children: o }) => {
  const a = ne(!1), [i, n] = re(!1), [e, t] = re(
    /** @type {InputPermissions} */
    { audioinput: void 0, videoinput: void 0 }
  ), [r, s] = re(
    /** @type {VirtualDevice[]} */
    []
  ), c = W(() => r.filter((A) => A.kind === "audioinput"), [r]), l = W(() => r.filter((A) => A.kind === "videoinput"), [r]), u = l.find(({ isFront: A }) => A), d = l.find(({ isBack: A }) => A), [f, p] = re(Wt.FRONT), [m, b] = re(() => {
    const A = Od();
    return A || [jd];
  }), h = W(() => {
    const A = m[0], E = [];
    if (!A)
      return E;
    if (A.audioInputId && !A.audioInputOff) {
      const F = c.find((B) => B.virtualDeviceId === A.audioInputId);
      F && E.push(F);
    }
    if (A.videoInputId && !A.videoInputOff) {
      const F = l.find((B) => B.virtualDeviceId === A.videoInputId);
      F && E.push(F);
    }
    return E.filter(Boolean);
  }, [c, m, l]), g = W(() => {
    const A = (E) => {
      b((F) => F.map((B) => B.id !== E.id ? B : { ...B, ...E }));
    };
    return { setPartialInputsConfig: A, addNewConfig: ({ label: E, id: F }) => {
      const B = [...c].filter((j) => !h.find((z) => z.virtualDeviceId === j.virtualDeviceId)).find(({ virtualDeviceId: j }) => !m.find((z) => z.audioInputId === j)), $ = [...l].filter((j) => !h.find((z) => z.virtualDeviceId === j.virtualDeviceId)).find(({ virtualDeviceId: j }) => !m.find((z) => z.videoInputId === j)), M = { label: E, id: F, audioInputOff: !1, videoInputOff: !1, audioInputId: (B == null ? void 0 : B.virtualDeviceId) ?? void 0, videoInputId: ($ == null ? void 0 : $.virtualDeviceId) ?? void 0 };
      b((j) => [...j, { ...M }]);
    }, activateAudioInput: (E) => {
      A({ id: E, audioInputOff: !1 });
    }, activateVideoInput: (E) => {
      A({ id: E, videoInputOff: !1 });
    }, deactivateAudioInput: (E) => {
      A({ id: E, audioInputOff: !0 });
    }, deactivateVideoInput: (E) => {
      A({ id: E, videoInputOff: !0 });
    }, deleteConfig: (E) => {
      b((F) => F.filter((B) => B.id !== E));
    }, changeAudioInputDevice: (E, F) => {
      A({ id: E, audioInputId: F });
    }, changeVideoInputDevice: (E, F) => {
      A({ id: E, videoInputId: F });
    }, changeConfigName: (E, F) => {
      A({ id: E, label: F });
    } };
  }, [c, h, m, l]), w = q(async () => {
    if (!Xa) {
      console.error("swapFrontAndBackCamera() is only available on mobile");
      return;
    }
    f === Wt.FRONT && d ? (g.changeVideoInputDevice(0, d.virtualDeviceId), p(Wt.BACK)) : u && (g.changeVideoInputDevice(0, u.virtualDeviceId), p(Wt.FRONT));
  }, [g, d, u, f]), _ = q((A) => {
    if (A !== Wt.BACK && A !== Wt.FRONT) {
      console.error('setTargetCamera() only accepts "back" or "front" as parameter');
      return;
    }
    A === Wt.BACK && d ? (g.changeVideoInputDevice(0, d.virtualDeviceId), p(Wt.BACK)) : u && (g.changeVideoInputDevice(0, u.virtualDeviceId), p(Wt.FRONT));
  }, [d, u, g]), [y, C] = re(0), S = ne(e);
  S.current = e;
  const P = q(async () => {
    let A = [], E, F;
    try {
      const M = S.current.audioinput === "granted", j = S.current.videoinput === "granted";
      if (!M && !j)
        throw new Error("No permissions");
      if (E = await Nd({ audio: M, video: j }), a.current || j && Xa && (F = await Fd(), a.current))
        return;
    } catch (M) {
      if (console.error(M), a.current) return;
    }
    try {
      if (A = await navigator.mediaDevices.enumerateDevices(), a.current) return;
    } catch (M) {
      if (console.error(M), a.current) return;
    }
    const B = (M) => {
      const j = (M.label || "").toUpperCase();
      return !!(j.includes("OBS ") || j.includes("VIRTUAL"));
    }, $ = A.filter((M) => !!M.deviceId && ["audioinput", "videoinput"].includes(M.kind)).sort((M, j) => {
      if (M.kind !== j.kind)
        return 0;
      let z = 0, te = 0;
      const ee = te - z;
      return ee !== 0 ? ee : (z = B(M) ? 0 : 1, te = B(j) ? 0 : 1, te - z);
    }).map((M) => {
      const j = M.deviceId === (E == null ? void 0 : E.audioDeviceId) || M.deviceId === (E == null ? void 0 : E.videoDeviceId), z = M.deviceId === (F == null ? void 0 : F.frontDeviceId), te = M.deviceId === (F == null ? void 0 : F.backDeviceId);
      return { deviceId: M.deviceId, groupId: M.groupId, isBack: te, isDefault: j, isFront: z, kind: M.kind, label: M.label || M.deviceId };
    });
    console.log({ uniqueDevicesInfo: $ }), s(Ad($));
  }, []), T = ne(
    /** @type {(() => Promise<void>) | undefined} */
    void 0
  ), I = ne(!1), k = ne(P);
  k.current = P;
  const x = q(() => {
    T.current = async () => {
      if (T.current = void 0, a.current)
        return;
      I.current = !0;
      try {
        C((E) => E + 1), await k.current();
      } catch (E) {
        console.error(E);
      }
      if (I.current = !1, a.current)
        return;
      const A = (
        /** @type {(() => Promise<void>) | undefined} */
        T.current
      );
      A && A(), C((E) => E - 1);
    }, I.current || T.current();
  }, []), O = q(async (A) => {
    const E = { audio: !1, video: !1 };
    if (A.audioinput && (E.audio = !0), A.videoinput && (E.video = !0), !E.audio && !E.video) return;
    let F;
    try {
      if (t((B) => ({ ...B, audioinput: E.audio ? "prompt" : B.audioinput, videoinput: E.video ? "prompt" : B.videoinput })), F = await wi(E), F.getTracks().forEach((B) => B.stop()), a.current) return;
      t((B) => ({ ...B, audioinput: E.audio ? "granted" : B.audioinput, videoinput: E.video ? "granted" : B.videoinput }));
    } catch (B) {
      if (console.error(B), js && js.error(B, { constraints: E }), a.current) return;
      throw t(($) => ({ ...$, audioinput: E.audio ? "denied" : $.audioinput, videoinput: E.video ? "denied" : $.videoinput })), B;
    } finally {
      F && F.getTracks().forEach((B) => B.stop());
    }
  }, []);
  Q(() => {
    const A = () => {
      x();
    }, E = {}, F = us(() => {
      const z = { ...E };
      t((te) => ({ ...te, ...z })), delete E.audioinput, delete E.videoinput;
    }, 100);
    function B() {
      const { state: z } = this;
      E.videoinput = z, F();
    }
    function $() {
      const { state: z } = this;
      E.audioinput = z, F();
    }
    let M, j;
    return i && (navigator.mediaDevices && navigator.mediaDevices.addEventListener && navigator.mediaDevices.addEventListener("devicechange", A), navigator.permissions ? Promise.allSettled([navigator.permissions.query({ name: (
      /** @type {PermissionName} */
      "camera"
    ) }).then((z) => {
      M = z, z.onchange = B;
    }), navigator.permissions.query({ name: (
      /** @type {PermissionName} */
      "microphone"
    ) }).then((z) => {
      j = z, z.onchange = $;
    })]).then(() => {
      t((z) => ({ ...z, audioinput: (j == null ? void 0 : j.state) || z.audioinput, videoinput: (M == null ? void 0 : M.state) || z.videoinput })), O({ audioinput: (j == null ? void 0 : j.state) !== "granted", videoinput: (M == null ? void 0 : M.state) !== "granted" }).catch(() => {
      });
    }) : O({ audioinput: !0, videoinput: !0 }).catch(() => {
    })), () => {
      navigator.mediaDevices && navigator.mediaDevices.removeEventListener && navigator.mediaDevices.removeEventListener("devicechange", A), M && (M.onchange = null), j && (j.onchange = null);
    };
  }, [i, O, x]), Q(() => {
    (e.audioinput || e.videoinput) && x();
  }, [e, x]), Q(() => {
    Md(m);
  }, [m]), Q(() => () => {
    a.current = !1;
  }, []), console.log({ inputDevices: r, inputsConfig: m });
  const D = W(() => ({ ...g, audioInputDevices: c, currentlyEnabledDefaultDevices: h, defaultFaceingMode: f, isDeviceUpdating: y > 0, inputsConfig: m, inputDevices: r, inputPermissions: e, requestInputPermissions: O, setDefaultFaceingMode: p, setEnabled: n, setInputDevices: s, setInputsConfig: b, setTargetCamera: _, swapFrontAndBackCamera: w, videoInputDevices: l }), [c, h, f, g, y, m, r, e, O, p, _, w, l]);
  return /* @__PURE__ */ V.jsx(Pc.Provider, { value: D, children: o });
};
$d.propTypes = { children: N.node.isRequired };
const cr = (o) => {
  o.stop(), o.dispatchEvent(new Event("ended"));
}, ma = { P1080: 1080, P720: 720, P480: 480 }, Mc = 24, Bd = {
  // autoGainControl: false,
  // channelCount: 2,
  // echoCancellation: false,
  // latency: 0,
  // noiseSuppression: false,
  // sampleRate: 48000,
  // sampleSize: 16,
  // volume: 1.0,
}, Qr = { SCREEN: "screen", VIDEO: "video", IMAGE: "image" }, Ot = (
  /** @type {const} */
  { CONFIG: "config", AUDIOSHARE: "audio", IMAGESHARE: "image", VIDEOSHARE: "video", SCREENSHARE: "screen", LIVE: "live" }
), jc = Xe(
  /** @type {ISourceParticipantOffersContext | undefined} */
  void 0
), en = () => {
  const o = Ze(jc);
  if (!o)
    throw new Error("useSourceParticipantOffers must be used within a SourceParticipantOffers");
  return o;
}, Vd = (o) => (
  /** @type {(source: SourceParticipantOffer) => source is SourceParticipantOffer<T>}*/
  (a) => a.subType === o
), Ud = (o) => {
  const { sources: a } = en();
  return W(() => a.filter(
    /** @type {(source: SourceParticipantOffer) => source is SourceParticipantOffer<T>} */
    (i) => i.subType === o
  ), [o, a]);
}, Nc = ({ createControllableTrack: o, onStopControllable: a }) => {
  const [i, n] = re(
    /** @type {MediaTracksInternalManagerTracksMap<T, U>} */
    {}
  ), e = W(() => Object.values(i).map((u) => u.controllable || u.original), [i]), t = W(() => Object.values(i).map((u) => u.original), [i]), r = q(
    /** @type {MediaTracksInternalManagerHook<T, U>['addTracks']} */
    (u, d) => {
      n((f) => {
        let p = !1;
        return u.forEach((m) => {
          var b, h;
          f[m.id] || (p = !0, f[m.id] = { original: m, controllable: o ? o(m) : void 0, options: { original: { ...d == null ? void 0 : d.original, stopOnRemove: ((b = d == null ? void 0 : d.original) == null ? void 0 : b.stopOnRemove) ?? !0 }, controllable: { ...d == null ? void 0 : d.controllable, stopOnRemove: ((h = d == null ? void 0 : d.controllable) == null ? void 0 : h.stopOnRemove) ?? !0 } } });
        }), p ? { ...f } : f;
      });
    },
    [o]
  ), s = q(
    /** @type {MediaTracksInternalManagerHook<T, U>['removeTrack']} */
    (u) => {
      n((d) => {
        var p, m;
        const f = "originalTrackId" in u ? d[u.originalTrackId] : d[u.id];
        return f ? ((p = f.options.original) != null && p.stopOnRemove && f.original.stop(), (m = f.options.controllable) != null && m.stopOnRemove && f.controllable && a(f.controllable), "originalTrackId" in u ? delete d[u.originalTrackId] : delete d[u.id], { ...d }) : d;
      });
    },
    [a]
  ), c = ne(i);
  Q(() => {
    c.current = i;
  }, [i]);
  const l = q(
    /** @type {MediaTracksInternalManagerHook<T, U>['clearTracks']} */
    () => {
      Object.values(c.current).forEach((u) => {
        var d, f;
        (d = u.options.original) != null && d.stopOnRemove && u.original.stop(), (f = u.options.controllable) != null && f.stopOnRemove && u.controllable && a(u.controllable);
      }), n({});
    },
    [a]
  );
  return Q(() => () => l(), [l]), W(() => ({ addTracks: r, clearTracks: l, originalTracks: t, removeTrack: s, setTracksMap: n, tracks: e }), [r, l, t, s, e]);
}, zd = ({ offscreen: o = !1, width: a = 0, height: i = 0 }) => {
  if (o && window.OffscreenCanvas) return new window.OffscreenCanvas(a, i);
  const n = document.createElement("canvas");
  return n.width = a, n.height = i, n;
}, ra = ({ offscreen: o, width: a, height: i, contextOptions: n }) => {
  const e = zd({ offscreen: o, width: a, height: i }), t = (
    /** @type {CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D} */
    e.getContext("2d", n)
  );
  return { canvas: e, context: t };
}, Gd = (o, a) => window.OffscreenCanvas && o instanceof window.OffscreenCanvas ? o.convertToBlob(a) : new Promise((i) => {
  o.toBlob((n) => i(n), a == null ? void 0 : a.type, a == null ? void 0 : a.quality);
}), qd = (o, a, i) => {
  const n = { x: a / 2, y: i / 2 }, e = a / o, t = i / o, r = (a - e) * (n.x / a), s = (i - t) * (n.y / i), c = { x: r, y: s }, l = { x: r + e, y: s }, u = { x: r, y: s + t };
  return { x: c.x, y: c.y, width: l.x - c.x, height: u.y - c.y };
}, Ai = (o) => (
  /** @type {ExtendedMediaTrackCapabilities} */
  o.getCapabilities().zoom
), Li = (o, a) => {
  o.applyConstraints({ advanced: [
    /** @type {ExtendedMediaTrackConstraintSet} */
    { zoom: a }
  ] });
}, Fc = Xe(
  /** @type {IMediaZoomContext}*/
  {}
), Kd = () => Ze(Fc), Fs = 4, $s = 1, Bs = (o) => Math.max(o || Fs, Fs), Vs = (o) => Math.min(o || $s, $s), Hd = ({ children: o }) => {
  const [a, i] = re(
    /** @type {IMediaZoomContext['personalZoom']} */
    void 0
  ), n = q(() => {
    i((s) => {
      if (s) {
        const c = Ai(s.videoTrack);
        c && c.max && Li(s.videoTrack, 1);
      }
    });
  }, []), e = q(
    /** @type {IMediaZoomContext['getZoomBounds']} */
    (s) => {
      const c = Ai(s);
      return { maxZoom: Bs(c == null ? void 0 : c.max), minZoom: Vs(c == null ? void 0 : c.min) };
    },
    []
  ), t = q(
    /** @type {IMediaZoomContext['updatePersonalZoom']} */
    (s) => {
      if (!s.zoomFactor) {
        n();
        return;
      }
      const c = Ai(s.videoTrack), { width: l, height: u } = s.videoTrack.getSettings();
      if (!l || !u) {
        console.warn("Unable to get video track settings"), n();
        return;
      }
      let d = 0, f = 0, p = 0, m = 0;
      const b = Bs(c == null ? void 0 : c.max), h = Vs(c == null ? void 0 : c.min), g = Math.max(Math.min(s.zoomFactor, b), h);
      if (c && c.max) {
        const _ = g - h, y = c.max - h;
        c.step ? (f = _ % c.step, m = _ - f) : m = _, m > y && (f += m - y, m = y), d = 1 + f, p = h + m;
      } else
        d = g;
      c && c.max && (p !== 0 ? Li(s.videoTrack, p) : Li(s.videoTrack, 1));
      let w;
      d !== 0 && (w = qd(d, l, u)), i({ zoomFactor: { canvas: d !== 0 ? d : void 0, native: p !== 0 ? p : void 0, original: g }, canvasZoomCoordinates: w, sourceOfferId: s.videoTrack.sourceOffer.id, videoTrack: s.videoTrack });
    },
    [n]
  ), r = W(() => ({ getZoomBounds: e, personalZoom: a, resetPersonalZoom: n, updatePersonalZoom: t }), [e, a, n, t]);
  return /* @__PURE__ */ V.jsx(Fc.Provider, { value: r, children: o });
}, Yd = ({ availableSourceOfferIds: o }) => {
  const { personalZoom: a } = Kd(), i = W(() => !a || !a.zoomFactor.canvas || !a.canvasZoomCoordinates ? [] : o.filter((e) => e === a.sourceOfferId), [a, o]), n = q(
    /** @type {MediaVideoTrackPerformerHook<T>['performer']} */
    async (e, t) => {
      !a || !a.canvasZoomCoordinates || (t.context.clearRect(0, 0, t.canvas.width, t.canvas.height), t.context.drawImage(e, a.canvasZoomCoordinates.x, a.canvasZoomCoordinates.y, a.canvasZoomCoordinates.width, a.canvasZoomCoordinates.height, 0, 0, t.canvas.width, t.canvas.height));
    },
    [a]
  );
  return W(() => ({ enabledSourceOfferIds: i, performer: n }), [i, n]);
};
var Wd = { VITE_BUILD_ID: "", VITE_GA_TRACKING_ID: "", VITE_MUX_THUMBNAIL: "", VITE_ROLLBAR_ACCESS_TOKEN: "", VITE_VERSION: "", VITE_VIDEO_WIDTH: "", VITE_VIDEO_HEIGHT: "", VITE_CONTENT_ENDPOINT: "", VITE_WSAPI_VIDEO_URL: "", VITE_API_URL: "", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const { VITE_CONTENT_ENDPOINT: Xd, VITE_MUX_THUMBNAIL: Qg } = Wd, Zd = Xd, Us = (o) => `${Zd}${o.name}`, Qd = (o) => {
  const a = new URL(o);
  return a.searchParams.set("crossorigin", "anonymous"), a.href;
}, Jd = (o) => {
  const a = ne(
    /** @type {{ value: C } | undefined}*/
    void 0
  );
  return typeof a.current > "u" && (a.current = { value: typeof o == "function" ? (
    /** @type {() => C} */
    o()
  ) : o }), a.current.value;
};
function Oi(o) {
  const a = ne(
    /** @type {P} */
    void 0
  );
  return Q(() => {
    a.current = o;
  }, [o]), a.current;
}
const $t = { AI: "AI", DISABLED: "DISABLED", RGB: "RGB" }, Lr = { BLUR: "BLUR", COLOR: "COLOR", IMAGE: "IMAGE", TRANSPARENT: "TRANSPARENT" }, el = { r: 18, g: 32, b: 44 }, tl = 100, Mi = { detection: { color: { r: 0, g: 255, b: 0 }, mode: $t.DISABLED, sensitivity: 80 }, replacement: { blur: 5, color: { r: 255, g: 255, b: 255 }, edgeBlur: 5, mode: Lr.BLUR, transparentColor: el, transparentColorSensitivity: tl } }, rl = { ...Mi, detection: { ...Mi.detection, mode: $t.AI }, replacement: { ...Mi.replacement, mode: Lr.TRANSPARENT } }, $c = Xe(
  /** @type {IMediaKeyContext} */
  {}
), Nn = () => Ze($c), Bc = "beeyou_localKeyConfig", nl = () => {
  const o = localStorage.getItem(Bc);
  return o ? JSON.parse(o) : void 0;
}, al = (o) => localStorage.setItem(Bc, JSON.stringify(o)), il = ({ children: o, isHost: a = !1 }) => {
  const [i, n] = re(() => nl()), [e, t] = re(), [r, s] = re(
    /** @type {string | undefined} */
    void 0
  ), c = W(() => {
    var w, _;
    const g = a ? (w = e == null ? void 0 : e.own) == null ? void 0 : w.replacement : (_ = e == null ? void 0 : e.all) == null ? void 0 : _.replacement;
    if (g)
      return { ...rl, replacement: g };
  }, [a, e]), l = !!c, u = l && a, d = W(() => {
    if (!u)
      return i;
  }, [u, i]), f = !!(d != null && d.detection.mode) && d.detection.mode !== $t.DISABLED || !!(c != null && c.detection.mode) && c.detection.mode !== $t.DISABLED, p = q(
    /** @type {IMediaKeyContext['handleCMSEvents']}*/
    (g) => {
      const { key: w } = g;
      t(w);
    },
    []
  ), m = q(
    /** @type {IMediaKeyContext['setLocalConfig']} */
    (g) => {
      al(g), n(g);
    },
    []
  ), b = W(() => !f || !r ? [] : [r], [f, r]), h = W(() => ({ config: d, configOverride: c, enabledSourceOfferIds: b, handleCMSEvents: p, isHost: a, isKeyEnabled: f, isKeyForced: u, isReplacementConfigOverriden: l, localConfig: i, setLocalConfig: m, setMainCamTrackSourceOfferId: s, setTempLocalConfig: n }), [d, c, b, p, a, f, u, l, i, m]);
  return /* @__PURE__ */ V.jsx($c.Provider, { value: h, children: o });
}, sl = async () => {
  const [o] = await Promise.all([import("@tensorflow-models/body-pix"), import("@tensorflow/tfjs-core"), import("@tensorflow/tfjs-converter"), import("@tensorflow/tfjs-backend-webgl")]);
  return o;
}, rn = (o, a) => Jd(() => ra({ offscreen: o, contextOptions: a })), ol = ({ r: o, g: a, b: i }, n) => {
  const { color: e, sensitivity: t } = n;
  return e ? o <= e.r + t && o >= e.r - t && a <= e.g + t && a >= e.g - t && i <= e.b + t && i >= e.b - t : !0;
}, cl = (o, a) => {
  if (!o) {
    a.context.clearRect(0, 0, a.canvas.width, a.canvas.height);
    return;
  }
  !o.isReady && o.complete && (a.canvas.width = o.width, a.canvas.height = o.height, a.context.clearRect(0, 0, a.canvas.width, a.canvas.height), a.context.drawImage(o, 0, 0, a.canvas.width, a.canvas.height), o.isReady = !0);
}, Vc = (o, a, i, { background: n, img: e, output: t, person: r, segmentationMask: s }) => {
  s.canvas.width = a.width, s.canvas.height = a.height, s.context.clearRect(0, 0, s.canvas.width, s.canvas.height), s.context.putImageData(a, 0, 0);
  const { color: c, edgeBlur: l, mode: u, transparentColor: d } = i, f = (l || 0) > 0;
  if (f && (r.canvas.width = s.canvas.width, r.canvas.height = s.canvas.height, r.context.clearRect(0, 0, r.canvas.width, r.canvas.height), r.context.globalCompositeOperation = "source-over", r.context.filter = `blur(${l}px)`, r.context.drawImage(s.canvas, 0, 0)), t.context.clearRect(0, 0, t.canvas.width, t.canvas.height), t.context.filter = "none", t.context.globalCompositeOperation = "source-over", t.context.drawImage(o, 0, 0, t.canvas.width, t.canvas.height), t.context.filter = "none", t.context.globalCompositeOperation = "destination-in", t.context.drawImage(f ? r.canvas : s.canvas, 0, 0, t.canvas.width, t.canvas.height), t.context.filter = "none", t.context.globalCompositeOperation = "destination-over", u === Lr.TRANSPARENT && d) {
    t.context.rect(0, 0, t.canvas.width, t.canvas.height), t.context.fillStyle = `rgb(${d.r}, ${d.g}, ${d.b})`, t.context.fill();
    return;
  }
  if (u === Lr.COLOR && c) {
    t.context.rect(0, 0, t.canvas.width, t.canvas.height), t.context.fillStyle = `rgb(${c.r}, ${c.g}, ${c.b})`, t.context.fill();
    return;
  }
  if (u === Lr.IMAGE && e.current) {
    cl(e.current, n), n.canvas.width > 0 && n.canvas.height > 0 && t.context.drawImage(n.canvas, 0, 0, t.canvas.width, t.canvas.height);
    return;
  }
  t.context.fillStyle = "black", t.context.fillRect(0, 0, t.canvas.width, t.canvas.height), t.context.fill();
}, zs = (o) => {
  var n;
  const a = ne(
    /** @type {HTMLImageElementReady | undefined} */
    void 0
  ), i = ((n = o == null ? void 0 : o.replacement) == null ? void 0 : n.mode) === Lr.IMAGE ? o.replacement.imageUrl : void 0;
  return Q(() => {
    if (!i) {
      a.current = void 0;
      return;
    }
    a.current = /** @type {HTMLImageElementReady} */
    new Image(), a.current.crossOrigin = "Anonymous", a.current.src = Qd(i), a.current.isReady = !1;
  }, [i]), a;
}, ul = async (o, a) => a.segmentPerson(o, { internalResolution: "low" }), dl = async (o, a, i) => {
  i.context.clearRect(0, 0, i.canvas.width, i.canvas.height), i.context.drawImage(o, 0, 0, i.canvas.width, i.canvas.height);
  const n = i.context.getImageData(0, 0, i.canvas.width, i.canvas.height), e = n.data;
  for (let t = 0; t < e.length; t += 4) {
    const [r, s, c] = [e[t], e[t + 1], e[t + 2]];
    ol({ r, g: s, b: c }, a) ? (n.data[t] = 0, n.data[t + 1] = 0, n.data[t + 2] = 0, n.data[t + 3] = 0) : (n.data[t] = 0, n.data[t + 1] = 0, n.data[t + 2] = 0, n.data[t + 3] = 255);
  }
  return n;
}, Gs = async (o, a, i, n) => {
  if (a.mode === $t.AI)
    return ul(o, i);
  if (a.mode === $t.RGB)
    return dl(o, a, n);
}, ll = (o, a, i, n, e) => {
  const { blur: t, edgeBlur: r, mode: s } = i.replacement;
  if (s === Lr.BLUR) {
    e.drawBokehEffect(n.output.canvas, o, a, t, r);
    return;
  }
  const c = e.toMask(a, { r: 0, g: 0, b: 0, a: 255 }, { r: 0, g: 0, b: 0, a: 0 }, !1);
  Vc(o, c, i.replacement, { background: n.background, img: n.img, output: n.output, person: n.person, segmentationMask: n.segmentationMask });
}, pl = (o, a, i, n) => {
  Vc(o, a, i.replacement, { background: n.background, img: n.img, output: n.output, person: n.person, segmentationMask: n.segmentationMask });
}, qs = (o) => "allPoses" in o, Ks = async (o, a, i, n, e) => {
  const { mode: t } = i.detection;
  if (t === $t.AI && qs(a))
    return ll(o, a, i, n, e);
  if (t === $t.RGB && !qs(a))
    return pl(o, a, i, n);
  throw new Error(`Incorrect detection result type  according to the detection mode ${t}`);
}, fl = () => {
  const { config: o, configOverride: a, enabledSourceOfferIds: i, isKeyEnabled: n } = Nn(), e = rn(), t = rn(!0), r = rn(!0), s = rn(!0, { alpha: !1 }), c = rn(!0, { alpha: !1 }), l = rn(!0), u = ne(
    /** @type {BodyPixModule|undefined}} */
    void 0
  ), d = ne(
    /** @type {BodyPix|undefined} */
    void 0
  ), f = ne(o), p = ne(a);
  Q(() => {
    f.current = o, p.current = a;
  }, [o, a]);
  const m = zs(o), b = zs(a), h = ne(!1), g = ne(!1), w = q((y, C) => {
    g.current || (g.current = !0, e.canvas.width = y, e.canvas.height = C, l.canvas.width = y, l.canvas.height = C, m.current && (m.current.isReady = !1), b.current && (b.current.isReady = !1));
  }, [m, b, e.canvas, l.canvas]), _ = q(
    /** @type {MediaVideoTrackPerformerHook<T>['performer']} */
    async (y, C) => {
      if (!d.current || !u.current || !h.current) return;
      w(C.canvas.width, C.canvas.height);
      const S = f.current, P = p.current, T = S == null ? void 0 : S.detection, I = P == null ? void 0 : P.detection, k = C;
      let x = y, O;
      const D = I && I.mode !== $t.DISABLED;
      if (T && T.mode !== $t.DISABLED) {
        if (O = await Gs(x, T, d.current, l), !h.current || !O) return;
        const A = D ? e : k;
        Ks(x, O, S, { background: c, img: m, output: A, person: r, segmentationMask: t }, u.current), x = A.canvas;
      }
      if (I && I.mode !== $t.DISABLED) {
        if ((T == null ? void 0 : T.mode) !== I.mode && (O = await Gs(x, I, d.current, l)), !h.current || !O) return;
        Ks(x, O, P, { background: s, img: b, output: k, person: r, segmentationMask: t }, u.current);
      }
    },
    [s, c, m, b, w, e, r, l, t]
  );
  return Q(() => (n ? ((async () => {
    if (!u.current)
      try {
        u.current = await sl();
        const C = await u.current.load({ architecture: "MobileNetV1", outputStride: 16, multiplier: 0.5, quantBytes: 2 });
        d.current = C;
      } catch (C) {
        console.error(C);
      }
  })(), h.current = !0) : (h.current = !1, g.current = !1), () => {
    h.current = !1, g.current = !1;
  }), [n]), W(() => ({ config: o, enabledSourceOfferIds: i, performer: _ }), [o, i, _]);
}, hl = (o) => {
  o.timeoutId && clearTimeout(o.timeoutId);
  const a = () => {
    o.isPerformable && o.performers.forEach(async (i) => {
      await i.fn(i.source, i.destination);
    }), o.timeoutId = setTimeout(a, 1e3 / o.fps);
  };
  a();
}, xa = (o, a) => {
  if (a === 1) {
    if (o.canvases.temp1) return o.canvases.temp1;
    const { width: i, height: n } = o.canvases.final.canvas;
    return o.canvases.temp1 = ra({ offscreen: !1, width: i, height: n }), o.canvases.temp1;
  }
  if (a === 2) {
    if (o.canvases.temp2) return o.canvases.temp2;
    const { width: i, height: n } = o.canvases.final.canvas;
    return o.canvases.temp2 = ra({ offscreen: !1, width: i, height: n }), o.canvases.temp2;
  }
  throw new Error(`Unknown temp canvas number ${a} for controllable video track`);
}, ml = (o, a) => {
  if (a.length === 0) {
    o.performers = [];
    return;
  }
  if (a.length === 1) {
    o.performers = [{ fn: a[0].performer, source: o.videoElement, destination: o.canvases.final }];
    return;
  }
  o.performers = a.map((i, n) => {
    if (n === 0)
      return { fn: i.performer, source: o.videoElement, destination: xa(o, 1) };
    const e = n % 2 || 2;
    if (n === a.length - 1)
      return { fn: i.performer, source: xa(o, e).canvas, destination: o.canvases.final };
    const t = n % 2 + 1;
    return { fn: i.performer, source: xa(o, e).canvas, destination: xa(o, t) };
  });
}, vl = (o, a) => {
  var u;
  const i = document.createElement("video"), n = new MediaStream([o]);
  i.setAttribute("playsinline", ""), i.autoplay = !0, i.muted = !0, i.srcObject = n, i.onloadeddata = () => {
    i.onloadeddata = null, i.width = i.videoWidth, i.height = i.videoHeight;
  };
  const { width: e, height: t } = o.getSettings(), r = ra({ offscreen: !1, width: e, height: t }), s = ((u = a == null ? void 0 : a.controllable) == null ? void 0 : u.fps) || Mc, l = /** @type {MediaVideoTrackControllable<T>[]}*/ /** @type {HTMLCanvasElement} */ r.canvas.captureStream(s).getVideoTracks()[0];
  return l.configId = o.configId, l.device = o.device, l.physicalDeviceId = o.physicalDeviceId, l.sourceOffer = o.sourceOffer, l.originalTrackId = o.id, l.videoElement = i, l.canvases = { final: r }, l.fps = s, l.performers = [], i.oncanplay = () => {
    i.play(), l.isPerformable = !0;
  }, l;
}, Hs = (o) => {
  o.timeoutId && clearTimeout(o.timeoutId), o.videoElement.pause(), o.videoElement.srcObject = null, o.videoElement.oncanplay = null, o.stop();
}, gl = () => {
  const { addTracks: o, clearTracks: a, originalTracks: i, removeTrack: n, setTracksMap: e, tracks: t } = Nc({ onStopControllable: Hs }), r = W(() => t.map((u) => u.sourceOffer.id), [t]), s = Yd({ availableSourceOfferIds: r }), c = fl(), l = W(() => [s, c], [s, c]);
  return Q(() => {
    e((u) => {
      let d = !1;
      return Object.values(u).forEach((f) => {
        const p = l.filter((b) => b.enabledSourceOfferIds.includes(f.original.sourceOffer.id)), m = p.length > 0;
        m && (f.controllable || (f.controllable = vl(f.original, f.options), d = !0), ml(f.controllable, p), hl(f.controllable)), !m && f.controllable && (Hs(f.controllable), f.controllable = void 0, d = !0);
      }), d ? { ...u } : u;
    });
  }, [e, l]), W(() => ({ addTracks: o, clearTracks: a, originalTracks: i, removeTrack: n, tracks: t }), [o, a, i, n, t]);
}, Uc = Xe(
  /** @type {IAudioFiltersContext} */
  {}
), zc = () => Ze(Uc), yl = ({ children: o }) => {
  const [a, i] = re(
    /** @type {AudioFiltersConfig[]} */
    []
  ), n = q((t) => {
    const { audioFilters: r } = t;
    i(r || []);
  }, []), e = W(() => ({ audioFiltersConfig: a, handleCMSEvents: n }), [a, n]);
  return /* @__PURE__ */ V.jsx(Uc.Provider, { value: e, children: o });
}, bl = (o, a) => {
  o.panner && (o.panner.pan.value = a.filters.balance), o.equalizers && o.equalizers.forEach((i) => {
    const n = a.filters.equalizer.find(({ freq: e }) => e === i.frequency.value);
    n && (i.gain.value = n.value);
  });
}, _l = (o) => {
  const { audioFiltersConfig: a } = zc();
  Q(() => {
    o.filter((i) => "originalTrackId" in i).forEach((i) => {
      const n = a.find(({ source: e }) => {
        var t;
        return e.id === ((t = i.sourceOffer) == null ? void 0 : t.id);
      });
      n && bl(i, n);
    });
  }, [o, a]);
}, wl = [32, 64, 125, 500, 2e3, 4e3, 8e3, 16e3], Sl = (o) => {
  const a = new AudioContext(), i = new MediaStream([o]), n = a.createMediaStreamSource(i), e = a.createMediaStreamDestination(), t = [], r = a.createStereoPanner();
  r.pan.value = 0, wl.forEach((c) => {
    const l = a.createBiquadFilter();
    l.type = "peaking", l.frequency.value = c, l.Q.value = 1, l.gain.value = 0, t.push(l);
  }), t.reduce((c, l) => (c.connect(l), l)), n.connect(r), r.connect(t[0]), t[t.length - 1].connect(e);
  const s = (
    /** @type {MediaAudioTrackControllable<T>} */
    e.stream.getAudioTracks()[0]
  );
  return s.configId = o.configId, s.device = o.device, s.physicalDeviceId = o.physicalDeviceId, s.sourceOffer = o.sourceOffer, s.audioContext = a, s.panner = r, s.equalizers = t, s.originalTrackId = o.id, s;
}, Cl = (o) => {
  o.audioContext.close(), o.panner.disconnect(), o.equalizers.forEach((a) => {
    a.disconnect();
  }), o.stop();
}, kl = () => {
  const { addTracks: o, clearTracks: a, originalTracks: i, removeTrack: n, tracks: e } = Nc({ createControllableTrack: Sl, onStopControllable: Cl });
  return _l(e), W(() => ({ addTracks: o, clearTracks: a, originalTracks: i, removeTrack: n, tracks: e }), [o, a, i, n, e]);
}, Jr = () => {
  const { addTracks: o, clearTracks: a, originalTracks: i, removeTrack: n, tracks: e } = gl(), { addTracks: t, clearTracks: r, originalTracks: s, removeTrack: c, tracks: l } = kl(), u = q(
    /** @type {MediaTracksManager<T>['addTracks']} */
    (h, g) => {
      t(h.filter((w) => w.kind === "audio")), o(h.filter((w) => w.kind === "video"), g == null ? void 0 : g.video);
    },
    [t, o]
  ), d = q(
    /** @type {MediaTracksManager<T>['addTrack']} */
    (h, g) => {
      u([h], g);
    },
    [u]
  ), f = q(
    /** @type {MediaTracksManager<T>['removeTrack']} */
    (h) => {
      c(h), n(h);
    },
    [c, n]
  ), p = q(
    /** @type {MediaTracksManager<T>['clearTracks']} */
    () => {
      r(), a();
    },
    [r, a]
  ), m = W(() => [...l, ...e], [l, e]), b = W(() => [...s, ...i], [s, i]);
  return W(() => ({ addTrack: d, addTracks: u, clearTracks: p, originalTracks: b, removeTrack: f, tracks: m }), [d, u, p, b, f, m]);
}, Ys = Tc(), Gc = Xe(
  /** @type {IMediaUserContext} */
  {}
), Fn = () => Ze(Gc), xl = (o, a) => ({
  deviceId: { exact: o },
  height: { ideal: a },
  frameRate: { ideal: Mc },
  // max: USER_MAX_FPS (24) is not supported by Firefox
  aspectRatio: { ideal: 16 / 9 }
}), Rl = (o, a = {}) => ({ deviceId: { exact: o }, ...Bd, ...a }), Il = (o, a) => {
  const { getDeviceTrack: i, getVirtualDeviceFromConfigAndKind: n, inputDeviceStatuses: e, resetInputDeviceStatusById: t } = Fn(), { activateAudioInput: r, activateVideoInput: s, deactivateAudioInput: c, deactivateVideoInput: l, inputPermissions: u } = ha(), d = n(o, a), f = d == null ? void 0 : d.virtualDeviceId, p = d == null ? void 0 : d.physicalDeviceId, m = p ? i(p, a) : void 0, b = p ? e[p] : void 0, h = !!m, g = u[a], w = () => {
    h ? a === "audioinput" ? c(o) : l(o) : (p && t(p), a === "audioinput" ? r(o) : s(o));
  };
  return { configId: o, device: d, deviceId: f, deviceTrack: m, error: b == null ? void 0 : b.error, inputDeviceStatus: b, isActive: !!m, isLoading: (b == null ? void 0 : b.status) === "prompt", permission: g, toggleInputDevice: w };
}, Pl = Vd(Ot.CONFIG), Tl = xc(function({ allowAudio: a = !1, allowVideo: i = !1, children: n, resolution: e = ma.P720 }) {
  const { setMainCamTrackSourceOfferId: t } = Nn(), { isDeviceUpdating: r, inputsConfig: s, inputDevices: c, inputPermissions: l } = ha(), { sources: u } = en(), d = W(() => u.filter(Pl), [u]), { addTrack: f, removeTrack: p, tracks: m } = Jr(), { addTrack: b, removeTrack: h, tracks: g, originalTracks: w } = Jr(), _ = W(() => [...m, ...g], [m, g]), y = ne(
    /** @type {MediaStreamUser[]}*/
    []
  ), C = W(() => {
    if (_.length > 0) {
      const Y = d.map((Z) => {
        const ae = _.filter((Oe) => Oe.configId === Z.configId);
        if (ae.length <= 0) return;
        const oe = y.current.find((Oe) => Oe.configId === Z.configId), ce = (oe == null ? void 0 : oe.getTracks()) || [];
        if (ae.length === (ce == null ? void 0 : ce.length) && ae.every((Oe) => ce.includes(Oe))) return oe;
        const ke = (
          /** @type {MediaStreamUser} */
          new MediaStream(ae)
        );
        return ke.configId = /** @type {number} */
        Z.configId, ke;
      }).filter((Z) => !!Z);
      return y.current = Y, Y;
    }
    return [];
  }, [_, d]), S = ne(_);
  S.current = _;
  const P = ne(!1);
  Q(() => () => {
    P.current = !0, S.current.forEach(cr);
  }, []);
  const T = q(
    /** @type {IMediaUserContext['getDeviceTrack']} */
    (Y, Z) => _ == null ? void 0 : _.find((ae) => {
      const oe = Z === "audioinput" ? "audio" : "video";
      return ae.physicalDeviceId === Y && ae.kind === oe;
    }),
    [_]
  ), I = q(
    /** @type {IMediaUserContext['getVirtualDeviceFromConfigAndKind']} */
    (Y, Z) => {
      const ae = s.find((ce) => ce.id === Y);
      if (!ae) return;
      let oe;
      if (Z === "audioinput" ? oe = ae.audioInputId : Z === "videoinput" && (oe = ae.videoInputId), !!oe)
        return c.find((ce) => ce.virtualDeviceId === oe);
    },
    [s, c]
  ), k = q((Y) => {
    if (Y.kind === "audio") f(Y);
    else if (Y.kind === "video") b(Y);
    else throw new Error(`addTrack: Unknown kind '${Y.kind}'`);
  }, [f, b]), x = q(
    /**
    * @param {{
    *  audio?: UserMediaTrackConstraints,
    *  video?: UserMediaTrackConstraints,
    * }} constraints
    * @param {DeviceRequest} deviceRequest
    * @returns {Promise<MediaStreamTrackUser[]>}
    */
    async (Y, Z) => {
      const ae = await wi(Y);
      if (P.current)
        return ae.getTracks().forEach((ce) => ce.stop()), [];
      const oe = (
        /** @type {MediaStreamTrackUser[]} */
        ae.getTracks()
      );
      return oe.forEach((ce) => {
        ce.configId = Z.source.configId, ce.device = { ...Z.device }, ce.physicalDeviceId = Z.physicalDeviceId, ce.sourceOffer = { ...Z.source }, k(ce);
      }), oe;
    },
    [k]
  ), [O, D] = re(
    /** @type {IMediaUserContext['inputDeviceStatuses']} */
    {}
  ), A = q(
    /**
    * @param {DeviceRequest} deviceRequest
    * @param {InputDeviceStatus['status']} status
    * @param {InputDeviceStatus['error']} [error]
    */
    (Y, Z, ae) => {
      D((oe) => ({ ...oe, [Y.physicalDeviceId]: { deviceRequest: Y, status: Z, error: ae } }));
    },
    []
  ), E = q(
    /** @type {IMediaUserContext['resetInputDeviceStatusById']} */
    (Y) => {
      D((Z) => {
        const { [Y]: ae, ...oe } = Z;
        return oe;
      });
    },
    []
  ), F = ne(e);
  F.current = e;
  const B = q(
    /** @type {IMediaUserContext['requestInputDevice']} */
    async (Y) => {
      const { device: Z, physicalDeviceId: ae } = Y;
      if (Z.kind !== "audioinput" && Z.kind !== "videoinput")
        throw new Error("Incorrect input devide kind");
      const oe = {};
      Z.kind === "audioinput" && (oe.audio = Rl(ae, { echoCancellation: { ideal: !0 }, noiseSuppression: { ideal: !0 } })), Z.kind === "videoinput" && (oe.video = xl(
        ae,
        F.current
        // Use the latest resolution.
        // Dont request a new mediatrack when resolution changes.
        // We will call applyConstraints() on existing track instead.
      )), A(Y, "prompt");
      try {
        const ce = await x(oe, Y);
        if (P.current)
          return;
        const ke = ce.find((Oe) => Oe.kind === "video" && Oe.configId === 0);
        return ke && t(ke.sourceOffer.id), A(Y, "granted"), ce;
      } catch (ce) {
        if (console.error(ce), Ys && Ys.error(ce, { constraints: oe }), P.current)
          return;
        const ke = ce instanceof Error ? ce : new Error("Unknown error");
        A(Y, "error", ke);
      }
    },
    [x, A, t]
  ), $ = q(
    /** @type {IMediaUserContext['stopInputDevice']} */
    (Y) => {
      _.filter((ae) => ae.physicalDeviceId === Y.physicalDeviceId && ae.kind === (Y.device.kind === "audioinput" ? "audio" : "video")).forEach((ae) => {
        cr(ae), ae.kind === "audio" && p(ae), ae.kind === "video" && h(ae);
      }), E(Y.physicalDeviceId);
    },
    [E, _, p, h]
  ), M = () => {
    c.forEach((Y) => {
      const { kind: Z, physicalDeviceId: ae } = Y;
      if (!ae || Z !== "audioinput" && Z !== "videoinput")
        return;
      const oe = O[ae];
      !T(ae, Z) && (oe == null ? void 0 : oe.status) === "granted" && E(ae);
    });
  }, j = ne(M);
  j.current = M;
  const z = ne(r);
  Q(() => {
    const Y = z.current;
    z.current = r, !r && r !== Y && j.current();
  }, [r]);
  const te = W(() => d.reduce(
    (Y, Z) => (Z.devices.forEach((ae) => {
      var ce;
      const oe = (ce = c.find((ke) => ke.virtualDeviceId === ae.deviceId)) == null ? void 0 : ce.physicalDeviceId;
      oe && (Y = [...Y, { device: ae, physicalDeviceId: oe, source: Z }]);
    }), Y),
    /** @type {DeviceRequest[]} */
    []
  ), [c, d]);
  Q(() => {
    if (r)
      return;
    Object.values(O).filter((Z) => {
      const { deviceRequest: ae } = Z;
      return !te.find((ce) => ce.physicalDeviceId === ae.physicalDeviceId);
    }).forEach((Z) => {
      $(Z.deviceRequest);
    }), te.forEach((Z) => {
      const { device: ae, physicalDeviceId: oe } = Z, { disabled: ce, kind: ke } = ae;
      if (ke !== "audioinput" && ke !== "videoinput")
        return;
      const Oe = !ce, nt = l[ke] === "granted", et = ke === "audioinput" ? a : i, Fe = O[oe], $e = T(oe, ke);
      if (!Oe || !et || !nt || !oe) {
        $e && $(Z);
        return;
      }
      !$e && !(Fe != null && Fe.status) && B(
        // Verified above that physicalDeviceId is defined
        /** @type {DeviceRequest & { physicalDeviceId: string }} */
        Z
      );
    });
  }, [a, i, T, O, l, r, B, $, te]), Q(() => {
    function Y() {
      const Z = this;
      Z.kind === "audio" && p(Z), Z.kind === "video" && h(Z);
    }
    return _.forEach((Z) => {
      Z.addEventListener("ended", Y);
    }), () => {
      _.forEach((Z) => {
        Z.removeEventListener("ended", Y);
      });
    };
  }, [_, p, h]);
  const ee = W(() => ({ getDeviceTrack: T, getVirtualDeviceFromConfigAndKind: I, inputDeviceStatuses: O, requestInputDevice: B, resetInputDeviceStatusById: E, stopInputDevice: $, userActiveTracks: _, userAudioActiveTracks: m, userMediastreams: C, userVideoActiveTracks: g, userVideoOriginalTracks: w }), [T, I, O, B, E, $, _, m, C, g, w]);
  return /* @__PURE__ */ V.jsx(Gc.Provider, { value: ee, children: n });
}), qc = "beeyou_computerId";
let qa = localStorage.getItem(qc);
qa || (qa = Wa(), localStorage.setItem(qc, qa));
const pt = () => qa, Dl = (o) => ({
  height: { max: o },
  // ideal is not supported by safari 16+ :
  // https://bugs.webkit.org/show_bug.cgi?id=247310
  width: { max: Math.round(o * (16 / 9)) },
  frameRate: { max: 5 }
}), Ws = 0, Kc = Xe(
  /** @type {MediaShareScreenContextValue} */
  {}
), fs = () => Ze(Kc), El = (o) => {
  if (o.kind === "audio") return "audioscreen";
  if (o.kind === "video") return "videoscreen";
  throw new Error(`Unknown kind '${o.kind}'`);
}, hs = ({ activeShareType: o, children: a, disabled: i, isHost: n, onShare: e, resolution: t }) => {
  const { createOrUpdateSource: r, removeSourceById: s } = en(), { addTracks: c, clearTracks: l, removeTrack: u, tracks: d } = Jr(), [f, p] = re(
    /** @type {MediaShareScreenContextValue['screenshareRequestError']} */
    void 0
  ), m = d.length > 0, b = W(() => {
    if (d.length > 0) {
      const T = (
        /** @type {MediaStreamScreenshare} */
        new MediaStream(d)
      );
      return T.configId = Ws, T;
    }
  }, [d]), h = ne(t);
  Q(() => {
    h.current = t;
  }, [t]);
  const g = n || o === Qr.SCREEN, w = ne(!1), _ = q(async () => {
    w.current = !0;
    try {
      p(void 0);
      const T = await navigator.mediaDevices.getDisplayMedia({ audio: !0, video: Dl(h.current) }), I = w.current, k = { computerId: pt(), configId: 0, id: `${pt()}:0:screen`, label: "Screenshare", subType: Ot.SCREENSHARE }, x = (
        /** @type {MediaStreamTrackScreenshare[]} */
        T.getTracks()
      );
      x.forEach((O) => {
        O.configId = Ws, O.device = { deviceId: `${pt()}:screen`, kind: El(O), label: `Screenshare ${O.kind}` }, O.sourceOffer = k;
      }), I ? (r({ ...k, devices: x.map((O) => O.device) }), c(x), e(Qr.SCREEN)) : x.forEach((O) => O.stop());
    } catch (T) {
      p(T);
    }
  }, [r, e, c]);
  Q(() => {
    function T() {
      u(this);
    }
    return d.forEach((I) => {
      I.addEventListener("ended", T);
    }), () => {
      d.forEach((I) => {
        I.removeEventListener("ended", T);
      });
    };
  }, [d, u]);
  const y = ne(d);
  y.current = d;
  const C = q(() => {
    w.current = !1, y.current.forEach(cr), l(), p(void 0), s(`${pt()}:0:screen`);
  }, [s, l]);
  Q(() => {
    w.current && d.length < 1 && C();
  }, [d, C]), Q(() => {
    w.current && (i || !g) && C();
  }, [i, g, C]), Q(() => () => {
    w.current = !1, y.current.forEach(cr);
  }, []);
  const S = q(() => {
    m ? C() : _();
  }, [_, m, C]), P = W(() => ({ requestScreenshare: _, screenshareActive: m, screenshareActiveTracks: d, screenshareMediastream: b, screenshareRequestError: f, stopScreenshare: C, toggleScreenshare: S }), [_, m, d, b, f, C, S]);
  return /* @__PURE__ */ V.jsx(Kc.Provider, { value: P, children: a });
};
hs.propTypes = { activeShareType: N.oneOf(Object.values(Qr)).isRequired, children: N.node.isRequired, disabled: N.bool, isHost: N.bool, onShare: N.func.isRequired, resolution: N.oneOf(Object.values(ma)) };
hs.defaultProps = { disabled: !1, isHost: !1, resolution: ma.P720 };
const Al = 30, ji = performance || Date, Ll = 0, Jg = { ACCEPTED_FORMATS: ["video/*"] }, Hc = Xe(
  /** @type {IMediaShareVideoContext} */
  {}
), Ci = () => Ze(Hc), Xs = (o, a, i, n) => {
  const e = a && o ? Math.min(n / a, i / o) : 0, t = Math.floor(a * e), r = Math.floor(o * e), s = Math.floor((i - r) / 2), c = Math.floor((n - t) / 2);
  return { height: t, width: r, x: s, y: c };
}, Ol = (o) => ({ height: o, width: Math.floor(o * (16 / 9)) }), Ml = (o) => {
  if (o.kind === "audio") return "audiofile";
  if (o.kind === "video") return "videofile";
  throw new Error(`Unknown kind '${o.kind}'`);
}, jl = ({ activeShareType: o, children: a, disabled: i = !1, isHost: n = !1, onShare: e, resolution: t = ma.P720 }) => {
  var $;
  const { createOrUpdateSource: r, removeSourceById: s } = en(), [c, l] = re(
    /** @type {IMediaShareVideoContext['videoshareData']} */
    null
  ), [u, d] = re({ startTime: 0, endTime: 0 }), [f, p] = re(!1), m = ne(
    /** @type {HTMLVideoElement?} */
    null
  ), { addTracks: b, clearTracks: h, removeTrack: g, tracks: w } = Jr(), [_, y] = re(
    /** @type {IMediaShareVideoContext['videoshareRequestError']} */
    null
  ), C = w.length > 0, S = W(() => {
    if (w.length > 0)
      return new MediaStream(w);
  }, [w]), P = n || o === Qr.VIDEO, T = ne(t);
  Q(() => {
    T.current = t;
  }, [t]);
  const I = q(() => {
    m.current && m.current.currentTime >= u.endTime && (m.current.currentTime = u.startTime, m.current.play(), u.endTime && m.current.addEventListener("timeupdate", I), p(!1));
  }, [u.endTime, u.startTime]), k = q(
    /** @type {IMediaShareVideoContext['playVideo']} */
    () => {
      m.current && (m.current.play(), u.endTime && m.current.addEventListener("timeupdate", I), p(!1));
    },
    [I, u.endTime]
  ), x = q(
    /** @type {IMediaShareVideoContext['pauseVideo']} */
    () => {
      if (!m.current) return;
      const M = m.current.currentTime;
      m.current.pause(), p(!0), m.current.currentTime = M;
    },
    []
  );
  Q(() => (m.current && u.endTime && (m.current.removeEventListener("timeupdate", I), m.current.addEventListener("timeupdate", I)), () => {
    m.current && m.current.removeEventListener("timeupdate", I);
  }), [I, u]);
  const O = ne(
    /** @type {File?} */
    null
  ), D = q(
    /** @type {IMediaShareVideoContext['handleChangeVideoShareTimeCodes']} */
    (M, j) => {
      m.current && (M !== u.startTime && (d((z) => ({ ...z, startTime: M })), m.current.currentTime = M), j !== u.endTime && d((z) => ({ ...z, endTime: j })));
    },
    [u.endTime, u.startTime]
  ), A = q(
    /** @type {IMediaShareVideoContext['requestVideoshare']} */
    async (M) => {
      O.current = M;
      try {
        y(null);
        const j = document.createElement("video");
        if (m.current = j, j.preload = "auto", j.loop = !0, j.crossOrigin = "anonymous", j.volume = 1, j.src = URL.createObjectURL(M), await j.play(), n && x(), l({ name: M.name, duration: m.current.duration, src: j.src }), !O.current) return;
        const z = document.createElement("canvas"), te = z.getContext("2d");
        if (!te) throw new Error("Canvas not supported");
        const ee = Ol(T.current);
        z.width = ee.width, z.height = ee.height;
        const Y = new AudioContext(), Z = Y.createMediaStreamDestination(), ae = Y.createGain();
        ae.gain.value = 1, ae.connect(Z), Y.createMediaElementSource(j).connect(ae);
        let ce = 0, ke = Xs(j.videoWidth, j.videoHeight, z.width, z.height);
        const Oe = () => {
          const Ie = ji.now();
          return Ie > ce && (ke = Xs(j.videoWidth, j.videoHeight, z.width, z.height), ce = Ie + 2e3), ke;
        };
        let nt = ji.now();
        const et = Math.floor(1e3 / Al), Fe = (
          /**
          * @type {Omit<MediaStream, 'getVideoTracks'> & {
          * 	requestFrame?: () => void,
          *  getVideoTracks: () => CanvasCaptureMediaStreamTrack[],
          * }}
          */
          z.captureStream(0)
        ), $e = () => {
          if (!O.current) return;
          requestAnimationFrame($e);
          const Ie = ji.now(), ut = Ie - nt;
          if (ut < et) return;
          nt = Ie - ut % et;
          const { x: qe, y: H, width: ue, height: Ve } = Oe();
          te.drawImage(j, qe, H, ue, Ve), Fe.requestFrame ? Fe.requestFrame() : Fe.getVideoTracks()[0].requestFrame();
        };
        requestAnimationFrame($e);
        const at = (
          /** @type {MediaStreamTrackVideo[]} */
          Fe.getTracks().map((Ie) => (Ie.firefoxFixCaptureSettings = { width: z.width, height: z.height }, Ie))
        ), vt = (
          /** @type {MediaStreamTrackVideo[]} */
          Z.stream.getTracks()
        ), gt = { computerId: pt(), configId: 0, id: `${pt()}:0:videoshare`, label: M.name, subType: Ot.VIDEOSHARE }, it = [...at, ...vt].map((Ie) => (Ie.configId = Ll, Ie.device = { deviceId: `${pt()}:videoshare`, kind: Ml(Ie), label: "Videoshare" }, Ie.sourceOffer = gt, Ie));
        r({ ...gt, devices: it.map((Ie) => Ie.device) }), b(it), e(Qr.VIDEO);
      } catch (j) {
        console.error(j), y(
          /** @type {Error} */
          j
        );
      }
    },
    [r, e, n, x, b]
  ), E = q(
    /** @type {IMediaShareVideoContext['stopVideoshare']} */
    () => {
      y(null), l(null), O.current = null, m.current = null, w.forEach(cr), h(), s(`${pt()}:0:videoshare`);
    },
    [s, w, h]
  );
  Q(() => {
    function M() {
      g(this);
    }
    return w.forEach((j) => {
      j.addEventListener("ended", M);
    }), () => {
      w.forEach((j) => {
        j.removeEventListener("ended", M);
      });
    };
  }, [w, g]), Q(() => {
    O.current && (i || !P) && E();
  }, [i, P, E]);
  const F = ne(w);
  Q(() => {
    F.current = w;
  }, [w]), (($ = m.current) == null ? void 0 : $.readyState) === HTMLMediaElement.HAVE_ENOUGH_DATA && m.current.paused && (m.current.currentTime = u.startTime), Q(() => () => {
    O.current = null, m.current && (x(), m.current = null), F.current.forEach(cr);
  }, [x]);
  const B = W(() => ({ handleChangeVideoShareTimeCodes: D, isVideoPaused: f, pauseVideo: x, playVideo: k, requestVideoshare: A, setVideoshareRequestError: y, stopVideoshare: E, videoshareActive: C, videoshareActiveTracks: w, videoshareData: c, videoshareMediastream: S, videoshareRequestError: _ }), [D, f, x, k, A, y, E, C, w, c, S, _]);
  return /* @__PURE__ */ V.jsx(Hc.Provider, { value: B, children: a });
}, Nl = 1, Zs = performance || Date, Fl = 0, ey = { ACCEPTED_FORMATS: ["image/jpeg", "image/webp", "image/png", "image/gif", "image/bmp"] }, Yc = Xe(
  /** @type {IMediaShareImageContext} */
  {}
), Wc = () => Ze(Yc), $l = async (o) => {
  try {
    const a = await new Promise((n, e) => {
      const t = new FileReader();
      t.onload = (r) => {
        var s;
        ((s = r.target) == null ? void 0 : s.result) instanceof ArrayBuffer ? n(r.target.result) : e(new Error("Invalid file"));
      }, t.onerror = e, t.readAsArrayBuffer(o);
    }), i = new Uint8Array(a);
    return new vd(i);
  } catch (a) {
    console.error("Error reading the file:", a);
  }
  return null;
}, Bl = async (o) => {
  const a = await $l(o);
  if (!a) throw new Error("Invalid GIF file");
  const i = document.createElement("canvas"), n = i.getContext("2d");
  if (!n) throw new Error("Canvas not supported");
  const e = a.numFrames(), t = a.width, r = a.height;
  i.width = t * e, i.height = r;
  for (let s = 0; s < e; s += 1) {
    const c = n.createImageData(t, r);
    a.decodeAndBlitFrameRGBA(s, c.data), n.putImageData(c, s * t, 0);
  }
  return { canvasUrl: i.toDataURL(), frameCount: e, frameWidth: t, frameHeight: r, frameDelays: Array.from({ length: e }, (s, c) => a.frameInfo(c).delay * 10), frameDisposals: Array.from({ length: e }, (s, c) => a.frameInfo(c).disposal) };
}, Vl = (o) => {
  if (o.kind === "audio") return "audiofile";
  if (o.kind === "video") return "videofile";
  throw new Error(`Unknown kind '${o.kind}'`);
}, Ul = ({ activeShareType: o, children: a, disabled: i = !1, isHost: n = !1, onShare: e }) => {
  const { createOrUpdateSource: t, removeSourceById: r } = en(), [s, c] = re(
    /** @type {IMediaShareImageContext['imageshareData']} */
    null
  ), l = ne(
    /** @type {HTMLImageElement?} */
    null
  ), { addTracks: u, clearTracks: d, tracks: f } = Jr(), [p, m] = re(
    /** @type {IMediaShareImageContext['imageshareRequestError']} */
    null
  ), b = f.length > 0, h = W(() => {
    if (f.length > 0)
      return new MediaStream(f);
  }, [f]), g = n || o === Qr.IMAGE, w = ne(
    /** @type {File?} */
    null
  ), _ = q(
    /** @type {IMediaShareImageContext['requestImageshare']} */
    async (P) => {
      w.current = P;
      try {
        m(null);
        const T = P.type === "image/gif";
        let I = null;
        T && (I = await Bl(P));
        const k = document.createElement("img");
        if (l.current = k, k.src = I ? I.canvasUrl : URL.createObjectURL(P), await new Promise((j) => {
          k.onload = j;
        }), c({ name: P.name, height: I ? I.frameHeight : k.height, width: I ? I.frameWidth : k.width, src: I ? URL.createObjectURL(P) : k.src }), !w.current) return;
        const x = document.createElement("canvas"), O = x.getContext("2d");
        if (!O) throw new Error("Canvas not supported");
        x.width = I ? I.frameWidth : k.width, x.height = I ? I.frameHeight : k.height;
        let D = Zs.now(), A = -1;
        const E = 1e3 / (I ? I.frameCount : Nl), F = (
          /**
          * @type {Omit<MediaStream, 'getVideoTracks'> & {
          * 	requestFrame?: () => void,
          *  getVideoTracks: () => CanvasCaptureMediaStreamTrack[],
          * }}
          */
          x.captureStream(0)
        ), B = () => {
          if (!w.current) return;
          requestAnimationFrame(B);
          const j = Zs.now(), z = j - D;
          if (I)
            if (A === -1) A = 0;
            else {
              const te = I.frameDelays[A];
              if (z < te) return;
              A = (A + 1) % I.frameCount, D = j - z % te;
            }
          else {
            if (z < E) return;
            D = j - z % E;
          }
          if (I) {
            const te = I.frameDisposals[A] === 2, ee = A === I.frameCount - 1;
            te && !ee && O.clearRect(0, 0, x.width, x.height), O.drawImage(k, A * I.frameWidth, 0, I.frameWidth, I.frameHeight, 0, 0, I.frameWidth, I.frameHeight);
          } else O.drawImage(k, 0, 0, k.width, k.height);
          F.requestFrame ? F.requestFrame() : F.getVideoTracks()[0].requestFrame();
        };
        requestAnimationFrame(B);
        const $ = { computerId: pt(), configId: 0, id: `${pt()}:0:imageshare`, label: P.name, subType: Ot.IMAGESHARE }, M = (
          /** @type {MediaStreamTrackImage[]} */
          F.getTracks().map((j) => (j.configId = Fl, j.device = { deviceId: `${pt()}:imageshare`, kind: Vl(j), label: "Imageshare" }, j.firefoxFixCaptureSettings = { width: x.width, height: x.height }, j.sourceOffer = $, j))
        );
        t({ ...$, devices: M.map((j) => j.device) }), u(M), e(Qr.IMAGE);
      } catch (T) {
        console.error(T), m(
          /** @type {Error} */
          T
        );
      }
    },
    [t, e, u]
  ), y = q(
    /** @type {IMediaShareImageContext['stopImageshare']} */
    () => {
      m(null), c(null), w.current = null, l.current = null, f.forEach(cr), d(), r(`${pt()}:0:imageshare`);
    },
    [f, r, d]
  );
  Q(() => {
    w.current && (i || !g) && y();
  }, [i, g, y]);
  const C = ne(f);
  Q(() => {
    C.current = f;
  }, [f]), Q(() => () => {
    w.current = null, l.current = null, C.current.forEach(cr);
  }, []);
  const S = W(() => ({ imageshareActive: b, imageshareActiveTracks: f, imageshareData: s, imageshareMediastream: h, imageshareRequestError: p, requestImageshare: _, setImageshareRequestError: m, stopImageshare: y }), [b, f, s, h, p, _, m, y]);
  return /* @__PURE__ */ V.jsx(Yc.Provider, { value: S, children: a });
}, zl = ({ disabled: o = !1, getMediastream: a, sourceParticipantType: i }) => {
  const { inputDevices: n } = ha(), e = Ud(i), { tracks: t, addTracks: r, removeTrack: s } = Jr(), [c, l] = re(
    /** @type {UseDeviceRequestsResult<T>['deviceRequestStates']} */
    []
  ), u = ne(t);
  u.current = t;
  const d = q(
    /**
    * @param {DeviceRequest<T>} deviceRequest
    * @param {DeviceRequestStateValue<T>} value
    * @returns {void}
    */
    (y, C) => l((S) => {
      const P = S.findIndex((I) => I.device.deviceId === y.device.deviceId), T = { ...y, ...C };
      return P === -1 ? [...S, T] : S.map((I, k) => k === P ? T : I);
    }),
    []
  ), f = q(
    /**
    * @param {MediaStreamTrackOffer<T>} track
    * @returns {void}
    */
    (y) => l((C) => {
      const S = C.findIndex((T) => T.status === "granted" && T.tracks.includes(y));
      if (S === -1) return C;
      s(y);
      const P = (
        /** @type {DeviceRequestState<T> & { status: 'granted' }} */
        C[S]
      );
      return C.map((T, I) => {
        var k;
        return I === S ? { ...P, tracks: (k = P.tracks) == null ? void 0 : k.filter((x) => x !== y) } : T;
      });
    }),
    [s]
  ), p = q(
    /**
    * @template {SourceParticipantOfferType} [T=SourceParticipantOfferType]
    * @param {DeviceRequest<T>} deviceRequest
    * @returns {void}
    */
    (y) => l((C) => {
      const S = C.findIndex((T) => T.device.deviceId === y.device.deviceId);
      if (S === -1) return C;
      const P = C[S];
      return "tracks" in P && P.tracks.forEach(s), C.filter((T, I) => I !== S);
    }),
    [s]
  ), m = ne(!1), b = ne(c);
  b.current = c;
  const h = q(
    /** @type {UseDeviceRequestsResult<T>['requestDevice']} */
    async (y) => {
      var C;
      try {
        d(y, { status: "prompt" });
        const S = await a(y), P = ((C = b.current.find((I) => I.physicalDeviceId === y.physicalDeviceId)) == null ? void 0 : C.status) === "prompt", T = (
          /** @type {MediaStreamTrackOffer<T>[]} */
          S.getTracks()
        );
        if (!P || m.current) {
          T.forEach((I) => I.stop());
          return;
        }
        T.forEach((I) => {
          I.device = y.device, I.physicalDeviceId = y.physicalDeviceId, I.sourceOffer = y.sourceOffer;
        }), d(y, { status: "granted", tracks: T }), r(T);
      } catch (S) {
        console.error(S), d(y, { status: "error", error: S });
      }
    },
    [a, d, r]
  );
  Q(() => {
    function y() {
      f(this);
    }
    return t.forEach((C) => {
      C.addEventListener("ended", y);
    }), () => {
      t.forEach((C) => {
        C.removeEventListener("ended", y);
      });
    };
  }, [t, f]);
  const g = q(
    /** @type {UseDeviceRequestsResult<T>['stopDevice']} */
    (y) => {
      if (y.status === "granted") {
        const { tracks: C } = y;
        C.forEach(cr);
      }
      p(y);
    },
    [p]
  ), w = W(() => o ? [] : e.reduce(
    (y, C) => (C.devices.forEach((S) => {
      var I;
      const P = (I = n.find((k) => k.virtualDeviceId === S.deviceId)) == null ? void 0 : I.physicalDeviceId;
      if (!P) return;
      const T = { device: S, physicalDeviceId: P, sourceOffer: C };
      y = [...y, T];
    }), y),
    /** @type {DeviceRequest<T>[]} */
    []
  ), [o, n, e]);
  return Q(() => {
    c.filter((y) => {
      const { physicalDeviceId: C } = y;
      return !w.find((S) => S.physicalDeviceId === C);
    }).forEach((y) => {
      g(y);
    }), w.filter((y) => {
      const { physicalDeviceId: C } = y;
      return !c.find((S) => S.physicalDeviceId === C);
    }).forEach((y) => {
      h(y);
    });
  }, [c, h, w, g]), Q(() => () => {
    m.current = !0, u.current.forEach(cr);
  }, []), W(() => ({ activeTracks: t, deviceRequestStates: c, requestDevice: h, stopDevice: g }), [t, c, h, g]);
}, Xc = Xe(
  /** @type {IMediaShareAudioContext} */
  {}
), ms = () => Ze(Xc), Gl = ({ children: o, disabled: a = !1 }) => {
  const i = q(
    /** @type {GetMediastream<AudioshareType>} */
    async (c) => await navigator.mediaDevices.getUserMedia({ video: !1, audio: {
      deviceId: c.physicalDeviceId,
      autoGainControl: !1,
      channelCount: 2,
      echoCancellation: !1,
      // @ts-ignore
      latency: 0,
      noiseSuppression: !1,
      sampleRate: 48e3,
      sampleSize: 16,
      volume: 1
    } }),
    []
  ), { activeTracks: n, deviceRequestStates: e, requestDevice: t, stopDevice: r } = zl({ disabled: a, getMediastream: i, sourceParticipantType: Ot.AUDIOSHARE }), s = W(() => ({ audioshareActiveTracks: n, deviceRequestStates: e, requestAudioshare: t, stopAudioshare: r }), [n, e, t, r]);
  return /* @__PURE__ */ V.jsx(Xc.Provider, { value: s, children: o });
}, Zc = Xe(
  /** @type {IMediaTalkbackContext} */
  {}
), vs = () => Ze(Zc), Qs = 0, ql = ({ children: o }) => {
  const { deviceTrack: a, toggleInputDevice: i } = Il(Qs, "audioinput"), n = ne(!1), [e, t] = re(!1), [r, s] = re(
    /** @type {TalkbackRecipientUser[]} */
    []
  ), c = ne(
    /** @type {TalkbackMediaStreamTrack?}*/
    null
  ), l = W(() => {
    var h;
    if (!r.length)
      return (h = c.current) == null || h.stop(), c.current = null, null;
    if (c.current) return c.current;
    const m = a;
    if (!m) return null;
    const b = (
      /** @type {TalkbackMediaStreamTrack} */
      m.clone()
    );
    return b.originalTrackId = m.id, c.current = b, b;
  }, [a, r]), u = q((m) => {
    s((h) => {
      const g = m.reduce(
        (w, _) => (w[_._id] = _, w),
        /** @type {{ [key: string]: TalkbackRecipientUser }} */
        {}
      );
      return h.forEach((w) => delete g[w._id]), [...h, ...Object.values(g)];
    }), r.length > 0 || (a ? n.current = !1 : (i(), n.current = !0));
  }, [a, i, r]), d = q(({ userId: m, groupId: b }) => {
    if (!m && !b) throw new Error("Either userId or groupId must be provided");
    if (m && b) throw new Error("Only one of userId or groupId can be provided");
    s((h) => {
      let g = [];
      return m ? g = h.filter((w) => w._id !== m) : b && (g = h.filter((w) => {
        var _;
        return ((_ = w.group) == null ? void 0 : _._id) !== b;
      })), !g.length && n.current ? (i(), t(!0), h) : g;
    });
  }, [i]), f = q(() => {
    s([]);
  }, []);
  Q(() => {
    e && !a && (t(!1), s([]));
  }, [a, e]);
  const p = W(() => ({ configId: Qs, isDisconnecting: e, recipientUsers: r, startTalkbacks: u, stopAllTalkbacks: f, stopTalkbacks: d, talkbackActiveTrack: l }), [r, u, f, d, e, l]);
  return /* @__PURE__ */ V.jsx(Zc.Provider, { value: p, children: o });
}, Kl = ({ children: o }) => {
  const [a, i] = re(
    /** @type {ISourceParticipantOffersContext['sources']} */
    []
  ), n = q(
    /** @type {ISourceParticipantOffersContext['removeSourceById']} */
    (l) => {
      i((u) => u.filter(({ id: d }) => d !== l));
    },
    []
  ), e = q(
    /** @type {ISourceParticipantOffersContext['removeSourceById']} */
    (l) => {
      i((u) => u.filter(({ subType: d }) => d !== l));
    },
    []
  ), t = q(
    /**
    * @type {ISourceParticipantOffersContext['createOrUpdateSource']}
    */
    (l) => {
      i((u) => u.find(({ id: f }) => f === l.id) ? u.map((f) => f.id === l.id ? { ...f, ...l } : f) : [...u, l]);
    },
    []
  ), { inputDevices: r, inputsConfig: s } = ha();
  Q(() => {
    e(Ot.CONFIG);
    const l = (u) => r.find((d) => d.virtualDeviceId === u);
    s.forEach((u) => {
      var m, b;
      const d = [u.audioInputId && u.audioInputId !== "none" ? { deviceId: u.audioInputId, disabled: u.audioInputOff, kind: (
        /** @type {SourceParticipantOfferMediaDeviceKind} */
        "audioinput"
      ), label: ((m = l(u.audioInputId)) == null ? void 0 : m.label) || "" } : void 0, u.videoInputId && u.videoInputId !== "none" ? { deviceId: u.videoInputId, disabled: u.videoInputOff, kind: (
        /** @type {SourceParticipantOfferMediaDeviceKind} */
        "videoinput"
      ), label: ((b = l(u.videoInputId)) == null ? void 0 : b.label) || "" } : void 0].filter((h) => !!h), f = `${pt()}:${u.id}:${Ot.CONFIG}`, p = { computerId: pt(), configId: u.id, id: f, label: u.label, subType: Ot.CONFIG, devices: d };
      t(p);
    });
  }, [t, s, r, e]);
  const c = W(() => ({ createOrUpdateSource: t, removeSourceById: n, sources: a }), [t, n, a]);
  return console.log({ SourceParticipantOffersProvider: c }), /* @__PURE__ */ V.jsx(jc.Provider, { value: c, children: o });
}, Qc = ({ children: o, isHost: a }) => /* @__PURE__ */ V.jsx(yl, { children: /* @__PURE__ */ V.jsx(Hd, { children: /* @__PURE__ */ V.jsx(il, { isHost: a, children: o }) }) }), Jc = Xe(
  /** @type {IMediaContext} */
  {}
), ty = () => Ze(Jc), ry = ({ children: o, disabled: a = !1, isHost: i = !1, resolution: n = ma.P720 }) => {
  const { setEnabled: e } = ha(), [t, r] = re(!a), [s, c] = re(
    /** @type {MediaShareVideoType?} */
    null
  ), l = W(() => ({ enabled: t, setEnabled: r }), [t]), u = ne(a);
  return Q(() => {
    u.current !== a && (r(!a), u.current = a);
  }, [a]), Q(() => {
    e(t);
  }, [t, e]), Q(() => () => {
    e(!1);
  }, [e]), /* @__PURE__ */ V.jsx(Kl, { children: /* @__PURE__ */ V.jsx(Qc, { isHost: i, children: /* @__PURE__ */ V.jsx(Jc.Provider, { value: l, children: /* @__PURE__ */ V.jsx(hs, { activeShareType: s, disabled: !t, isHost: i, onShare: c, resolution: n, children: /* @__PURE__ */ V.jsx(jl, { activeShareType: s, disabled: !t, isHost: i, onShare: c, resolution: n, children: /* @__PURE__ */ V.jsx(Ul, { activeShareType: s, disabled: !t, isHost: i, onShare: c, children: /* @__PURE__ */ V.jsx(Gl, { disabled: !t, children: /* @__PURE__ */ V.jsx(Tl, { allowAudio: t, allowVideo: t, resolution: n, children: /* @__PURE__ */ V.jsx(ql, { children: o }) }) }) }) }) }) }) }) });
}, Hl = "/mixing";
let Ln;
const Yl = async ({ baseUrl: o, options: a }) => (Ln = `${o}${Hl}`, Rc(Ln, a)), Wl = () => {
  Ln && Ic(Ln);
}, Le = () => {
  if (Ln)
    return gd(Ln)();
};
async function Xl(o) {
  const a = Le(), i = () => new Promise((t, r) => {
    a.emit("join.control", { hashtag: o }, ({ error: s, data: c }) => {
      s ? (console.error(`Error while joining signaling of channel [${o}]`), r(s)) : (console.info(`joined ${c.hashtag}`), t(c));
    });
  }), n = () => i();
  a.on("reconnect", n);
  const e = () => new Promise((t, r) => {
    a.off("reconnect", n), a.emit("leave", { hashtag: o }, ({ error: s, data: c }) => {
      s ? (console.error(`Error while leaving signaling of channel [${o}]`), r(s)) : (console.info(`leaved ${c.hashtag}`), t());
    });
  });
  return await i(), async () => e();
}
function Zl(o, a) {
  Le().emit("layer", { hashtag: o, layer: a });
}
function Ql(o, a, i) {
  Le().emit("source", { hashtag: o, source: a, layer: i });
}
function Jl(o, a) {
  Le().emit("record.start", { hashtag: o, durationMinutes: a });
}
function ep(o) {
  Le().emit("record.stop", { hashtag: o });
}
function Js(o) {
  const a = Le();
  return a.on("event.status", o), function() {
    a.off("event.status", o);
  };
}
function tp(o) {
  Le().emit("publish.status", { hashtag: o });
}
async function rp(o, a) {
  Le().emit("event.drawing.new", { hashtag: o, drawing: a });
}
async function np(o) {
  Le().emit("event.drawing.clear", { hashtag: o });
}
async function ap(o) {
  Le().emit("event.drawing.clear.all", { hashtag: o });
}
async function ip(o, a) {
  Le().emit("event.drawing.toggle", { hashtag: o, allowedUser: a });
}
async function sp(o, a) {
  Le().emit("event.drawing.background.toggle", { hashtag: o, data: a });
}
async function op(o, a) {
  Le().emit("event.key.config", { hashtag: o, config: a });
}
function cp(o, a) {
  Le().emit("event.source.toggle.play", { hashtag: o, source: a });
}
function up(o, a) {
  Le().emit("event.source.toggle.loop", { hashtag: o, source: a });
}
function dp(o, a, i) {
  Le().emit("event.source.muted.changed", { hashtag: o, source: a, muted: i });
}
function lp(o, a, i) {
  Le().emit("event.source.volume.changed", { hashtag: o, source: a, volume: i });
}
function pp(o, a, i) {
  Le().emit("event.source.timecodes.changed", { hashtag: o, source: a, timecodes: i });
}
function fp(o, a, i) {
  Le().emit("event.source.speed.changed", { hashtag: o, source: a, speed: i });
}
function hp(o, a, i) {
  Le().emit("event.source.progresstime.changed", { hashtag: o, source: a, progresstime: i });
}
function mp(o, a, i, n, e, t) {
  Le().emit("event.pip.position.change", { hashtag: o, x: a, y: i, pipLayer: n, width: e, height: t });
}
function vp(o, a) {
  Le().emit("publish.mode.change", { hashtag: o, mode: a });
}
function gp(o, a) {
  Le().emit("publish.automaticswitch.change", { hashtag: o, isEnabled: a });
}
function yp(o, a) {
  Le().emit("event.crop.change", { hashtag: o, rect: a });
}
function bp(o, a) {
  Le().emit("event.drawnickname.change", { hashtag: o, isEnabled: a });
}
function _p(o, a, i) {
  Le().emit("event.pipmode.change", { hashtag: o, mode: a, sources: i });
}
function wp(o, a) {
  Le().emit("publish.gfx.update", { hashtag: o, gfx: a });
}
function Sp(o, a) {
  Le().emit("publish.text.update", { hashtag: o, text: a });
}
function Cp(o, a) {
  Le().emit("publish.scene.apply", { hashtag: o, scene: a });
}
function kp(o, a) {
  Le().emit("publish.automaticfill.change", { hashtag: o, isEnabled: a });
}
function xp(o, a) {
  Le().emit("event.canvaslogo.change", { hashtag: o, canvasLogoSettings: a });
}
function Rp(o, a) {
  Le().emit("event.sourcesShape.change", { hashtag: o, sourceShape: a });
}
function Ip(o, a) {
  Le().emit("event.sourceparticipantoffers.change", { hashtag: o, sources: a });
}
function Pp(o, a, i) {
  Le().emit("event.source.filters.changed", { hashtag: o, source: a, filters: i });
}
function Tp(o, a, i) {
  Le().emit("event.host.mute.participant.cam", { hashtag: o, sourceId: a, isMuted: i });
}
const eu = Xe(
  /** @type {IReactVideoContext} */
  {}
), $n = () => Ze(eu), Dp = ({ children: o, getConnectionConfig: a, isController: i = !1, roomId: n, user: e }) => {
  const t = W(() => ({ getConnectionConfig: a, isController: i, roomId: n, user: e }), [a, i, n, e]);
  return /* @__PURE__ */ V.jsx(eu.Provider, { value: t, children: o });
}, sr = { FLOATING_PIP: "FLOATING_PIP", DRAW: "DRAW", CROP: "CROP" }, tu = Xe(
  /** @type {IPlayerModeContext} */
  {}
), ki = () => Ze(tu), gs = ({ children: o, isController: a }) => {
  const [i, n] = re(
    /** @type {PlayerModes | undefined} */
    void 0
  ), e = a ? sr.FLOATING_PIP : void 0, t = i || e, r = W(() => ({ mode: t, modeState: i, setMode: n }), [t, i, n]);
  return /* @__PURE__ */ V.jsx(tu.Provider, { value: r, children: o });
};
gs.propTypes = { children: N.node.isRequired, isController: N.bool };
gs.defaultProps = { isController: !1 };
const ru = Xe({}), nu = () => Ze(ru), au = ({ children: o }) => {
  const [a, i] = re({ colorPrimary: "#FEC82E", colorSecondary: "rgba(0, 0, 0, 0)", penWidth: "2" }), [n, e] = re(!1), [t, r] = re("pen"), { mode: s, setMode: c } = ki(), l = q((b) => {
    c(b ? sr.DRAW : void 0);
  }, [c]), u = s === sr.DRAW, d = q((b) => {
    i((h) => ({ ...h, colorPrimary: b }));
  }, []), f = q((b) => {
    i((h) => ({ ...h, colorSecondary: b }));
  }, []), p = q((b) => {
    i((h) => ({ ...h, penWidth: b }));
  }, []);
  Q(() => {
    s === sr.DRAW && !n && l(!1);
  }, [n, s, l]);
  const m = W(() => ({ config: a, isDrawEnabled: n, setPrimaryColor: d, setSecondaryColor: f, setIsDrawEnabled: e, setPenWidth: p, setShowCanvas: l, showCanvas: u, drawMode: t, setDrawMode: r }), [a, n, d, f, e, p, l, u, t, r]);
  return /* @__PURE__ */ V.jsx(ru.Provider, { value: m, children: o });
};
au.propTypes = { children: N.node.isRequired };
const iu = { PORTRAIT: { width: 1080, height: 1920 }, LANDSCAPE: { width: 1920, height: 1080 } }, Ra = (o) => o === 0 ? "main" : `pip${o}`, Ia = (o, a, i, n = 10) => {
  const e = [], t = a > i ? a : i;
  for (let r = 0; r < a; r += 1)
    for (let s = 0; s < i; s += 1) {
      let c = s * (o.width / t), l = r * (o.height / t);
      const u = o.width / t, d = o.height / t;
      i * u < o.width && (c += (o.width - i * u) / 2), a * d < o.height && (l += (o.height - a * d) / 2), e.push({ x: c, y: l, width: u - n, height: d - n, hotkeySwitch: { up: r !== 0 ? Ra((r - 1) * i + s) : void 0, down: r !== a - 1 ? Ra((r + 1) * i + s) : void 0, left: s !== 0 ? Ra(r * i + s - 1) : void 0, right: s !== i - 1 ? Ra(r * i + s + 1) : void 0 } });
    }
  return e;
}, Ep = (o, a) => ({ width: Math.floor(o * (1 / 4)), height: Math.floor(a * (1 / 4)) }), na = (o, a) => ({
  horizontal: Math.floor(o * (5 / 100)),
  // 5% of the width (approx 96px on 1920px)
  vertical: Math.floor(a * (5 / 100))
  // 5% of the height (approx 54px on 1080px)
}), Ap = (o, a, i, n) => ({ x: na(i, n).horizontal, y: n - a - na(i, n).vertical }), Lp = (o, a, i, n) => ({ x: i - o - na(i, n).horizontal, y: n - a - na(i, n).vertical }), Op = (o) => {
  const { width: a, height: i } = o, n = Ep(a, i), e = Ap(n.width, n.height, a, i), t = Lp(n.width, n.height, a, i), r = (i - 5 * (i * 0.2)) / 5;
  return { DEFAULT_MODE: { autoFill: !1, automaticSwitchAllowed: !0, layers: [{ x: 0, y: 0, width: a, height: i, hotkeySwitch: { down: "pip1", left: "pip1", right: "pip2" } }, { ...e, ...n, hotkeySwitch: { up: "main", right: "pip2" } }, { ...t, ...n, hotkeySwitch: { up: "main", left: "pip1" } }] }, HALF_RATIO: { autoFill: !1, automaticSwitchAllowed: !0, layers: [{ x: 0, y: (i - (i / 2 - 10)) / 2, width: a / 2 - 10, height: i / 2 - 10, hotkeySwitch: { right: "pip1" } }, { x: a - (a / 2 - 10), y: (i - (i / 2 - 10)) / 2, width: a / 2 - 10, height: i / 2 - 10, hotkeySwitch: { left: "main" } }] }, HALF_THIRD_THIRD: { autoFill: !1, automaticSwitchAllowed: !0, layers: [{ x: 0, y: 0, width: a / 2 - 10, height: i, hotkeySwitch: { right: "pip1", down: "pip2", up: "pip1" } }, { x: a - (a / 2 - 10), y: 0, width: a / 2 - 10, height: i / 2 - 10, hotkeySwitch: { down: "pip2", left: "main" } }, { x: a - (a / 2 - 10), y: i - (i / 2 - 10), width: a / 2 - 10, height: i / 2 - 10, hotkeySwitch: { left: "main", up: "pip1" } }] }, CENTER_ALL_BOTTOM: { autoFill: !1, automaticSwitchAllowed: !0, layers: [{ x: (a - a * 0.75) / 2, y: 0, width: a * 0.75, height: i * 0.75, hotkeySwitch: { down: "pip3", left: "pip1", right: "pip5" } }, { x: 0, y: i * 0.75 + 10, width: a / 5 - 10, height: i / 5 - 10, hotkeySwitch: { right: "pip2", up: "main" } }, { x: a - 4 * (a * 0.2), y: i * 0.75 + 10, width: a / 5 - 10, height: i / 5 - 10, hotkeySwitch: { left: "pip1", right: "pip3", up: "main" } }, { x: a - 3 * (a * 0.2), y: i * 0.75 + 10, width: a / 5 - 10, height: i / 5 - 10, hotkeySwitch: { left: "pip2", right: "pip4", up: "main" } }, { x: a - 2 * (a * 0.2), y: i * 0.75 + 10, width: a / 5 - 10, height: i / 5 - 10, hotkeySwitch: { left: "pip3", right: "pip5", up: "main" } }, { x: a - 1 * (a * 0.2), y: i * 0.75 + 10, width: a / 5 - 10, height: i / 5 - 10, hotkeySwitch: { left: "pip4", up: "main" } }] }, CENTER_ALL_RIGHT: { autoFill: !1, automaticSwitchAllowed: !0, layers: [{ x: 0, y: (i - (i * 0.75 - 10)) / 2, width: a * 0.75 - 10, height: i * 0.75 - 10, hotkeySwitch: { down: "pip4", right: "pip1", up: "pip1" } }, { x: a * 0.75, y: r, width: a * 0.2, height: i * 0.2, hotkeySwitch: { down: "pip2", left: "main" } }, { x: a * 0.75, y: i - 4 * (i * 0.2) - 4 * r, width: a * 0.2, height: i * 0.2, hotkeySwitch: { down: "pip3", left: "main", up: "pip1" } }, { x: a * 0.75, y: i - 3 * (i * 0.2) - 3 * r, width: a * 0.2, height: i * 0.2, hotkeySwitch: { down: "pip4", left: "main", up: "pip2" } }, { x: a * 0.75, y: i - 2 * (i * 0.2) - 2 * r, width: a * 0.2, height: i * 0.2, hotkeySwitch: { down: "pip5", left: "main", up: "pip3" } }, { x: a * 0.75, y: i - 1 * (i * 0.2) - r, width: a * 0.2, height: i * 0.2, hotkeySwitch: { left: "main", up: "pip4" } }] }, MOSAIC_QUAD: { autoFill: !0, automaticSwitchAllowed: !0, layers: Ia(o, 2, 2) }, MOSAIC_SIX: { autoFill: !0, automaticSwitchAllowed: !1, layers: Ia(o, 2, 3) }, MOSAIC_TWELVE: { autoFill: !0, automaticSwitchAllowed: !1, layers: Ia(o, 3, 4) }, MOSAIC_SIXTEEN: { autoFill: !0, automaticSwitchAllowed: !1, layers: Ia(o, 4, 4) }, FULL_CANVAS: { autoFill: !1, automaticSwitchAllowed: !0, layers: [{ x: 0, y: 0, width: a, height: i }] } };
}, Tn = "DEFAULT_MODE", su = Xe(), ou = () => Ze(su), ys = ({ children: o }) => {
  const [a, i] = re(Tn), n = W(() => ({ displayMode: a, setDisplayMode: i }), [a, i]);
  return /* @__PURE__ */ V.jsx(su.Provider, { value: n, children: o });
};
ys.propTypes = { children: N.node };
ys.defaultProps = { children: void 0 };
const cu = Xe(
  /** @type {ISoupContext | undefined} */
  void 0
), Bn = () => {
  const o = Ze(cu);
  if (!o)
    throw new Error("useSoup must be used within a Soup");
  return o;
}, uu = Xe(
  /** @type {IMixingContext | undefined} */
  void 0
), lr = () => {
  const o = Ze(uu);
  if (!o)
    throw new Error("useMixing must be used within a MixingProvider");
  return o;
}, eo = "MIXING_CONNECTING_STATE_CONNECTED", Ni = "MIXING_CONNECTING_STATE_DISCONNECTED", Mp = "MIXING_CONNECTING_STATE_PENDING", du = ({ children: o, hashtag: a }) => {
  const { isController: i, getConnectionConfig: n, roomId: e, user: t } = $n(), { join: r, soupSession: s } = Bn(), { setIsDrawEnabled: c } = nu(), [l, u] = re(
    /** @type {ChannelMixerStatus | undefined} */
    void 0
  ), [d, f] = re(Ni), [p, m] = re("main"), b = d === eo, { handleCMSEvents: h } = Nn(), { setDisplayMode: g } = ou(), { handleCMSEvents: w } = zc(), _ = q(async (H) => {
    try {
      console.log("[joinMixing]"), f(Mp);
      const ue = await n();
      if (H() || (await Yl(ue), H()) || (await Xl(a), H())) return;
      f(eo);
    } catch {
      f(Ni);
    }
  }, [n, a]), y = q(async () => {
    f(Ni), console.log("[leaveMixing]"), await Wl();
  }, []);
  Q(() => {
    if (s) {
      let H = !1;
      return _(() => H), () => {
        H = !0, y();
      };
    }
  }, [s, _, y]);
  const C = q(
    /** @type {IMixingContext['clearLayer']} */
    async (H = null) => (console.log("clearLayer", a, H ?? p), Zl(a, H ?? p)),
    [a, p]
  ), S = q(
    /** @type {IMixingContext['setSource']} */
    async (H, ue = null) => (console.log("setSource", a, H, ue ?? p), Ql(a, H, ue ?? p)),
    [a, p]
  ), P = q(async (H) => (console.log("setDrawing", a, { drawing: H }), rp(a, H)), [a]), T = q(async () => (console.log("clearDrawing", a), np(a)), [a]), I = q(async () => (console.log("clearAllDrawings", a), ap(a)), [a]), k = q(async (H) => (console.log("toggleDrawings", a, H), ip(a, H)), [a]), x = q(async (H) => (console.log("toggleDrawingsBackground", a, H), sp(a, H)), [a]), O = q(async (H) => (console.log("keyConfig", { hashtag: a, config: H }), op(a, H)), [a]), D = q(async (H, ue) => (console.log("setSourceMuted", a, H, ue), dp(a, H, ue)), [a]), A = q(async (H, ue) => (console.log("setSourceVolume", a, H, ue), lp(a, H, ue)), [a]), E = q(async (H, ue) => (console.log("setSourceTimecodes", a, H, ue), pp(a, H, ue)), [a]), F = q(async (H, ue) => (console.log("setSourceProgresstime", a, H, ue), hp(a, H, ue)), [a]), B = q(async (H, ue) => (console.log("setSourceSpeed", a, H, ue), fp(a, H, ue)), [a]), $ = q(async (H) => (console.log("notifyTogglePlayPauseVideoSource", { hashtag: a, source: H }), cp(a, H)), [a]), M = q(async (H) => (console.log("notifyToggleLoopVideoSource", { hashtag: a, source: H }), up(a, H)), [a]), j = q(async ({ x: H, y: ue, pipLayer: Ve, width: Tt, height: It }) => (console.log("setPiPPosition", { hashtag: a, x: H, y: ue, pipLayer: Ve, width: Tt, height: It }), mp(a, H, ue, Ve, Tt, It)), [a]), z = q(async (H) => (console.log("notifyModeChange", { hashtag: a, mode: H }), vp(a, H)), [a]), te = q(async (H) => (console.log("notifyAutomaticSwitchChange", { hashtag: a, isEnabled: H }), gp(a, H)), [a]), ee = q(async (H) => (console.log("notifyCrop", { hashtag: a, rect: H }), yp(a, H)), [a]), Y = q(async (H) => (console.log("notifyDrawNickname", { hashtag: a, isEnabled: H }), bp(a, H)), [a]), Z = q(async (H) => (console.log("notifyPipMode", { hashtag: a, mode: H }), _p(a, H)), [a]), ae = q(async (H) => (console.log("updateGfx", { hashtag: a, gfx: H }), wp(a, H)), [a]), oe = q(async (H) => (console.log("updateText", { hashtag: a, text: H }), Sp(a, H)), [a]), ce = q(async (H) => (console.log("notifySceneApply", { hashtag: a, scene: H }), Cp(a, H)), [a]), ke = q(async (H) => (console.log("notifyAutomaticFillChange", { hashtag: a, isEnabled: H }), kp(a, H)), [a]), Oe = q(async ({ showLogo: H, showQrCode: ue, customLogoAsset: Ve, customQrCodeAsset: Tt, forcedPositions: It, isLogoFormatForced: Ct }) => (console.log("notifyCanvasLogoChange", { hashtag: a, showLogo: H, showQrCode: ue, customLogoAsset: Ve, customQrCodeAsset: Tt, forcedPositions: It, isLogoFormatForced: Ct }), xp(a, { showLogo: H, showQrCode: ue, customLogoAsset: Ve, customQrCodeAsset: Tt, forcedPositions: It, isLogoFormatForced: Ct })), [a]), nt = q(async (H) => (console.log("notifySourcesShapeChange", { hashtag: a, sourceShape: H }), Rp(a, H)), [a]), et = q(async (H) => (console.log("notifySourceParticipantOffersChange", { hashtag: a, sources: H }), Ip(a, H)), [a]), Fe = q(async (H, ue) => (console.log("setSourceFilters", a, H, ue), Pp(a, H, ue)), [a]), $e = q(async (H, ue) => (console.log("onHostMuteParticipantCam", { hashtag: a, sourceId: H, isMuted: ue }), Tp(a, H, ue)), [a]), at = q(
    /**
    * @param {number} durationInMinutes
    * @returns {Promise<void>}
    */
    async (H) => (console.log("startRecording", { hashtag: a, durationInMinutes: H }), Jl(a, H)),
    [a]
  ), vt = q(
    /**
    * @returns {Promise<void>}
    */
    async () => (console.log("stopRecording", { hashtag: a }), ep(a)),
    [a]
  ), { sources: gt } = en(), it = q(() => {
    b && et(gt.map((H) => ({ configId: H.configId, computerId: pt(), devices: H.devices.map((ue) => ({ deviceId: ue.deviceId, disabled: ue.disabled, label: ue.label, kind: ue.kind })), id: H.id, label: H.label, subType: H.subType, user: { avatar: t.picture, nickname: t.preferred_username, userId: t.sub } })));
  }, [b, et, gt, t.picture, t.preferred_username, t.sub]);
  Q(() => {
    it();
  }, [it]);
  const Ie = ne(it);
  Ie.current = it, Q(() => {
    if (b) {
      const H = Js((ue) => {
        ue.initial && (console.log("INITIAL"), Ie.current());
      });
      return () => {
        H();
      };
    }
  }, [b]), Q(() => {
    if (b) {
      const H = Js((ue) => {
        console.log("onEventStatus", ue), u(ue);
        const Ve = ue.allowedUserToDraw === t.sub || ue.allowedUserToDraw === "all";
        c(i || Ve), h(ue), w(ue), ue.displayMode && g(ue.displayMode);
      });
      return tp(a), () => {
        u(void 0), H();
      };
    }
  }, [i, h, w, a, b, c, t, g]);
  const ut = W(() => (l == null ? void 0 : l.sources) || [], [l == null ? void 0 : l.sources]);
  Q(() => {
    const H = ut.filter((Ve) => "roomId" in Ve).filter((Ve) => Ve.roomId !== e);
    if (H.length < 1)
      return;
    const ue = Array.from(new Set(H.map((Ve) => Ve.roomId)));
    r(ue);
  }, [e, ut, r]);
  const qe = W(() => ({ channelMixerStatus: l, clearLayer: C, connectingState: d, isConnected: b, layer: p, setLayer: m, setSource: S, setSourceMuted: D, setSourceVolume: A, setSourceTimecodes: E, setSourceSpeed: B, setSourceProgresstime: F, notifyNewDrawing: P, notifyClearDrawing: T, notifyClearAllDrawings: I, notifyDrawNickname: Y, notifyKeyConfig: O, notifyToggleDrawings: k, notifyToggleDrawingsBackground: x, changePiPPosition: j, notifyModeChange: z, notifyAutomaticSwitchChange: te, notifyCrop: ee, notifyPipMode: Z, notifyTogglePlayPauseVideoSource: $, notifyToggleLoopVideoSource: M, updateGfx: ae, updateText: oe, notifySceneApply: ce, notifyAutomaticFillChange: ke, notifyCanvasLogoChange: Oe, notifyHostMuteParticipantCam: $e, notifySourcesShapeChange: nt, setSourceFilters: Fe, notifySourceParticipantOffersChange: et, startRecording: at, stopRecording: vt }), [l, C, d, b, p, m, S, D, A, E, B, F, P, T, I, Y, O, k, x, j, z, te, ee, Z, $, M, ae, oe, ce, ke, Oe, $e, nt, Fe, et, at, vt]);
  return /* @__PURE__ */ V.jsx(uu.Provider, { value: qe, children: o });
};
du.propTypes = { children: N.node.isRequired, hashtag: N.string.isRequired };
const Vr = { width: 1280, height: 720 }, jp = 150, xr = [];
let ht = { x: 0, y: 0 };
const Np = (o, a) => Math.sqrt((a.x - o.x) ** 2 + (a.y - o.y) ** 2), bs = ({ size: o }) => {
  const a = ne(null), [i, n] = re(void 0), { notifyNewDrawing: e } = lr(), { config: t, drawMode: r } = nu(), [s, c] = re(!1), [l, u] = re(void 0), [d, f] = re(void 0);
  return Q(() => {
    const p = a.current, m = p == null ? void 0 : p.getContext("2d");
    let b;
    Pt && (b = p == null ? void 0 : p.getBoundingClientRect());
    const h = Vr.width / o.width, g = Vr.height / o.height, w = setInterval(() => {
      xr.length > 0 && (e({ instructions: xr, config: t, size: Vr }), xr.splice(0, xr.length)), !s && (l && (e({ instructions: [{ type: "rect", data: l }], config: t, size: Vr }), u(void 0)), d && (e({ instructions: [{ type: "circle", data: d }], config: t, size: Vr }), f(void 0)));
    }, jp), _ = (k) => {
      m.clearRect(0, 0, p.width, p.height), m.strokeRect(ht.x, ht.y, k.x - ht.x, k.y - ht.y), m.fillRect(ht.x, ht.y, k.x - ht.x, k.y - ht.y), u({ x: ht.x, y: ht.y, width: k.x - ht.x, height: k.y - ht.y });
    }, y = (k) => {
      m.lineTo(k.x, k.y), m.stroke(), xr.push({ type: "lineTo", data: { x: k.x, y: k.y } });
    }, C = (k) => {
      const x = Np(ht, k) / 2, O = ht.x + (k.x - ht.x) / 2, D = ht.y + (k.y - ht.y) / 2;
      m.beginPath(), m.clearRect(0, 0, p.width, p.height), m.arc(O, D, x + 1, 0, 2 * Math.PI), m.closePath(), m.stroke(), m.beginPath(), m.arc(O, D, x, 0, 2 * Math.PI), m.closePath(), m.fill(), f({ x: O, y: D, radius: x });
    }, S = (k) => {
      xr.push({ type: "eraser", data: { x: k.x, y: k.y } });
    }, P = () => {
      c(!1), n(setTimeout(() => {
        m.clearRect(0, 0, 1280, 720);
      }, 2e3));
    }, T = (k) => {
      Pt && (k.offsetX = k.touches[0].clientX - b.left, k.offsetY = k.touches[0].clientY - b.top);
      const x = { x: k.offsetX * h, y: k.offsetY * g };
      switch (clearTimeout && (clearInterval(i), n(void 0)), c(!0), m.lineWidth = t.penWidth, m.strokeStyle = t.colorPrimary, m.fillStyle = t.colorSecondary, r) {
        case "pen":
          m.beginPath(), m.moveTo(x.x, x.y), xr.push({ type: "moveTo", data: { x: x.x, y: x.y } });
          break;
        case "shape.rect":
          ht = x;
          break;
        case "shape.circle":
          ht = x;
          break;
        case "eraser":
          m.beginPath(), m.moveTo(x.x, x.y), xr.push({ type: "eraser.moveTo", data: { x: x.x, y: x.y } });
          break;
      }
    }, I = (k) => {
      Pt && (k.preventDefault(), k.offsetX = k.touches[0].clientX - b.left, k.offsetY = k.touches[0].clientY - b.top);
      const x = { x: k.offsetX * h, y: k.offsetY * g };
      if (s)
        switch (r) {
          case "pen":
            y(x);
            break;
          case "shape.rect":
            _(x);
            break;
          case "shape.circle":
            C(x);
            break;
          case "eraser":
            S(x);
            break;
        }
    };
    return m && (Pt ? (p.addEventListener("touchmove", I), document.addEventListener("touchend", P), p.addEventListener("touchstart", T)) : (p.addEventListener("mousemove", I), document.addEventListener("mouseup", P), p.addEventListener("mousedown", T))), () => {
      clearInterval(w), p && (Pt ? (p.removeEventListener("touchmove", I), document.removeEventListener("touchend", P), p.removeEventListener("mousedown", T)) : (p.removeEventListener("mousemove", I), document.removeEventListener("mouseup", P), p.removeEventListener("mousedown", T)));
    };
  }, [i, s, e, t, o, r, l, d]), /* @__PURE__ */ V.jsx("canvas", { style: { cursor: "crosshair", height: o.height, width: o.width, left: o.left, zIndex: 11 }, width: Vr.width, height: Vr.height, className: "PlayerCanvas position-absolute", ref: a });
};
bs.propTypes = { size: N.shape({ width: N.number, height: N.number, top: N.number, left: N.number }) };
bs.defaultProps = { size: { width: 0, height: 0 } };
const lu = Xe({}), Fp = () => Ze(lu), pu = ({ children: o }) => {
  const a = ne(
    /** @type {HTMLVideoElement|undefined} */
    void 0
  ), i = q(async () => {
    if (!a.current) throw new Error("PlayerScreenshotProvider: playerRef.current is not defined");
    const { canvas: t, context: r } = ra({ offscreen: !0, width: a.current.videoWidth, height: a.current.videoHeight });
    r.drawImage(a.current, 0, 0, t.width, t.height);
    const s = await Gd(t, { type: "image/png" });
    if (!s)
      throw new Error("Screenshot failed");
    const c = URL.createObjectURL(s), l = new Image();
    return l.src = c, { file: new File([s], "filename"), blob: s, filename: l.src, width: t.width, height: t.height, label: "Screenshot studio" };
  }, []), n = q(
    /**
    * @param {HTMLVideoElement} ref
    * @returns {void}
    */
    (t) => {
      a.current = t;
    },
    []
  ), e = W(() => ({ screenShot: i, setPlayerRef: n }), [i, n]);
  return /* @__PURE__ */ V.jsx(lu.Provider, { value: e, children: o });
};
pu.propTypes = { children: N.node.isRequired };
const On = (o) => {
  const { publications: a } = Bn(), i = o == null ? void 0 : o.deviceIds, n = o == null ? void 0 : o.roomId;
  return W(() => {
    let t = a;
    return n && (t = t.filter((r) => r.roomId === n)), i ? i && i.length < 1 ? [] : t.filter((r) => {
      var s, c;
      return i ? (s = r.appData.device) != null && s.deviceId ? i.includes((c = r.appData.device) == null ? void 0 : c.deviceId) : !1 : !0;
    }) : t;
  }, [i, a, n]);
}, ea = /* @__PURE__ */ new Map(), $p = async (o, a, i, n) => {
  const e = ea.get(i.producerId) || [];
  return e.includes(a) || e.push(a), ea.set(i.producerId, e), o.subscribe(i, n);
}, Fi = async (o, a, i) => {
  const n = ea.get(i.producerId) || [], e = n.indexOf(a);
  if (console.log("unsubscribe", i), e > -1 && n.splice(e, 1), n.length < 1)
    return console.log("REAL unsubscribe", i, a), ea.delete(i.producerId), o.unsubscribe(i);
  console.log("FALSE unsubscribe", i, a), ea.set(i.producerId, n);
}, Bp = (o) => {
  const a = ne(
    /** @type {SubscriptionRequest[] | undefined} */
    void 0
  );
  return W(() => o === a.current ? o : !a.current || !o || a.current.length !== o.length ? (a.current = o, o) : (JSON.stringify(a.current) === JSON.stringify(o) || (a.current = o), a.current), [o]);
}, Vp = (o) => {
  const a = fd(), { soupSession: i } = Bn(), [n, e] = re(
    /** @type {Subscription[]} */
    []
  ), t = ne(i);
  t.current = i;
  const r = ne(n);
  r.current = n;
  const s = Bp(o), c = ne(s);
  c.current = s, Q(() => {
    if (!i) {
      e((_) => _.length < 1 ? _ : []);
      return;
    }
    const u = (_) => c.current.some((y) => y.publication.producerId === _.producerId), d = (_) => r.current.some((y) => y.producerId === _.producerId), f = s.filter((_) => !r.current.find((C) => C.producerId === _.publication.producerId)), p = r.current.filter((_) => !s.find((C) => _.producerId === C.publication.producerId));
    console.log({ immutableSubscriptionRequests: s, newSubscriptionRequests: f, oldSubscriptions: p, "subscriptionsRef.current": r.current }), p.forEach((_) => {
      Fi(i, a, _), e((y) => y.filter((C) => C.producerId !== _.producerId));
    });
    const m = (_) => {
      u(_) && (console.log({ onTrackSubscribed: _, immutableSubscriptionRequests: s }), e((y) => y.findIndex((S) => S.producerId === _.producerId) < 0 ? [...y, _] : y));
    }, b = ({ roomId: _ }) => {
      console.log({ newSubscriptionRequests: f, roomId: _, reactId: a }), Promise.all(f.filter((y) => y.publication.roomId === _).map((y) => (console.log({ SUBSCRIBE: y }), $p(i, a, y.publication, y.preferredLayers)))).then((y) => y.filter((C) => !!C).forEach((C) => {
        u(C) ? (console.log("onSoupConnected", { sub: C, roomId: _, reactId: a }), m(C)) : Fi(i, a, C);
      }));
    }, h = ({ roomId: _ }) => {
      e((y) => y.length < 1 ? y : y.filter((C) => C.roomId !== _));
    }, g = (_) => {
      d(_) && (console.log({ onTrackUnsubscribed: _ }), e((y) => y.filter((C) => C.producerId !== _.producerId)));
    }, w = (_) => {
      d(_) && (console.log({ onTrackUpdated: _ }), e((y) => y.map((C) => C.producerId === _.producerId ? { ...C, appData: { ...C.appData, ..._.appData } } : C)));
    };
    return i.on("trackSubscribed", m), i.on("trackUnsubscribed", g), i.on("trackUpdated", w), i.on("soup:connected", b), i.on("soup:disconnected", h), i.soupServers.forEach((_) => {
      _.status === "connected" && b({ roomId: _.roomId });
    }), function() {
      i.off("trackSubscribed", m), i.off("trackUnsubscribed", g), i.off("trackUpdated", w), i.off("soup:connected", b), i.off("soup:disconnected", h);
    };
  }, [a, i, s]);
  const l = ne(a);
  return l.current = a, Q(() => () => {
    if (!t.current) return;
    const u = t.current;
    setTimeout(() => {
      r.current.forEach((d) => {
        Fi(u, l.current, d);
      });
    }, 0);
  }, []), n;
}, Up = (o) => {
  const a = ne(
    /** @type {MediaStream | undefined} */
    void 0
  );
  return W(() => {
    const n = o.map(({ mediaStreamTrack: t }) => t);
    if (!a.current)
      return a.current = new MediaStream(n), a.current;
    const e = a.current.getTracks();
    return e.find((t) => !n.find((r) => r.id === t.id)) ? (a.current = new MediaStream(n), a.current) : (n.find((t) => !e.find((r) => r.id === t.id)) && (a.current = new MediaStream(n)), a.current);
  }, [o]);
}, xi = (o) => {
  const a = Vp(o);
  console.log({ subscriptions: a });
  const i = Up(a);
  return console.log({ mediastream: i }), i;
}, zp = (o) => !!o.appData.talkback, Gp = (o) => {
  const a = On({ roomId: o });
  return W(() => a.filter((i) => zp(i)), [a]);
}, _s = () => {
  const { roomId: o, user: a } = $n(), i = Gp(o), n = W(() => (i || []).filter(({ appData: t }) => {
    var r, s;
    return t.computerId !== pt() && ((s = (r = t.talkback) == null ? void 0 : r.receiverUserIds) == null ? void 0 : s.includes(a.sub));
  }), [i, a]), e = W(() => (i || []).filter(({ appData: t }) => t.computerId === pt()), [i]);
  return W(() => ({ talkbackReceivingSources: n, talkbackSendingSources: e }), [n, e]);
}, ny = () => {
  const { configId: o, isDisconnecting: a, recipientUsers: i, startTalkbacks: n, stopAllTalkbacks: e, stopTalkbacks: t, userAudioRequestError: r } = vs();
  return W(() => ({ configId: o, isDisconnecting: a, recipientUsers: i, startTalkbacks: n, stopAllTalkbacks: e, stopTalkbacks: t, userAudioRequestError: r }), [o, a, i, n, e, t, r]);
}, nn = { READY: "READY", CONNECTING: "CONNECTING", CONNECTED: "CONNECTED", DISCONNECTING: "DISCONNECTING" }, ay = () => {
  const { isDisconnecting: o, recipientUsers: a } = vs(), { talkbackSendingSources: i, talkbackReceivingSources: n } = _s(), e = a.length > 0, t = i.length > 0, r = e && !t, s = q(() => o ? nn.DISCONNECTING : r ? nn.CONNECTING : t ? nn.CONNECTED : nn.READY, [r, t, o]), c = q(() => n.length > 0 ? nn.CONNECTED : nn.READY, [n]);
  return W(() => ({ receiverStatus: c(), senderStatus: s() }), [c, s]);
}, fu = Xe(
  /** @type {ILiveVolumeContext | undefined} */
  void 0
), qp = () => {
  const o = Ze(fu);
  if (!o)
    throw new Error("usePlayerLiveVolume must be used within a PlayerLiveVolumeProvider");
  return o;
}, Kp = ({ children: o }) => {
  const [a, i] = re(!1), { talkbackReceivingSources: n } = _s(), e = n.length > 0, t = W(() => ({ isDisabled: e, isMuted: a || e, setIsMuted: i }), [a, e, i]);
  return /* @__PURE__ */ V.jsx(fu.Provider, { value: t, children: o });
}, { MediaStream: Hp } = window, ws = hd(function({ className: a, src: i, isFullscreen: n }, e) {
  const { setPlayerRef: t } = Fp(), { isMuted: r } = qp();
  return ta(() => {
    e.current && (e.current.srcObject = i, t(e.current));
  }, [i, e, t]), Q(() => {
    e.current && (e.current.muted = r);
  }, [r, e]), /* @__PURE__ */ V.jsx("div", { className: St("PlayerCustom d-flex position-relative overflow-hidden", { "PlayerCustom--isFullscreen": !!n, "h-100 w-100": !n }, a), children: /* @__PURE__ */ V.jsx("div", { className: "d-flex w-100 mw-100 mh-100 overflow-hidden", children: /* @__PURE__ */ V.jsx("video", { autoPlay: !0, playsInline: !0, className: "PlayerCustom_video w-100 h-100 mw-100 mh-100", ref: e }) }) });
});
ws.propTypes = { className: N.string, src: N.instanceOf(Hp), isFullscreen: N.bool };
ws.defaultProps = { className: "", src: null, isFullscreen: !1 };
const hu = Xe(
  /** @type {IPiPContext} */
  {}
), Yp = () => Ze(hu), mu = ({ children: o }) => {
  const { mode: a } = ki(), [i, n] = re(!0), e = !a || a === sr.FLOATING_PIP, t = q(() => {
    n((s) => !s);
  }, [n]), r = W(() => ({ toggleRatio: t, keepRatio: i, floatingPiPEnabled: e }), [t, i, e]);
  return /* @__PURE__ */ V.jsx(hu.Provider, { value: r, children: o });
};
mu.propTypes = { children: N.node.isRequired };
const vu = (o, a) => {
  const { width: i, height: n } = a.canvas;
  a.clearRect(0, 0, i, n);
  const e = { horizontal: 1, vertical: 1 };
  let t = o.text;
  const r = 0, s = 0, c = 15 * e.vertical;
  a.font = `${o.fontSize * e.vertical}px ${o.font}`;
  const l = { width: 0, height: 0, x: r, y: s }, u = [];
  o.text.split(`
`).forEach((f, p) => {
    let m = f;
    const b = parseInt(a.font, 10);
    let h = a.measureText(f).width;
    for (; h > i; )
      m = m.slice(0, -1), h = a.measureText(m).width;
    m !== f && (t = o.text.replace(f, m), h = a.measureText(m).width), l.width < h && (l.width = h), l.height + b <= n && (l.height += b / 2 + c);
  });
  let d = 0;
  t.split(`
`).forEach((f, p) => {
    const m = a.measureText(f).width, b = parseInt(a.font, 10);
    p === 0 && (l.x = r + i / 2 - l.width / 2, l.y = s + n / 2 - l.height / 2);
    const h = d !== 0 ? d + b / 2 + c : l.y + l.height / t.split(`
`).length;
    d = h, h <= s + n && m < i && u.push({ line: f, x: l.x, y: h });
  }), a.fillStyle = o.backgroundColor, a.globalAlpha = 1 - o.backgroundTransparency, a.fillRect(r, s, i, n), a.globalAlpha = 1, a.fillStyle = o.fontColor, u.forEach((f) => {
    a.fillText(f.line, f.x, f.y);
  });
}, Wp = (o, a) => (o.x < o.width / 2 * -1 && (o.x = o.width / 2 * -1), o.x > a.width - o.width / 2 && (o.x = a.width - o.width / 2), o.y < o.height / 2 * -1 && (o.y = o.height / 2 * -1), o.y > a.height - o.height / 2 && (o.y = a.height - o.height / 2), o), Ss = ({ isGfxInEdition: o, onMovingPiP: a, onUpdatePiP: i, orientation: n, pip: e, size: t }) => {
  var w;
  const { keepRatio: r } = Yp(), s = ne(
    /** @type {HTMLDivElement?} */
    null
  ), c = ne(
    /** @type {HTMLCanvasElement?} */
    null
  ), l = ne(
    /** @type {HTMLVideoElement?} */
    null
  ), u = (e == null ? void 0 : e.type) !== "text" && (((w = e == null ? void 0 : e.asset) == null ? void 0 : w.filename) || "").startsWith("blob:"), d = iu[n], f = W(() => ({ horizontal: t.width / d.width || 1, vertical: t.height / d.height || 1 }), [d, t]), p = W(() => {
    const { properties: _ } = e;
    return { x: _.x * f.horizontal, y: _.y * f.vertical, width: _.width * f.horizontal, height: _.height * f.vertical };
  }, [e, f]), m = q((_) => {
    const { properties: y } = e, C = Wp({ x: _.x ? Math.round(_.x / f.horizontal) : y.x, y: _.y ? Math.round(_.y / f.vertical) : y.y, width: _.width ? Math.round(_.width / f.horizontal) : y.width, height: _.height ? Math.round(_.height / f.vertical) : y.height }, d);
    i(C);
  }, [d, i, e, f.horizontal, f.vertical]), b = q((_, y) => {
    a(!1), m(y);
  }, [a, m]), h = q((_, y, C, S, P) => {
    m({ width: C.offsetWidth, height: C.offsetHeight, x: P.x, y: P.y });
  }, [m]), g = q((_, y, C, S, P) => {
    a(!1), o || h(_, y, C, S, P);
  }, [h, o, a]);
  return Q(() => {
    if (o && e.type === "text" && c.current) {
      c.current.width = e.properties.width, c.current.height = e.properties.height;
      const _ = c.current.getContext("2d");
      if (!_) return;
      vu(e.asset, _);
    }
  }, [o, e]), /* @__PURE__ */ V.jsx(yd, { default: { x: p.x, y: p.y, width: p.width, height: p.height }, position: { x: p.x, y: p.y }, size: { width: p.width, height: p.height }, enableResizing: !0, lockAspectRatio: e.type === "text" || e.type === "gfx" ? !1 : r, minWidth: e.properties.minWidth * f.horizontal, minHeight: e.properties.minHeight * f.vertical, maxWidth: e.properties.maxWidth * f.horizontal, maxHeight: e.properties.maxHeight * f.vertical, onDragStart: () => a(!0), onDragStop: b, onResize: o ? h : void 0, onResizeStart: () => a(!0), onResizeStop: g, children: /* @__PURE__ */ V.jsxs("div", { ref: s, className: St("overflow-auto border", o ? "PiPOverlay_gfx" : "PiPOverlay_div"), id: e.id, children: [
    o && e.type === "text" && /* @__PURE__ */ V.jsx("canvas", { className: "position-absolute", ref: c, style: { zIndex: -1, width: "100%", height: "100%" } }),
    o && e.type === "gfx" && /* @__PURE__ */ V.jsx("img", { className: "PiPOverlay_imgPreview w-100 h-100", src: u ? e.asset.filename : Us({ name: e.asset.filename }) }),
    o && e.type === "gfxvideo" && /* @__PURE__ */ V.jsx("video", { onCanPlay: () => {
      l.current && (l.current.currentTime = l.current.duration / 2);
    }, ref: l, className: "w-100 h-100", src: u ? e.asset.filename : Us({ name: e.asset.filename }) })
  ] }) });
};
Ss.propTypes = { isGfxInEdition: N.bool, onMovingPiP: N.func.isRequired, onUpdatePiP: N.func.isRequired, orientation: N.string, size: N.shape({ right: N.number, height: N.number, width: N.number }).isRequired, pip: N.shape({ asset: N.shape({ filename: N.string }), id: N.string, properties: N.shape({ minWidth: N.number, minHeight: N.number, maxWidth: N.number, maxHeight: N.number, x: N.number, y: N.number, width: N.number, height: N.number }), layer: N.string, type: N.string, isGfxInEdition: N.bool }).isRequired };
Ss.defaultProps = { isGfxInEdition: !1, orientation: "LANDSCAPE" };
const gu = Xe({}), Xp = () => Ze(gu), yu = ({ children: o }) => {
  const [a, i] = re(void 0), n = W(() => ({ gfxInEdition: a, setGfxInEdition: i }), [a, i]);
  return /* @__PURE__ */ V.jsx(gu.Provider, { value: n, children: o });
};
yu.propTypes = { children: N.node.isRequired };
const Zp = /(?:pip)(\d+)$/, to = (o) => {
  const a = Zp.exec(o);
  return (a == null ? void 0 : a.length) === 2 ? parseInt(a[1], 10) : null;
}, Cs = ({ safeZoneComponent: o, size: a }) => {
  const { channelMixerStatus: i, changePiPPosition: n } = lr(), { gfxInEdition: e, setGfxInEdition: t } = Xp(), [r, s] = re(!1), c = W(() => ((i == null ? void 0 : i.sources) || []).filter((d) => d.isResizable).sort((d, f) => to(d.layer) < to(f.layer) ? 1 : -1), [i == null ? void 0 : i.sources]), l = !!e, u = q((d, f) => {
    l ? t((p) => ({ ...p, properties: { ...p.properties, ...d } })) : n({ pipLayer: f.layer, ...d });
  }, [n, l, t]);
  return /* @__PURE__ */ V.jsxs("div", { className: "PlayerLivePiPHandler", style: { position: "absolute", left: `${a.left}px`, right: `${a.left || 0}px`, zIndex: 4 }, children: [
    i && (e ? [e] : c).map((d) => {
      var f;
      return /* @__PURE__ */ V.jsx(Ss, { isGfxInEdition: !!e, onMovingPiP: s, onUpdatePiP: (p) => u(p, d), orientation: i.orientation, pip: d, size: a }, d.layer || ((f = d.asset) == null ? void 0 : f._id));
    }),
    r && o && /* @__PURE__ */ V.jsx(o, { playerSize: a })
  ] });
};
Cs.propTypes = { safeZoneComponent: N.elementType, size: N.shape({ width: N.number, height: N.number, left: N.number, right: N.number }) };
Cs.defaultProps = { safeZoneComponent: null, size: {} };
const bu = Xe({}), Qp = () => Ze(bu), _u = ({ children: o }) => {
  const [a, i] = re(!0), { mode: n, setMode: e } = ki(), t = q((l) => {
    e(l ? sr.CROP : void 0);
  }, [e]), r = q(() => {
    i((l) => !l);
  }, []), s = n === sr.CROP, c = W(() => ({ isCropEnabled: s, isCoefficientEnabled: a, toggleCoefficient: r, setIsCropEnabled: t }), [s, a, r, t]);
  return /* @__PURE__ */ V.jsx(bu.Provider, { value: c, children: o });
};
_u.propTypes = { children: N.node.isRequired };
const Rr = { width: 1280, height: 720 }, ro = 100, no = 100 / (16 / 9);
let Bt = { x: 0, y: 0 };
const wu = ({ size: o }) => {
  const { notifyCrop: a, channelMixerStatus: i } = lr(), { setIsCropEnabled: n, isCoefficientEnabled: e } = Qp(), t = ne(null), [r, s] = re(!1), [c, l] = re(void 0), u = W(() => {
    var d, f;
    return { horizontal: o.width / (((d = i == null ? void 0 : i.liveResolution) == null ? void 0 : d.width) || 1), vertical: o.height / (((f = i == null ? void 0 : i.liveResolution) == null ? void 0 : f.height) || 1) };
  }, [o, i == null ? void 0 : i.liveResolution]);
  return Q(() => {
    const d = t.current, f = d == null ? void 0 : d.getContext("2d");
    let p;
    Pt && (p = d == null ? void 0 : d.getBoundingClientRect());
    const m = Rr.width / o.width, b = Rr.height / o.height, h = (C, S) => {
      const P = Bt.x + Math.abs(C) / 2 > Rr.width || Bt.x - Math.abs(C) / 2 < 0, T = Bt.y + Math.abs(S) / 2 > Rr.height || Bt.y - Math.abs(S) / 2 < 0;
      if (e) {
        if (!T && !P)
          return { width: C, height: S };
        if (c)
          return { width: c.width, height: c.height };
      } else if (c)
        return { width: P ? c.width : C, height: T ? c.height : S };
      return { width: 0, height: 0 };
    }, g = (C) => {
      const { width: S, height: P } = h((C.x - Bt.x) / u.horizontal, e ? (C.x - Bt.x) / u.horizontal * 0.5625 : (C.y - Bt.y) / u.vertical);
      f.strokeStyle = "#FEC82E", f.clearRect(0, 0, d.width, d.height), f.strokeRect(C.x - S, Bt.y - P / 2, S, P), l({ x: C.x - S, y: Bt.y - P / 2, width: S, height: P, size: Rr });
    }, w = ({ target: { id: C } }) => {
      f.clearRect(0, 0, d.width, d.height), C === "PlayerCanvasZoom" && (c && c.width > 0 && c.height > 0 ? (s(!1), a(c), n(!1), l(void 0)) : (s(!1), a({ x: Bt.x - ro / 2, y: Bt.y - no / 2, width: ro, height: no, size: Rr }), n(!1), l(void 0)));
    }, _ = (C) => {
      Pt && (C.offsetX = C.touches[0].clientX - p.left, C.offsetY = C.touches[0].clientY - p.top);
      const S = { x: C.offsetX * m, y: C.offsetY * b };
      s(!0), f.lineWidth = 2, Bt = S;
    }, y = (C) => {
      Pt && (C.preventDefault(), C.offsetX = C.touches[0].clientX - p.left, C.offsetY = C.touches[0].clientY - p.top);
      const S = { x: C.offsetX * m, y: C.offsetY * b };
      r && g(S);
    };
    return f && (Pt ? (d.addEventListener("touchmove", y), document.addEventListener("touchend", w), d.addEventListener("touchstart", _)) : (d.addEventListener("mousemove", y), document.addEventListener("mouseup", w), d.addEventListener("mousedown", _))), () => {
      d && (Pt ? (d.removeEventListener("touchmove", y), document.removeEventListener("touchend", w), d.removeEventListener("mousedown", _)) : (d.removeEventListener("mousemove", y), document.removeEventListener("mouseup", w), d.removeEventListener("mousedown", _)));
    };
  }, [r, i == null ? void 0 : i.liveResolution, a, u, o, c, n, e]), /* @__PURE__ */ V.jsx("canvas", { style: { cursor: "crosshair", height: o.height, width: o.width, left: o.left, zIndex: 1 }, width: Rr.width, height: Rr.height, className: "PlayerCanvas position-absolute", ref: t, id: "PlayerCanvasZoom" });
};
wu.propTypes = { size: N.shape({ width: N.number, height: N.number, top: N.number, left: N.number }).isRequired };
const Jp = (o, a, i, n, e, t) => {
  const r = n / e || 1.7777777777777777, s = a / i || 16 / 9, c = { width: 0, height: 0, left: 0, right: 0 };
  return r > s ? (c.width = a, c.height = a / r) : (c.width = i * r, c.height = i), c.left = (a - c.width) * (t / 100), c.right = c.width + c.left, c;
}, ef = (o) => {
  const [a, i] = re({ width: 0, height: 0, left: 0 });
  return Q(() => {
    const n = o.current, e = () => {
      const s = window.getComputedStyle(n).getPropertyValue("object-position").split(" ");
      i(Jp(!0, n.clientWidth, n.clientHeight, n.videoWidth, n.videoHeight, parseInt(s[0], 10)));
    };
    let t, r;
    try {
      t = new ResizeObserver(e);
    } catch {
      console.warn("ResizeObserver not supported, using setInterval instead."), r = setInterval(() => e(), 1500);
    }
    return n && (n.addEventListener("resize", e), t && t.observe(n)), () => {
      n && (n.removeEventListener("resize", e), t && t.unobserve(n)), r && clearInterval(r);
    };
  }, [o]), a;
}, tf = (o) => {
  const { mode: a } = ki();
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    a === sr.DRAW && /* @__PURE__ */ V.jsx(bs, { className: "PlayerLive", ...o }),
    a === sr.CROP && /* @__PURE__ */ V.jsx(wu, { ...o }),
    a === sr.FLOATING_PIP && /* @__PURE__ */ V.jsx(Cs, { ...o })
  ] });
}, rf = (o) => {
  const a = pt(), i = o.find((s) => s.kind === "video" && s.appData.streamType === "live"), n = o.filter((s) => s.kind === "audio" && s.appData.streamType === "live"), e = n.find((s) => !s.appData.peerReceiver), r = n.find((s) => {
    const { appData: c } = s, { peerReceiver: l } = c;
    return l === a;
  }) || e;
  return [i, r].filter((s) => !!s);
}, ks = ({ children: o, className: a, controls: i, handleClickFullScreen: n, isCameraOnMainLayer: e, isFullscreen: t, safeZoneComponent: r }) => {
  const { roomId: s } = $n(), c = ne(), l = ef(c), u = On({ roomId: s }), d = W(() => rf(u), [u]), f = W(() => d.map((m) => ({ publication: m })), [d]), p = xi(f);
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    /* @__PURE__ */ V.jsx(ws, { className: St("PlayerLive", { "camera-on-main-layer": e }, a), src: p, controls: i, handleClickFullScreen: n, isFullscreen: t, ref: c }),
    /* @__PURE__ */ V.jsx(tf, { size: l, safeZoneComponent: r }),
    /* @__PURE__ */ V.jsx("div", { className: "position-absolute", style: { height: l.height, width: l.width }, children: o })
  ] });
};
ks.propTypes = { children: N.node, className: N.string, controls: N.bool, handleClickFullScreen: N.func.isRequired, isCameraOnMainLayer: N.bool, isFullscreen: N.bool, safeZoneComponent: N.elementType };
ks.defaultProps = { children: null, className: "", controls: !0, isCameraOnMainLayer: !1, isFullscreen: !1, safeZoneComponent: null };
const Su = "beeyou.alertTooltipDismissed", nf = () => JSON.parse(localStorage.getItem(Su)) || {}, af = (o) => {
  localStorage.setItem(Su, JSON.stringify(o));
}, sf = Xe(), Cu = ({ children: o }) => {
  const [a, i] = re(() => nf()), [n, e] = re({}), t = q((u) => {
    i((d) => ({ ...d, [u]: !d[u] }));
  }, []), r = q((u) => {
    e((d) => ({ ...d, [u]: !d[u] }));
  }, []), s = q((u, d) => {
    i((f) => ({ ...f, [u]: d }));
  }, []), c = q((u, d) => {
    e((f) => ({ ...f, [u]: d }));
  }, []), l = W(() => ({ alertTooltipsDismissed: a, alertTooltipsIsOpen: n, toggleAlertTooltipDimissedById: t, toggleAlertTooltipIsOpenById: r, updateAlertTooltipDimissedById: s, updateAlertTooltipIsOpenById: c }), [n, a, t, r, s, c]);
  return Q(() => {
    af(a);
  }, [a]), /* @__PURE__ */ V.jsx(sf.Provider, { value: l, children: o });
};
Cu.propTypes = { children: N.node.isRequired };
N.string.isRequired, N.node.isRequired, N.bool;
N.string.isRequired, N.string;
const ku = Xe({}), of = () => Ze(ku), xu = ({ children: o }) => {
  const [a, i] = re(!0), n = W(() => ({ isEnabled: a, setIsEnabled: i }), [a, i]);
  return /* @__PURE__ */ V.jsx(ku.Provider, { value: n, children: o });
};
xu.propTypes = { children: N.node.isRequired };
const Ru = Xe(
  /** @type {ISourcesPropertiesContext} */
  {}
), Iu = () => Ze(Ru), cf = (o) => Iu().findSourcePropertiesBySource(o), Ji = (o) => {
  const a = { id: o.id, type: o.type, properties: {} };
  return o.muted !== void 0 && (a.properties.muted = o.muted), o.volume !== void 0 && (a.properties.volume = o.volume), a;
}, uf = (o = []) => o.map(Ji), ao = (o, a) => o.id === a.id && o.type === a.type, df = ({ children: o }) => {
  const { channelMixerStatus: a } = lr(), [i, n] = re(
    /** @returns {SourceProperties[]} */
    () => uf(a == null ? void 0 : a.sources)
  ), e = q(
    /**
    * @param {ISource} source
    * @returns {SourceProperties | undefined}
    */
    (l) => l ? i.find((u) => ao(u, l)) : void 0,
    [i]
  ), t = q(
    /**
    * @param {ISource[]} newSourcesProperties
    * @returns {void}
    */
    (l) => {
      n((u) => {
        let d = u;
        return l.forEach((f) => {
          const p = d.findIndex((b) => ao(b, f));
          if (p < 0) {
            d = [...d, Ji(f)];
            return;
          }
          const m = d[p];
          d = [...d.slice(0, p), { ...m, properties: { ...m.properties, ...Ji(f).properties } }, ...d.slice(p + 1)];
        }), d;
      });
    },
    []
  ), r = q(
    /**
    * @param {ISource} source
    * @returns {void}
    */
    (l) => t([l]),
    [t]
  ), s = a == null ? void 0 : a.sources;
  Q(() => {
    s && t(s);
  }, [s, t]);
  const c = W(() => ({ findSourcePropertiesBySource: e, sourcesProperties: i, updateSourceProperties: r, updateSourcesProperties: t }), [e, i, r, t]);
  return /* @__PURE__ */ V.jsx(Ru.Provider, { value: c, children: o });
};
function es(o, a) {
  (a == null || a > o.length) && (a = o.length);
  for (var i = 0, n = new Array(a); i < a; i++) n[i] = o[i];
  return n;
}
function xs(o, a) {
  if (o) {
    if (typeof o == "string") return es(o, a);
    var i = Object.prototype.toString.call(o).slice(8, -1);
    return i === "Object" && o.constructor && (i = o.constructor.name), i === "Map" || i === "Set" ? Array.from(o) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? es(o, a) : void 0;
  }
}
function Or(o) {
  return function(i) {
    if (Array.isArray(i)) return es(i);
  }(o) || function(i) {
    if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
  }(o) || xs(o) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Ft(o, a, i) {
  return a in o ? Object.defineProperty(o, a, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : o[a] = i, o;
}
var Ur, zr, Za = 1080, Qa = 720, aa = 480, ia = 360, Ja = 240, Hr = 180, lf = function(a) {
  return a >= Za ? Za : a >= Qa ? Qa : a >= aa ? aa : a >= ia ? ia : a >= Ja ? Ja : Hr;
}, pf = (Ft(Ur = {}, Za, 5e3), Ft(Ur, Qa, 2500), Ft(Ur, aa, 1200), Ft(Ur, ia, 700), Ft(Ur, Ja, 450), Ft(Ur, Hr, 200), Ur), ff = function(a, i) {
  return +a / i;
}, hf = (Ft(zr = {}, Za, [aa, Hr]), Ft(zr, Qa, [ia, Hr]), Ft(zr, aa, [Hr]), Ft(zr, ia, [Hr]), Ft(zr, Ja, []), Ft(zr, Hr, []), zr), mf = function(a) {
  return a === 1 ? 30 : 24;
}, vf = function(a) {
  var i = lf(a);
  return [i].concat(Or(hf[i])).reverse().map(function(n) {
    var e = ff(i, n);
    return { maxBitrate: 1e3 * pf[n], maxFramerate: mf(e), scaleResolutionDownBy: e };
  });
};
function io(o, a) {
  var i = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(o);
    a && (n = n.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function Re(o) {
  for (var a = 1; a < arguments.length; a++) {
    var i = arguments[a] != null ? arguments[a] : {};
    a % 2 ? io(Object(i), !0).forEach(function(n) {
      Ft(o, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(i)) : io(Object(i)).forEach(function(n) {
      Object.defineProperty(o, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return o;
}
function ei(o) {
  return ei = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
    return typeof a;
  } : function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, ei(o);
}
function v() {
  v = function() {
    return o;
  };
  var o = {}, a = Object.prototype, i = a.hasOwnProperty, n = typeof Symbol == "function" ? Symbol : {}, e = n.iterator || "@@iterator", t = n.asyncIterator || "@@asyncIterator", r = n.toStringTag || "@@toStringTag";
  function s(k, x, O) {
    return Object.defineProperty(k, x, { value: O, enumerable: !0, configurable: !0, writable: !0 }), k[x];
  }
  try {
    s({}, "");
  } catch {
    s = function(O, D, A) {
      return O[D] = A;
    };
  }
  function c(k, x, O, D) {
    var A = x && x.prototype instanceof d ? x : d, E = Object.create(A.prototype), F = new P(D || []);
    return E._invoke = /* @__PURE__ */ function(B, $, M) {
      var j = "suspendedStart";
      return function(z, te) {
        if (j === "executing") throw new Error("Generator is already running");
        if (j === "completed") {
          if (z === "throw") throw te;
          return I();
        }
        for (M.method = z, M.arg = te; ; ) {
          var ee = M.delegate;
          if (ee) {
            var Y = y(ee, M);
            if (Y) {
              if (Y === u) continue;
              return Y;
            }
          }
          if (M.method === "next") M.sent = M._sent = M.arg;
          else if (M.method === "throw") {
            if (j === "suspendedStart") throw j = "completed", M.arg;
            M.dispatchException(M.arg);
          } else M.method === "return" && M.abrupt("return", M.arg);
          j = "executing";
          var Z = l(B, $, M);
          if (Z.type === "normal") {
            if (j = M.done ? "completed" : "suspendedYield", Z.arg === u) continue;
            return { value: Z.arg, done: M.done };
          }
          Z.type === "throw" && (j = "completed", M.method = "throw", M.arg = Z.arg);
        }
      };
    }(k, O, F), E;
  }
  function l(k, x, O) {
    try {
      return { type: "normal", arg: k.call(x, O) };
    } catch (D) {
      return { type: "throw", arg: D };
    }
  }
  o.wrap = c;
  var u = {};
  function d() {
  }
  function f() {
  }
  function p() {
  }
  var m = {};
  s(m, e, function() {
    return this;
  });
  var b = Object.getPrototypeOf, h = b && b(b(T([])));
  h && h !== a && i.call(h, e) && (m = h);
  var g = p.prototype = d.prototype = Object.create(m);
  function w(k) {
    ["next", "throw", "return"].forEach(function(x) {
      s(k, x, function(O) {
        return this._invoke(x, O);
      });
    });
  }
  function _(k, x) {
    function O(A, E, F, B) {
      var $ = l(k[A], k, E);
      if ($.type !== "throw") {
        var M = $.arg, j = M.value;
        return j && ei(j) == "object" && i.call(j, "__await") ? x.resolve(j.__await).then(function(z) {
          O("next", z, F, B);
        }, function(z) {
          O("throw", z, F, B);
        }) : x.resolve(j).then(function(z) {
          M.value = z, F(M);
        }, function(z) {
          return O("throw", z, F, B);
        });
      }
      B($.arg);
    }
    var D;
    this._invoke = function(A, E) {
      function F() {
        return new x(function(B, $) {
          O(A, E, B, $);
        });
      }
      return D = D ? D.then(F, F) : F();
    };
  }
  function y(k, x) {
    var O = k.iterator[x.method];
    if (O === void 0) {
      if (x.delegate = null, x.method === "throw") {
        if (k.iterator.return && (x.method = "return", x.arg = void 0, y(k, x), x.method === "throw")) return u;
        x.method = "throw", x.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return u;
    }
    var D = l(O, k.iterator, x.arg);
    if (D.type === "throw") return x.method = "throw", x.arg = D.arg, x.delegate = null, u;
    var A = D.arg;
    return A ? A.done ? (x[k.resultName] = A.value, x.next = k.nextLoc, x.method !== "return" && (x.method = "next", x.arg = void 0), x.delegate = null, u) : A : (x.method = "throw", x.arg = new TypeError("iterator result is not an object"), x.delegate = null, u);
  }
  function C(k) {
    var x = { tryLoc: k[0] };
    1 in k && (x.catchLoc = k[1]), 2 in k && (x.finallyLoc = k[2], x.afterLoc = k[3]), this.tryEntries.push(x);
  }
  function S(k) {
    var x = k.completion || {};
    x.type = "normal", delete x.arg, k.completion = x;
  }
  function P(k) {
    this.tryEntries = [{ tryLoc: "root" }], k.forEach(C, this), this.reset(!0);
  }
  function T(k) {
    if (k) {
      var x = k[e];
      if (x) return x.call(k);
      if (typeof k.next == "function") return k;
      if (!isNaN(k.length)) {
        var O = -1, D = function A() {
          for (; ++O < k.length; ) if (i.call(k, O)) return A.value = k[O], A.done = !1, A;
          return A.value = void 0, A.done = !0, A;
        };
        return D.next = D;
      }
    }
    return { next: I };
  }
  function I() {
    return { value: void 0, done: !0 };
  }
  return f.prototype = p, s(g, "constructor", p), s(p, "constructor", f), f.displayName = s(p, r, "GeneratorFunction"), o.isGeneratorFunction = function(k) {
    var x = typeof k == "function" && k.constructor;
    return !!x && (x === f || (x.displayName || x.name) === "GeneratorFunction");
  }, o.mark = function(k) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(k, p) : (k.__proto__ = p, s(k, r, "GeneratorFunction")), k.prototype = Object.create(g), k;
  }, o.awrap = function(k) {
    return { __await: k };
  }, w(_.prototype), s(_.prototype, t, function() {
    return this;
  }), o.AsyncIterator = _, o.async = function(k, x, O, D, A) {
    A === void 0 && (A = Promise);
    var E = new _(c(k, x, O, D), A);
    return o.isGeneratorFunction(x) ? E : E.next().then(function(F) {
      return F.done ? F.value : E.next();
    });
  }, w(g), s(g, r, "Generator"), s(g, e, function() {
    return this;
  }), s(g, "toString", function() {
    return "[object Generator]";
  }), o.keys = function(k) {
    var x = [];
    for (var O in k) x.push(O);
    return x.reverse(), function D() {
      for (; x.length; ) {
        var A = x.pop();
        if (A in k) return D.value = A, D.done = !1, D;
      }
      return D.done = !0, D;
    };
  }, o.values = T, P.prototype = { constructor: P, reset: function(x) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(S), !x) for (var O in this) O.charAt(0) === "t" && i.call(this, O) && !isNaN(+O.slice(1)) && (this[O] = void 0);
  }, stop: function() {
    this.done = !0;
    var x = this.tryEntries[0].completion;
    if (x.type === "throw") throw x.arg;
    return this.rval;
  }, dispatchException: function(x) {
    if (this.done) throw x;
    var O = this;
    function D(M, j) {
      return F.type = "throw", F.arg = x, O.next = M, j && (O.method = "next", O.arg = void 0), !!j;
    }
    for (var A = this.tryEntries.length - 1; A >= 0; --A) {
      var E = this.tryEntries[A], F = E.completion;
      if (E.tryLoc === "root") return D("end");
      if (E.tryLoc <= this.prev) {
        var B = i.call(E, "catchLoc"), $ = i.call(E, "finallyLoc");
        if (B && $) {
          if (this.prev < E.catchLoc) return D(E.catchLoc, !0);
          if (this.prev < E.finallyLoc) return D(E.finallyLoc);
        } else if (B) {
          if (this.prev < E.catchLoc) return D(E.catchLoc, !0);
        } else {
          if (!$) throw new Error("try statement without catch or finally");
          if (this.prev < E.finallyLoc) return D(E.finallyLoc);
        }
      }
    }
  }, abrupt: function(x, O) {
    for (var D = this.tryEntries.length - 1; D >= 0; --D) {
      var A = this.tryEntries[D];
      if (A.tryLoc <= this.prev && i.call(A, "finallyLoc") && this.prev < A.finallyLoc) {
        var E = A;
        break;
      }
    }
    E && (x === "break" || x === "continue") && E.tryLoc <= O && O <= E.finallyLoc && (E = null);
    var F = E ? E.completion : {};
    return F.type = x, F.arg = O, E ? (this.method = "next", this.next = E.finallyLoc, u) : this.complete(F);
  }, complete: function(x, O) {
    if (x.type === "throw") throw x.arg;
    return x.type === "break" || x.type === "continue" ? this.next = x.arg : x.type === "return" ? (this.rval = this.arg = x.arg, this.method = "return", this.next = "end") : x.type === "normal" && O && (this.next = O), u;
  }, finish: function(x) {
    for (var O = this.tryEntries.length - 1; O >= 0; --O) {
      var D = this.tryEntries[O];
      if (D.finallyLoc === x) return this.complete(D.completion, D.afterLoc), S(D), u;
    }
  }, catch: function(x) {
    for (var O = this.tryEntries.length - 1; O >= 0; --O) {
      var D = this.tryEntries[O];
      if (D.tryLoc === x) {
        var A = D.completion;
        if (A.type === "throw") {
          var E = A.arg;
          S(D);
        }
        return E;
      }
    }
    throw new Error("illegal catch attempt");
  }, delegateYield: function(x, O, D) {
    return this.delegate = { iterator: T(x), resultName: O, nextLoc: D }, this.method === "next" && (this.arg = void 0), u;
  } }, o;
}
function Pe(o, a) {
  if (!(o instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function so(o, a) {
  for (var i = 0; i < a.length; i++) {
    var n = a[i];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(o, n.key, n);
  }
}
function Te(o, a, i) {
  return a && so(o.prototype, a), i && so(o, i), Object.defineProperty(o, "prototype", { writable: !1 }), o;
}
function Mr(o) {
  if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return o;
}
function sa(o, a) {
  return sa = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, e) {
    return n.__proto__ = e, n;
  }, sa(o, a);
}
function Qe(o, a) {
  if (typeof a != "function" && a !== null) throw new TypeError("Super expression must either be null or a function");
  o.prototype = Object.create(a && a.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), Object.defineProperty(o, "prototype", { writable: !1 }), a && sa(o, a);
}
function ot(o) {
  return ot = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, ot(o);
}
function Pu() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function gf(o, a) {
  if (a && (ei(a) === "object" || typeof a == "function")) return a;
  if (a !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Mr(o);
}
function Je(o) {
  var a = Pu();
  return function() {
    var n, e = ot(o);
    if (a) {
      var t = ot(this).constructor;
      n = Reflect.construct(e, arguments, t);
    } else n = e.apply(this, arguments);
    return gf(this, n);
  };
}
function oo(o, a, i, n, e, t, r) {
  try {
    var s = o[t](r), c = s.value;
  } catch (l) {
    return void i(l);
  }
  s.done ? a(c) : Promise.resolve(c).then(n, e);
}
function R(o) {
  return function() {
    var a = this, i = arguments;
    return new Promise(function(n, e) {
      var t = o.apply(a, i);
      function r(c) {
        oo(t, n, e, r, s, "next", c);
      }
      function s(c) {
        oo(t, n, e, r, s, "throw", c);
      }
      r(void 0);
    });
  };
}
var K = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Rs = {}, oa = { exports: {} };
function U(o, a) {
  var i = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (!i) {
    if (Array.isArray(o) || (i = xs(o)) || a) {
      i && (o = i);
      var n = 0, e = function() {
      };
      return { s: e, n: function() {
        return n >= o.length ? { done: !0 } : { done: !1, value: o[n++] };
      }, e: function(l) {
        throw l;
      }, f: e };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var t, r = !0, s = !1;
  return { s: function() {
    i = i.call(o);
  }, n: function() {
    var l = i.next();
    return r = l.done, l;
  }, e: function(l) {
    s = !0, t = l;
  }, f: function() {
    try {
      r || i.return == null || i.return();
    } finally {
      if (s) throw t;
    }
  } };
}
var co = 1e3, kn = 6e4, xn = 60 * kn, Yn = 24 * xn, Tu = function(a, i) {
  i = i || {};
  var n = typeof a;
  if (n === "string" && a.length > 0) return function(t) {
    if (!((t = String(t)).length > 100)) {
      var r = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(t);
      if (r) {
        var s = parseFloat(r[1]);
        switch ((r[2] || "ms").toLowerCase()) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return 315576e5 * s;
          case "weeks":
          case "week":
          case "w":
            return 6048e5 * s;
          case "days":
          case "day":
          case "d":
            return s * Yn;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return s * xn;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return s * kn;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return 1e3 * s;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return s;
          default:
            return;
        }
      }
    }
  }(a);
  if (n === "number" && isFinite(a)) return i.long ? function(t) {
    var r = Math.abs(t);
    return r >= Yn ? Pa(t, r, Yn, "day") : r >= xn ? Pa(t, r, xn, "hour") : r >= kn ? Pa(t, r, kn, "minute") : r >= 1e3 ? Pa(t, r, 1e3, "second") : t + " ms";
  }(a) : function(t) {
    var r = Math.abs(t);
    return r >= Yn ? Math.round(t / Yn) + "d" : r >= xn ? Math.round(t / xn) + "h" : r >= kn ? Math.round(t / kn) + "m" : r >= co ? Math.round(t / co) + "s" : t + "ms";
  }(a);
  throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(a));
};
function Pa(o, a, i, n) {
  var e = a >= 1.5 * i;
  return Math.round(o / i) + " " + n + (e ? "s" : "");
}
var Ta, Vt, yf = function(a) {
  function i(t) {
    var r, s, c, l = null;
    function u() {
      for (var d = arguments.length, f = new Array(d), p = 0; p < d; p++) f[p] = arguments[p];
      if (u.enabled) {
        var m = u, b = Number(/* @__PURE__ */ new Date()), h = b - (r || b);
        m.diff = h, m.prev = r, m.curr = b, r = b, f[0] = i.coerce(f[0]), typeof f[0] != "string" && f.unshift("%O");
        var g = 0;
        f[0] = f[0].replace(/%([a-zA-Z%])/g, function(_, y) {
          if (_ === "%%") return "%";
          g++;
          var C = i.formatters[y];
          if (typeof C == "function") {
            var S = f[g];
            _ = C.call(m, S), f.splice(g, 1), g--;
          }
          return _;
        }), i.formatArgs.call(m, f);
        var w = m.log || i.log;
        w.apply(m, f);
      }
    }
    return u.namespace = t, u.useColors = i.useColors(), u.color = i.selectColor(t), u.extend = n, u.destroy = i.destroy, Object.defineProperty(u, "enabled", { enumerable: !0, configurable: !1, get: function() {
      return l !== null ? l : (s !== i.namespaces && (s = i.namespaces, c = i.enabled(t)), c);
    }, set: function(f) {
      l = f;
    } }), typeof i.init == "function" && i.init(u), u;
  }
  function n(t, r) {
    var s = i(this.namespace + (typeof r > "u" ? ":" : r) + t);
    return s.log = this.log, s;
  }
  function e(t, r) {
    for (var s = 0, c = 0, l = -1, u = 0; s < t.length; ) if (c < r.length && (r[c] === t[s] || r[c] === "*")) r[c] === "*" ? (l = c, u = s, c++) : (s++, c++);
    else {
      if (l === -1) return !1;
      c = l + 1, s = ++u;
    }
    for (; c < r.length && r[c] === "*"; ) c++;
    return c === r.length;
  }
  return i.debug = i, i.default = i, i.coerce = function(r) {
    return r instanceof Error ? r.stack || r.message : r;
  }, i.disable = function() {
    var r = [].concat(Or(i.names), Or(i.skips.map(function(s) {
      return "-" + s;
    }))).join(",");
    return i.enable(""), r;
  }, i.enable = function(r) {
    i.save(r), i.namespaces = r, i.names = [], i.skips = [];
    var s, c = U((typeof r == "string" ? r : "").trim().replace(" ", ",").split(",").filter(Boolean));
    try {
      for (c.s(); !(s = c.n()).done; ) {
        var l = s.value;
        l[0] === "-" ? i.skips.push(l.slice(1)) : i.names.push(l);
      }
    } catch (u) {
      c.e(u);
    } finally {
      c.f();
    }
  }, i.enabled = function(r) {
    var s, c = U(i.skips);
    try {
      for (c.s(); !(s = c.n()).done; ) {
        var l = s.value;
        if (e(r, l)) return !1;
      }
    } catch (p) {
      c.e(p);
    } finally {
      c.f();
    }
    var u, d = U(i.names);
    try {
      for (d.s(); !(u = d.n()).done; ) {
        var f = u.value;
        if (e(r, f)) return !0;
      }
    } catch (p) {
      d.e(p);
    } finally {
      d.f();
    }
    return !1;
  }, i.humanize = Tu, i.destroy = function() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }, Object.keys(a).forEach(function(t) {
    i[t] = a[t];
  }), i.names = [], i.skips = [], i.formatters = {}, i.selectColor = function(r) {
    for (var s = 0, c = 0; c < r.length; c++) s = (s << 5) - s + r.charCodeAt(c), s |= 0;
    return i.colors[Math.abs(s) % i.colors.length];
  }, i.enable(i.load()), i;
};
Ta = oa, (Vt = oa.exports).formatArgs = function(a) {
  if (a[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + a[0] + (this.useColors ? "%c " : " ") + "+" + Ta.exports.humanize(this.diff), this.useColors) {
    var i = "color: " + this.color;
    a.splice(1, 0, i, "color: inherit");
    var n = 0, e = 0;
    a[0].replace(/%[a-zA-Z%]/g, function(t) {
      t !== "%%" && (n++, t === "%c" && (e = n));
    }), a.splice(e, 0, i);
  }
}, Vt.save = function(a) {
  try {
    a ? Vt.storage.setItem("debug", a) : Vt.storage.removeItem("debug");
  } catch {
  }
}, Vt.load = function() {
  var a;
  try {
    a = Vt.storage.getItem("debug");
  } catch {
  }
  return !a && typeof process < "u" && "env" in process && (a = process.env.DEBUG), a;
}, Vt.useColors = function() {
  return !(typeof window > "u" || !window.process || window.process.type !== "renderer" && !window.process.__nwjs) || (typeof navigator > "u" || !navigator.userAgent || !navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) && (typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && (a = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(a[1], 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
  var a;
}, Vt.storage = function() {
  try {
    return localStorage;
  } catch {
  }
}(), Vt.destroy = /* @__PURE__ */ function() {
  var o = !1;
  return function() {
    o || (o = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
  };
}(), Vt.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], Vt.log = console.debug || console.log || function() {
}, Ta.exports = yf(Vt), Ta.exports.formatters.j = function(o) {
  try {
    return JSON.stringify(o);
  } catch (a) {
    return "[UnexpectedJSONParseError]: " + a.message;
  }
};
var Dn = {}, ts = { exports: {} };
(function(o, a) {
  (function(i, n) {
    var e = "user-agent", t = "", r = "function", s = "undefined", c = "object", l = "string", u = "browser", d = "cpu", f = "device", p = "engine", m = "os", b = "result", h = "name", g = "type", w = "vendor", _ = "version", y = "architecture", C = "major", S = "model", P = "console", T = "mobile", I = "tablet", k = "smarttv", x = "wearable", O = "xr", D = "embedded", A = "inapp", E = "brands", F = "formFactors", B = "fullVersionList", $ = "platform", M = "platformVersion", j = "bitness", z = "sec-ch-ua", te = "sec-ch-ua-platform", ee = [E, B, T, S, $, M, y, F, j], Y = "Amazon", Z = "Apple", ae = "ASUS", oe = "BlackBerry", ce = "Google", ke = "Huawei", Oe = "Lenovo", nt = "Honor", et = "LG", Fe = "Microsoft", $e = "Motorola", at = "Nvidia", vt = "OnePlus", gt = "OPPO", it = "Samsung", Ie = "Sharp", ut = "Sony", qe = "Xiaomi", H = "Zebra", ue = "Chromium", Ve = "Chromecast", Tt = "Opera", It = "Facebook", Ct = "Windows", br = typeof i !== s, dt = br && i.navigator ? i.navigator : n, kt = dt && dt.userAgentData ? dt.userAgentData : n, zt = function(se) {
      for (var de = {}, L = 0; L < se.length; L++) de[se[L].toUpperCase()] = se[L];
      return de;
    }, _r = function(se, de) {
      if (typeof se === c && se.length > 0) {
        for (var L in se) if (Dt(se[L]) == Dt(de)) return !0;
        return !1;
      }
      return !!Gt(se) && Dt(de).indexOf(Dt(se)) !== -1;
    }, wr = function ve(se, de) {
      for (var L in se) return /^(browser|cpu|device|engine|os)$/.test(L) || !!de && ve(se[L]);
    }, Gt = function(se) {
      return typeof se === l;
    }, Sr = function(se) {
      if (!se) return n;
      for (var de = [], L = Nt(/\\?\"/g, se).split(","), G = 0; G < L.length; G++) if (L[G].indexOf(";") > -1) {
        var X = Et(L[G]).split(";v=");
        de[G] = { brand: X[0], version: X[1] };
      } else de[G] = Et(L[G]);
      return de;
    }, Dt = function(se) {
      return Gt(se) ? se.toLowerCase() : se;
    }, jr = function(se) {
      return Gt(se) ? Nt(/[^\d\.]/g, se).split(".")[0] : n;
    }, jt = function(se) {
      for (var de in se) {
        var L = se[de];
        typeof L == c && L.length == 2 ? this[L[0]] = L[1] : this[L] = n;
      }
      return this;
    }, Nt = function(se, de) {
      return Gt(de) ? de.replace(se, t) : de;
    }, qt = function(se) {
      return Nt(/\\?\"/g, se);
    }, Et = function(se, de) {
      if (Gt(se)) return se = Nt(/^\s\s*/, se), typeof de === s ? se : se.substring(0, 500);
    }, pr = function(se, de) {
      if (se && de) for (var L, G, X, J, fe, le, ie = 0; ie < de.length && !fe; ) {
        var me = de[ie], ze = de[ie + 1];
        for (L = G = 0; L < me.length && !fe && me[L]; ) if (fe = me[L++].exec(se)) for (X = 0; X < ze.length; X++) le = fe[++G], typeof (J = ze[X]) === c && J.length > 0 ? J.length === 2 ? typeof J[1] == r ? this[J[0]] = J[1].call(this, le) : this[J[0]] = J[1] : J.length === 3 ? typeof J[1] !== r || J[1].exec && J[1].test ? this[J[0]] = le ? le.replace(J[1], J[2]) : n : this[J[0]] = le ? J[1].call(this, le, J[2]) : n : J.length === 4 && (this[J[0]] = le ? J[3].call(this, le.replace(J[1], J[2])) : n) : this[J] = le || n;
        ie += 2;
      }
    }, At = function(se, de) {
      for (var L in de) if (typeof de[L] === c && de[L].length > 0) {
        for (var G = 0; G < de[L].length; G++) if (_r(de[L][G], se)) return L === "?" ? n : L;
      } else if (_r(de[L], se)) return L === "?" ? n : L;
      return de.hasOwnProperty("*") ? de["*"] : se;
    }, Nr = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, Fr = { embedded: "Automotive", mobile: "Mobile", tablet: ["Tablet", "EInk"], smarttv: "TV", wearable: "Watch", xr: ["VR", "XR"], "?": ["Desktop", "Unknown"], "*": n }, Cr = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [_, [h, "Mobile Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [_, [h, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [h, _], [/opios[\/ ]+([\w\.]+)/i], [_, [h, "Opera Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [_, [h, "Opera GX"]], [/\bopr\/([\w\.]+)/i], [_, [h, Tt]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [_, [h, "Baidu"]], [/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i], [_, [h, "Maxthon"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i, /(heytap|ovi|115)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [h, _], [/quark(?:pc)?\/([-\w\.]+)/i], [_, [h, "Quark"]], [/\bddg\/([\w\.]+)/i], [_, [h, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [_, [h, "UCBrowser"]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [_, [h, "WeChat"]], [/konqueror\/([\w\.]+)/i], [_, [h, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [_, [h, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [_, [h, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [_, [h, "Smart Lenovo Browser"]], [/(avast|avg)\/([\w\.]+)/i], [[h, /(.+)/, "$1 Secure Browser"], _], [/\bfocus\/([\w\.]+)/i], [_, [h, "Firefox Focus"]], [/\bopt\/([\w\.]+)/i], [_, [h, "Opera Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [_, [h, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [_, [h, "Dolphin"]], [/coast\/([\w\.]+)/i], [_, [h, "Opera Coast"]], [/miuibrowser\/([\w\.]+)/i], [_, [h, "MIUI Browser"]], [/fxios\/([\w\.-]+)/i], [_, [h, "Mobile Firefox"]], [/\bqihoobrowser\/?([\w\.]*)/i], [_, [h, "360"]], [/\b(qq)\/([\w\.]+)/i], [[h, /(.+)/, "$1Browser"], _], [/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i], [[h, /(.+)/, "$1 Browser"], _], [/samsungbrowser\/([\w\.]+)/i], [_, [h, "Samsung Internet"]], [/metasr[\/ ]?([\d\.]+)/i], [_, [h, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[h, "Sogou Mobile"], _], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i], [h, _], [/(lbbrowser|rekonq)/i], [h], [/ome\/([\w\.]+) \w* ?(iron) saf/i, /ome\/([\w\.]+).+qihu (360)[es]e/i], [_, h], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[h, It], _, [g, A]], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /(daum)apps[\/ ]([\w\.]+)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(instagram|snapchat)[\/ ]([-\w\.]+)/i], [h, _, [g, A]], [/\bgsa\/([\w\.]+) .*safari\//i], [_, [h, "GSA"], [g, A]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [_, [h, "TikTok"], [g, A]], [/\[(linkedin)app\]/i], [h, [g, A]], [/(chromium)[\/ ]([-\w\.]+)/i], [h, _], [/headlesschrome(?:\/([\w\.]+)| )/i], [_, [h, "Chrome Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[h, "Chrome WebView"], _], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [_, [h, "Android Browser"]], [/chrome\/([\w\.]+) mobile/i], [_, [h, "Mobile Chrome"]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [h, _], [/version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i], [_, [h, "Mobile Safari"]], [/iphone .*mobile(?:\/\w+ | ?)safari/i], [[h, "Mobile Safari"]], [/version\/([\w\.\,]+) .*(safari)/i], [_, h], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [h, [_, "1"]], [/(webkit|khtml)\/([\w\.]+)/i], [h, _], [/(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i], [[h, "Mobile Firefox"], _], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[h, "Netscape"], _], [/(wolvic|librewolf)\/([\w\.]+)/i], [h, _], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [_, [h, "Firefox Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /\b(links) \(([\w\.]+)/i], [h, [_, /_/g, "."]], [/(cobalt)\/([\w\.]+)/i], [h, [_, /[^\d\.]+./, t]]], cpu: [[/\b((amd|x|x86[-_]?|wow|win)64)\b/i], [[y, "amd64"]], [/(ia32(?=;))/i, /\b((i[346]|x)86)(pc)?\b/i], [[y, "ia32"]], [/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i], [[y, "arm64"]], [/\b(arm(v[67])?ht?n?[fl]p?)\b/i], [[y, "armhf"]], [/( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i], [[y, "arm"]], [/((ppc|powerpc)(64)?)( mac|;|\))/i], [[y, /ower/, t, Dt]], [/ sun4\w[;\)]/i], [[y, "sparc"]], [/\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i], [[y, Dt]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [S, [w, it], [g, I]], [/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]((?!sm-[lr])[-\w]+)/i, /sec-(sgh\w+)/i], [S, [w, it], [g, T]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [S, [w, Z], [g, T]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [S, [w, Z], [g, I]], [/(macintosh);/i], [S, [w, Z]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [S, [w, Ie], [g, T]], [/\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i], [S, [w, nt], [g, I]], [/honor([-\w ]+)[;\)]/i], [S, [w, nt], [g, T]], [/\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i], [S, [w, ke], [g, I]], [/(?:huawei)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [S, [w, ke], [g, T]], [/oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i, /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i], [[S, /_/g, " "], [w, qe], [g, I]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i, / ([\w ]+) miui\/v?\d/i], [[S, /_/g, " "], [w, qe], [g, T]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [S, [w, gt], [g, T]], [/\b(opd2(\d{3}a?))(?: bui|\))/i], [S, [w, At, { OnePlus: ["304", "403", "203"], "*": gt }], [g, I]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [S, [w, "Vivo"], [g, T]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [S, [w, "Realme"], [g, T]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [S, [w, $e], [g, T]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [S, [w, $e], [g, I]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [S, [w, et], [g, I]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i, /\blg-?([\d\w]+) bui/i], [S, [w, et], [g, T]], [/(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i, /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i], [S, [w, Oe], [g, I]], [/(nokia) (t[12][01])/i], [w, S, [g, I]], [/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i, /nokia[-_ ]?(([-\w\. ]*))/i], [[S, /_/g, " "], [g, T], [w, "Nokia"]], [/(pixel (c|tablet))\b/i], [S, [w, ce], [g, I]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [S, [w, ce], [g, T]], [/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [S, [w, ut], [g, T]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[S, "Xperia Tablet"], [w, ut], [g, I]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [S, [w, vt], [g, T]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [S, [w, Y], [g, I]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[S, /(.+)/g, "Fire Phone $1"], [w, Y], [g, T]], [/(playbook);[-\w\),; ]+(rim)/i], [S, w, [g, I]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [S, [w, oe], [g, T]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [S, [w, ae], [g, I]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [S, [w, ae], [g, T]], [/(nexus 9)/i], [S, [w, "HTC"], [g, I]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [w, [S, /_/g, " "], [g, T]], [/tcl (xess p17aa)/i, /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i], [S, [w, "TCL"], [g, I]], [/droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i], [S, [w, "TCL"], [g, T]], [/(itel) ((\w+))/i], [[w, Dt], S, [g, At, { tablet: ["p10001l", "w7001"], "*": "mobile" }]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [S, [w, "Acer"], [g, I]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [S, [w, "Meizu"], [g, T]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [S, [w, "Ulefone"], [g, T]], [/; (energy ?\w+)(?: bui|\))/i, /; energizer ([\w ]+)(?: bui|\))/i], [S, [w, "Energizer"], [g, T]], [/; cat (b35);/i, /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i], [S, [w, "Cat"], [g, T]], [/((?:new )?andromax[\w- ]+)(?: bui|\))/i], [S, [w, "Smartfren"], [g, T]], [/droid.+; (a(?:015|06[35]|142p?))/i], [S, [w, "Nothing"], [g, T]], [/(imo) (tab \w+)/i, /(infinix) (x1101b?)/i], [w, S, [g, I]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i, /; (hmd|imo) ([\w ]+?)(?: bui|\))/i, /(hp) ([\w ]+\w)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i, /(oppo) ?([\w ]+) bui/i], [w, S, [g, T]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i], [w, S, [g, I]], [/(surface duo)/i], [S, [w, Fe], [g, I]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [S, [w, "Fairphone"], [g, T]], [/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i], [S, [w, at], [g, I]], [/(sprint) (\w+)/i], [w, S, [g, T]], [/(kin\.[onetw]{3})/i], [[S, /\./g, " "], [w, Fe], [g, T]], [/droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [S, [w, H], [g, I]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [S, [w, H], [g, T]], [/smart-tv.+(samsung)/i], [w, [g, k]], [/hbbtv.+maple;(\d+)/i], [[S, /^/, "SmartTV"], [w, it], [g, k]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[w, et], [g, k]], [/(apple) ?tv/i], [w, [S, "Apple TV"], [g, k]], [/crkey.*devicetype\/chromecast/i], [[S, "Chromecast Third Generation"], [w, ce], [g, k]], [/crkey.*devicetype\/([^/]*)/i], [[S, /^/, "Chromecast "], [w, ce], [g, k]], [/fuchsia.*crkey/i], [[S, "Chromecast Nest Hub"], [w, ce], [g, k]], [/crkey/i], [[S, Ve], [w, ce], [g, k]], [/droid.+aft(\w+)( bui|\))/i], [S, [w, Y], [g, k]], [/(shield \w+ tv)/i], [S, [w, at], [g, k]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [S, [w, Ie], [g, k]], [/(bravia[\w ]+)( bui|\))/i], [S, [w, ut], [g, k]], [/(mi(tv|box)-?\w+) bui/i], [S, [w, qe], [g, k]], [/Hbbtv.*(technisat) (.*);/i], [w, S, [g, k]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[w, Et], [S, Et], [g, k]], [/droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i], [S, [g, k]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[g, k]], [/(ouya)/i, /(nintendo) (\w+)/i], [w, S, [g, P]], [/droid.+; (shield)( bui|\))/i], [S, [w, at], [g, P]], [/(playstation \w+)/i], [S, [w, ut], [g, P]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [S, [w, Fe], [g, P]], [/\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i], [S, [w, it], [g, x]], [/((pebble))app/i, /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i], [w, S, [g, x]], [/(ow(?:19|20)?we?[1-3]{1,3})/i], [S, [w, gt], [g, x]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [S, [w, Z], [g, x]], [/(opwwe\d{3})/i], [S, [w, vt], [g, x]], [/(moto 360)/i], [S, [w, $e], [g, x]], [/(smartwatch 3)/i], [S, [w, ut], [g, x]], [/(g watch r)/i], [S, [w, et], [g, x]], [/droid.+; (wt63?0{2,3})\)/i], [S, [w, H], [g, x]], [/droid.+; (glass) \d/i], [S, [w, ce], [g, O]], [/(pico) (4|neo3(?: link|pro)?)/i], [w, S, [g, O]], [/; (quest( \d| pro)?)/i], [S, [w, It], [g, O]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [w, [g, D]], [/(aeobc)\b/i], [S, [w, Y], [g, D]], [/(homepod).+mac os/i], [S, [w, Z], [g, D]], [/windows iot/i], [[g, D]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+?(mobile|vr|\d) safari/i], [S, [g, At, { mobile: "Mobile", xr: "VR", "*": I }]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[g, I]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[g, T]], [/droid .+?; ([\w\. -]+)( bui|\))/i], [S, [w, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [_, [h, "EdgeHTML"]], [/(arkweb)\/([\w\.]+)/i], [h, _], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [_, [h, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [h, _], [/ladybird\//i], [[h, "LibWeb"]], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [_, h]], os: [[/microsoft (windows) (vista|xp)/i], [h, _], [/(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i], [h, [_, At, Nr]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[_, At, Nr], [h, Ct]], [/[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[_, /_/g, "."], [h, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[h, "macOS"], [_, /_/g, "."]], [/android ([\d\.]+).*crkey/i], [_, [h, "Chromecast Android"]], [/fuchsia.*crkey\/([\d\.]+)/i], [_, [h, "Chromecast Fuchsia"]], [/crkey\/([\d\.]+).*devicetype\/smartspeaker/i], [_, [h, "Chromecast SmartSpeaker"]], [/linux.*crkey\/([\d\.]+)/i], [_, [h, "Chromecast Linux"]], [/crkey\/([\d\.]+)/i], [_, [h, Ve]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [_, h], [/(ubuntu) ([\w\.]+) like android/i], [[h, /(.+)/, "$1 Touch"], _], [/(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i], [h, _], [/\(bb(10);/i], [_, [h, oe]], [/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i], [_, [h, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [_, [h, "Firefox OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [_, [h, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [_, [h, "watchOS"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[h, "Chrome OS"], _], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) (\w+)/i, /(xbox); +xbox ([^\);]+)/i, /(pico) .+os([\w\.]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [h, _], [/(sunos) ?([\w\.\d]*)/i], [[h, "Solaris"], _], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [h, _]] }, fr = function() {
      var ve = { init: {}, isIgnore: {}, isIgnoreRgx: {}, toString: {} };
      return jt.call(ve.init, [[u, [h, _, C, g]], [d, [y]], [f, [g, S, w]], [p, [h, _]], [m, [h, _]]]), jt.call(ve.isIgnore, [[u, [_, C]], [p, [_]], [m, [_]]]), jt.call(ve.isIgnoreRgx, [[u, / ?browser$/i], [m, / ?os$/i]]), jt.call(ve.toString, [[u, [h, _]], [d, [y]], [f, [w, S]], [p, [h, _]], [m, [h, _]]]), ve;
    }(), $r = function(se, de) {
      var L = fr.init[de], G = fr.isIgnore[de] || 0, X = fr.isIgnoreRgx[de] || 0, J = fr.toString[de] || 0;
      function fe() {
        jt.call(this, L);
      }
      return fe.prototype.getItem = function() {
        return se;
      }, fe.prototype.withClientHints = function() {
        return kt ? kt.getHighEntropyValues(ee).then(function(le) {
          return se.setCH(new kr(le, !1)).parseCH().get();
        }) : se.parseCH().get();
      }, fe.prototype.withFeatureCheck = function() {
        return se.detectFeature().get();
      }, de != b && (fe.prototype.is = function(le) {
        var ie = !1;
        for (var me in this) if (this.hasOwnProperty(me) && !_r(G, me) && Dt(X ? Nt(X, this[me]) : this[me]) == Dt(X ? Nt(X, le) : le)) {
          if (ie = !0, le != s) break;
        } else if (le == s && ie) {
          ie = !ie;
          break;
        }
        return ie;
      }, fe.prototype.toString = function() {
        var le = t;
        for (var ie in J) typeof this[J[ie]] !== s && (le += (le ? " " : t) + this[J[ie]]);
        return le || s;
      }), kt || (fe.prototype.then = function(le) {
        var ie = this, me = function() {
          for (var je in ie) ie.hasOwnProperty(je) && (this[je] = ie[je]);
        };
        me.prototype = { is: fe.prototype.is, toString: fe.prototype.toString };
        var ze = new me();
        return le(ze), ze;
      }), new fe();
    };
    function kr(ve, se) {
      if (ve = ve || {}, jt.call(this, ee), se) jt.call(this, [[E, Sr(ve[z])], [B, Sr(ve["sec-ch-ua-full-version-list"])], [T, /\?1/.test(ve["sec-ch-ua-mobile"])], [S, qt(ve["sec-ch-ua-model"])], [$, qt(ve[te])], [M, qt(ve["sec-ch-ua-platform-version"])], [y, qt(ve["sec-ch-ua-arch"])], [F, Sr(ve["sec-ch-ua-form-factors"])], [j, qt(ve["sec-ch-ua-bitness"])]]);
      else for (var de in ve) this.hasOwnProperty(de) && typeof ve[de] !== s && (this[de] = ve[de]);
    }
    function Br(ve, se, de, L) {
      return this.get = function(G) {
        return G ? this.data.hasOwnProperty(G) ? this.data[G] : n : this.data;
      }, this.set = function(G, X) {
        return this.data[G] = X, this;
      }, this.setCH = function(G) {
        return this.uaCH = G, this;
      }, this.detectFeature = function() {
        if (dt && dt.userAgent == this.ua) switch (this.itemType) {
          case u:
            dt.brave && typeof dt.brave.isBrave == r && this.set(h, "Brave");
            break;
          case f:
            !this.get(g) && kt && kt.mobile && this.set(g, T), this.get(S) == "Macintosh" && dt && typeof dt.standalone !== s && dt.maxTouchPoints && dt.maxTouchPoints > 2 && this.set(S, "iPad").set(g, I);
            break;
          case m:
            !this.get(h) && kt && kt.platform && this.set(h, kt.platform);
            break;
          case b:
            var G = this.data, X = function(fe) {
              return G[fe].getItem().detectFeature().get();
            };
            this.set(u, X(u)).set(d, X(d)).set(f, X(f)).set(p, X(p)).set(m, X(m));
        }
        return this;
      }, this.parseUA = function() {
        return this.itemType != b && pr.call(this.data, this.ua, this.rgxMap), this.itemType == u && this.set(C, jr(this.get(_))), this;
      }, this.parseCH = function() {
        var G = this.uaCH, X = this.rgxMap;
        switch (this.itemType) {
          case u:
          case p:
            var J, fe = G[B] || G.brands;
            if (fe) for (var le in fe) {
              var ie = fe[le].brand || fe[le], me = fe[le].version;
              this.itemType != u || /not.a.brand/i.test(ie) || J && (!/chrom/i.test(J) || ie == ue) || (ie = At(ie, { Chrome: "Google Chrome", Edge: "Microsoft Edge", "Chrome WebView": "Android WebView", "Chrome Headless": "HeadlessChrome" }), this.set(h, ie).set(_, me).set(C, jr(me)), J = ie), this.itemType == p && ie == ue && this.set(_, me);
            }
            break;
          case d:
            var ze = G.architecture;
            ze && (ze && G.bitness == "64" && (ze += "64"), pr.call(this.data, ze + ";", X));
            break;
          case f:
            if (G.mobile && this.set(g, T), G.model && (this.set(S, G.model), !this.get(g) || !this.get(w))) {
              var De = {};
              pr.call(De, "droid 9; " + G.model + ")", X), !this.get(g) && De.type && this.set(g, De.type), !this.get(w) && De.vendor && this.set(w, De.vendor);
            }
            if (G.formFactors) {
              var je;
              if (typeof G.formFactors != "string") for (var lt = 0; !je && lt < G.formFactors.length; ) je = At(G.formFactors[lt++], Fr);
              else je = At(G.formFactors, Fr);
              this.set(g, je);
            }
            break;
          case m:
            var bt = G.platform;
            if (bt) {
              var tn = G[M];
              bt == Ct && (tn = parseInt(jr(tn), 10) >= 13 ? "11" : "10"), this.set(h, bt).set(_, tn);
            }
            this.get(h) == Ct && G.model == "Xbox" && this.set(h, "Xbox").set(_, n);
            break;
          case b:
            var Ht = this.data, qn = function(pd) {
              return Ht[pd].getItem().setCH(G).parseCH().get();
            };
            this.set(u, qn(u)).set(d, qn(d)).set(f, qn(f)).set(p, qn(p)).set(m, qn(m));
        }
        return this;
      }, jt.call(this, [["itemType", ve], ["ua", se], ["uaCH", L], ["rgxMap", de], ["data", $r(this, ve)]]), this;
    }
    function he(ve, se, de) {
      if (typeof ve === c ? (wr(ve, !0) ? (typeof se === c && (de = se), se = ve) : (de = ve, se = n), ve = n) : typeof ve !== l || wr(se, !0) || (de = se, se = n), de && typeof de.append === r) {
        var L = {};
        de.forEach(function(le, ie) {
          L[ie] = le;
        }), de = L;
      }
      if (!(this instanceof he)) return new he(ve, se, de).getResult();
      var G = typeof ve === l ? ve : de && de[e] ? de[e] : dt && dt.userAgent ? dt.userAgent : t, X = new kr(de, !0), J = se ? function(ie, me) {
        var ze = {}, De = me;
        if (!wr(me)) for (var je in De = {}, me) for (var lt in me[je]) De[lt] = me[je][lt].concat(De[lt] ? De[lt] : []);
        for (var bt in ie) ze[bt] = De[bt] && De[bt].length % 2 === 0 ? De[bt].concat(ie[bt]) : ie[bt];
        return ze;
      }(Cr, se) : Cr, fe = function(ie) {
        return ie == b ? function() {
          return new Br(ie, G, J, X).set("ua", G).set(u, this.getBrowser()).set(d, this.getCPU()).set(f, this.getDevice()).set(p, this.getEngine()).set(m, this.getOS()).get();
        } : function() {
          return new Br(ie, G, J[ie], X).parseUA().get();
        };
      };
      return jt.call(this, [["getBrowser", fe(u)], ["getCPU", fe(d)], ["getDevice", fe(f)], ["getEngine", fe(p)], ["getOS", fe(m)], ["getResult", fe(b)], ["getUA", function() {
        return G;
      }], ["setUA", function(le) {
        return Gt(le) && (G = le.length > 500 ? Et(le, 500) : le), this;
      }]]).setUA(G), this;
    }
    he.VERSION = "2.0.2", he.BROWSER = zt([h, _, C, g]), he.CPU = zt([y]), he.DEVICE = zt([S, w, g, P, T, k, I, x, D]), he.ENGINE = he.OS = zt([h, _]), o.exports && (a = o.exports = he), a.UAParser = he;
    var Ue = br && (i.jQuery || i.Zepto);
    if (Ue && !Ue.ua) {
      var Kt = new he();
      Ue.ua = Kt.getResult(), Ue.ua.get = function() {
        return Kt.getUA();
      }, Ue.ua.set = function(ve) {
        Kt.setUA(ve);
        var se = Kt.getResult();
        for (var de in se) Ue.ua[de] = se[de];
      };
    }
  })(typeof window == "object" ? window : K);
})(ts, ts.exports);
var rt = {}, bf = K && K.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(rt, "__esModule", { value: !0 }), rt.Logger = void 0;
var an = bf(oa.exports), sn = "mediasoup-client", _f = function() {
  function o(a) {
    Pe(this, o), a ? (this._debug = (0, an.default)("".concat(sn, ":").concat(a)), this._warn = (0, an.default)("".concat(sn, ":WARN:").concat(a)), this._error = (0, an.default)("".concat(sn, ":ERROR:").concat(a))) : (this._debug = (0, an.default)(sn), this._warn = (0, an.default)("".concat(sn, ":WARN")), this._error = (0, an.default)("".concat(sn, ":ERROR"))), this._debug.log = console.info.bind(console), this._warn.log = console.warn.bind(console), this._error.log = console.error.bind(console);
  }
  return Te(o, [{ key: "debug", get: function() {
    return this._debug;
  } }, { key: "warn", get: function() {
    return this._warn;
  } }, { key: "error", get: function() {
    return this._error;
  } }]), o;
}();
function wf(o, a) {
  for (; !Object.prototype.hasOwnProperty.call(o, a) && (o = ot(o)) !== null; ) ;
  return o;
}
function _t() {
  return _t = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(a, i, n) {
    var e = wf(a, i);
    if (e) {
      var t = Object.getOwnPropertyDescriptor(e, i);
      return t.get ? t.get.call(arguments.length < 3 ? a : n) : t.value;
    }
  }, _t.apply(this, arguments);
}
rt.Logger = _f;
var Du, ur = {}, rs = { exports: {} }, En = typeof Reflect == "object" ? Reflect : null, uo = En && typeof En.apply == "function" ? En.apply : function(a, i, n) {
  return Function.prototype.apply.call(a, i, n);
};
Du = En && typeof En.ownKeys == "function" ? En.ownKeys : Object.getOwnPropertySymbols ? function(a) {
  return Object.getOwnPropertyNames(a).concat(Object.getOwnPropertySymbols(a));
} : function(a) {
  return Object.getOwnPropertyNames(a);
};
var lo = Number.isNaN || function(a) {
  return a !== a;
};
function Ke() {
  Ke.init.call(this);
}
rs.exports = Ke, rs.exports.once = function(a, i) {
  return new Promise(function(n, e) {
    function t(s) {
      a.removeListener(i, r), e(s);
    }
    function r() {
      typeof a.removeListener == "function" && a.removeListener("error", t), n([].slice.call(arguments));
    }
    go(a, i, r, { once: !0 }), i !== "error" && function(c, l, u) {
      typeof c.on == "function" && go(c, "error", l, u);
    }(a, t, { once: !0 });
  });
}, Ke.EventEmitter = Ke, Ke.prototype._events = void 0, Ke.prototype._eventsCount = 0, Ke.prototype._maxListeners = void 0;
var po = 10;
function Ka(o) {
  if (typeof o != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof o);
}
function Eu(o) {
  return o._maxListeners === void 0 ? Ke.defaultMaxListeners : o._maxListeners;
}
function fo(o, a, i, n) {
  var e, t, r;
  if (Ka(i), (t = o._events) === void 0 ? (t = o._events = /* @__PURE__ */ Object.create(null), o._eventsCount = 0) : (t.newListener !== void 0 && (o.emit("newListener", a, i.listener ? i.listener : i), t = o._events), r = t[a]), r === void 0) r = t[a] = i, ++o._eventsCount;
  else if (typeof r == "function" ? r = t[a] = n ? [i, r] : [r, i] : n ? r.unshift(i) : r.push(i), (e = Eu(o)) > 0 && r.length > e && !r.warned) {
    r.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + r.length + " " + String(a) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = o, s.type = a, s.count = r.length, function(l) {
      console && console.warn && console.warn(l);
    }(s);
  }
  return o;
}
function Sf() {
  if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function ho(o, a, i) {
  var n = { fired: !1, wrapFn: void 0, target: o, type: a, listener: i }, e = Sf.bind(n);
  return e.listener = i, n.wrapFn = e, e;
}
function mo(o, a, i) {
  var n = o._events;
  if (n === void 0) return [];
  var e = n[a];
  return e === void 0 ? [] : typeof e == "function" ? i ? [e.listener || e] : [e] : i ? function(r) {
    for (var s = new Array(r.length), c = 0; c < s.length; ++c) s[c] = r[c].listener || r[c];
    return s;
  }(e) : Au(e, e.length);
}
function vo(o) {
  var a = this._events;
  if (a !== void 0) {
    var i = a[o];
    if (typeof i == "function") return 1;
    if (i !== void 0) return i.length;
  }
  return 0;
}
function Au(o, a) {
  for (var i = new Array(a), n = 0; n < a; ++n) i[n] = o[n];
  return i;
}
function go(o, a, i, n) {
  if (typeof o.on == "function") n.once ? o.once(a, i) : o.on(a, i);
  else {
    if (typeof o.addEventListener != "function") throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof o);
    o.addEventListener(a, function e(t) {
      n.once && o.removeEventListener(a, e), i(t);
    });
  }
}
Object.defineProperty(Ke, "defaultMaxListeners", { enumerable: !0, get: function() {
  return po;
}, set: function(a) {
  if (typeof a != "number" || a < 0 || lo(a)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + a + ".");
  po = a;
} }), Ke.init = function() {
  this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
}, Ke.prototype.setMaxListeners = function(a) {
  if (typeof a != "number" || a < 0 || lo(a)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + a + ".");
  return this._maxListeners = a, this;
}, Ke.prototype.getMaxListeners = function() {
  return Eu(this);
}, Ke.prototype.emit = function(a) {
  for (var i = [], n = 1; n < arguments.length; n++) i.push(arguments[n]);
  var e = a === "error", t = this._events;
  if (t !== void 0) e = e && t.error === void 0;
  else if (!e) return !1;
  if (e) {
    var r;
    if (i.length > 0 && (r = i[0]), r instanceof Error) throw r;
    var s = new Error("Unhandled error." + (r ? " (" + r.message + ")" : ""));
    throw s.context = r, s;
  }
  var c = t[a];
  if (c === void 0) return !1;
  if (typeof c == "function") uo(c, this, i);
  else {
    var l = c.length, u = Au(c, l);
    for (n = 0; n < l; ++n) uo(u[n], this, i);
  }
  return !0;
}, Ke.prototype.addListener = function(a, i) {
  return fo(this, a, i, !1);
}, Ke.prototype.on = Ke.prototype.addListener, Ke.prototype.prependListener = function(a, i) {
  return fo(this, a, i, !0);
}, Ke.prototype.once = function(a, i) {
  return Ka(i), this.on(a, ho(this, a, i)), this;
}, Ke.prototype.prependOnceListener = function(a, i) {
  return Ka(i), this.prependListener(a, ho(this, a, i)), this;
}, Ke.prototype.removeListener = function(a, i) {
  var n, e, t, r, s;
  if (Ka(i), (e = this._events) === void 0) return this;
  if ((n = e[a]) === void 0) return this;
  if (n === i || n.listener === i) --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete e[a], e.removeListener && this.emit("removeListener", a, n.listener || i));
  else if (typeof n != "function") {
    for (t = -1, r = n.length - 1; r >= 0; r--) if (n[r] === i || n[r].listener === i) {
      s = n[r].listener, t = r;
      break;
    }
    if (t < 0) return this;
    t === 0 ? n.shift() : function(l, u) {
      for (; u + 1 < l.length; u++) l[u] = l[u + 1];
      l.pop();
    }(n, t), n.length === 1 && (e[a] = n[0]), e.removeListener !== void 0 && this.emit("removeListener", a, s || i);
  }
  return this;
}, Ke.prototype.off = Ke.prototype.removeListener, Ke.prototype.removeAllListeners = function(a) {
  var i, n, e;
  if ((n = this._events) === void 0) return this;
  if (n.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[a] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[a]), this;
  if (arguments.length === 0) {
    var t, r = Object.keys(n);
    for (e = 0; e < r.length; ++e) (t = r[e]) !== "removeListener" && this.removeAllListeners(t);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (typeof (i = n[a]) == "function") this.removeListener(a, i);
  else if (i !== void 0) for (e = i.length - 1; e >= 0; e--) this.removeListener(a, i[e]);
  return this;
}, Ke.prototype.listeners = function(a) {
  return mo(this, a, !0);
}, Ke.prototype.rawListeners = function(a) {
  return mo(this, a, !1);
}, Ke.listenerCount = function(o, a) {
  return typeof o.listenerCount == "function" ? o.listenerCount(a) : vo.call(o, a);
}, Ke.prototype.listenerCount = vo, Ke.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Du(this._events) : [];
}, Object.defineProperty(ur, "__esModule", { value: !0 }), ur.EnhancedEventEmitter = void 0;
var Cf = rs.exports, kf = new rt.Logger("EnhancedEventEmitter"), xf = function(o) {
  Qe(i, Cf.EventEmitter);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this)).setMaxListeners(1 / 0), n;
  }
  return Te(i, [{ key: "emit", value: function(e) {
    for (var t, r = arguments.length, s = new Array(r > 1 ? r - 1 : 0), c = 1; c < r; c++) s[c - 1] = arguments[c];
    return (t = _t(ot(i.prototype), "emit", this)).call.apply(t, [this, e].concat(s));
  } }, { key: "safeEmit", value: function(e) {
    try {
      for (var t, r = arguments.length, s = new Array(r > 1 ? r - 1 : 0), c = 1; c < r; c++) s[c - 1] = arguments[c];
      return (t = _t(ot(i.prototype), "emit", this)).call.apply(t, [this, e].concat(s));
    } catch (l) {
      kf.error("safeEmit() | event listener threw an error [eventName:%s]:%o", e, l);
      try {
        _t(ot(i.prototype), "emit", this).call(this, "listenererror", e, l);
      } catch {
      }
      return !!_t(ot(i.prototype), "listenerCount", this).call(this, e);
    }
  } }, { key: "on", value: function(e, t) {
    return _t(ot(i.prototype), "on", this).call(this, e, t), this;
  } }, { key: "off", value: function(e, t) {
    return _t(ot(i.prototype), "off", this).call(this, e, t), this;
  } }, { key: "addListener", value: function(e, t) {
    return _t(ot(i.prototype), "on", this).call(this, e, t), this;
  } }, { key: "prependListener", value: function(e, t) {
    return _t(ot(i.prototype), "prependListener", this).call(this, e, t), this;
  } }, { key: "once", value: function(e, t) {
    return _t(ot(i.prototype), "once", this).call(this, e, t), this;
  } }, { key: "prependOnceListener", value: function(e, t) {
    return _t(ot(i.prototype), "prependOnceListener", this).call(this, e, t), this;
  } }, { key: "removeListener", value: function(e, t) {
    return _t(ot(i.prototype), "off", this).call(this, e, t), this;
  } }, { key: "removeAllListeners", value: function(e) {
    return _t(ot(i.prototype), "removeAllListeners", this).call(this, e), this;
  } }, { key: "listenerCount", value: function(e) {
    return _t(ot(i.prototype), "listenerCount", this).call(this, e);
  } }, { key: "listeners", value: function(e) {
    return _t(ot(i.prototype), "listeners", this).call(this, e);
  } }, { key: "rawListeners", value: function(e) {
    return _t(ot(i.prototype), "rawListeners", this).call(this, e);
  } }]), i;
}();
function ns(o, a, i) {
  return ns = Pu() ? Reflect.construct.bind() : function(e, t, r) {
    var s = [null];
    s.push.apply(s, t);
    var c = new (Function.bind.apply(e, s))();
    return r && sa(c, r.prototype), c;
  }, ns.apply(null, arguments);
}
function Mn(o) {
  var a = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Mn = function(n) {
    if (n === null || !function(r) {
      return Function.toString.call(r).indexOf("[native code]") !== -1;
    }(n)) return n;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (typeof a < "u") {
      if (a.has(n)) return a.get(n);
      a.set(n, e);
    }
    function e() {
      return ns(n, arguments, ot(this).constructor);
    }
    return e.prototype = Object.create(n.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), sa(e, n);
  }, Mn(o);
}
ur.EnhancedEventEmitter = xf;
var ft = {};
Object.defineProperty(ft, "__esModule", { value: !0 }), ft.InvalidStateError = ft.UnsupportedError = void 0;
var Rf = function(o) {
  Qe(i, Mn(Error));
  var a = Je(i);
  function i(n) {
    var e;
    return Pe(this, i), (e = a.call(this, n)).name = "UnsupportedError", Error.hasOwnProperty("captureStackTrace") ? Error.captureStackTrace(Mr(e), i) : e.stack = new Error(n).stack, e;
  }
  return Te(i);
}();
ft.UnsupportedError = Rf;
var If = function(o) {
  Qe(i, Mn(Error));
  var a = Je(i);
  function i(n) {
    var e;
    return Pe(this, i), (e = a.call(this, n)).name = "InvalidStateError", Error.hasOwnProperty("captureStackTrace") ? Error.captureStackTrace(Mr(e), i) : e.stack = new Error(n).stack, e;
  }
  return Te(i);
}();
ft.InvalidStateError = If;
var ct = {};
Object.defineProperty(ct, "__esModule", { value: !0 }), ct.clone = function(a) {
  return a === void 0 ? void 0 : Number.isNaN(a) ? NaN : typeof structuredClone == "function" ? structuredClone(a) : JSON.parse(JSON.stringify(a));
}, ct.generateRandomNumber = function() {
  return Math.round(1e7 * Math.random());
}, ct.deepFreeze = function o(a) {
  var i, n = U(Reflect.ownKeys(a));
  try {
    for (n.s(); !(i = n.n()).done; ) {
      var e = i.value, t = a[e];
      (t && typeof t == "object" || typeof t == "function") && o(t);
    }
  } catch (r) {
    n.e(r);
  } finally {
    n.f();
  }
  return Object.freeze(a);
};
var Ye = {}, wt = {}, ti = {}, Pf = K && K.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(ti, "__esModule", { value: !0 }), ti.Logger = void 0;
var on = Pf(oa.exports), cn = "h264-profile-level-id", Tf = function() {
  function o(a) {
    Pe(this, o), a ? (this._debug = (0, on.default)("".concat(cn, ":").concat(a)), this._warn = (0, on.default)("".concat(cn, ":WARN:").concat(a)), this._error = (0, on.default)("".concat(cn, ":ERROR:").concat(a))) : (this._debug = (0, on.default)(cn), this._warn = (0, on.default)("".concat(cn, ":WARN")), this._error = (0, on.default)("".concat(cn, ":ERROR"))), this._debug.log = console.info.bind(console), this._warn.log = console.warn.bind(console), this._error.log = console.error.bind(console);
  }
  return Te(o, [{ key: "debug", get: function() {
    return this._debug;
  } }, { key: "warn", get: function() {
    return this._warn;
  } }, { key: "error", get: function() {
    return this._error;
  } }]), o;
}();
ti.Logger = Tf, Object.defineProperty(wt, "__esModule", { value: !0 }), wt.ProfileLevelId = wt.Level = wt.Profile = void 0, wt.parseProfileLevelId = Lu, wt.profileLevelIdToString = bo, wt.profileToString = function(a) {
  switch (a) {
    case We.ConstrainedBaseline:
      return "ConstrainedBaseline";
    case We.Baseline:
      return "Baseline";
    case We.Main:
      return "Main";
    case We.ConstrainedHigh:
      return "ConstrainedHigh";
    case We.High:
      return "High";
    case We.PredictiveHigh444:
      return "PredictiveHigh444";
    default:
      return void Xt.warn("profileToString() | unrecognized profile ".concat(a));
  }
}, wt.levelToString = function(a) {
  switch (a) {
    case pe.L1_b:
      return "1b";
    case pe.L1:
      return "1";
    case pe.L1_1:
      return "1.1";
    case pe.L1_2:
      return "1.2";
    case pe.L1_3:
      return "1.3";
    case pe.L2:
      return "2";
    case pe.L2_1:
      return "2.1";
    case pe.L2_2:
      return "2.2";
    case pe.L3:
      return "3";
    case pe.L3_1:
      return "3.1";
    case pe.L3_2:
      return "3.2";
    case pe.L4:
      return "4";
    case pe.L4_1:
      return "4.1";
    case pe.L4_2:
      return "4.2";
    case pe.L5:
      return "5";
    case pe.L5_1:
      return "5.1";
    case pe.L5_2:
      return "5.2";
    default:
      return void Xt.warn("levelToString() | unrecognized level ".concat(a));
  }
}, wt.parseSdpProfileLevelId = Gr, wt.isSameProfile = function() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Gr(a), e = Gr(i);
  return !!(n && e && n.profile === e.profile);
}, wt.isSameProfileAndLevel = function() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = Gr(a), e = Gr(i);
  return !!(n && e && n.profile === e.profile && n.level == e.level);
}, wt.generateProfileLevelIdStringForAnswer = function() {
  var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!a["profile-level-id"] && !i["profile-level-id"]) return void Xt.warn("generateProfileLevelIdStringForAnswer() | profile-level-id missing in local and remote params");
  var n = Gr(a), e = Gr(i);
  if (!n) throw new TypeError("invalid local_profile_level_id");
  if (!e) throw new TypeError("invalid remote_profile_level_id");
  if (n.profile !== e.profile) throw new TypeError("H264 Profile mismatch");
  var t = wo(a) && wo(i), r = n.level, s = e.level, c = Af(r, s), l = t ? r : c;
  return Xt.debug("generateProfileLevelIdStringForAnswer() | result [profile:".concat(n.profile, ", level:").concat(l, "]")), bo(new Ri(n.profile, l));
}, wt.supportedLevel = function(a, i) {
  for (var n = yo.length - 1; n >= 0; --n) {
    var e = yo[n];
    if (256 * e.max_macroblock_frame_size <= a && e.max_macroblocks_per_second <= i * e.max_macroblock_frame_size) return Xt.debug("supportedLevel() | result [max_frame_pixel_count:".concat(a, ", max_fps:").concat(i, ", level:").concat(e.level, "]")), e.level;
  }
  return void Xt.warn("supportedLevel() | no level supported [max_frame_pixel_count:".concat(a, ", max_fps:").concat(i, "]"));
};
var We, pe, Xt = new ti.Logger();
(function(o) {
  o[o.ConstrainedBaseline = 1] = "ConstrainedBaseline", o[o.Baseline = 2] = "Baseline", o[o.Main = 3] = "Main", o[o.ConstrainedHigh = 4] = "ConstrainedHigh", o[o.High = 5] = "High", o[o.PredictiveHigh444 = 6] = "PredictiveHigh444";
})(We || (wt.Profile = We = {})), function(o) {
  o[o.L1_b = 0] = "L1_b", o[o.L1 = 10] = "L1", o[o.L1_1 = 11] = "L1_1", o[o.L1_2 = 12] = "L1_2", o[o.L1_3 = 13] = "L1_3", o[o.L2 = 20] = "L2", o[o.L2_1 = 21] = "L2_1", o[o.L2_2 = 22] = "L2_2", o[o.L3 = 30] = "L3", o[o.L3_1 = 31] = "L3_1", o[o.L3_2 = 32] = "L3_2", o[o.L4 = 40] = "L4", o[o.L4_1 = 41] = "L4_1", o[o.L4_2 = 42] = "L4_2", o[o.L5 = 50] = "L5", o[o.L5_1 = 51] = "L5_1", o[o.L5_2 = 52] = "L5_2";
}(pe || (wt.Level = pe = {}));
var Ri = Te(function o(a, i) {
  Pe(this, o), this.profile = a, this.level = i;
});
wt.ProfileLevelId = Ri;
var Df = new Ri(We.ConstrainedBaseline, pe.L3_1), hr = function() {
  function o(a) {
    Pe(this, o), this.mask = ~_o("x", a), this.masked_value = _o("1", a);
  }
  return Te(o, [{ key: "isMatch", value: function(i) {
    return this.masked_value === (i & this.mask);
  } }]), o;
}(), mr = Te(function o(a, i, n) {
  Pe(this, o), this.profile_idc = a, this.profile_iop = i, this.profile = n;
}), Ef = [new mr(66, new hr("x1xx0000"), We.ConstrainedBaseline), new mr(77, new hr("1xxx0000"), We.ConstrainedBaseline), new mr(88, new hr("11xx0000"), We.ConstrainedBaseline), new mr(66, new hr("x0xx0000"), We.Baseline), new mr(88, new hr("10xx0000"), We.Baseline), new mr(77, new hr("0x0x0000"), We.Main), new mr(100, new hr("00000000"), We.High), new mr(100, new hr("00001100"), We.ConstrainedHigh), new mr(244, new hr("00000000"), We.PredictiveHigh444)], yo = [{ max_macroblocks_per_second: 1485, max_macroblock_frame_size: 99, level: pe.L1 }, { max_macroblocks_per_second: 1485, max_macroblock_frame_size: 99, level: pe.L1_b }, { max_macroblocks_per_second: 3e3, max_macroblock_frame_size: 396, level: pe.L1_1 }, { max_macroblocks_per_second: 6e3, max_macroblock_frame_size: 396, level: pe.L1_2 }, { max_macroblocks_per_second: 11880, max_macroblock_frame_size: 396, level: pe.L1_3 }, { max_macroblocks_per_second: 11880, max_macroblock_frame_size: 396, level: pe.L2 }, { max_macroblocks_per_second: 19800, max_macroblock_frame_size: 792, level: pe.L2_1 }, { max_macroblocks_per_second: 20250, max_macroblock_frame_size: 1620, level: pe.L2_2 }, { max_macroblocks_per_second: 40500, max_macroblock_frame_size: 1620, level: pe.L3 }, { max_macroblocks_per_second: 108e3, max_macroblock_frame_size: 3600, level: pe.L3_1 }, { max_macroblocks_per_second: 216e3, max_macroblock_frame_size: 5120, level: pe.L3_2 }, { max_macroblocks_per_second: 245760, max_macroblock_frame_size: 8192, level: pe.L4 }, { max_macroblocks_per_second: 245760, max_macroblock_frame_size: 8192, level: pe.L4_1 }, { max_macroblocks_per_second: 522240, max_macroblock_frame_size: 8704, level: pe.L4_2 }, { max_macroblocks_per_second: 589824, max_macroblock_frame_size: 22080, level: pe.L5 }, { max_macroblocks_per_second: 983040, max_macroblock_frame_size: 36864, level: pe.L5_1 }, { max_macroblocks_per_second: 2073600, max_macroblock_frame_size: 36864, level: pe.L5_2 }];
function Lu(o) {
  if (typeof o == "string" && o.length === 6) {
    var a = parseInt(o, 16);
    if (a !== 0) {
      var i, n = 255 & a, e = a >> 8 & 255, t = a >> 16 & 255;
      switch (n) {
        case pe.L1_1:
          i = 16 & e ? pe.L1_b : pe.L1_1;
          break;
        case pe.L1:
        case pe.L1_2:
        case pe.L1_3:
        case pe.L2:
        case pe.L2_1:
        case pe.L2_2:
        case pe.L3:
        case pe.L3_1:
        case pe.L3_2:
        case pe.L4:
        case pe.L4_1:
        case pe.L4_2:
        case pe.L5:
        case pe.L5_1:
        case pe.L5_2:
          i = n;
          break;
        default:
          return void Xt.warn("parseProfileLevelId() | unrecognized level_idc [str:".concat(o, ", level_idc:").concat(n, "]"));
      }
      var r, s = U(Ef);
      try {
        for (s.s(); !(r = s.n()).done; ) {
          var c = r.value;
          if (t === c.profile_idc && c.profile_iop.isMatch(e)) return Xt.debug("parseProfileLevelId() | result [str:".concat(o, ", profile:").concat(c.profile, ", level:").concat(i, "]")), new Ri(c.profile, i);
        }
      } catch (l) {
        s.e(l);
      } finally {
        s.f();
      }
      Xt.warn("parseProfileLevelId() | unrecognized profile_idc/profile_iop combination [str:".concat(o, ", profile_idc:").concat(t, ", profile_iop:").concat(e, "]"));
    }
  }
}
function bo(o) {
  if (o.level == pe.L1_b) switch (o.profile) {
    case We.ConstrainedBaseline:
      return "42f00b";
    case We.Baseline:
      return "42100b";
    case We.Main:
      return "4d100b";
    default:
      return void Xt.warn("profileLevelIdToString() | Level 1_b not is allowed for profile ".concat(o.profile));
  }
  var a;
  switch (o.profile) {
    case We.ConstrainedBaseline:
      a = "42e0";
      break;
    case We.Baseline:
      a = "4200";
      break;
    case We.Main:
      a = "4d00";
      break;
    case We.ConstrainedHigh:
      a = "640c";
      break;
    case We.High:
      a = "6400";
      break;
    case We.PredictiveHigh444:
      a = "f400";
      break;
    default:
      return void Xt.warn("profileLevelIdToString() | unrecognized profile ".concat(o.profile));
  }
  var i = o.level.toString(16);
  return i.length === 1 && (i = "0".concat(i)), "".concat(a).concat(i);
}
function Gr() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = o["profile-level-id"];
  return a ? Lu(a) : Df;
}
function _o(o, a) {
  return +(a[0] === o) << 7 | +(a[1] === o) << 6 | +(a[2] === o) << 5 | +(a[3] === o) << 4 | +(a[4] === o) << 3 | +(a[5] === o) << 2 | +(a[6] === o) << 1 | +(a[7] === o) << 0;
}
function Af(o, a) {
  return function(n, e) {
    return n === pe.L1_b ? e !== pe.L1 && e !== pe.L1_b : e === pe.L1_b ? n !== pe.L1 : n < e;
  }(o, a) ? o : a;
}
function wo() {
  var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = o["level-asymmetry-allowed"];
  return a === !0 || a === 1 || a === "1";
}
var Lf = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), Of = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), Ou = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && Lf(i, a, n[e]);
    return Of(i, a), i;
  };
}();
Object.defineProperty(Ye, "__esModule", { value: !0 }), Ye.validateRtpCapabilities = function(a) {
  if (typeof a != "object") throw new TypeError("caps is not an object");
  if (a.codecs && !Array.isArray(a.codecs)) throw new TypeError("caps.codecs is not an array");
  a.codecs || (a.codecs = []);
  var i, n = U(a.codecs);
  try {
    for (n.s(); !(i = n.n()).done; )
      jf(i.value);
  } catch (r) {
    n.e(r);
  } finally {
    n.f();
  }
  if (a.headerExtensions && !Array.isArray(a.headerExtensions)) throw new TypeError("caps.headerExtensions is not an array");
  a.headerExtensions || (a.headerExtensions = []);
  var e, t = U(a.headerExtensions);
  try {
    for (t.s(); !(e = t.n()).done; )
      Nf(e.value);
  } catch (r) {
    t.e(r);
  } finally {
    t.f();
  }
}, Ye.validateRtpParameters = $i, Ye.validateSctpStreamParameters = function(a) {
  if (typeof a != "object") throw new TypeError("params is not an object");
  if (typeof a.streamId != "number") throw new TypeError("missing params.streamId");
  var i = !1;
  if (typeof a.ordered == "boolean" ? i = !0 : a.ordered = !0, a.maxPacketLifeTime && typeof a.maxPacketLifeTime != "number") throw new TypeError("invalid params.maxPacketLifeTime");
  if (a.maxRetransmits && typeof a.maxRetransmits != "number") throw new TypeError("invalid params.maxRetransmits");
  if (a.maxPacketLifeTime && a.maxRetransmits) throw new TypeError("cannot provide both maxPacketLifeTime and maxRetransmits");
  if (i && a.ordered && (a.maxPacketLifeTime || a.maxRetransmits)) throw new TypeError("cannot be ordered with maxPacketLifeTime or maxRetransmits");
  if (i || !a.maxPacketLifeTime && !a.maxRetransmits || (a.ordered = !1), a.label && typeof a.label != "string") throw new TypeError("invalid params.label");
  if (a.protocol && typeof a.protocol != "string") throw new TypeError("invalid params.protocol");
}, Ye.validateSctpCapabilities = function(a) {
  if (typeof a != "object") throw new TypeError("caps is not an object");
  if (!a.numStreams || typeof a.numStreams != "object") throw new TypeError("missing caps.numStreams");
  (function(n) {
    if (typeof n != "object") throw new TypeError("numStreams is not an object");
    if (typeof n.OS != "number") throw new TypeError("missing numStreams.OS");
    if (typeof n.MIS != "number") throw new TypeError("missing numStreams.MIS");
  })(a.numStreams);
}, Ye.getExtendedRtpCapabilities = function(a, i) {
  var n, e, t = { codecs: [], headerExtensions: [] }, r = U((n = i.codecs) !== null && n !== void 0 ? n : []);
  try {
    var s = function() {
      var b, h = e.value;
      if (Wn(h)) return "continue";
      var g = ((b = a.codecs) !== null && b !== void 0 ? b : []).find(function(_) {
        return Co(_, h, { strict: !0, modify: !0 });
      });
      if (!g) return "continue";
      var w = { mimeType: g.mimeType, kind: g.kind, clockRate: g.clockRate, channels: g.channels, localPayloadType: g.preferredPayloadType, localRtxPayloadType: void 0, remotePayloadType: h.preferredPayloadType, remoteRtxPayloadType: void 0, localParameters: g.parameters, remoteParameters: h.parameters, rtcpFeedback: Vf(g, h) };
      t.codecs.push(w);
    };
    for (r.s(); !(e = r.n()).done; ) s();
  } catch (m) {
    r.e(m);
  } finally {
    r.f();
  }
  var c, l = U(t.codecs);
  try {
    var u = function() {
      var b = c.value, h = a.codecs.find(function(w) {
        return Wn(w) && w.parameters.apt === b.localPayloadType;
      }), g = i.codecs.find(function(w) {
        return Wn(w) && w.parameters.apt === b.remotePayloadType;
      });
      h && g && (b.localRtxPayloadType = h.preferredPayloadType, b.remoteRtxPayloadType = g.preferredPayloadType);
    };
    for (l.s(); !(c = l.n()).done; ) u();
  } catch (m) {
    l.e(m);
  } finally {
    l.f();
  }
  var d, f = U(i.headerExtensions);
  try {
    var p = function() {
      var b = d.value, h = a.headerExtensions.find(function(w) {
        return function(y, C) {
          return !(y.kind && C.kind && y.kind !== C.kind || y.uri !== C.uri);
        }(w, b);
      });
      if (!h) return "continue";
      var g = { kind: b.kind, uri: b.uri, sendId: h.preferredId, recvId: b.preferredId, encrypt: h.preferredEncrypt, direction: "sendrecv" };
      switch (b.direction) {
        case "sendrecv":
          g.direction = "sendrecv";
          break;
        case "recvonly":
          g.direction = "sendonly";
          break;
        case "sendonly":
          g.direction = "recvonly";
          break;
        case "inactive":
          g.direction = "inactive";
      }
      t.headerExtensions.push(g);
    };
    for (f.s(); !(d = f.n()).done; ) p();
  } catch (m) {
    f.e(m);
  } finally {
    f.f();
  }
  return t;
}, Ye.getRecvRtpCapabilities = function(a) {
  var i, n = { codecs: [], headerExtensions: [] }, e = U(a.codecs);
  try {
    for (e.s(); !(i = e.n()).done; ) {
      var t = i.value, r = { mimeType: t.mimeType, kind: t.kind, preferredPayloadType: t.remotePayloadType, clockRate: t.clockRate, channels: t.channels, parameters: t.localParameters, rtcpFeedback: t.rtcpFeedback };
      if (n.codecs.push(r), t.remoteRtxPayloadType) {
        var s = { mimeType: "".concat(t.kind, "/rtx"), kind: t.kind, preferredPayloadType: t.remoteRtxPayloadType, clockRate: t.clockRate, parameters: { apt: t.remotePayloadType }, rtcpFeedback: [] };
        n.codecs.push(s);
      }
    }
  } catch (f) {
    e.e(f);
  } finally {
    e.f();
  }
  var c, l = U(a.headerExtensions);
  try {
    for (l.s(); !(c = l.n()).done; ) {
      var u = c.value;
      if (u.direction === "sendrecv" || u.direction === "recvonly") {
        var d = { kind: u.kind, uri: u.uri, preferredId: u.recvId, preferredEncrypt: u.encrypt, direction: u.direction };
        n.headerExtensions.push(d);
      }
    }
  } catch (f) {
    l.e(f);
  } finally {
    l.f();
  }
  return n;
}, Ye.getSendingRtpParameters = function(a, i) {
  var n, e = { mid: void 0, codecs: [], headerExtensions: [], encodings: [], rtcp: {} }, t = U(i.codecs);
  try {
    for (t.s(); !(n = t.n()).done; ) {
      var r = n.value;
      if (r.kind === a) {
        var s = { mimeType: r.mimeType, payloadType: r.localPayloadType, clockRate: r.clockRate, channels: r.channels, parameters: r.localParameters, rtcpFeedback: r.rtcpFeedback };
        if (e.codecs.push(s), r.localRtxPayloadType) {
          var c = { mimeType: "".concat(r.kind, "/rtx"), payloadType: r.localRtxPayloadType, clockRate: r.clockRate, parameters: { apt: r.localPayloadType }, rtcpFeedback: [] };
          e.codecs.push(c);
        }
      }
    }
  } catch (p) {
    t.e(p);
  } finally {
    t.f();
  }
  var l, u = U(i.headerExtensions);
  try {
    for (u.s(); !(l = u.n()).done; ) {
      var d = l.value;
      if (!(d.kind && d.kind !== a || d.direction !== "sendrecv" && d.direction !== "sendonly")) {
        var f = { uri: d.uri, id: d.sendId, encrypt: d.encrypt, parameters: {} };
        e.headerExtensions.push(f);
      }
    }
  } catch (p) {
    u.e(p);
  } finally {
    u.f();
  }
  return e;
}, Ye.getSendingRemoteRtpParameters = function(a, i) {
  var n, e = { mid: void 0, codecs: [], headerExtensions: [], encodings: [], rtcp: {} }, t = U(i.codecs);
  try {
    for (t.s(); !(n = t.n()).done; ) {
      var r = n.value;
      if (r.kind === a) {
        var s = { mimeType: r.mimeType, payloadType: r.localPayloadType, clockRate: r.clockRate, channels: r.channels, parameters: r.remoteParameters, rtcpFeedback: r.rtcpFeedback };
        if (e.codecs.push(s), r.localRtxPayloadType) {
          var c = { mimeType: "".concat(r.kind, "/rtx"), payloadType: r.localRtxPayloadType, clockRate: r.clockRate, parameters: { apt: r.localPayloadType }, rtcpFeedback: [] };
          e.codecs.push(c);
        }
      }
    }
  } catch (I) {
    t.e(I);
  } finally {
    t.f();
  }
  var l, u = U(i.headerExtensions);
  try {
    for (u.s(); !(l = u.n()).done; ) {
      var d = l.value;
      if (!(d.kind && d.kind !== a || d.direction !== "sendrecv" && d.direction !== "sendonly")) {
        var f = { uri: d.uri, id: d.sendId, encrypt: d.encrypt, parameters: {} };
        e.headerExtensions.push(f);
      }
    }
  } catch (I) {
    u.e(I);
  } finally {
    u.f();
  }
  if (e.headerExtensions.some(function(I) {
    return I.uri === "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01";
  })) {
    var p, m = U(e.codecs);
    try {
      for (m.s(); !(p = m.n()).done; ) {
        var b, h = p.value;
        h.rtcpFeedback = ((b = h.rtcpFeedback) !== null && b !== void 0 ? b : []).filter(function(I) {
          return I.type !== "goog-remb";
        });
      }
    } catch (I) {
      m.e(I);
    } finally {
      m.f();
    }
  } else if (e.headerExtensions.some(function(I) {
    return I.uri === "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time";
  })) {
    var g, w = U(e.codecs);
    try {
      for (w.s(); !(g = w.n()).done; ) {
        var _, y = g.value;
        y.rtcpFeedback = ((_ = y.rtcpFeedback) !== null && _ !== void 0 ? _ : []).filter(function(I) {
          return I.type !== "transport-cc";
        });
      }
    } catch (I) {
      w.e(I);
    } finally {
      w.f();
    }
  } else {
    var C, S = U(e.codecs);
    try {
      for (S.s(); !(C = S.n()).done; ) {
        var P, T = C.value;
        T.rtcpFeedback = ((P = T.rtcpFeedback) !== null && P !== void 0 ? P : []).filter(function(I) {
          return I.type !== "transport-cc" && I.type !== "goog-remb";
        });
      }
    } catch (I) {
      S.e(I);
    } finally {
      S.f();
    }
  }
  return e;
}, Ye.reduceCodecs = function(a, i) {
  var n = [];
  if (i) {
    for (var e = 0; e < a.length; ++e) if (Co(a[e], i, { strict: !0 })) {
      n.push(a[e]), Wn(a[e + 1]) && n.push(a[e + 1]);
      break;
    }
    if (n.length === 0) throw new TypeError("no matching codec found");
  } else n.push(a[0]), Wn(a[1]) && n.push(a[1]);
  return n;
}, Ye.generateProbatorRtpParameters = function(a) {
  $i(a = Mf.clone(a));
  var i = { mid: "probator", codecs: [], headerExtensions: [], encodings: [{ ssrc: 1234 }], rtcp: { cname: "probator" } };
  return i.codecs.push(a.codecs[0]), i.codecs[0].payloadType = 127, i.headerExtensions = a.headerExtensions, i;
}, Ye.canSend = function(a, i) {
  return i.codecs.some(function(n) {
    return n.kind === a;
  });
}, Ye.canReceive = function(a, i) {
  if ($i(a), a.codecs.length === 0) return !1;
  var n = a.codecs[0];
  return i.codecs.some(function(e) {
    return e.remotePayloadType === n.payloadType;
  });
};
var So = Ou(wt), Mf = Ou(ct);
function $i(o) {
  if (typeof o != "object") throw new TypeError("params is not an object");
  if (o.mid && typeof o.mid != "string") throw new TypeError("params.mid is not a string");
  if (!Array.isArray(o.codecs)) throw new TypeError("missing params.codecs");
  var a, i = U(o.codecs);
  try {
    for (i.s(); !(a = i.n()).done; )
      Ff(a.value);
  } catch (s) {
    i.e(s);
  } finally {
    i.f();
  }
  if (o.headerExtensions && !Array.isArray(o.headerExtensions)) throw new TypeError("params.headerExtensions is not an array");
  o.headerExtensions || (o.headerExtensions = []);
  var n, e = U(o.headerExtensions);
  try {
    for (e.s(); !(n = e.n()).done; )
      $f(n.value);
  } catch (s) {
    e.e(s);
  } finally {
    e.f();
  }
  if (o.encodings && !Array.isArray(o.encodings)) throw new TypeError("params.encodings is not an array");
  o.encodings || (o.encodings = []);
  var t, r = U(o.encodings);
  try {
    for (r.s(); !(t = r.n()).done; )
      Bf(t.value);
  } catch (s) {
    r.e(s);
  } finally {
    r.f();
  }
  if (o.rtcp && typeof o.rtcp != "object") throw new TypeError("params.rtcp is not an object");
  o.rtcp || (o.rtcp = {}), function(c) {
    if (typeof c != "object") throw new TypeError("rtcp is not an object");
    if (c.cname && typeof c.cname != "string") throw new TypeError("invalid rtcp.cname");
    c.reducedSize && typeof c.reducedSize == "boolean" || (c.reducedSize = !0);
  }(o.rtcp);
}
function jf(o) {
  var a = new RegExp("^(audio|video)/(.+)", "i");
  if (typeof o != "object") throw new TypeError("codec is not an object");
  if (!o.mimeType || typeof o.mimeType != "string") throw new TypeError("missing codec.mimeType");
  var i = a.exec(o.mimeType);
  if (!i) throw new TypeError("invalid codec.mimeType");
  if (o.kind = i[1].toLowerCase(), o.preferredPayloadType && typeof o.preferredPayloadType != "number") throw new TypeError("invalid codec.preferredPayloadType");
  if (typeof o.clockRate != "number") throw new TypeError("missing codec.clockRate");
  o.kind === "audio" ? typeof o.channels != "number" && (o.channels = 1) : delete o.channels, o.parameters && typeof o.parameters == "object" || (o.parameters = {});
  for (var n = 0, e = Object.keys(o.parameters); n < e.length; n++) {
    var t = e[n], r = o.parameters[t];
    if (r === void 0 && (o.parameters[t] = "", r = ""), typeof r != "string" && typeof r != "number") throw new TypeError("invalid codec parameter [key:".concat(t, "s, value:").concat(r, "]"));
    if (t === "apt" && typeof r != "number") throw new TypeError("invalid codec apt parameter");
  }
  o.rtcpFeedback && Array.isArray(o.rtcpFeedback) || (o.rtcpFeedback = []);
  var s, c = U(o.rtcpFeedback);
  try {
    for (c.s(); !(s = c.n()).done; )
      Mu(s.value);
  } catch (l) {
    c.e(l);
  } finally {
    c.f();
  }
}
function Mu(o) {
  if (typeof o != "object") throw new TypeError("fb is not an object");
  if (!o.type || typeof o.type != "string") throw new TypeError("missing fb.type");
  o.parameter && typeof o.parameter == "string" || (o.parameter = "");
}
function Nf(o) {
  if (typeof o != "object") throw new TypeError("ext is not an object");
  if (o.kind !== "audio" && o.kind !== "video") throw new TypeError("invalid ext.kind");
  if (!o.uri || typeof o.uri != "string") throw new TypeError("missing ext.uri");
  if (typeof o.preferredId != "number") throw new TypeError("missing ext.preferredId");
  if (o.preferredEncrypt && typeof o.preferredEncrypt != "boolean") throw new TypeError("invalid ext.preferredEncrypt");
  if (o.preferredEncrypt || (o.preferredEncrypt = !1), o.direction && typeof o.direction != "string") throw new TypeError("invalid ext.direction");
  o.direction || (o.direction = "sendrecv");
}
function Ff(o) {
  var a = new RegExp("^(audio|video)/(.+)", "i");
  if (typeof o != "object") throw new TypeError("codec is not an object");
  if (!o.mimeType || typeof o.mimeType != "string") throw new TypeError("missing codec.mimeType");
  var i = a.exec(o.mimeType);
  if (!i) throw new TypeError("invalid codec.mimeType");
  if (typeof o.payloadType != "number") throw new TypeError("missing codec.payloadType");
  if (typeof o.clockRate != "number") throw new TypeError("missing codec.clockRate");
  i[1].toLowerCase() === "audio" ? typeof o.channels != "number" && (o.channels = 1) : delete o.channels, o.parameters && typeof o.parameters == "object" || (o.parameters = {});
  for (var n = 0, e = Object.keys(o.parameters); n < e.length; n++) {
    var t = e[n], r = o.parameters[t];
    if (r === void 0 && (o.parameters[t] = "", r = ""), typeof r != "string" && typeof r != "number") throw new TypeError("invalid codec parameter [key:".concat(t, "s, value:").concat(r, "]"));
    if (t === "apt" && typeof r != "number") throw new TypeError("invalid codec apt parameter");
  }
  o.rtcpFeedback && Array.isArray(o.rtcpFeedback) || (o.rtcpFeedback = []);
  var s, c = U(o.rtcpFeedback);
  try {
    for (c.s(); !(s = c.n()).done; )
      Mu(s.value);
  } catch (l) {
    c.e(l);
  } finally {
    c.f();
  }
}
function $f(o) {
  if (typeof o != "object") throw new TypeError("ext is not an object");
  if (!o.uri || typeof o.uri != "string") throw new TypeError("missing ext.uri");
  if (typeof o.id != "number") throw new TypeError("missing ext.id");
  if (o.encrypt && typeof o.encrypt != "boolean") throw new TypeError("invalid ext.encrypt");
  o.encrypt || (o.encrypt = !1), o.parameters && typeof o.parameters == "object" || (o.parameters = {});
  for (var a = 0, i = Object.keys(o.parameters); a < i.length; a++) {
    var n = i[a], e = o.parameters[n];
    if (e === void 0 && (o.parameters[n] = "", e = ""), typeof e != "string" && typeof e != "number") throw new TypeError("invalid header extension parameter");
  }
}
function Bf(o) {
  if (typeof o != "object") throw new TypeError("encoding is not an object");
  if (o.ssrc && typeof o.ssrc != "number") throw new TypeError("invalid encoding.ssrc");
  if (o.rid && typeof o.rid != "string") throw new TypeError("invalid encoding.rid");
  if (o.rtx && typeof o.rtx != "object") throw new TypeError("invalid encoding.rtx");
  if (o.rtx && typeof o.rtx.ssrc != "number") throw new TypeError("missing encoding.rtx.ssrc");
  if (o.dtx && typeof o.dtx == "boolean" || (o.dtx = !1), o.scalabilityMode && typeof o.scalabilityMode != "string") throw new TypeError("invalid encoding.scalabilityMode");
}
function Wn(o) {
  return !!o && /.+\/rtx$/i.test(o.mimeType);
}
function Co(o, a) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = i.strict, e = n !== void 0 && n, t = i.modify, r = t !== void 0 && t, s = o.mimeType.toLowerCase(), c = a.mimeType.toLowerCase();
  if (s !== c || o.clockRate !== a.clockRate || o.channels !== a.channels) return !1;
  switch (s) {
    case "video/h264":
      if (e) {
        var l, u, d, f = (l = o.parameters["packetization-mode"]) !== null && l !== void 0 ? l : 0, p = (u = a.parameters["packetization-mode"]) !== null && u !== void 0 ? u : 0;
        if (f !== p || !So.isSameProfile(o.parameters, a.parameters)) return !1;
        try {
          d = So.generateProfileLevelIdStringForAnswer(o.parameters, a.parameters);
        } catch {
          return !1;
        }
        r && (d ? (o.parameters["profile-level-id"] = d, a.parameters["profile-level-id"] = d) : (delete o.parameters["profile-level-id"], delete a.parameters["profile-level-id"]));
      }
      break;
    case "video/vp9":
      if (e) {
        var m, b, h = (m = o.parameters["profile-id"]) !== null && m !== void 0 ? m : 0, g = (b = a.parameters["profile-id"]) !== null && b !== void 0 ? b : 0;
        if (h !== g) return !1;
      }
  }
  return !0;
}
function Vf(o, a) {
  var i, n, e = [], t = U((i = o.rtcpFeedback) !== null && i !== void 0 ? i : []);
  try {
    var r = function() {
      var c, l = n.value, u = ((c = a.rtcpFeedback) !== null && c !== void 0 ? c : []).find(function(d) {
        return d.type === l.type && (d.parameter === l.parameter || !d.parameter && !l.parameter);
      });
      u && e.push(u);
    };
    for (t.s(); !(n = t.n()).done; ) r();
  } catch (s) {
    t.e(s);
  } finally {
    t.f();
  }
  return e;
}
var ca = {}, ju = {};
function Wr(o, a) {
  return function(n) {
    if (Array.isArray(n)) return n;
  }(o) || function(n, e) {
    var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (t != null) {
      var r, s, c = [], l = !0, u = !1;
      try {
        for (t = t.call(n); !(l = (r = t.next()).done) && (c.push(r.value), !e || c.length !== e); l = !0) ;
      } catch (d) {
        u = !0, s = d;
      } finally {
        try {
          l || t.return == null || t.return();
        } finally {
          if (u) throw s;
        }
      }
      return c;
    }
  }(o, a) || xs(o, a) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
var ri = {}, ni = {}, as = { exports: {} }, Uf = function(a) {
  function i(t) {
    var r, s, c, l = null;
    function u() {
      for (var d = arguments.length, f = new Array(d), p = 0; p < d; p++) f[p] = arguments[p];
      if (u.enabled) {
        var m = u, b = Number(/* @__PURE__ */ new Date()), h = b - (r || b);
        m.diff = h, m.prev = r, m.curr = b, r = b, f[0] = i.coerce(f[0]), typeof f[0] != "string" && f.unshift("%O");
        var g = 0;
        f[0] = f[0].replace(/%([a-zA-Z%])/g, function(_, y) {
          if (_ === "%%") return "%";
          g++;
          var C = i.formatters[y];
          if (typeof C == "function") {
            var S = f[g];
            _ = C.call(m, S), f.splice(g, 1), g--;
          }
          return _;
        }), i.formatArgs.call(m, f);
        var w = m.log || i.log;
        w.apply(m, f);
      }
    }
    return u.namespace = t, u.useColors = i.useColors(), u.color = i.selectColor(t), u.extend = n, u.destroy = i.destroy, Object.defineProperty(u, "enabled", { enumerable: !0, configurable: !1, get: function() {
      return l !== null ? l : (s !== i.namespaces && (s = i.namespaces, c = i.enabled(t)), c);
    }, set: function(f) {
      l = f;
    } }), typeof i.init == "function" && i.init(u), u;
  }
  function n(t, r) {
    var s = i(this.namespace + (typeof r > "u" ? ":" : r) + t);
    return s.log = this.log, s;
  }
  function e(t, r) {
    for (var s = 0, c = 0, l = -1, u = 0; s < t.length; ) if (c < r.length && (r[c] === t[s] || r[c] === "*")) r[c] === "*" ? (l = c, u = s, c++) : (s++, c++);
    else {
      if (l === -1) return !1;
      c = l + 1, s = ++u;
    }
    for (; c < r.length && r[c] === "*"; ) c++;
    return c === r.length;
  }
  return i.debug = i, i.default = i, i.coerce = function(r) {
    return r instanceof Error ? r.stack || r.message : r;
  }, i.disable = function() {
    var r = [].concat(Or(i.names), Or(i.skips.map(function(s) {
      return "-" + s;
    }))).join(",");
    return i.enable(""), r;
  }, i.enable = function(r) {
    i.save(r), i.namespaces = r, i.names = [], i.skips = [];
    var s, c = U((typeof r == "string" ? r : "").trim().replace(" ", ",").split(",").filter(Boolean));
    try {
      for (c.s(); !(s = c.n()).done; ) {
        var l = s.value;
        l[0] === "-" ? i.skips.push(l.slice(1)) : i.names.push(l);
      }
    } catch (u) {
      c.e(u);
    } finally {
      c.f();
    }
  }, i.enabled = function(r) {
    var s, c = U(i.skips);
    try {
      for (c.s(); !(s = c.n()).done; ) {
        var l = s.value;
        if (e(r, l)) return !1;
      }
    } catch (p) {
      c.e(p);
    } finally {
      c.f();
    }
    var u, d = U(i.names);
    try {
      for (d.s(); !(u = d.n()).done; ) {
        var f = u.value;
        if (e(r, f)) return !0;
      }
    } catch (p) {
      d.e(p);
    } finally {
      d.f();
    }
    return !1;
  }, i.humanize = Tu, i.destroy = function() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }, Object.keys(a).forEach(function(t) {
    i[t] = a[t];
  }), i.names = [], i.skips = [], i.formatters = {}, i.selectColor = function(r) {
    for (var s = 0, c = 0; c < r.length; c++) s = (s << 5) - s + r.charCodeAt(c), s |= 0;
    return i.colors[Math.abs(s) % i.colors.length];
  }, i.enable(i.load()), i;
};
(function(o, a) {
  a.formatArgs = function(n) {
    if (n[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + n[0] + (this.useColors ? "%c " : " ") + "+" + o.exports.humanize(this.diff), !!this.useColors) {
      var e = "color: " + this.color;
      n.splice(1, 0, e, "color: inherit");
      var t = 0, r = 0;
      n[0].replace(/%[a-zA-Z%]/g, function(s) {
        s !== "%%" && (t++, s === "%c" && (r = t));
      }), n.splice(r, 0, e);
    }
  }, a.save = function(n) {
    try {
      n ? a.storage.setItem("debug", n) : a.storage.removeItem("debug");
    } catch {
    }
  }, a.load = function() {
    var n;
    try {
      n = a.storage.getItem("debug");
    } catch {
    }
    return !n && typeof process < "u" && "env" in process && (n = process.env.DEBUG), n;
  }, a.useColors = function() {
    if (typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return !0;
    if (typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
    var n;
    return typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && (n = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(n[1], 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }, a.storage = function() {
    try {
      return localStorage;
    } catch {
    }
  }(), a.destroy = /* @__PURE__ */ function() {
    var i = !1;
    return function() {
      i || (i = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  }(), a.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], a.log = console.debug || console.log || function() {
  }, o.exports = Uf(a), o.exports.formatters.j = function(i) {
    try {
      return JSON.stringify(i);
    } catch (n) {
      return "[UnexpectedJSONParseError]: " + n.message;
    }
  };
})(as, as.exports), Object.defineProperty(ni, "__esModule", { value: !0 }), ni.Logger = void 0;
var un = as.exports, dn = "awaitqueue", zf = function() {
  function o(a) {
    Pe(this, o), a ? (this._debug = un("".concat(dn, ":").concat(a)), this._warn = un("".concat(dn, ":WARN:").concat(a)), this._error = un("".concat(dn, ":ERROR:").concat(a))) : (this._debug = un(dn), this._warn = un("".concat(dn, ":WARN")), this._error = un("".concat(dn, ":ERROR"))), this._debug.log = console.info.bind(console), this._warn.log = console.warn.bind(console), this._error.log = console.error.bind(console);
  }
  return Te(o, [{ key: "debug", get: function() {
    return this._debug;
  } }, { key: "warn", get: function() {
    return this._warn;
  } }, { key: "error", get: function() {
    return this._error;
  } }]), o;
}();
ni.Logger = zf;
var Xr = {};
Object.defineProperty(Xr, "__esModule", { value: !0 }), Xr.AwaitQueueRemovedTaskError = Xr.AwaitQueueStoppedError = void 0;
var Gf = function(o) {
  Qe(i, Mn(Error));
  var a = Je(i);
  function i(n) {
    var e;
    return Pe(this, i), (e = a.call(this, n ?? "queue stopped")).name = "AwaitQueueStoppedError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(Mr(e), i), e;
  }
  return Te(i);
}();
Xr.AwaitQueueStoppedError = Gf;
var qf = function(o) {
  Qe(i, Mn(Error));
  var a = Je(i);
  function i(n) {
    var e;
    return Pe(this, i), (e = a.call(this, n ?? "queue task removed")).name = "AwaitQueueRemovedTaskError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(Mr(e), i), e;
  }
  return Te(i);
}();
Xr.AwaitQueueRemovedTaskError = qf, Object.defineProperty(ri, "__esModule", { value: !0 }), ri.AwaitQueue = void 0;
var ko, xo = Xr, vr = new ni.Logger("AwaitQueue"), Kf = function() {
  function o() {
    Pe(this, o), this.pendingTasks = /* @__PURE__ */ new Map(), this.nextTaskId = 0, this.stopping = !1, vr.debug("constructor()");
  }
  return Te(o, [{ key: "size", get: function() {
    return this.pendingTasks.size;
  } }, { key: "push", value: function() {
    var a = R(v().mark(function i(n, e) {
      var t, r = this;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (e = (t = e) !== null && t !== void 0 ? t : n.name, vr.debug("push() [name:".concat(e, "]")), typeof n == "function") {
              c.next = 4;
              break;
            }
            throw new TypeError("given task is not a function");
          case 4:
            if (e) try {
              Object.defineProperty(n, "name", { value: e });
            } catch {
            }
            return c.abrupt("return", new Promise(function(l, u) {
              var d = { id: r.nextTaskId++, task: n, name: e, enqueuedAt: Date.now(), executedAt: void 0, completed: !1, resolve: function(p) {
                if (!d.completed) {
                  d.completed = !0, r.pendingTasks.delete(d.id), vr.debug("resolving task [name:".concat(d.name, "]")), l(p);
                  var m = Wr(r.pendingTasks.values(), 1)[0];
                  m && !m.executedAt && r.execute(m);
                }
              }, reject: function(p) {
                if (!d.completed && (d.completed = !0, r.pendingTasks.delete(d.id), vr.debug("rejecting task [name:".concat(d.name, "]: %s"), String(p)), u(p), !r.stopping)) {
                  var m = Wr(r.pendingTasks.values(), 1)[0];
                  m && !m.executedAt && r.execute(m);
                }
              } };
              r.pendingTasks.set(d.id, d), r.pendingTasks.size === 1 && r.execute(d);
            }));
          case 6:
          case "end":
            return c.stop();
        }
      }, i);
    }));
    return function(n, e) {
      return a.apply(this, arguments);
    };
  }() }, { key: "stop", value: function() {
    vr.debug("stop()"), this.stopping = !0;
    var i, n = U(this.pendingTasks.values());
    try {
      for (n.s(); !(i = n.n()).done; ) {
        var e = i.value;
        vr.debug("stop() | stopping task [name:".concat(e.name, "]")), e.reject(new xo.AwaitQueueStoppedError());
      }
    } catch (t) {
      n.e(t);
    } finally {
      n.f();
    }
    this.stopping = !1;
  } }, { key: "remove", value: function(i) {
    vr.debug("remove() [taskIdx:".concat(i, "]"));
    var n = Array.from(this.pendingTasks.values())[i];
    n ? n.reject(new xo.AwaitQueueRemovedTaskError()) : vr.debug("stop() | no task with given idx [taskIdx:".concat(i, "]"));
  } }, { key: "dump", value: function() {
    var i = Date.now(), n = 0;
    return Array.from(this.pendingTasks.values()).map(function(e) {
      return { idx: n++, task: e.task, name: e.name, enqueuedTime: e.executedAt ? e.executedAt - e.enqueuedAt : i - e.enqueuedAt, executionTime: e.executedAt ? i - e.executedAt : 0 };
    });
  } }, { key: "execute", value: function() {
    var a = R(v().mark(function i(n) {
      var e;
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            if (vr.debug("execute() [name:".concat(n.name, "]")), !n.executedAt) {
              r.next = 3;
              break;
            }
            throw new Error("task already being executed");
          case 3:
            return n.executedAt = Date.now(), r.prev = 4, r.next = 7, n.task();
          case 7:
            e = r.sent, n.resolve(e), r.next = 14;
            break;
          case 11:
            r.prev = 11, r.t0 = r.catch(4), n.reject(r.t0);
          case 14:
          case "end":
            return r.stop();
        }
      }, i, null, [[4, 11]]);
    }));
    return function(n) {
      return a.apply(this, arguments);
    };
  }() }]), o;
}();
ri.AwaitQueue = Kf, function(o) {
  Object.defineProperty(o, "__esModule", { value: !0 }), o.AwaitQueueRemovedTaskError = o.AwaitQueueStoppedError = o.AwaitQueue = void 0;
  var a = ri;
  Object.defineProperty(o, "AwaitQueue", { enumerable: !0, get: function() {
    return a.AwaitQueue;
  } });
  var i = Xr;
  Object.defineProperty(o, "AwaitQueueStoppedError", { enumerable: !0, get: function() {
    return i.AwaitQueueStoppedError;
  } }), Object.defineProperty(o, "AwaitQueueRemovedTaskError", { enumerable: !0, get: function() {
    return i.AwaitQueueRemovedTaskError;
  } });
}(ju);
var Hf = typeof queueMicrotask == "function" ? queueMicrotask.bind(typeof window < "u" ? window : K) : function(o) {
  return (ko || (ko = Promise.resolve())).then(o).catch(function(a) {
    return setTimeout(function() {
      throw a;
    }, 0);
  });
}, ua = {};
Object.defineProperty(ua, "__esModule", { value: !0 }), ua.Producer = void 0;
var Ro = ur, ln = ft, Zt = new rt.Logger("Producer"), Yf = function(o) {
  Qe(i, Ro.EnhancedEventEmitter);
  var a = Je(i);
  function i(n) {
    var e, t = n.id, r = n.localId, s = n.rtpSender, c = n.track, l = n.rtpParameters, u = n.stopTracks, d = n.disableTrackOnPause, f = n.zeroRtpOnPause, p = n.appData;
    return Pe(this, i), (e = a.call(this))._closed = !1, e._observer = new Ro.EnhancedEventEmitter(), Zt.debug("constructor()"), e._id = t, e._localId = r, e._rtpSender = s, e._track = c, e._kind = c.kind, e._rtpParameters = l, e._paused = !!d && !c.enabled, e._maxSpatialLayer = void 0, e._stopTracks = u, e._disableTrackOnPause = d, e._zeroRtpOnPause = f, e._appData = p ?? {}, e.onTrackEnded = e.onTrackEnded.bind(Mr(e)), e.handleTrack(), e;
  }
  return Te(i, [{ key: "id", get: function() {
    return this._id;
  } }, { key: "localId", get: function() {
    return this._localId;
  } }, { key: "closed", get: function() {
    return this._closed;
  } }, { key: "kind", get: function() {
    return this._kind;
  } }, { key: "rtpSender", get: function() {
    return this._rtpSender;
  } }, { key: "track", get: function() {
    return this._track;
  } }, { key: "rtpParameters", get: function() {
    return this._rtpParameters;
  } }, { key: "paused", get: function() {
    return this._paused;
  } }, { key: "maxSpatialLayer", get: function() {
    return this._maxSpatialLayer;
  } }, { key: "appData", get: function() {
    return this._appData;
  }, set: function(e) {
    this._appData = e;
  } }, { key: "observer", get: function() {
    return this._observer;
  } }, { key: "close", value: function() {
    this._closed || (Zt.debug("close()"), this._closed = !0, this.destroyTrack(), this.emit("@close"), this._observer.safeEmit("close"));
  } }, { key: "transportClosed", value: function() {
    this._closed || (Zt.debug("transportClosed()"), this._closed = !0, this.destroyTrack(), this.safeEmit("transportclose"), this._observer.safeEmit("close"));
  } }, { key: "getStats", value: function() {
    var n = R(v().mark(function e() {
      var t = this;
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            if (!this._closed) {
              s.next = 2;
              break;
            }
            throw new ln.InvalidStateError("closed");
          case 2:
            return s.abrupt("return", new Promise(function(c, l) {
              t.safeEmit("@getstats", c, l);
            }));
          case 3:
          case "end":
            return s.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "pause", value: function() {
    var e = this;
    Zt.debug("pause()"), this._closed ? Zt.error("pause() | Producer closed") : (this._paused = !0, this._track && this._disableTrackOnPause && (this._track.enabled = !1), this._zeroRtpOnPause && new Promise(function(t, r) {
      e.safeEmit("@pause", t, r);
    }).catch(function() {
    }), this._observer.safeEmit("pause"));
  } }, { key: "resume", value: function() {
    var e = this;
    Zt.debug("resume()"), this._closed ? Zt.error("resume() | Producer closed") : (this._paused = !1, this._track && this._disableTrackOnPause && (this._track.enabled = !0), this._zeroRtpOnPause && new Promise(function(t, r) {
      e.safeEmit("@resume", t, r);
    }).catch(function() {
    }), this._observer.safeEmit("resume"));
  } }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s = this;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (r = t.track, Zt.debug("replaceTrack() [track:%o]", r), !this._closed) {
              l.next = 7;
              break;
            }
            if (r && this._stopTracks) try {
              r.stop();
            } catch {
            }
            throw new ln.InvalidStateError("closed");
          case 7:
            if (!r || r.readyState !== "ended") {
              l.next = 9;
              break;
            }
            throw new ln.InvalidStateError("track ended");
          case 9:
            if (r !== this._track) {
              l.next = 12;
              break;
            }
            return Zt.debug("replaceTrack() | same track, ignored"), l.abrupt("return");
          case 12:
            return l.next = 14, new Promise(function(u, d) {
              s.safeEmit("@replacetrack", r, u, d);
            });
          case 14:
            this.destroyTrack(), this._track = r, this._track && this._disableTrackOnPause && (this._paused ? this._paused && (this._track.enabled = !1) : this._track.enabled = !0), this.handleTrack();
          case 18:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t) {
      var r = this;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (!this._closed) {
              c.next = 4;
              break;
            }
            throw new ln.InvalidStateError("closed");
          case 4:
            if (this._kind === "video") {
              c.next = 8;
              break;
            }
            throw new ln.UnsupportedError("not a video Producer");
          case 8:
            if (typeof t == "number") {
              c.next = 10;
              break;
            }
            throw new TypeError("invalid spatialLayer");
          case 10:
            if (t !== this._maxSpatialLayer) {
              c.next = 12;
              break;
            }
            return c.abrupt("return");
          case 12:
            return c.next = 14, new Promise(function(l, u) {
              r.safeEmit("@setmaxspatiallayer", t, l, u);
            }).catch(function() {
            });
          case 14:
            this._maxSpatialLayer = t;
          case 15:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t) {
      var r = this;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (!this._closed) {
              c.next = 4;
              break;
            }
            throw new ln.InvalidStateError("closed");
          case 4:
            if (typeof t == "object") {
              c.next = 6;
              break;
            }
            throw new TypeError("invalid params");
          case 6:
            return c.next = 8, new Promise(function(l, u) {
              r.safeEmit("@setrtpencodingparameters", t, l, u);
            });
          case 8:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "onTrackEnded", value: function() {
    Zt.debug('track "ended" event'), this.safeEmit("trackended"), this._observer.safeEmit("trackended");
  } }, { key: "handleTrack", value: function() {
    this._track && this._track.addEventListener("ended", this.onTrackEnded);
  } }, { key: "destroyTrack", value: function() {
    if (this._track) try {
      this._track.removeEventListener("ended", this.onTrackEnded), this._stopTracks && this._track.stop();
    } catch {
    }
  } }]), i;
}();
ua.Producer = Yf;
var da = {};
Object.defineProperty(da, "__esModule", { value: !0 }), da.Consumer = void 0;
var Io = ur, Wf = ft, Qt = new rt.Logger("Consumer"), Xf = function(o) {
  Qe(i, Io.EnhancedEventEmitter);
  var a = Je(i);
  function i(n) {
    var e, t = n.id, r = n.localId, s = n.producerId, c = n.rtpReceiver, l = n.track, u = n.rtpParameters, d = n.appData;
    return Pe(this, i), (e = a.call(this))._closed = !1, e._observer = new Io.EnhancedEventEmitter(), Qt.debug("constructor()"), e._id = t, e._localId = r, e._producerId = s, e._rtpReceiver = c, e._track = l, e._rtpParameters = u, e._paused = !l.enabled, e._appData = d ?? {}, e.onTrackEnded = e.onTrackEnded.bind(Mr(e)), e.handleTrack(), e;
  }
  return Te(i, [{ key: "id", get: function() {
    return this._id;
  } }, { key: "localId", get: function() {
    return this._localId;
  } }, { key: "producerId", get: function() {
    return this._producerId;
  } }, { key: "closed", get: function() {
    return this._closed;
  } }, { key: "kind", get: function() {
    return this._track.kind;
  } }, { key: "rtpReceiver", get: function() {
    return this._rtpReceiver;
  } }, { key: "track", get: function() {
    return this._track;
  } }, { key: "rtpParameters", get: function() {
    return this._rtpParameters;
  } }, { key: "paused", get: function() {
    return this._paused;
  } }, { key: "appData", get: function() {
    return this._appData;
  }, set: function(e) {
    this._appData = e;
  } }, { key: "observer", get: function() {
    return this._observer;
  } }, { key: "close", value: function() {
    this._closed || (Qt.debug("close()"), this._closed = !0, this.destroyTrack(), this.emit("@close"), this._observer.safeEmit("close"));
  } }, { key: "transportClosed", value: function() {
    this._closed || (Qt.debug("transportClosed()"), this._closed = !0, this.destroyTrack(), this.safeEmit("transportclose"), this._observer.safeEmit("close"));
  } }, { key: "getStats", value: function() {
    var n = R(v().mark(function e() {
      var t = this;
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            if (!this._closed) {
              s.next = 2;
              break;
            }
            throw new Wf.InvalidStateError("closed");
          case 2:
            return s.abrupt("return", new Promise(function(c, l) {
              t.safeEmit("@getstats", c, l);
            }));
          case 3:
          case "end":
            return s.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "pause", value: function() {
    Qt.debug("pause()"), this._closed ? Qt.error("pause() | Consumer closed") : this._paused ? Qt.debug("pause() | Consumer is already paused") : (this._paused = !0, this._track.enabled = !1, this.emit("@pause"), this._observer.safeEmit("pause"));
  } }, { key: "resume", value: function() {
    Qt.debug("resume()"), this._closed ? Qt.error("resume() | Consumer closed") : this._paused ? (this._paused = !1, this._track.enabled = !0, this.emit("@resume"), this._observer.safeEmit("resume")) : Qt.debug("resume() | Consumer is already resumed");
  } }, { key: "onTrackEnded", value: function() {
    Qt.debug('track "ended" event'), this.safeEmit("trackended"), this._observer.safeEmit("trackended");
  } }, { key: "handleTrack", value: function() {
    this._track.addEventListener("ended", this.onTrackEnded);
  } }, { key: "destroyTrack", value: function() {
    try {
      this._track.removeEventListener("ended", this.onTrackEnded), this._track.stop();
    } catch {
    }
  } }]), i;
}();
da.Consumer = Xf;
var la = {};
Object.defineProperty(la, "__esModule", { value: !0 }), la.DataProducer = void 0;
var Po = ur, Zf = ft, gr = new rt.Logger("DataProducer"), Qf = function(o) {
  Qe(i, Po.EnhancedEventEmitter);
  var a = Je(i);
  function i(n) {
    var e, t = n.id, r = n.dataChannel, s = n.sctpStreamParameters, c = n.appData;
    return Pe(this, i), (e = a.call(this))._closed = !1, e._observer = new Po.EnhancedEventEmitter(), gr.debug("constructor()"), e._id = t, e._dataChannel = r, e._sctpStreamParameters = s, e._appData = c ?? {}, e.handleDataChannel(), e;
  }
  return Te(i, [{ key: "id", get: function() {
    return this._id;
  } }, { key: "closed", get: function() {
    return this._closed;
  } }, { key: "sctpStreamParameters", get: function() {
    return this._sctpStreamParameters;
  } }, { key: "readyState", get: function() {
    return this._dataChannel.readyState;
  } }, { key: "label", get: function() {
    return this._dataChannel.label;
  } }, { key: "protocol", get: function() {
    return this._dataChannel.protocol;
  } }, { key: "bufferedAmount", get: function() {
    return this._dataChannel.bufferedAmount;
  } }, { key: "bufferedAmountLowThreshold", get: function() {
    return this._dataChannel.bufferedAmountLowThreshold;
  }, set: function(e) {
    this._dataChannel.bufferedAmountLowThreshold = e;
  } }, { key: "appData", get: function() {
    return this._appData;
  }, set: function(e) {
    this._appData = e;
  } }, { key: "observer", get: function() {
    return this._observer;
  } }, { key: "close", value: function() {
    this._closed || (gr.debug("close()"), this._closed = !0, this._dataChannel.close(), this.emit("@close"), this._observer.safeEmit("close"));
  } }, { key: "transportClosed", value: function() {
    this._closed || (gr.debug("transportClosed()"), this._closed = !0, this._dataChannel.close(), this.safeEmit("transportclose"), this._observer.safeEmit("close"));
  } }, { key: "send", value: function(e) {
    if (gr.debug("send()"), this._closed) throw new Zf.InvalidStateError("closed");
    this._dataChannel.send(e);
  } }, { key: "handleDataChannel", value: function() {
    var e = this;
    this._dataChannel.addEventListener("open", function() {
      e._closed || (gr.debug('DataChannel "open" event'), e.safeEmit("open"));
    }), this._dataChannel.addEventListener("error", function(t) {
      if (!e._closed) {
        var r = t.error;
        r || (r = new Error("unknown DataChannel error")), r.errorDetail === "sctp-failure" ? gr.error("DataChannel SCTP error [sctpCauseCode:%s]: %s", r.sctpCauseCode, r.message) : gr.error('DataChannel "error" event: %o', r), e.safeEmit("error", r);
      }
    }), this._dataChannel.addEventListener("close", function() {
      e._closed || (gr.warn('DataChannel "close" event'), e._closed = !0, e.emit("@close"), e.safeEmit("close"), e._observer.safeEmit("close"));
    }), this._dataChannel.addEventListener("message", function() {
      e._closed || gr.warn('DataChannel "message" event in a DataProducer, message discarded');
    }), this._dataChannel.addEventListener("bufferedamountlow", function() {
      e._closed || e.safeEmit("bufferedamountlow");
    });
  } }]), i;
}();
la.DataProducer = Qf;
var pa = {};
Object.defineProperty(pa, "__esModule", { value: !0 }), pa.DataConsumer = void 0;
var To = ur, qr = new rt.Logger("DataConsumer"), Jf = function(o) {
  Qe(i, To.EnhancedEventEmitter);
  var a = Je(i);
  function i(n) {
    var e, t = n.id, r = n.dataProducerId, s = n.dataChannel, c = n.sctpStreamParameters, l = n.appData;
    return Pe(this, i), (e = a.call(this))._closed = !1, e._observer = new To.EnhancedEventEmitter(), qr.debug("constructor()"), e._id = t, e._dataProducerId = r, e._dataChannel = s, e._sctpStreamParameters = c, e._appData = l ?? {}, e.handleDataChannel(), e;
  }
  return Te(i, [{ key: "id", get: function() {
    return this._id;
  } }, { key: "dataProducerId", get: function() {
    return this._dataProducerId;
  } }, { key: "closed", get: function() {
    return this._closed;
  } }, { key: "sctpStreamParameters", get: function() {
    return this._sctpStreamParameters;
  } }, { key: "readyState", get: function() {
    return this._dataChannel.readyState;
  } }, { key: "label", get: function() {
    return this._dataChannel.label;
  } }, { key: "protocol", get: function() {
    return this._dataChannel.protocol;
  } }, { key: "binaryType", get: function() {
    return this._dataChannel.binaryType;
  }, set: function(e) {
    this._dataChannel.binaryType = e;
  } }, { key: "appData", get: function() {
    return this._appData;
  }, set: function(e) {
    this._appData = e;
  } }, { key: "observer", get: function() {
    return this._observer;
  } }, { key: "close", value: function() {
    this._closed || (qr.debug("close()"), this._closed = !0, this._dataChannel.close(), this.emit("@close"), this._observer.safeEmit("close"));
  } }, { key: "transportClosed", value: function() {
    this._closed || (qr.debug("transportClosed()"), this._closed = !0, this._dataChannel.close(), this.safeEmit("transportclose"), this._observer.safeEmit("close"));
  } }, { key: "handleDataChannel", value: function() {
    var e = this;
    this._dataChannel.addEventListener("open", function() {
      e._closed || (qr.debug('DataChannel "open" event'), e.safeEmit("open"));
    }), this._dataChannel.addEventListener("error", function(t) {
      if (!e._closed) {
        var r = t.error;
        r || (r = new Error("unknown DataChannel error")), r.errorDetail === "sctp-failure" ? qr.error("DataChannel SCTP error [sctpCauseCode:%s]: %s", r.sctpCauseCode, r.message) : qr.error('DataChannel "error" event: %o', r), e.safeEmit("error", r);
      }
    }), this._dataChannel.addEventListener("close", function() {
      e._closed || (qr.warn('DataChannel "close" event'), e._closed = !0, e.emit("@close"), e.safeEmit("close"), e._observer.safeEmit("close"));
    }), this._dataChannel.addEventListener("message", function(t) {
      e._closed || e.safeEmit("message", t.data);
    });
  } }]), i;
}();
pa.DataConsumer = Jf;
var eh = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), th = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), Nu = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && eh(i, a, n[e]);
    return th(i, a), i;
  };
}(), rh = K && K.__importDefault || function(o) {
  return o && o.__esModule ? o : { default: o };
};
Object.defineProperty(ca, "__esModule", { value: !0 }), ca.Transport = void 0;
var nh = ju, Bi = rh(Hf), ah = rt, Do = ur, mt = ft, Vi = Nu(ct), Xn = Nu(Ye), ih = ua, sh = da, oh = la, ch = pa, st = new ah.Logger("Transport"), uh = Te(function o(a) {
  var i = this;
  Pe(this, o), this.consumerOptions = a, this.promise = new Promise(function(n, e) {
    i.resolve = n, i.reject = e;
  });
}), dh = function(o) {
  Qe(i, Do.EnhancedEventEmitter);
  var a = Je(i);
  function i(n) {
    var e, t, r = n.direction, s = n.id, c = n.iceParameters, l = n.iceCandidates, u = n.dtlsParameters, d = n.sctpParameters, f = n.iceServers, p = n.iceTransportPolicy, m = n.additionalSettings, b = n.proprietaryConstraints, h = n.appData, g = n.handlerFactory, w = n.extendedRtpCapabilities, _ = n.canProduceByKind;
    Pe(this, i), (t = a.call(this))._closed = !1, t._iceGatheringState = "new", t._connectionState = "new", t._producers = /* @__PURE__ */ new Map(), t._consumers = /* @__PURE__ */ new Map(), t._dataProducers = /* @__PURE__ */ new Map(), t._dataConsumers = /* @__PURE__ */ new Map(), t._probatorConsumerCreated = !1, t._awaitQueue = new nh.AwaitQueue(), t._pendingConsumerTasks = [], t._consumerCreationInProgress = !1, t._pendingPauseConsumers = /* @__PURE__ */ new Map(), t._consumerPauseInProgress = !1, t._pendingResumeConsumers = /* @__PURE__ */ new Map(), t._consumerResumeInProgress = !1, t._pendingCloseConsumers = /* @__PURE__ */ new Map(), t._consumerCloseInProgress = !1, t._observer = new Do.EnhancedEventEmitter(), st.debug("constructor() [id:%s, direction:%s]", s, r), t._id = s, t._direction = r, t._extendedRtpCapabilities = w, t._canProduceByKind = _, t._maxSctpMessageSize = d ? d.maxMessageSize : null;
    var y = (e = Vi.clone(m)) !== null && e !== void 0 ? e : {};
    return delete y.iceServers, delete y.iceTransportPolicy, delete y.bundlePolicy, delete y.rtcpMuxPolicy, delete y.sdpSemantics, t._handler = g(), t._handler.run({ direction: r, iceParameters: c, iceCandidates: l, dtlsParameters: u, sctpParameters: d, iceServers: f, iceTransportPolicy: p, additionalSettings: y, proprietaryConstraints: b, extendedRtpCapabilities: w }), t._appData = h ?? {}, t.handleHandler(), t;
  }
  return Te(i, [{ key: "id", get: function() {
    return this._id;
  } }, { key: "closed", get: function() {
    return this._closed;
  } }, { key: "direction", get: function() {
    return this._direction;
  } }, { key: "handler", get: function() {
    return this._handler;
  } }, { key: "iceGatheringState", get: function() {
    return this._iceGatheringState;
  } }, { key: "connectionState", get: function() {
    return this._connectionState;
  } }, { key: "appData", get: function() {
    return this._appData;
  }, set: function(e) {
    this._appData = e;
  } }, { key: "observer", get: function() {
    return this._observer;
  } }, { key: "close", value: function() {
    if (!this._closed) {
      st.debug("close()"), this._closed = !0, this._awaitQueue.stop(), this._handler.close(), this._connectionState = "closed";
      var e, t = U(this._producers.values());
      try {
        for (t.s(); !(e = t.n()).done; )
          e.value.transportClosed();
      } catch (f) {
        t.e(f);
      } finally {
        t.f();
      }
      this._producers.clear();
      var r, s = U(this._consumers.values());
      try {
        for (s.s(); !(r = s.n()).done; )
          r.value.transportClosed();
      } catch (f) {
        s.e(f);
      } finally {
        s.f();
      }
      this._consumers.clear();
      var c, l = U(this._dataProducers.values());
      try {
        for (l.s(); !(c = l.n()).done; )
          c.value.transportClosed();
      } catch (f) {
        l.e(f);
      } finally {
        l.f();
      }
      this._dataProducers.clear();
      var u, d = U(this._dataConsumers.values());
      try {
        for (d.s(); !(u = d.n()).done; )
          u.value.transportClosed();
      } catch (f) {
        d.e(f);
      } finally {
        d.f();
      }
      this._dataConsumers.clear(), this._observer.safeEmit("close");
    }
  } }, { key: "getStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            if (!this._closed) {
              r.next = 2;
              break;
            }
            throw new mt.InvalidStateError("closed");
          case 2:
            return r.abrupt("return", this._handler.getTransportStats());
          case 3:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s = this;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (r = t.iceParameters, st.debug("restartIce()"), !this._closed) {
              l.next = 6;
              break;
            }
            throw new mt.InvalidStateError("closed");
          case 6:
            if (r) {
              l.next = 8;
              break;
            }
            throw new TypeError("missing iceParameters");
          case 8:
            return l.abrupt("return", this._awaitQueue.push(R(v().mark(function u() {
              return v().wrap(function(f) {
                for (; ; ) switch (f.prev = f.next) {
                  case 0:
                    return f.next = 2, s._handler.restartIce(r);
                  case 2:
                    return f.abrupt("return", f.sent);
                  case 3:
                  case "end":
                    return f.stop();
                }
              }, u);
            })), "transport.restartIce()"));
          case 9:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s = this, c = arguments;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (t = c.length > 0 && c[0] !== void 0 ? c[0] : {}, r = t.iceServers, st.debug("updateIceServers()"), !this._closed) {
              u.next = 6;
              break;
            }
            throw new mt.InvalidStateError("closed");
          case 6:
            if (Array.isArray(r)) {
              u.next = 8;
              break;
            }
            throw new TypeError("missing iceServers");
          case 8:
            return u.abrupt("return", this._awaitQueue.push(R(v().mark(function d() {
              return v().wrap(function(p) {
                for (; ; ) switch (p.prev = p.next) {
                  case 0:
                    return p.abrupt("return", s._handler.updateIceServers(r));
                  case 1:
                  case "end":
                    return p.stop();
                }
              }, d);
            })), "transport.updateIceServers()"));
          case 9:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "produce", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c, l, u, d, f, p, m, b, h, g, w, _ = this, y = arguments;
      return v().wrap(function(S) {
        for (; ; ) switch (S.prev = S.next) {
          case 0:
            if (t = y.length > 0 && y[0] !== void 0 ? y[0] : {}, r = t.track, s = t.encodings, c = t.codecOptions, l = t.codec, u = t.stopTracks, d = u === void 0 || u, f = t.disableTrackOnPause, p = f === void 0 || f, m = t.zeroRtpOnPause, b = m !== void 0 && m, h = t.onRtpSender, g = t.appData, w = g === void 0 ? {} : g, st.debug("produce() [track:%o]", r), !this._closed) {
              S.next = 6;
              break;
            }
            throw new mt.InvalidStateError("closed");
          case 6:
            if (r) {
              S.next = 10;
              break;
            }
            throw new TypeError("missing track");
          case 10:
            if (this._direction === "send") {
              S.next = 14;
              break;
            }
            throw new mt.UnsupportedError("not a sending Transport");
          case 14:
            if (this._canProduceByKind[r.kind]) {
              S.next = 18;
              break;
            }
            throw new mt.UnsupportedError("cannot produce ".concat(r.kind));
          case 18:
            if (r.readyState !== "ended") {
              S.next = 22;
              break;
            }
            throw new mt.InvalidStateError("track ended");
          case 22:
            if (this.listenerCount("connect") !== 0 || this._connectionState !== "new") {
              S.next = 26;
              break;
            }
            throw new TypeError('no "connect" listener set into this transport');
          case 26:
            if (this.listenerCount("produce") !== 0) {
              S.next = 30;
              break;
            }
            throw new TypeError('no "produce" listener set into this transport');
          case 30:
            if (!w || typeof w == "object") {
              S.next = 32;
              break;
            }
            throw new TypeError("if given, appData must be an object");
          case 32:
            return S.abrupt("return", this._awaitQueue.push(R(v().mark(function P() {
              var T, I, k, x, O, D, A, E;
              return v().wrap(function(B) {
                for (; ; ) switch (B.prev = B.next) {
                  case 0:
                    if (!s || Array.isArray(s)) {
                      B.next = 4;
                      break;
                    }
                    throw TypeError("encodings must be an array");
                  case 4:
                    s && s.length === 0 ? T = void 0 : s && (T = s.map(function($) {
                      var M = { active: !0 };
                      return $.active === !1 && (M.active = !1), typeof $.dtx == "boolean" && (M.dtx = $.dtx), typeof $.scalabilityMode == "string" && (M.scalabilityMode = $.scalabilityMode), typeof $.scaleResolutionDownBy == "number" && (M.scaleResolutionDownBy = $.scaleResolutionDownBy), typeof $.maxBitrate == "number" && (M.maxBitrate = $.maxBitrate), typeof $.maxFramerate == "number" && (M.maxFramerate = $.maxFramerate), typeof $.adaptivePtime == "boolean" && (M.adaptivePtime = $.adaptivePtime), typeof $.priority == "string" && (M.priority = $.priority), typeof $.networkPriority == "string" && (M.networkPriority = $.networkPriority), M;
                    }));
                  case 5:
                    return B.next = 7, _._handler.send({ track: r, encodings: T, codecOptions: c, codec: l, onRtpSender: h });
                  case 7:
                    return I = B.sent, k = I.localId, x = I.rtpParameters, O = I.rtpSender, B.prev = 11, Xn.validateRtpParameters(x), B.next = 15, new Promise(function($, M) {
                      _.safeEmit("produce", { kind: r.kind, rtpParameters: x, appData: w }, $, M);
                    });
                  case 15:
                    return D = B.sent, A = D.id, E = new ih.Producer({ id: A, localId: k, rtpSender: O, track: r, rtpParameters: x, stopTracks: d, disableTrackOnPause: p, zeroRtpOnPause: b, appData: w }), _._producers.set(E.id, E), _.handleProducer(E), _._observer.safeEmit("newproducer", E), B.abrupt("return", E);
                  case 24:
                    throw B.prev = 24, B.t0 = B.catch(11), _._handler.stopSending(k).catch(function() {
                    }), B.t0;
                  case 28:
                  case "end":
                    return B.stop();
                }
              }, P, null, [[11, 24]]);
            })), "transport.produce()").catch(function(P) {
              if (d) try {
                r.stop();
              } catch {
              }
              throw P;
            }));
          case 33:
          case "end":
            return S.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "consume", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h = this;
      return v().wrap(function(w) {
        for (; ; ) switch (w.prev = w.next) {
          case 0:
            if (r = t.id, s = t.producerId, c = t.kind, l = t.rtpParameters, u = t.streamId, d = t.onRtpReceiver, f = t.appData, p = f === void 0 ? {} : f, st.debug("consume()"), !this._closed) {
              w.next = 6;
              break;
            }
            throw new mt.InvalidStateError("closed");
          case 6:
            if (this._direction === "recv") {
              w.next = 10;
              break;
            }
            throw new mt.UnsupportedError("not a receiving Transport");
          case 10:
            if (typeof r == "string") {
              w.next = 14;
              break;
            }
            throw new TypeError("missing id");
          case 14:
            if (typeof s == "string") {
              w.next = 18;
              break;
            }
            throw new TypeError("missing producerId");
          case 18:
            if (c === "audio" || c === "video") {
              w.next = 22;
              break;
            }
            throw new TypeError("invalid kind '".concat(c, "'"));
          case 22:
            if (this.listenerCount("connect") !== 0 || this._connectionState !== "new") {
              w.next = 26;
              break;
            }
            throw new TypeError('no "connect" listener set into this transport');
          case 26:
            if (!p || typeof p == "object") {
              w.next = 28;
              break;
            }
            throw new TypeError("if given, appData must be an object");
          case 28:
            if (m = Vi.clone(l), Xn.canReceive(m, this._extendedRtpCapabilities)) {
              w.next = 32;
              break;
            }
            throw new mt.UnsupportedError("cannot consume this Producer");
          case 32:
            return b = new uh({ id: r, producerId: s, kind: c, rtpParameters: m, streamId: u, onRtpReceiver: d, appData: p }), this._pendingConsumerTasks.push(b), (0, Bi.default)(function() {
              h._closed || h._consumerCreationInProgress === !1 && h.createPendingConsumers();
            }), w.abrupt("return", b.promise);
          case 36:
          case "end":
            return w.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "produceData", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c, l, u, d, f, p, m, b, h = this, g = arguments;
      return v().wrap(function(_) {
        for (; ; ) switch (_.prev = _.next) {
          case 0:
            if (t = g.length > 0 && g[0] !== void 0 ? g[0] : {}, r = t.ordered, s = r === void 0 || r, c = t.maxPacketLifeTime, l = t.maxRetransmits, u = t.label, d = u === void 0 ? "" : u, f = t.protocol, p = f === void 0 ? "" : f, m = t.appData, b = m === void 0 ? {} : m, st.debug("produceData()"), !this._closed) {
              _.next = 6;
              break;
            }
            throw new mt.InvalidStateError("closed");
          case 6:
            if (this._direction === "send") {
              _.next = 10;
              break;
            }
            throw new mt.UnsupportedError("not a sending Transport");
          case 10:
            if (this._maxSctpMessageSize) {
              _.next = 14;
              break;
            }
            throw new mt.UnsupportedError("SCTP not enabled by remote Transport");
          case 14:
            if (this.listenerCount("connect") !== 0 || this._connectionState !== "new") {
              _.next = 18;
              break;
            }
            throw new TypeError('no "connect" listener set into this transport');
          case 18:
            if (this.listenerCount("producedata") !== 0) {
              _.next = 22;
              break;
            }
            throw new TypeError('no "producedata" listener set into this transport');
          case 22:
            if (!b || typeof b == "object") {
              _.next = 24;
              break;
            }
            throw new TypeError("if given, appData must be an object");
          case 24:
            return (c || l) && (s = !1), _.abrupt("return", this._awaitQueue.push(R(v().mark(function y() {
              var C, S, P, T, I, k;
              return v().wrap(function(O) {
                for (; ; ) switch (O.prev = O.next) {
                  case 0:
                    return O.next = 2, h._handler.sendDataChannel({ ordered: s, maxPacketLifeTime: c, maxRetransmits: l, label: d, protocol: p });
                  case 2:
                    return C = O.sent, S = C.dataChannel, P = C.sctpStreamParameters, Xn.validateSctpStreamParameters(P), O.next = 8, new Promise(function(D, A) {
                      h.safeEmit("producedata", { sctpStreamParameters: P, label: d, protocol: p, appData: b }, D, A);
                    });
                  case 8:
                    return T = O.sent, I = T.id, k = new oh.DataProducer({ id: I, dataChannel: S, sctpStreamParameters: P, appData: b }), h._dataProducers.set(k.id, k), h.handleDataProducer(k), h._observer.safeEmit("newdataproducer", k), O.abrupt("return", k);
                  case 15:
                  case "end":
                    return O.stop();
                }
              }, y);
            })), "transport.produceData()"));
          case 26:
          case "end":
            return _.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "consumeData", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h = this;
      return v().wrap(function(w) {
        for (; ; ) switch (w.prev = w.next) {
          case 0:
            if (r = t.id, s = t.dataProducerId, c = t.sctpStreamParameters, l = t.label, u = l === void 0 ? "" : l, d = t.protocol, f = d === void 0 ? "" : d, p = t.appData, m = p === void 0 ? {} : p, st.debug("consumeData()"), !this._closed) {
              w.next = 6;
              break;
            }
            throw new mt.InvalidStateError("closed");
          case 6:
            if (this._direction === "recv") {
              w.next = 10;
              break;
            }
            throw new mt.UnsupportedError("not a receiving Transport");
          case 10:
            if (this._maxSctpMessageSize) {
              w.next = 14;
              break;
            }
            throw new mt.UnsupportedError("SCTP not enabled by remote Transport");
          case 14:
            if (typeof r == "string") {
              w.next = 18;
              break;
            }
            throw new TypeError("missing id");
          case 18:
            if (typeof s == "string") {
              w.next = 22;
              break;
            }
            throw new TypeError("missing dataProducerId");
          case 22:
            if (this.listenerCount("connect") !== 0 || this._connectionState !== "new") {
              w.next = 26;
              break;
            }
            throw new TypeError('no "connect" listener set into this transport');
          case 26:
            if (!m || typeof m == "object") {
              w.next = 28;
              break;
            }
            throw new TypeError("if given, appData must be an object");
          case 28:
            return b = Vi.clone(c), Xn.validateSctpStreamParameters(b), w.abrupt("return", this._awaitQueue.push(R(v().mark(function _() {
              var y, C, S;
              return v().wrap(function(T) {
                for (; ; ) switch (T.prev = T.next) {
                  case 0:
                    return T.next = 2, h._handler.receiveDataChannel({ sctpStreamParameters: b, label: u, protocol: f });
                  case 2:
                    return y = T.sent, C = y.dataChannel, S = new ch.DataConsumer({ id: r, dataProducerId: s, dataChannel: C, sctpStreamParameters: b, appData: m }), h._dataConsumers.set(S.id, S), h.handleDataConsumer(S), h._observer.safeEmit("newdataconsumer", S), T.abrupt("return", S);
                  case 9:
                  case "end":
                    return T.stop();
                }
              }, _);
            })), "transport.consumeData()"));
          case 31:
          case "end":
            return w.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "createPendingConsumers", value: function() {
    var n = R(v().mark(function e() {
      var t = this;
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            this._consumerCreationInProgress = !0, this._awaitQueue.push(R(v().mark(function c() {
              var l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k, x, O, D, A, E, F, B, $, M, j, z;
              return v().wrap(function(ee) {
                for (; ; ) switch (ee.prev = ee.next) {
                  case 0:
                    if (t._pendingConsumerTasks.length !== 0) {
                      ee.next = 3;
                      break;
                    }
                    return st.debug("createPendingConsumers() | there is no Consumer to be created"), ee.abrupt("return");
                  case 3:
                    l = Or(t._pendingConsumerTasks), t._pendingConsumerTasks = [], u = void 0, d = [], f = U(l);
                    try {
                      for (f.s(); !(p = f.n()).done; ) m = p.value, b = m.consumerOptions, h = b.id, g = b.kind, w = b.rtpParameters, _ = b.streamId, y = b.onRtpReceiver, d.push({ trackId: h, kind: g, rtpParameters: w, streamId: _, onRtpReceiver: y });
                    } catch (Y) {
                      f.e(Y);
                    } finally {
                      f.f();
                    }
                    return ee.prev = 9, ee.next = 12, t._handler.receive(d);
                  case 12:
                    for (C = ee.sent, S = 0; S < C.length; ++S) P = l[S], T = C[S], I = P.consumerOptions, k = I.id, x = I.producerId, O = I.kind, D = I.rtpParameters, A = I.appData, E = T.localId, F = T.rtpReceiver, B = T.track, $ = new sh.Consumer({ id: k, localId: E, producerId: x, rtpReceiver: F, track: B, rtpParameters: D, appData: A }), t._consumers.set($.id, $), t.handleConsumer($), t._probatorConsumerCreated || u || O !== "video" || (u = $), t._observer.safeEmit("newconsumer", $), P.resolve($);
                    ee.next = 20;
                    break;
                  case 16:
                    ee.prev = 16, ee.t0 = ee.catch(9), M = U(l);
                    try {
                      for (M.s(); !(j = M.n()).done; ) j.value.reject(ee.t0);
                    } catch (Y) {
                      M.e(Y);
                    } finally {
                      M.f();
                    }
                  case 20:
                    if (!u) {
                      ee.next = 32;
                      break;
                    }
                    return ee.prev = 21, z = Xn.generateProbatorRtpParameters(u.rtpParameters), ee.next = 25, t._handler.receive([{ trackId: "probator", kind: "video", rtpParameters: z }]);
                  case 25:
                    st.debug("createPendingConsumers() | Consumer for RTP probation created"), t._probatorConsumerCreated = !0, ee.next = 32;
                    break;
                  case 29:
                    ee.prev = 29, ee.t1 = ee.catch(21), st.error("createPendingConsumers() | failed to create Consumer for RTP probation:%o", ee.t1);
                  case 32:
                  case "end":
                    return ee.stop();
                }
              }, c, null, [[9, 16], [21, 29]]);
            })), "transport.createPendingConsumers()").then(function() {
              t._consumerCreationInProgress = !1, t._pendingConsumerTasks.length > 0 && t.createPendingConsumers();
            }).catch(function() {
            });
          case 2:
          case "end":
            return s.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "pausePendingConsumers", value: function() {
    var e = this;
    this._consumerPauseInProgress = !0, this._awaitQueue.push(R(v().mark(function t() {
      var r, s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (e._pendingPauseConsumers.size !== 0) {
              l.next = 3;
              break;
            }
            return st.debug("pausePendingConsumers() | there is no Consumer to be paused"), l.abrupt("return");
          case 3:
            return r = Array.from(e._pendingPauseConsumers.values()), e._pendingPauseConsumers.clear(), l.prev = 5, s = r.map(function(u) {
              return u.localId;
            }), l.next = 9, e._handler.pauseReceiving(s);
          case 9:
            l.next = 14;
            break;
          case 11:
            l.prev = 11, l.t0 = l.catch(5), st.error("pausePendingConsumers() | failed to pause Consumers:", l.t0);
          case 14:
          case "end":
            return l.stop();
        }
      }, t, null, [[5, 11]]);
    })), "transport.pausePendingConsumers").then(function() {
      e._consumerPauseInProgress = !1, e._pendingPauseConsumers.size > 0 && e.pausePendingConsumers();
    }).catch(function() {
    });
  } }, { key: "resumePendingConsumers", value: function() {
    var e = this;
    this._consumerResumeInProgress = !0, this._awaitQueue.push(R(v().mark(function t() {
      var r, s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (e._pendingResumeConsumers.size !== 0) {
              l.next = 3;
              break;
            }
            return st.debug("resumePendingConsumers() | there is no Consumer to be resumed"), l.abrupt("return");
          case 3:
            return r = Array.from(e._pendingResumeConsumers.values()), e._pendingResumeConsumers.clear(), l.prev = 5, s = r.map(function(u) {
              return u.localId;
            }), l.next = 9, e._handler.resumeReceiving(s);
          case 9:
            l.next = 14;
            break;
          case 11:
            l.prev = 11, l.t0 = l.catch(5), st.error("resumePendingConsumers() | failed to resume Consumers:", l.t0);
          case 14:
          case "end":
            return l.stop();
        }
      }, t, null, [[5, 11]]);
    })), "transport.resumePendingConsumers").then(function() {
      e._consumerResumeInProgress = !1, e._pendingResumeConsumers.size > 0 && e.resumePendingConsumers();
    }).catch(function() {
    });
  } }, { key: "closePendingConsumers", value: function() {
    var e = this;
    this._consumerCloseInProgress = !0, this._awaitQueue.push(R(v().mark(function t() {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (e._pendingCloseConsumers.size !== 0) {
              c.next = 3;
              break;
            }
            return st.debug("closePendingConsumers() | there is no Consumer to be closed"), c.abrupt("return");
          case 3:
            return r = Array.from(e._pendingCloseConsumers.values()), e._pendingCloseConsumers.clear(), c.prev = 5, c.next = 8, e._handler.stopReceiving(r.map(function(l) {
              return l.localId;
            }));
          case 8:
            c.next = 13;
            break;
          case 10:
            c.prev = 10, c.t0 = c.catch(5), st.error("closePendingConsumers() | failed to close Consumers:", c.t0);
          case 13:
          case "end":
            return c.stop();
        }
      }, t, null, [[5, 10]]);
    })), "transport.closePendingConsumers").then(function() {
      e._consumerCloseInProgress = !1, e._pendingCloseConsumers.size > 0 && e.closePendingConsumers();
    }).catch(function() {
    });
  } }, { key: "handleHandler", value: function() {
    var e = this, t = this._handler;
    t.on("@connect", function(r, s, c) {
      var l = r.dtlsParameters;
      e._closed ? c(new mt.InvalidStateError("closed")) : e.safeEmit("connect", { dtlsParameters: l }, s, c);
    }), t.on("@icegatheringstatechange", function(r) {
      r !== e._iceGatheringState && (st.debug("ICE gathering state changed to %s", r), e._iceGatheringState = r, e._closed || e.safeEmit("icegatheringstatechange", r));
    }), t.on("@icecandidateerror", function(r) {
      st.warn("ICE candidate error [url:".concat(r.url, ", localAddress:").concat(r.address, ", localPort:").concat(r.port, "]: ").concat(r.errorCode, ' "').concat(r.errorText, '"')), e.safeEmit("icecandidateerror", r);
    }), t.on("@connectionstatechange", function(r) {
      r !== e._connectionState && (st.debug("connection state changed to %s", r), e._connectionState = r, e._closed || e.safeEmit("connectionstatechange", r));
    });
  } }, { key: "handleProducer", value: function(e) {
    var t = this;
    e.on("@close", function() {
      t._producers.delete(e.id), t._closed || t._awaitQueue.push(R(v().mark(function r() {
        return v().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              return c.next = 2, t._handler.stopSending(e.localId);
            case 2:
              return c.abrupt("return", c.sent);
            case 3:
            case "end":
              return c.stop();
          }
        }, r);
      })), "producer @close event").catch(function(r) {
        return st.warn("producer.close() failed:%o", r);
      });
    }), e.on("@pause", function(r, s) {
      t._awaitQueue.push(R(v().mark(function c() {
        return v().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.next = 2, t._handler.pauseSending(e.localId);
            case 2:
              return u.abrupt("return", u.sent);
            case 3:
            case "end":
              return u.stop();
          }
        }, c);
      })), "producer @pause event").then(r).catch(s);
    }), e.on("@resume", function(r, s) {
      t._awaitQueue.push(R(v().mark(function c() {
        return v().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.next = 2, t._handler.resumeSending(e.localId);
            case 2:
              return u.abrupt("return", u.sent);
            case 3:
            case "end":
              return u.stop();
          }
        }, c);
      })), "producer @resume event").then(r).catch(s);
    }), e.on("@replacetrack", function(r, s, c) {
      t._awaitQueue.push(R(v().mark(function l() {
        return v().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              return d.next = 2, t._handler.replaceTrack(e.localId, r);
            case 2:
              return d.abrupt("return", d.sent);
            case 3:
            case "end":
              return d.stop();
          }
        }, l);
      })), "producer @replacetrack event").then(s).catch(c);
    }), e.on("@setmaxspatiallayer", function(r, s, c) {
      t._awaitQueue.push(R(v().mark(function l() {
        return v().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              return d.next = 2, t._handler.setMaxSpatialLayer(e.localId, r);
            case 2:
              return d.abrupt("return", d.sent);
            case 3:
            case "end":
              return d.stop();
          }
        }, l);
      })), "producer @setmaxspatiallayer event").then(s).catch(c);
    }), e.on("@setrtpencodingparameters", function(r, s, c) {
      t._awaitQueue.push(R(v().mark(function l() {
        return v().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              return d.next = 2, t._handler.setRtpEncodingParameters(e.localId, r);
            case 2:
              return d.abrupt("return", d.sent);
            case 3:
            case "end":
              return d.stop();
          }
        }, l);
      })), "producer @setrtpencodingparameters event").then(s).catch(c);
    }), e.on("@getstats", function(r, s) {
      if (t._closed) return s(new mt.InvalidStateError("closed"));
      t._handler.getSenderStats(e.localId).then(r).catch(s);
    });
  } }, { key: "handleConsumer", value: function(e) {
    var t = this;
    e.on("@close", function() {
      t._consumers.delete(e.id), t._pendingPauseConsumers.delete(e.id), t._pendingResumeConsumers.delete(e.id), t._closed || (t._pendingCloseConsumers.set(e.id, e), t._consumerCloseInProgress === !1 && t.closePendingConsumers());
    }), e.on("@pause", function() {
      t._pendingResumeConsumers.has(e.id) && t._pendingResumeConsumers.delete(e.id), t._pendingPauseConsumers.set(e.id, e), (0, Bi.default)(function() {
        t._closed || t._consumerPauseInProgress === !1 && t.pausePendingConsumers();
      });
    }), e.on("@resume", function() {
      t._pendingPauseConsumers.has(e.id) && t._pendingPauseConsumers.delete(e.id), t._pendingResumeConsumers.set(e.id, e), (0, Bi.default)(function() {
        t._closed || t._consumerResumeInProgress === !1 && t.resumePendingConsumers();
      });
    }), e.on("@getstats", function(r, s) {
      if (t._closed) return s(new mt.InvalidStateError("closed"));
      t._handler.getReceiverStats(e.localId).then(r).catch(s);
    });
  } }, { key: "handleDataProducer", value: function(e) {
    var t = this;
    e.on("@close", function() {
      t._dataProducers.delete(e.id);
    });
  } }, { key: "handleDataConsumer", value: function(e) {
    var t = this;
    e.on("@close", function() {
      t._dataConsumers.delete(e.id);
    });
  } }]), i;
}();
ca.Transport = dh;
var ai = {}, tt = {}, Fu = {}, Ii = { exports: {} }, Eo = Ii.exports = { v: [{ name: "version", reg: /^(\d*)$/ }], o: [{ name: "origin", reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/, names: ["username", "sessionId", "sessionVersion", "netType", "ipVer", "address"], format: "%s %s %d %s IP%d %s" }], s: [{ name: "name" }], i: [{ name: "description" }], u: [{ name: "uri" }], e: [{ name: "email" }], p: [{ name: "phone" }], z: [{ name: "timezones" }], r: [{ name: "repeats" }], t: [{ name: "timing", reg: /^(\d*) (\d*)/, names: ["start", "stop"], format: "%d %d" }], c: [{ name: "connection", reg: /^IN IP(\d) (\S*)/, names: ["version", "ip"], format: "IN IP%d %s" }], b: [{ push: "bandwidth", reg: /^(TIAS|AS|CT|RR|RS):(\d*)/, names: ["type", "limit"], format: "%s:%s" }], m: [{ reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/, names: ["type", "port", "protocol", "payloads"], format: "%s %d %s %s" }], a: [{ push: "rtp", reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/, names: ["payload", "codec", "rate", "encoding"], format: function(a) {
  return a.encoding ? "rtpmap:%d %s/%s/%s" : a.rate ? "rtpmap:%d %s/%s" : "rtpmap:%d %s";
} }, { push: "fmtp", reg: /^fmtp:(\d*) ([\S| ]*)/, names: ["payload", "config"], format: "fmtp:%d %s" }, { name: "control", reg: /^control:(.*)/, format: "control:%s" }, { name: "rtcp", reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/, names: ["port", "netType", "ipVer", "address"], format: function(a) {
  return a.address != null ? "rtcp:%d %s IP%d %s" : "rtcp:%d";
} }, { push: "rtcpFbTrrInt", reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/, names: ["payload", "value"], format: "rtcp-fb:%s trr-int %d" }, { push: "rtcpFb", reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/, names: ["payload", "type", "subtype"], format: function(a) {
  return a.subtype != null ? "rtcp-fb:%s %s %s" : "rtcp-fb:%s %s";
} }, { push: "ext", reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/, names: ["value", "direction", "encrypt-uri", "uri", "config"], format: function(a) {
  return "extmap:%d" + (a.direction ? "/%s" : "%v") + (a["encrypt-uri"] ? " %s" : "%v") + " %s" + (a.config ? " %s" : "");
} }, { name: "extmapAllowMixed", reg: /^(extmap-allow-mixed)/ }, { push: "crypto", reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/, names: ["id", "suite", "config", "sessionConfig"], format: function(a) {
  return a.sessionConfig != null ? "crypto:%d %s %s %s" : "crypto:%d %s %s";
} }, { name: "setup", reg: /^setup:(\w*)/, format: "setup:%s" }, { name: "connectionType", reg: /^connection:(new|existing)/, format: "connection:%s" }, { name: "mid", reg: /^mid:([^\s]*)/, format: "mid:%s" }, { name: "msid", reg: /^msid:(.*)/, format: "msid:%s" }, { name: "ptime", reg: /^ptime:(\d*(?:\.\d*)*)/, format: "ptime:%d" }, { name: "maxptime", reg: /^maxptime:(\d*(?:\.\d*)*)/, format: "maxptime:%d" }, { name: "direction", reg: /^(sendrecv|recvonly|sendonly|inactive)/ }, { name: "icelite", reg: /^(ice-lite)/ }, { name: "iceUfrag", reg: /^ice-ufrag:(\S*)/, format: "ice-ufrag:%s" }, { name: "icePwd", reg: /^ice-pwd:(\S*)/, format: "ice-pwd:%s" }, { name: "fingerprint", reg: /^fingerprint:(\S*) (\S*)/, names: ["type", "hash"], format: "fingerprint:%s %s" }, { push: "candidates", reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/, names: ["foundation", "component", "transport", "priority", "ip", "port", "type", "raddr", "rport", "tcptype", "generation", "network-id", "network-cost"], format: function(a) {
  var i = "candidate:%s %d %s %d %s %d typ %s";
  return i += a.raddr != null ? " raddr %s rport %d" : "%v%v", i += a.tcptype != null ? " tcptype %s" : "%v", a.generation != null && (i += " generation %d"), i += a["network-id"] != null ? " network-id %d" : "%v", i += a["network-cost"] != null ? " network-cost %d" : "%v";
} }, { name: "endOfCandidates", reg: /^(end-of-candidates)/ }, { name: "remoteCandidates", reg: /^remote-candidates:(.*)/, format: "remote-candidates:%s" }, { name: "iceOptions", reg: /^ice-options:(\S*)/, format: "ice-options:%s" }, { push: "ssrcs", reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/, names: ["id", "attribute", "value"], format: function(a) {
  var i = "ssrc:%d";
  return a.attribute != null && (i += " %s", a.value != null && (i += ":%s")), i;
} }, { push: "ssrcGroups", reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/, names: ["semantics", "ssrcs"], format: "ssrc-group:%s %s" }, { name: "msidSemantic", reg: /^msid-semantic:\s?(\w*) (\S*)/, names: ["semantic", "token"], format: "msid-semantic: %s %s" }, { push: "groups", reg: /^group:(\w*) (.*)/, names: ["type", "mids"], format: "group:%s %s" }, { name: "rtcpMux", reg: /^(rtcp-mux)/ }, { name: "rtcpRsize", reg: /^(rtcp-rsize)/ }, { name: "sctpmap", reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/, names: ["sctpmapNumber", "app", "maxMessageSize"], format: function(a) {
  return a.maxMessageSize != null ? "sctpmap:%s %s %s" : "sctpmap:%s %s";
} }, { name: "xGoogleFlag", reg: /^x-google-flag:([^\s]*)/, format: "x-google-flag:%s" }, { push: "rids", reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/, names: ["id", "direction", "params"], format: function(a) {
  return a.params ? "rid:%s %s %s" : "rid:%s %s";
} }, { push: "imageattrs", reg: new RegExp("^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"), names: ["pt", "dir1", "attrs1", "dir2", "attrs2"], format: function(a) {
  return "imageattr:%s %s %s" + (a.dir2 ? " %s %s" : "");
} }, { name: "simulcast", reg: new RegExp("^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"), names: ["dir1", "list1", "dir2", "list2"], format: function(a) {
  return "simulcast:%s %s" + (a.dir2 ? " %s %s" : "");
} }, { name: "simulcast_03", reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/, names: ["value"], format: "simulcast: %s" }, { name: "framerate", reg: /^framerate:(\d+(?:$|\.\d+))/, format: "framerate:%s" }, { name: "sourceFilter", reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/, names: ["filterMode", "netType", "addressTypes", "destAddress", "srcList"], format: "source-filter: %s %s %s %s %s" }, { name: "bundleOnly", reg: /^(bundle-only)/ }, { name: "label", reg: /^label:(.+)/, format: "label:%s" }, { name: "sctpPort", reg: /^sctp-port:(\d+)$/, format: "sctp-port:%s" }, { name: "maxMessageSize", reg: /^max-message-size:(\d+)$/, format: "max-message-size:%s" }, { push: "tsRefClocks", reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/, names: ["clksrc", "clksrcExt"], format: function(a) {
  return "ts-refclk:%s" + (a.clksrcExt != null ? "=%s" : "");
} }, { name: "mediaClk", reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/, names: ["id", "mediaClockName", "mediaClockValue", "rateNumerator", "rateDenominator"], format: function(a) {
  var i = "mediaclk:";
  return i += a.id != null ? "id=%s %s" : "%v%s", i += a.mediaClockValue != null ? "=%s" : "", i += a.rateNumerator != null ? " rate=%s" : "", i += a.rateDenominator != null ? "/%s" : "";
} }, { name: "keywords", reg: /^keywds:(.+)$/, format: "keywds:%s" }, { name: "content", reg: /^content:(.+)/, format: "content:%s" }, { name: "bfcpFloorCtrl", reg: /^floorctrl:(c-only|s-only|c-s)/, format: "floorctrl:%s" }, { name: "bfcpConfId", reg: /^confid:(\d+)/, format: "confid:%s" }, { name: "bfcpUserId", reg: /^userid:(\d+)/, format: "userid:%s" }, { name: "bfcpFloorId", reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/, names: ["id", "mStream"], format: "floorid:%s mstrm:%s" }, { push: "invalid", names: ["value"] }] };
Object.keys(Eo).forEach(function(o) {
  Eo[o].forEach(function(a) {
    a.reg || (a.reg = /(.*)/), a.format || (a.format = "%s");
  });
}), function(o) {
  var a = function(s) {
    return String(Number(s)) === s ? Number(s) : s;
  }, i = function(s, c, l) {
    var u = s.name && s.names;
    s.push && !c[s.push] ? c[s.push] = [] : u && !c[s.name] && (c[s.name] = {});
    var d = s.push ? {} : u ? c[s.name] : c;
    (function(p, m, b, h) {
      if (h && !b) m[h] = a(p[1]);
      else for (var g = 0; g < b.length; g += 1) p[g + 1] != null && (m[b[g]] = a(p[g + 1]));
    })(l.match(s.reg), d, s.names, s.name), s.push && c[s.push].push(d);
  }, n = Ii.exports, e = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
  o.parse = function(r) {
    var s = {}, c = [], l = s;
    return r.split(/(\r\n|\r|\n)/).filter(e).forEach(function(u) {
      var d = u[0], f = u.slice(2);
      d === "m" && (c.push({ rtp: [], fmtp: [] }), l = c[c.length - 1]);
      for (var p = 0; p < (n[d] || []).length; p += 1) {
        var m = n[d][p];
        if (m.reg.test(f)) return i(m, l, f);
      }
    }), s.media = c, s;
  };
  var t = function(s, c) {
    var l = c.split(/=(.+)/, 2);
    return l.length === 2 ? s[l[0]] = a(l[1]) : l.length === 1 && c.length > 1 && (s[l[0]] = void 0), s;
  };
  o.parseParams = function(r) {
    return r.split(/;\s?/).reduce(t, {});
  }, o.parseFmtpConfig = o.parseParams, o.parsePayloads = function(r) {
    return r.toString().split(" ").map(Number);
  }, o.parseRemoteCandidates = function(r) {
    for (var s = [], c = r.split(" ").map(a), l = 0; l < c.length; l += 3) s.push({ component: c[l], ip: c[l + 1], port: c[l + 2] });
    return s;
  }, o.parseImageAttributes = function(r) {
    return r.split(" ").map(function(s) {
      return s.substring(1, s.length - 1).split(",").reduce(t, {});
    });
  }, o.parseSimulcastStreamList = function(r) {
    return r.split(";").map(function(s) {
      return s.split(",").map(function(c) {
        var l, u = !1;
        return c[0] !== "~" ? l = a(c) : (l = a(c.substring(1, c.length)), u = !0), { scid: l, paused: u };
      });
    });
  };
}(Fu);
var Ui = Ii.exports, lh = /%[sdv%]/g, ph = function(a) {
  var i = 1, n = arguments, e = n.length;
  return a.replace(lh, function(t) {
    if (i >= e) return t;
    var r = n[i];
    switch (i += 1, t) {
      case "%%":
        return "%";
      case "%s":
        return String(r);
      case "%d":
        return Number(r);
      case "%v":
        return "";
    }
  });
}, Zn = function(a, i, n) {
  var e = [a + "=" + (i.format instanceof Function ? i.format(i.push ? n : n[i.name]) : i.format)];
  if (i.names) for (var t = 0; t < i.names.length; t += 1) {
    var r = i.names[t];
    i.name ? e.push(n[i.name][r]) : e.push(n[i.names[t]]);
  }
  else e.push(n[i.name]);
  return ph.apply(null, e);
}, fh = ["v", "o", "s", "i", "u", "e", "p", "c", "b", "t", "r", "z", "a"], hh = ["i", "c", "b", "a"], Kr = Fu, mh = function(a, i) {
  i = i || {}, a.version == null && (a.version = 0), a.name == null && (a.name = " "), a.media.forEach(function(r) {
    r.payloads == null && (r.payloads = "");
  });
  var n = i.outerOrder || fh, e = i.innerOrder || hh, t = [];
  return n.forEach(function(r) {
    Ui[r].forEach(function(s) {
      s.name in a && a[s.name] != null ? t.push(Zn(r, s, a)) : s.push in a && a[s.push] != null && a[s.push].forEach(function(c) {
        t.push(Zn(r, s, c));
      });
    });
  }), a.media.forEach(function(r) {
    t.push(Zn("m", Ui.m[0], r)), e.forEach(function(s) {
      Ui[s].forEach(function(c) {
        c.name in r && r[c.name] != null ? t.push(Zn(s, c, r)) : c.push in r && r[c.push] != null && r[c.push].forEach(function(l) {
          t.push(Zn(s, c, l));
        });
      });
    });
  }), t.join(`\r
`) + `\r
`;
}, vh = Ii.exports;
tt.grammar = vh, tt.write = mh, tt.parse = Kr.parse, tt.parseParams = Kr.parseParams, tt.parseFmtpConfig = Kr.parseFmtpConfig, tt.parsePayloads = Kr.parsePayloads, tt.parseRemoteCandidates = Kr.parseRemoteCandidates, tt.parseImageAttributes = Kr.parseImageAttributes, tt.parseSimulcastStreamList = Kr.parseSimulcastStreamList;
var xt = {}, gh = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), yh = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), bh = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && gh(i, a, n[e]);
    return yh(i, a), i;
  };
}();
Object.defineProperty(xt, "__esModule", { value: !0 }), xt.extractRtpCapabilities = function(a) {
  var i, n = a.sdpObject, e = /* @__PURE__ */ new Map(), t = [], r = !1, s = !1, c = U(n.media);
  try {
    for (c.s(); !(i = c.n()).done; ) {
      var l, u, d, f = i.value, p = f.type;
      switch (p) {
        case "audio":
          if (r) continue;
          r = !0;
          break;
        case "video":
          if (s) continue;
          s = !0;
          break;
        default:
          continue;
      }
      var m, b = U(f.rtp);
      try {
        for (b.s(); !(m = b.n()).done; ) {
          var h = m.value, g = { kind: p, mimeType: "".concat(p, "/").concat(h.codec), preferredPayloadType: h.payload, clockRate: h.rate, channels: h.encoding, parameters: {}, rtcpFeedback: [] };
          e.set(g.preferredPayloadType, g);
        }
      } catch (M) {
        b.e(M);
      } finally {
        b.f();
      }
      var w, _ = U((l = f.fmtp) !== null && l !== void 0 ? l : []);
      try {
        for (_.s(); !(w = _.n()).done; ) {
          var y = w.value, C = Ao.parseParams(y.config), S = e.get(y.payload);
          S && (C != null && C.hasOwnProperty("profile-level-id") && (C["profile-level-id"] = String(C["profile-level-id"])), S.parameters = C);
        }
      } catch (M) {
        _.e(M);
      } finally {
        _.f();
      }
      var P, T = U((u = f.rtcpFb) !== null && u !== void 0 ? u : []);
      try {
        for (T.s(); !(P = T.n()).done; ) {
          var I = P.value, k = { type: I.type, parameter: I.subtype };
          if (k.parameter || delete k.parameter, I.payload !== "*") {
            var x = e.get(I.payload);
            if (!x) continue;
            x.rtcpFeedback.push(k);
          } else {
            var O, D = U(e.values());
            try {
              for (D.s(); !(O = D.n()).done; ) {
                var A = O.value;
                A.kind !== p || /.+\/rtx$/i.test(A.mimeType) || A.rtcpFeedback.push(k);
              }
            } catch (M) {
              D.e(M);
            } finally {
              D.f();
            }
          }
        }
      } catch (M) {
        T.e(M);
      } finally {
        T.f();
      }
      var E, F = U((d = f.ext) !== null && d !== void 0 ? d : []);
      try {
        for (F.s(); !(E = F.n()).done; ) {
          var B = E.value;
          if (!B["encrypt-uri"]) {
            var $ = { kind: p, uri: B.uri, preferredId: B.value };
            t.push($);
          }
        }
      } catch (M) {
        F.e(M);
      } finally {
        F.f();
      }
    }
  } catch (M) {
    c.e(M);
  } finally {
    c.f();
  }
  return { codecs: Array.from(e.values()), headerExtensions: t };
}, xt.extractDtlsParameters = function(a) {
  var i, n = a.sdpObject, e = n.setup, t = n.fingerprint;
  if (!e || !t) {
    var r, s, c, l = ((r = n.media) !== null && r !== void 0 ? r : []).find(function(u) {
      return u.port !== 0;
    });
    l && ((s = e) !== null && s !== void 0 || (e = l.setup), (c = t) !== null && c !== void 0 || (t = l.fingerprint));
  }
  if (!e) throw new Error("no a=setup found at SDP session or media level");
  if (!t) throw new Error("no a=fingerprint found at SDP session or media level");
  switch (e) {
    case "active":
      i = "client";
      break;
    case "passive":
      i = "server";
      break;
    case "actpass":
      i = "auto";
  }
  return { role: i, fingerprints: [{ algorithm: t.type, value: t.hash }] };
}, xt.getCname = function(a) {
  var i, n = a.offerMediaObject, e = ((i = n.ssrcs) !== null && i !== void 0 ? i : []).find(function(t) {
    return t.attribute === "cname";
  });
  return e ? e.value : "";
}, xt.applyCodecParameters = function(a) {
  var i, n = a.offerRtpParameters, e = a.answerMediaObject, t = U(n.codecs);
  try {
    var r = function() {
      var c, l, u = i.value, d = u.mimeType.toLowerCase();
      if (d !== "audio/opus" || !((c = e.rtp) !== null && c !== void 0 ? c : []).find(function(w) {
        return w.payload === u.payloadType;
      })) return "continue";
      e.fmtp = (l = e.fmtp) !== null && l !== void 0 ? l : [];
      var f = e.fmtp.find(function(w) {
        return w.payload === u.payloadType;
      });
      f || (f = { payload: u.payloadType, config: "" }, e.fmtp.push(f));
      var p = Ao.parseParams(f.config);
      if (d === "audio/opus") {
        var m = u.parameters["sprop-stereo"];
        m !== void 0 && (p.stereo = Number(m) ? 1 : 0);
      }
      f.config = "";
      for (var b = 0, h = Object.keys(p); b < h.length; b++) {
        var g = h[b];
        f.config && (f.config += ";"), f.config += "".concat(g, "=").concat(p[g]);
      }
    };
    for (t.s(); !(i = t.n()).done; ) r();
  } catch (s) {
    t.e(s);
  } finally {
    t.f();
  }
};
var Ao = bh(tt), or = {};
Object.defineProperty(or, "__esModule", { value: !0 }), or.getRtpEncodings = function(a) {
  var i, n, e, t = a.offerMediaObject, r = /* @__PURE__ */ new Set(), s = U((i = t.ssrcs) !== null && i !== void 0 ? i : []);
  try {
    for (s.s(); !(e = s.n()).done; ) {
      var c = e.value.id;
      r.add(c);
    }
  } catch (k) {
    s.e(k);
  } finally {
    s.f();
  }
  if (r.size === 0) throw new Error("no a=ssrc lines found");
  var l, u = /* @__PURE__ */ new Map(), d = U((n = t.ssrcGroups) !== null && n !== void 0 ? n : []);
  try {
    for (d.s(); !(l = d.n()).done; ) {
      var f = l.value;
      if (f.semantics === "FID") {
        var p = Wr(f.ssrcs.split(/\s+/), 2), m = p[0], b = p[1];
        m = Number(m), b = Number(b), r.has(m) && (r.delete(m), r.delete(b), u.set(m, b));
      }
    }
  } catch (k) {
    d.e(k);
  } finally {
    d.f();
  }
  var h, g = U(r);
  try {
    for (g.s(); !(h = g.n()).done; ) {
      var w = h.value;
      u.set(w, null);
    }
  } catch (k) {
    g.e(k);
  } finally {
    g.f();
  }
  var _, y = [], C = U(u);
  try {
    for (C.s(); !(_ = C.n()).done; ) {
      var S = Wr(_.value, 2), P = S[0], T = S[1], I = { ssrc: P };
      T && (I.rtx = { ssrc: T }), y.push(I);
    }
  } catch (k) {
    C.e(k);
  } finally {
    C.f();
  }
  return y;
}, or.addLegacySimulcast = function(a) {
  var i, n, e = a.offerMediaObject, t = a.numStreams;
  if (t <= 1) throw new TypeError("numStreams must be greater than 1");
  var r = ((i = e.ssrcs) !== null && i !== void 0 ? i : []).find(function(P) {
    return P.attribute === "msid";
  });
  if (!r) throw new Error("a=ssrc line with msid information not found");
  var s, c = Wr(r.value.split(" "), 2), l = c[0], u = c[1], d = Number(r.id);
  ((n = e.ssrcGroups) !== null && n !== void 0 ? n : []).some(function(P) {
    if (P.semantics !== "FID") return !1;
    var T = P.ssrcs.split(/\s+/);
    return Number(T[0]) === d && (s = Number(T[1]), !0);
  });
  var f = e.ssrcs.find(function(P) {
    return P.attribute === "cname";
  });
  if (!f) throw new Error("a=ssrc line with cname information not found");
  for (var p = f.value, m = [], b = [], h = 0; h < t; ++h) m.push(d + h), s && b.push(s + h);
  e.ssrcGroups = [], e.ssrcs = [], e.ssrcGroups.push({ semantics: "SIM", ssrcs: m.join(" ") });
  for (var g = 0, w = m; g < w.length; g++) {
    var _ = w[g];
    e.ssrcs.push({ id: _, attribute: "cname", value: p }), e.ssrcs.push({ id: _, attribute: "msid", value: "".concat(l, " ").concat(u) });
  }
  for (var y = 0; y < b.length; ++y) {
    var C = m[y], S = b[y];
    e.ssrcs.push({ id: S, attribute: "cname", value: p }), e.ssrcs.push({ id: S, attribute: "msid", value: "".concat(l, " ").concat(u) }), e.ssrcGroups.push({ semantics: "FID", ssrcs: "".concat(C, " ").concat(S) });
  }
};
var jn = {};
Object.defineProperty(jn, "__esModule", { value: !0 }), jn.addNackSupportForOpus = function(a) {
  var i, n, e = U((i = a.codecs) !== null && i !== void 0 ? i : []);
  try {
    for (e.s(); !(n = e.n()).done; ) {
      var t, r = n.value;
      r.mimeType.toLowerCase() !== "audio/opus" && r.mimeType.toLowerCase() !== "audio/multiopus" || (t = r.rtcpFeedback) !== null && t !== void 0 && t.some(function(s) {
        return s.type === "nack" && !s.parameter;
      }) || (r.rtcpFeedback || (r.rtcpFeedback = []), r.rtcpFeedback.push({ type: "nack" }));
    }
  } catch (s) {
    e.e(s);
  } finally {
    e.f();
  }
};
var Rt = {};
Object.defineProperty(Rt, "__esModule", { value: !0 }), Rt.HandlerInterface = void 0;
var _h = ur, wh = function(o) {
  Qe(i, _h.EnhancedEventEmitter);
  var a = Je(i);
  function i() {
    return Pe(this, i), a.call(this);
  }
  return Te(i);
}();
Rt.HandlerInterface = wh;
var Mt = {}, Ar = {}, Sh = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), Ch = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), $u = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && Sh(i, a, n[e]);
    return Ch(i, a), i;
  };
}();
Object.defineProperty(Ar, "__esModule", { value: !0 }), Ar.OfferMediaSection = Ar.AnswerMediaSection = Ar.MediaSection = void 0;
var kh = $u(tt), Lo = $u(ct), Is = function() {
  function o(a) {
    var i = a.iceParameters, n = a.iceCandidates, e = a.dtlsParameters, t = a.planB, r = t !== void 0 && t;
    if (Pe(this, o), this._mediaObject = {}, this._planB = r, i && this.setIceParameters(i), n) {
      this._mediaObject.candidates = [];
      var s, c = U(n);
      try {
        for (c.s(); !(s = c.n()).done; ) {
          var l, u = s.value, d = { component: 1 };
          d.foundation = u.foundation, d.ip = (l = u.address) !== null && l !== void 0 ? l : u.ip, d.port = u.port, d.priority = u.priority, d.transport = u.protocol, d.type = u.type, u.tcpType && (d.tcptype = u.tcpType), this._mediaObject.candidates.push(d);
        }
      } catch (f) {
        c.e(f);
      } finally {
        c.f();
      }
      this._mediaObject.endOfCandidates = "end-of-candidates", this._mediaObject.iceOptions = "renomination";
    }
    e && this.setDtlsRole(e.role);
  }
  return Te(o, [{ key: "mid", get: function() {
    return String(this._mediaObject.mid);
  } }, { key: "closed", get: function() {
    return this._mediaObject.port === 0;
  } }, { key: "getObject", value: function() {
    return this._mediaObject;
  } }, { key: "setIceParameters", value: function(i) {
    this._mediaObject.iceUfrag = i.usernameFragment, this._mediaObject.icePwd = i.password;
  } }, { key: "pause", value: function() {
    this._mediaObject.direction = "inactive";
  } }, { key: "disable", value: function() {
    this.pause(), delete this._mediaObject.ext, delete this._mediaObject.ssrcs, delete this._mediaObject.ssrcGroups, delete this._mediaObject.simulcast, delete this._mediaObject.simulcast_03, delete this._mediaObject.rids, delete this._mediaObject.extmapAllowMixed;
  } }, { key: "close", value: function() {
    this.disable(), this._mediaObject.port = 0;
  } }]), o;
}();
Ar.MediaSection = Is;
var xh = function(o) {
  Qe(i, Is);
  var a = Je(i);
  function i(n) {
    var e, t = n.iceParameters, r = n.iceCandidates, s = n.dtlsParameters, c = n.sctpParameters, l = n.plainRtpParameters, u = n.planB, d = u !== void 0 && u, f = n.offerMediaObject, p = n.offerRtpParameters, m = n.answerRtpParameters, b = n.codecOptions, h = n.extmapAllowMixed, g = h !== void 0 && h;
    switch (Pe(this, i), (e = a.call(this, { iceParameters: t, iceCandidates: r, dtlsParameters: s, planB: d }))._mediaObject.mid = String(f.mid), e._mediaObject.type = f.type, e._mediaObject.protocol = f.protocol, l ? (e._mediaObject.connection = { ip: l.ip, version: l.ipVersion }, e._mediaObject.port = l.port) : (e._mediaObject.connection = { ip: "127.0.0.1", version: 4 }, e._mediaObject.port = 7), f.type) {
      case "audio":
      case "video":
        e._mediaObject.direction = "recvonly", e._mediaObject.rtp = [], e._mediaObject.rtcpFb = [], e._mediaObject.fmtp = [];
        var w, _ = U(m.codecs);
        try {
          var y = function() {
            var B, $, M = w.value, j = { payload: M.payloadType, codec: is(M), rate: M.clockRate };
            M.channels > 1 && (j.encoding = M.channels), e._mediaObject.rtp.push(j);
            var z = (B = Lo.clone(M.parameters)) !== null && B !== void 0 ? B : {}, te = ($ = Lo.clone(M.rtcpFeedback)) !== null && $ !== void 0 ? $ : [];
            if (b) {
              var ee = b.opusStereo, Y = b.opusFec, Z = b.opusDtx, ae = b.opusMaxPlaybackRate, oe = b.opusMaxAverageBitrate, ce = b.opusPtime, ke = b.opusNack, Oe = b.videoGoogleStartBitrate, nt = b.videoGoogleMaxBitrate, et = b.videoGoogleMinBitrate, Fe = p.codecs.find(function(qe) {
                return qe.payloadType === M.payloadType;
              });
              switch (M.mimeType.toLowerCase()) {
                case "audio/opus":
                case "audio/multiopus":
                  ee !== void 0 && (Fe.parameters["sprop-stereo"] = ee ? 1 : 0, z.stereo = ee ? 1 : 0), Y !== void 0 && (Fe.parameters.useinbandfec = Y ? 1 : 0, z.useinbandfec = Y ? 1 : 0), Z !== void 0 && (Fe.parameters.usedtx = Z ? 1 : 0, z.usedtx = Z ? 1 : 0), ae !== void 0 && (z.maxplaybackrate = ae), oe !== void 0 && (z.maxaveragebitrate = oe), ce !== void 0 && (Fe.parameters.ptime = ce, z.ptime = ce), ke || (Fe.rtcpFeedback = Fe.rtcpFeedback.filter(function(qe) {
                    return qe.type !== "nack" || qe.parameter;
                  }), te = te.filter(function(qe) {
                    return qe.type !== "nack" || qe.parameter;
                  }));
                  break;
                case "video/vp8":
                case "video/vp9":
                case "video/h264":
                case "video/h265":
                  Oe !== void 0 && (z["x-google-start-bitrate"] = Oe), nt !== void 0 && (z["x-google-max-bitrate"] = nt), et !== void 0 && (z["x-google-min-bitrate"] = et);
              }
            }
            for (var $e = { payload: M.payloadType, config: "" }, at = 0, vt = Object.keys(z); at < vt.length; at++) {
              var gt = vt[at];
              $e.config && ($e.config += ";"), $e.config += "".concat(gt, "=").concat(z[gt]);
            }
            $e.config && e._mediaObject.fmtp.push($e);
            var it, Ie = U(te);
            try {
              for (Ie.s(); !(it = Ie.n()).done; ) {
                var ut = it.value;
                e._mediaObject.rtcpFb.push({ payload: M.payloadType, type: ut.type, subtype: ut.parameter });
              }
            } catch (qe) {
              Ie.e(qe);
            } finally {
              Ie.f();
            }
          };
          for (_.s(); !(w = _.n()).done; ) y();
        } catch (F) {
          _.e(F);
        } finally {
          _.f();
        }
        e._mediaObject.payloads = m.codecs.map(function(F) {
          return F.payloadType;
        }).join(" "), e._mediaObject.ext = [];
        var C, S = U(m.headerExtensions);
        try {
          var P = function() {
            var B, $ = C.value;
            if (!((B = f.ext) !== null && B !== void 0 ? B : []).some(function(M) {
              return M.uri === $.uri;
            })) return "continue";
            e._mediaObject.ext.push({ uri: $.uri, value: $.id });
          };
          for (S.s(); !(C = S.n()).done; ) P();
        } catch (F) {
          S.e(F);
        } finally {
          S.f();
        }
        if (g && f.extmapAllowMixed === "extmap-allow-mixed" && (e._mediaObject.extmapAllowMixed = "extmap-allow-mixed"), f.simulcast) {
          var T;
          e._mediaObject.simulcast = { dir1: "recv", list1: f.simulcast.list1 }, e._mediaObject.rids = [];
          var I, k = U((T = f.rids) !== null && T !== void 0 ? T : []);
          try {
            for (k.s(); !(I = k.n()).done; ) {
              var x = I.value;
              x.direction === "send" && e._mediaObject.rids.push({ id: x.id, direction: "recv" });
            }
          } catch (F) {
            k.e(F);
          } finally {
            k.f();
          }
        } else if (f.simulcast_03) {
          var O;
          e._mediaObject.simulcast_03 = { value: f.simulcast_03.value.replace(/send/g, "recv") }, e._mediaObject.rids = [];
          var D, A = U((O = f.rids) !== null && O !== void 0 ? O : []);
          try {
            for (A.s(); !(D = A.n()).done; ) {
              var E = D.value;
              E.direction === "send" && e._mediaObject.rids.push({ id: E.id, direction: "recv" });
            }
          } catch (F) {
            A.e(F);
          } finally {
            A.f();
          }
        }
        e._mediaObject.rtcpMux = "rtcp-mux", e._mediaObject.rtcpRsize = "rtcp-rsize", e._planB && e._mediaObject.type === "video" && (e._mediaObject.xGoogleFlag = "conference");
        break;
      case "application":
        typeof f.sctpPort == "number" ? (e._mediaObject.payloads = "webrtc-datachannel", e._mediaObject.sctpPort = c.port, e._mediaObject.maxMessageSize = c.maxMessageSize) : f.sctpmap && (e._mediaObject.payloads = c.port, e._mediaObject.sctpmap = { app: "webrtc-datachannel", sctpmapNumber: c.port, maxMessageSize: c.maxMessageSize });
    }
    return e;
  }
  return Te(i, [{ key: "setDtlsRole", value: function(e) {
    switch (e) {
      case "client":
        this._mediaObject.setup = "active";
        break;
      case "server":
        this._mediaObject.setup = "passive";
        break;
      case "auto":
        this._mediaObject.setup = "actpass";
    }
  } }, { key: "resume", value: function() {
    this._mediaObject.direction = "recvonly";
  } }, { key: "muxSimulcastStreams", value: function(e) {
    var t;
    if ((t = this._mediaObject.simulcast) !== null && t !== void 0 && t.list1) {
      var r, s = {}, c = U(e);
      try {
        for (c.s(); !(r = c.n()).done; ) {
          var l = r.value;
          l.rid && (s[l.rid] = l);
        }
      } catch (w) {
        c.e(w);
      } finally {
        c.f();
      }
      var u, d = this._mediaObject.simulcast.list1, f = kh.parseSimulcastStreamList(d), p = U(f);
      try {
        for (p.s(); !(u = p.n()).done; ) {
          var m, b = U(u.value);
          try {
            for (b.s(); !(m = b.n()).done; ) {
              var h, g = m.value;
              g.paused = !((h = s[g.scid]) !== null && h !== void 0 && h.active);
            }
          } catch (w) {
            b.e(w);
          } finally {
            b.f();
          }
        }
      } catch (w) {
        p.e(w);
      } finally {
        p.f();
      }
      this._mediaObject.simulcast.list1 = f.map(function(w) {
        return w.map(function(_) {
          return "".concat(_.paused ? "~" : "").concat(_.scid);
        }).join(",");
      }).join(";");
    }
  } }]), i;
}();
Ar.AnswerMediaSection = xh;
var Rh = function(o) {
  Qe(i, Is);
  var a = Je(i);
  function i(n) {
    var e, t = n.iceParameters, r = n.iceCandidates, s = n.dtlsParameters, c = n.sctpParameters, l = n.plainRtpParameters, u = n.planB, d = u !== void 0 && u, f = n.mid, p = n.kind, m = n.offerRtpParameters, b = n.streamId, h = n.trackId, g = n.oldDataChannelSpec, w = g !== void 0 && g;
    switch (Pe(this, i), (e = a.call(this, { iceParameters: t, iceCandidates: r, dtlsParameters: s, planB: d }))._mediaObject.mid = String(f), e._mediaObject.type = p, l ? (e._mediaObject.connection = { ip: l.ip, version: l.ipVersion }, e._mediaObject.protocol = "RTP/AVP", e._mediaObject.port = l.port) : (e._mediaObject.connection = { ip: "127.0.0.1", version: 4 }, e._mediaObject.protocol = c ? "UDP/DTLS/SCTP" : "UDP/TLS/RTP/SAVPF", e._mediaObject.port = 7), p) {
      case "audio":
      case "video":
        var _;
        e._mediaObject.direction = "sendonly", e._mediaObject.rtp = [], e._mediaObject.rtcpFb = [], e._mediaObject.fmtp = [], e._planB || (e._mediaObject.msid = "".concat(b ?? "-", " ").concat(h));
        var y, C = U(m.codecs);
        try {
          for (C.s(); !(y = C.n()).done; ) {
            var S = y.value, P = { payload: S.payloadType, codec: is(S), rate: S.clockRate };
            S.channels > 1 && (P.encoding = S.channels), e._mediaObject.rtp.push(P);
            for (var T = { payload: S.payloadType, config: "" }, I = 0, k = Object.keys(S.parameters); I < k.length; I++) {
              var x = k[I];
              T.config && (T.config += ";"), T.config += "".concat(x, "=").concat(S.parameters[x]);
            }
            T.config && e._mediaObject.fmtp.push(T);
            var O, D = U(S.rtcpFeedback);
            try {
              for (D.s(); !(O = D.n()).done; ) {
                var A = O.value;
                e._mediaObject.rtcpFb.push({ payload: S.payloadType, type: A.type, subtype: A.parameter });
              }
            } catch (z) {
              D.e(z);
            } finally {
              D.f();
            }
          }
        } catch (z) {
          C.e(z);
        } finally {
          C.f();
        }
        e._mediaObject.payloads = m.codecs.map(function(z) {
          return z.payloadType;
        }).join(" "), e._mediaObject.ext = [];
        var E, F = U(m.headerExtensions);
        try {
          for (F.s(); !(E = F.n()).done; ) {
            var B = E.value;
            e._mediaObject.ext.push({ uri: B.uri, value: B.id });
          }
        } catch (z) {
          F.e(z);
        } finally {
          F.f();
        }
        e._mediaObject.rtcpMux = "rtcp-mux", e._mediaObject.rtcpRsize = "rtcp-rsize";
        var $ = m.encodings[0], M = $.ssrc, j = (_ = $.rtx) === null || _ === void 0 ? void 0 : _.ssrc;
        e._mediaObject.ssrcs = [], e._mediaObject.ssrcGroups = [], m.rtcp.cname && e._mediaObject.ssrcs.push({ id: M, attribute: "cname", value: m.rtcp.cname }), e._planB && e._mediaObject.ssrcs.push({ id: M, attribute: "msid", value: "".concat(b ?? "-", " ").concat(h) }), j && (m.rtcp.cname && e._mediaObject.ssrcs.push({ id: j, attribute: "cname", value: m.rtcp.cname }), e._planB && e._mediaObject.ssrcs.push({ id: j, attribute: "msid", value: "".concat(b ?? "-", " ").concat(h) }), e._mediaObject.ssrcGroups.push({ semantics: "FID", ssrcs: "".concat(M, " ").concat(j) }));
        break;
      case "application":
        w ? (e._mediaObject.payloads = c.port, e._mediaObject.sctpmap = { app: "webrtc-datachannel", sctpmapNumber: c.port, maxMessageSize: c.maxMessageSize }) : (e._mediaObject.payloads = "webrtc-datachannel", e._mediaObject.sctpPort = c.port, e._mediaObject.maxMessageSize = c.maxMessageSize);
    }
    return e;
  }
  return Te(i, [{ key: "setDtlsRole", value: function(e) {
    this._mediaObject.setup = "actpass";
  } }, { key: "resume", value: function() {
    this._mediaObject.direction = "sendonly";
  } }, { key: "planBReceive", value: function(e) {
    var t, r, s = this, c = e.offerRtpParameters, l = e.streamId, u = e.trackId, d = c.encodings[0], f = d.ssrc, p = (t = d.rtx) === null || t === void 0 ? void 0 : t.ssrc, m = this._mediaObject.payloads.split(" "), b = U(c.codecs);
    try {
      for (b.s(); !(r = b.n()).done; ) {
        var h = r.value;
        if (!m.includes(String(h.payloadType))) {
          var g = { payload: h.payloadType, codec: is(h), rate: h.clockRate };
          h.channels > 1 && (g.encoding = h.channels), this._mediaObject.rtp.push(g);
          for (var w = { payload: h.payloadType, config: "" }, _ = 0, y = Object.keys(h.parameters); _ < y.length; _++) {
            var C = y[_];
            w.config && (w.config += ";"), w.config += "".concat(C, "=").concat(h.parameters[C]);
          }
          w.config && this._mediaObject.fmtp.push(w);
          var S, P = U(h.rtcpFeedback);
          try {
            for (P.s(); !(S = P.n()).done; ) {
              var T = S.value;
              this._mediaObject.rtcpFb.push({ payload: h.payloadType, type: T.type, subtype: T.parameter });
            }
          } catch (I) {
            P.e(I);
          } finally {
            P.f();
          }
        }
      }
    } catch (I) {
      b.e(I);
    } finally {
      b.f();
    }
    this._mediaObject.payloads += " ".concat(c.codecs.filter(function(I) {
      return !s._mediaObject.payloads.includes(I.payloadType);
    }).map(function(I) {
      return I.payloadType;
    }).join(" ")), this._mediaObject.payloads = this._mediaObject.payloads.trim(), c.rtcp.cname && this._mediaObject.ssrcs.push({ id: f, attribute: "cname", value: c.rtcp.cname }), this._mediaObject.ssrcs.push({ id: f, attribute: "msid", value: "".concat(l ?? "-", " ").concat(u) }), p && (c.rtcp.cname && this._mediaObject.ssrcs.push({ id: p, attribute: "cname", value: c.rtcp.cname }), this._mediaObject.ssrcs.push({ id: p, attribute: "msid", value: "".concat(l ?? "-", " ").concat(u) }), this._mediaObject.ssrcGroups.push({ semantics: "FID", ssrcs: "".concat(f, " ").concat(p) }));
  } }, { key: "planBStopReceiving", value: function(e) {
    var t, r = e.offerRtpParameters.encodings[0], s = r.ssrc, c = (t = r.rtx) === null || t === void 0 ? void 0 : t.ssrc;
    this._mediaObject.ssrcs = this._mediaObject.ssrcs.filter(function(l) {
      return l.id !== s && l.id !== c;
    }), c && (this._mediaObject.ssrcGroups = this._mediaObject.ssrcGroups.filter(function(l) {
      return l.ssrcs !== "".concat(s, " ").concat(c);
    }));
  } }]), i;
}();
function is(o) {
  var a = new RegExp("^(audio|video)/(.+)", "i").exec(o.mimeType);
  if (!a) throw new TypeError("invalid codec.mimeType");
  return a[2];
}
Ar.OfferMediaSection = Rh;
var Ih = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), Ph = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), Th = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && Ih(i, a, n[e]);
    return Ph(i, a), i;
  };
}();
Object.defineProperty(Mt, "__esModule", { value: !0 }), Mt.RemoteSdp = void 0;
var Dh = Th(tt), Da = Ar, zi = new rt.Logger("RemoteSdp"), Eh = function() {
  function o(a) {
    var i = a.iceParameters, n = a.iceCandidates, e = a.dtlsParameters, t = a.sctpParameters, r = a.plainRtpParameters, s = a.planB, c = s !== void 0 && s;
    if (Pe(this, o), this._mediaSections = [], this._midToIndex = /* @__PURE__ */ new Map(), this._iceParameters = i, this._iceCandidates = n, this._dtlsParameters = e, this._sctpParameters = t, this._plainRtpParameters = r, this._planB = c, this._sdpObject = { version: 0, origin: { address: "0.0.0.0", ipVer: 4, netType: "IN", sessionId: 1e4, sessionVersion: 0, username: "mediasoup-client" }, name: "-", timing: { start: 0, stop: 0 }, media: [] }, i != null && i.iceLite && (this._sdpObject.icelite = "ice-lite"), e) {
      this._sdpObject.msidSemantic = { semantic: "WMS", token: "*" };
      var l = this._dtlsParameters.fingerprints.length;
      this._sdpObject.fingerprint = { type: e.fingerprints[l - 1].algorithm, hash: e.fingerprints[l - 1].value }, this._sdpObject.groups = [{ type: "BUNDLE", mids: "" }];
    }
    r && (this._sdpObject.origin.address = r.ip, this._sdpObject.origin.ipVer = r.ipVersion);
  }
  return Te(o, [{ key: "updateIceParameters", value: function(i) {
    zi.debug("updateIceParameters() [iceParameters:%o]", i), this._iceParameters = i, this._sdpObject.icelite = i.iceLite ? "ice-lite" : void 0;
    var n, e = U(this._mediaSections);
    try {
      for (e.s(); !(n = e.n()).done; )
        n.value.setIceParameters(i);
    } catch (t) {
      e.e(t);
    } finally {
      e.f();
    }
  } }, { key: "updateDtlsRole", value: function(i) {
    zi.debug("updateDtlsRole() [role:%s]", i), this._dtlsParameters.role = i;
    var n, e = U(this._mediaSections);
    try {
      for (e.s(); !(n = e.n()).done; )
        n.value.setDtlsRole(i);
    } catch (t) {
      e.e(t);
    } finally {
      e.f();
    }
  } }, { key: "getNextMediaSectionIdx", value: function() {
    for (var i = 0; i < this._mediaSections.length; ++i) {
      var n = this._mediaSections[i];
      if (n.closed) return { idx: i, reuseMid: n.mid };
    }
    return { idx: this._mediaSections.length };
  } }, { key: "send", value: function(i) {
    var n = i.offerMediaObject, e = i.reuseMid, t = i.offerRtpParameters, r = i.answerRtpParameters, s = i.codecOptions, c = i.extmapAllowMixed, l = c !== void 0 && c, u = new Da.AnswerMediaSection({ iceParameters: this._iceParameters, iceCandidates: this._iceCandidates, dtlsParameters: this._dtlsParameters, plainRtpParameters: this._plainRtpParameters, planB: this._planB, offerMediaObject: n, offerRtpParameters: t, answerRtpParameters: r, codecOptions: s, extmapAllowMixed: l });
    e ? this._replaceMediaSection(u, e) : this._midToIndex.has(u.mid) ? this._replaceMediaSection(u) : this._addMediaSection(u);
  } }, { key: "receive", value: function(i) {
    var n, e = i.mid, t = i.kind, r = i.offerRtpParameters, s = i.streamId, c = i.trackId, l = this._midToIndex.get(e);
    if (l !== void 0 && (n = this._mediaSections[l]), n) n.planBReceive({ offerRtpParameters: r, streamId: s, trackId: c }), this._replaceMediaSection(n);
    else {
      n = new Da.OfferMediaSection({ iceParameters: this._iceParameters, iceCandidates: this._iceCandidates, dtlsParameters: this._dtlsParameters, plainRtpParameters: this._plainRtpParameters, planB: this._planB, mid: e, kind: t, offerRtpParameters: r, streamId: s, trackId: c });
      var u = this._mediaSections.find(function(d) {
        return d.closed;
      });
      u ? this._replaceMediaSection(n, u.mid) : this._addMediaSection(n);
    }
  } }, { key: "pauseMediaSection", value: function(i) {
    this._findMediaSection(i).pause();
  } }, { key: "resumeSendingMediaSection", value: function(i) {
    this._findMediaSection(i).resume();
  } }, { key: "resumeReceivingMediaSection", value: function(i) {
    this._findMediaSection(i).resume();
  } }, { key: "disableMediaSection", value: function(i) {
    this._findMediaSection(i).disable();
  } }, { key: "closeMediaSection", value: function(i) {
    var n = this._findMediaSection(i);
    return i === this._firstMid ? (zi.debug("closeMediaSection() | cannot close first media section, disabling it instead [mid:%s]", i), this.disableMediaSection(i), !1) : (n.close(), this._regenerateBundleMids(), !0);
  } }, { key: "muxMediaSectionSimulcast", value: function(i, n) {
    var e = this._findMediaSection(i);
    e.muxSimulcastStreams(n), this._replaceMediaSection(e);
  } }, { key: "planBStopReceiving", value: function(i) {
    var n = i.mid, e = i.offerRtpParameters, t = this._findMediaSection(n);
    t.planBStopReceiving({ offerRtpParameters: e }), this._replaceMediaSection(t);
  } }, { key: "sendSctpAssociation", value: function(i) {
    var n = i.offerMediaObject, e = new Da.AnswerMediaSection({ iceParameters: this._iceParameters, iceCandidates: this._iceCandidates, dtlsParameters: this._dtlsParameters, sctpParameters: this._sctpParameters, plainRtpParameters: this._plainRtpParameters, offerMediaObject: n });
    this._addMediaSection(e);
  } }, { key: "receiveSctpAssociation", value: function() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = i.oldDataChannelSpec, e = n !== void 0 && n, t = new Da.OfferMediaSection({ iceParameters: this._iceParameters, iceCandidates: this._iceCandidates, dtlsParameters: this._dtlsParameters, sctpParameters: this._sctpParameters, plainRtpParameters: this._plainRtpParameters, mid: "datachannel", kind: "application", oldDataChannelSpec: e });
    this._addMediaSection(t);
  } }, { key: "getSdp", value: function() {
    return this._sdpObject.origin.sessionVersion++, Dh.write(this._sdpObject);
  } }, { key: "_addMediaSection", value: function(i) {
    this._firstMid || (this._firstMid = i.mid), this._mediaSections.push(i), this._midToIndex.set(i.mid, this._mediaSections.length - 1), this._sdpObject.media.push(i.getObject()), this._regenerateBundleMids();
  } }, { key: "_replaceMediaSection", value: function(i, n) {
    if (typeof n == "string") {
      var e = this._midToIndex.get(n);
      if (e === void 0) throw new Error("no media section found for reuseMid '".concat(n, "'"));
      var t = this._mediaSections[e];
      this._mediaSections[e] = i, this._midToIndex.delete(t.mid), this._midToIndex.set(i.mid, e), this._sdpObject.media[e] = i.getObject(), this._regenerateBundleMids();
    } else {
      var r = this._midToIndex.get(i.mid);
      if (r === void 0) throw new Error("no media section found with mid '".concat(i.mid, "'"));
      this._mediaSections[r] = i, this._sdpObject.media[r] = i.getObject();
    }
  } }, { key: "_findMediaSection", value: function(i) {
    var n = this._midToIndex.get(i);
    if (n === void 0) throw new Error("no media section found with mid '".concat(i, "'"));
    return this._mediaSections[n];
  } }, { key: "_regenerateBundleMids", value: function() {
    this._dtlsParameters && (this._sdpObject.groups[0].mids = this._mediaSections.filter(function(i) {
      return !i.closed;
    }).map(function(i) {
      return i.mid;
    }).join(" "));
  } }]), o;
}();
Mt.RemoteSdp = Eh;
var dr = {};
Object.defineProperty(dr, "__esModule", { value: !0 }), dr.parse = function(a) {
  var i = Ah.exec(a ?? "");
  return i ? { spatialLayers: Number(i[1]), temporalLayers: Number(i[2]) } : { spatialLayers: 1, temporalLayers: 1 };
};
var Ah = new RegExp("^[LS]([1-9]\\d{0,1})T([1-9]\\d{0,1})"), Lh = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), Oh = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), Vn = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && Lh(i, a, n[e]);
    return Oh(i, a), i;
  };
}();
Object.defineProperty(ai, "__esModule", { value: !0 }), ai.Chrome111 = void 0;
var Ir = Vn(tt), Mh = rt, Oo = Vn(ct), pn = Vn(Ye), Ea = Vn(xt), Mo = Vn(or), jh = Vn(jn), Nh = ft, Fh = Rt, $h = Mt, Bh = dr, _e = new Mh.Logger("Chrome111"), jo = { OS: 1024, MIS: 1024 }, Vh = function(o) {
  Qe(i, Fh.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._closed = !1, n._mapMidTransceiver = /* @__PURE__ */ new Map(), n._sendStream = new MediaStream(), n._hasDataChannelMediaSection = !1, n._nextSendSctpStreamId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "Chrome111";
  } }, { key: "close", value: function() {
    if (_e.debug("close()"), !this._closed) {
      if (this._closed = !0, this._pc) try {
        this._pc.close();
      } catch {
      }
      this.emit("@close");
    }
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            return _e.debug("getNativeRtpCapabilities()"), t = new RTCPeerConnection({ iceServers: [], iceTransportPolicy: "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "unified-plan" }), u.prev = 2, t.addTransceiver("audio"), t.addTransceiver("video"), u.next = 7, t.createOffer();
          case 7:
            r = u.sent;
            try {
              t.close();
            } catch {
            }
            return s = Ir.parse(r.sdp), c = Ea.extractRtpCapabilities({ sdpObject: s }), jh.addNackSupportForOpus(c), u.abrupt("return", c);
          case 15:
            u.prev = 15, u.t0 = u.catch(2);
            try {
              t.close();
            } catch {
            }
            throw u.t0;
          case 19:
          case "end":
            return u.stop();
        }
      }, e, null, [[2, 15]]);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return _e.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: jo });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    var t = this, r = e.direction, s = e.iceParameters, c = e.iceCandidates, l = e.dtlsParameters, u = e.sctpParameters, d = e.iceServers, f = e.iceTransportPolicy, p = e.additionalSettings, m = e.proprietaryConstraints, b = e.extendedRtpCapabilities;
    this.assertNotClosed(), _e.debug("run()"), this._direction = r, this._remoteSdp = new $h.RemoteSdp({ iceParameters: s, iceCandidates: c, dtlsParameters: l, sctpParameters: u }), this._sendingRtpParametersByKind = { audio: pn.getSendingRtpParameters("audio", b), video: pn.getSendingRtpParameters("video", b) }, this._sendingRemoteRtpParametersByKind = { audio: pn.getSendingRemoteRtpParameters("audio", b), video: pn.getSendingRemoteRtpParameters("video", b) }, l.role && l.role !== "auto" && (this._forcedLocalDtlsRole = l.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection(Re({ iceServers: d ?? [], iceTransportPolicy: f ?? "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "unified-plan" }, p), m), this._pc.addEventListener("icegatheringstatechange", function() {
      t.emit("@icegatheringstatechange", t._pc.iceGatheringState);
    }), this._pc.addEventListener("icecandidateerror", function(h) {
      t.emit("@icecandidateerror", h);
    }), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", function() {
      t.emit("@connectionstatechange", t._pc.connectionState);
    }) : (_e.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), this._pc.addEventListener("iceconnectionstatechange", function() {
      switch (t._pc.iceConnectionState) {
        case "checking":
          t.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          t.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          t.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          t.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          t.emit("@connectionstatechange", "closed");
      }
    }));
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            this.assertNotClosed(), _e.debug("updateIceServers()"), (r = this._pc.getConfiguration()).iceServers = t, this._pc.setConfiguration(r);
          case 5:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (this.assertNotClosed(), _e.debug("restartIce()"), this._remoteSdp.updateIceParameters(t), this._transportReady) {
              d.next = 5;
              break;
            }
            return d.abrupt("return");
          case 5:
            if (this._direction !== "send") {
              d.next = 18;
              break;
            }
            return d.next = 8, this._pc.createOffer({ iceRestart: !0 });
          case 8:
            return r = d.sent, _e.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", r), d.next = 12, this._pc.setLocalDescription(r);
          case 12:
            return s = { type: "answer", sdp: this._remoteSdp.getSdp() }, _e.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), d.next = 16, this._pc.setRemoteDescription(s);
          case 16:
            d.next = 28;
            break;
          case 18:
            return c = { type: "offer", sdp: this._remoteSdp.getSdp() }, _e.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", c), d.next = 22, this._pc.setRemoteDescription(c);
          case 22:
            return d.next = 24, this._pc.createAnswer();
          case 24:
            return l = d.sent, _e.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", l), d.next = 28, this._pc.setLocalDescription(l);
          case 28:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return this.assertNotClosed(), r.abrupt("return", this._pc.getStats());
          case 2:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k;
      return v().wrap(function(O) {
        for (; ; ) switch (O.prev = O.next) {
          case 0:
            if (r = t.track, s = t.encodings, c = t.codecOptions, l = t.codec, u = t.onRtpSender, this.assertNotClosed(), this.assertSendDirection(), _e.debug("send() [kind:%s, track.id:%s]", r.kind, r.id), s && s.length > 1) {
              d = 1, f = U(s);
              try {
                for (f.s(); !(p = f.n()).done; ) m = p.value, (b = m.scalabilityMode ? (0, Bh.parse)(m.scalabilityMode).temporalLayers : 3) > d && (d = b);
              } catch (D) {
                f.e(D);
              } finally {
                f.f();
              }
              s.forEach(function(D, A) {
                D.rid = "r".concat(A), D.scalabilityMode = "L1T".concat(d);
              });
            }
            return (h = Oo.clone(this._sendingRtpParametersByKind[r.kind])).codecs = pn.reduceCodecs(h.codecs, l), (g = Oo.clone(this._sendingRemoteRtpParametersByKind[r.kind])).codecs = pn.reduceCodecs(g.codecs, l), w = this._remoteSdp.getNextMediaSectionIdx(), _ = this._pc.addTransceiver(r, { direction: "sendonly", streams: [this._sendStream], sendEncodings: s }), u && u(_.sender), O.next = 14, this._pc.createOffer();
          case 14:
            if (y = O.sent, C = Ir.parse(y.sdp), this._transportReady) {
              O.next = 19;
              break;
            }
            return O.next = 19, this.setupTransport({ localDtlsRole: (S = this._forcedLocalDtlsRole) !== null && S !== void 0 ? S : "client", localSdpObject: C });
          case 19:
            return _e.debug("send() | calling pc.setLocalDescription() [offer:%o]", y), O.next = 22, this._pc.setLocalDescription(y);
          case 22:
            return P = _.mid, h.mid = P, C = Ir.parse(this._pc.localDescription.sdp), T = C.media[w.idx], h.rtcp.cname = Ea.getCname({ offerMediaObject: T }), s ? s.length === 1 ? (I = Mo.getRtpEncodings({ offerMediaObject: T }), Object.assign(I[0], s[0]), h.encodings = I) : h.encodings = s : h.encodings = Mo.getRtpEncodings({ offerMediaObject: T }), this._remoteSdp.send({ offerMediaObject: T, reuseMid: w.reuseMid, offerRtpParameters: h, answerRtpParameters: g, codecOptions: c, extmapAllowMixed: !0 }), k = { type: "answer", sdp: this._remoteSdp.getSdp() }, _e.debug("send() | calling pc.setRemoteDescription() [answer:%o]", k), O.next = 33, this._pc.setRemoteDescription(k);
          case 33:
            return this._mapMidTransceiver.set(P, _), O.abrupt("return", { localId: P, rtpParameters: h, rtpSender: _.sender });
          case 35:
          case "end":
            return O.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), _e.debug("stopSending() [localId:%s]", t), !this._closed) {
              u.next = 4;
              break;
            }
            return u.abrupt("return");
          case 4:
            if (r = this._mapMidTransceiver.get(t)) {
              u.next = 7;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 7:
            if (r.sender.replaceTrack(null), this._pc.removeTrack(r.sender), this._remoteSdp.closeMediaSection(r.mid)) try {
              r.stop();
            } catch {
            }
            return u.next = 13, this._pc.createOffer();
          case 13:
            return s = u.sent, _e.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 17, this._pc.setLocalDescription(s);
          case 17:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, _e.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 21, this._pc.setRemoteDescription(c);
          case 21:
            this._mapMidTransceiver.delete(t);
          case 22:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), _e.debug("pauseSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return r.direction = "inactive", this._remoteSdp.pauseMediaSection(t), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, _e.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, _e.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), _e.debug("resumeSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t), this._remoteSdp.resumeSendingMediaSection(t), r) {
              u.next = 7;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 7:
            return r.direction = "sendonly", u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, _e.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, _e.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r ? _e.debug("replaceTrack() [localId:%s, track.id:%s]", t, r.id) : _e.debug("replaceTrack() [localId:%s, no track]", t), s = this._mapMidTransceiver.get(t)) {
              l.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return l.next = 8, s.sender.replaceTrack(r);
          case 8:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), _e.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              p.active = m <= r;
            }), f.next = 10, s.sender.setParameters(c);
          case 10:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 13, this._pc.createOffer();
          case 13:
            return l = f.sent, _e.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 17, this._pc.setLocalDescription(l);
          case 17:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, _e.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 21, this._pc.setRemoteDescription(u);
          case 21:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), _e.debug("setRtpEncodingParameters() [localId:%s, params:%o]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              c.encodings[m] = Re(Re({}, p), r);
            }), f.next = 10, s.sender.setParameters(c);
          case 10:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 13, this._pc.createOffer();
          case 13:
            return l = f.sent, _e.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 17, this._pc.setLocalDescription(l);
          case 17:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, _e.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 21, this._pc.setRemoteDescription(u);
          case 21:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return c.abrupt("return", r.sender.getStats());
          case 6:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.ordered, s = t.maxPacketLifeTime, c = t.maxRetransmits, l = t.label, u = t.protocol, this.assertNotClosed(), this.assertSendDirection(), d = { negotiated: !0, id: this._nextSendSctpStreamId, ordered: r, maxPacketLifeTime: s, maxRetransmits: c, protocol: u }, _e.debug("sendDataChannel() [options:%o]", d), f = this._pc.createDataChannel(l, d), this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % jo.MIS, this._hasDataChannelMediaSection) {
              y.next = 25;
              break;
            }
            return y.next = 10, this._pc.createOffer();
          case 10:
            if (p = y.sent, m = Ir.parse(p.sdp), b = m.media.find(function(C) {
              return C.type === "application";
            }), this._transportReady) {
              y.next = 16;
              break;
            }
            return y.next = 16, this.setupTransport({ localDtlsRole: (h = this._forcedLocalDtlsRole) !== null && h !== void 0 ? h : "client", localSdpObject: m });
          case 16:
            return _e.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), y.next = 19, this._pc.setLocalDescription(p);
          case 19:
            return this._remoteSdp.sendSctpAssociation({ offerMediaObject: b }), g = { type: "answer", sdp: this._remoteSdp.getSdp() }, _e.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), y.next = 24, this._pc.setRemoteDescription(g);
          case 24:
            this._hasDataChannelMediaSection = !0;
          case 25:
            return w = { streamId: d.id, ordered: d.ordered, maxPacketLifeTime: d.maxPacketLifeTime, maxRetransmits: d.maxRetransmits }, y.abrupt("return", { dataChannel: f, sctpStreamParameters: w });
          case 27:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k, x, O, D, A, E, F = this;
      return v().wrap(function($) {
        for (; ; ) switch ($.prev = $.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = [], s = /* @__PURE__ */ new Map(), c = U(t);
            try {
              for (c.s(); !(l = c.n()).done; ) d = l.value, f = d.trackId, p = d.kind, m = d.rtpParameters, b = d.streamId, _e.debug("receive() [trackId:%s, kind:%s]", f, p), h = (u = m.mid) !== null && u !== void 0 ? u : String(this._mapMidTransceiver.size), s.set(f, h), this._remoteSdp.receive({ mid: h, kind: p, offerRtpParameters: m, streamId: b ?? m.rtcp.cname, trackId: f });
            } catch (M) {
              c.e(M);
            } finally {
              c.f();
            }
            return g = { type: "offer", sdp: this._remoteSdp.getSdp() }, _e.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", g), $.next = 10, this._pc.setRemoteDescription(g);
          case 10:
            w = U(t);
            try {
              for (w.s(); !(_ = w.n()).done; ) y = _.value, C = y.trackId, (S = y.onRtpReceiver) && function() {
                var M = s.get(C), j = F._pc.getTransceivers().find(function(z) {
                  return z.mid === M;
                });
                if (!j) throw new Error("transceiver not found");
                S(j.receiver);
              }();
            } catch (M) {
              w.e(M);
            } finally {
              w.f();
            }
            return $.next = 14, this._pc.createAnswer();
          case 14:
            P = $.sent, T = Ir.parse(P.sdp), I = U(t);
            try {
              for (x = function() {
                var j = k.value, z = j.trackId, te = j.rtpParameters, ee = s.get(z), Y = T.media.find(function(Z) {
                  return String(Z.mid) === ee;
                });
                Ea.applyCodecParameters({ offerRtpParameters: te, answerMediaObject: Y });
              }, I.s(); !(k = I.n()).done; ) x();
            } catch (M) {
              I.e(M);
            } finally {
              I.f();
            }
            if (P = { type: "answer", sdp: Ir.write(T) }, this._transportReady) {
              $.next = 22;
              break;
            }
            return $.next = 22, this.setupTransport({ localDtlsRole: (O = this._forcedLocalDtlsRole) !== null && O !== void 0 ? O : "client", localSdpObject: T });
          case 22:
            return _e.debug("receive() | calling pc.setLocalDescription() [answer:%o]", P), $.next = 25, this._pc.setLocalDescription(P);
          case 25:
            D = U(t);
            try {
              for (E = function() {
                var j = A.value.trackId, z = s.get(j), te = F._pc.getTransceivers().find(function(ee) {
                  return ee.mid === z;
                });
                if (!te) throw new Error("new RTCRtpTransceiver not found");
                F._mapMidTransceiver.set(z, te), r.push({ localId: z, track: te.receiver.track, rtpReceiver: te.receiver });
              }, D.s(); !(A = D.n()).done; ) E();
            } catch (M) {
              D.e(M);
            } finally {
              D.f();
            }
            return $.abrupt("return", r);
          case 28:
          case "end":
            return $.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            if (this.assertRecvDirection(), !this._closed) {
              h.next = 3;
              break;
            }
            return h.abrupt("return");
          case 3:
            r = U(t), h.prev = 4, r.s();
          case 6:
            if ((s = r.n()).done) {
              h.next = 15;
              break;
            }
            if (c = s.value, _e.debug("stopReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              h.next = 12;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 12:
            this._remoteSdp.closeMediaSection(l.mid);
          case 13:
            h.next = 6;
            break;
          case 15:
            h.next = 20;
            break;
          case 17:
            h.prev = 17, h.t0 = h.catch(4), r.e(h.t0);
          case 20:
            return h.prev = 20, r.f(), h.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, _e.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), h.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return h.next = 29, this._pc.createAnswer();
          case 29:
            return d = h.sent, _e.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", d), h.next = 33, this._pc.setLocalDescription(d);
          case 33:
            f = U(t);
            try {
              for (f.s(); !(p = f.n()).done; ) m = p.value, this._mapMidTransceiver.delete(m);
            } catch (g) {
              f.e(g);
            } finally {
              f.f();
            }
          case 35:
          case "end":
            return h.stop();
        }
      }, e, this, [[4, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, _e.debug("pauseReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "inactive", this._remoteSdp.pauseMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, _e.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, _e.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, _e.debug("resumeReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "recvonly", this._remoteSdp.resumeReceivingMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, _e.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, _e.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertNotClosed(), this.assertRecvDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return c.abrupt("return", r.receiver.getStats());
          case 6:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.sctpStreamParameters, s = t.label, c = t.protocol, this.assertNotClosed(), this.assertRecvDirection(), l = r.streamId, u = r.ordered, d = r.maxPacketLifeTime, f = r.maxRetransmits, p = { negotiated: !0, id: l, ordered: u, maxPacketLifeTime: d, maxRetransmits: f, protocol: c }, _e.debug("receiveDataChannel() [options:%o]", p), m = this._pc.createDataChannel(s, p), this._hasDataChannelMediaSection) {
              y.next = 24;
              break;
            }
            return this._remoteSdp.receiveSctpAssociation(), b = { type: "offer", sdp: this._remoteSdp.getSdp() }, _e.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", b), y.next = 13, this._pc.setRemoteDescription(b);
          case 13:
            return y.next = 15, this._pc.createAnswer();
          case 15:
            if (h = y.sent, this._transportReady) {
              y.next = 20;
              break;
            }
            return w = Ir.parse(h.sdp), y.next = 20, this.setupTransport({ localDtlsRole: (g = this._forcedLocalDtlsRole) !== null && g !== void 0 ? g : "client", localSdpObject: w });
          case 20:
            return _e.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), y.next = 23, this._pc.setLocalDescription(h);
          case 23:
            this._hasDataChannelMediaSection = !0;
          case 24:
            return y.abrupt("return", { dataChannel: m });
          case 25:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l = this;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return r = t.localDtlsRole, (s = t.localSdpObject) || (s = Ir.parse(this._pc.localDescription.sdp)), (c = Ea.extractDtlsParameters({ sdpObject: s })).role = r, this._remoteSdp.updateDtlsRole(r === "client" ? "server" : "client"), d.next = 7, new Promise(function(f, p) {
              l.safeEmit("@connect", { dtlsParameters: c }, f, p);
            });
          case 7:
            this._transportReady = !0;
          case 8:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "assertNotClosed", value: function() {
    if (this._closed) throw new Nh.InvalidStateError("method called in a closed handler");
  } }, { key: "assertSendDirection", value: function() {
    if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
  } }, { key: "assertRecvDirection", value: function() {
    if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
  } }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
ai.Chrome111 = Vh;
var ii = {}, Uh = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), zh = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), Un = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && Uh(i, a, n[e]);
    return zh(i, a), i;
  };
}();
Object.defineProperty(ii, "__esModule", { value: !0 }), ii.Chrome74 = void 0;
var Jt = Un(tt), Gh = rt, No = Un(ct), fn = Un(Ye), Aa = Un(xt), Gi = Un(or), qh = Un(jn), Kh = ft, Hh = Rt, Yh = Mt, Wh = dr, ye = new Gh.Logger("Chrome74"), Fo = { OS: 1024, MIS: 1024 }, Xh = function(o) {
  Qe(i, Hh.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._closed = !1, n._mapMidTransceiver = /* @__PURE__ */ new Map(), n._sendStream = new MediaStream(), n._hasDataChannelMediaSection = !1, n._nextSendSctpStreamId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "Chrome74";
  } }, { key: "close", value: function() {
    if (ye.debug("close()"), !this._closed) {
      if (this._closed = !0, this._pc) try {
        this._pc.close();
      } catch {
      }
      this.emit("@close");
    }
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            return ye.debug("getNativeRtpCapabilities()"), t = new RTCPeerConnection({ iceServers: [], iceTransportPolicy: "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "unified-plan" }), u.prev = 2, t.addTransceiver("audio"), t.addTransceiver("video"), u.next = 7, t.createOffer();
          case 7:
            r = u.sent;
            try {
              t.close();
            } catch {
            }
            return s = Jt.parse(r.sdp), c = Aa.extractRtpCapabilities({ sdpObject: s }), qh.addNackSupportForOpus(c), u.abrupt("return", c);
          case 15:
            u.prev = 15, u.t0 = u.catch(2);
            try {
              t.close();
            } catch {
            }
            throw u.t0;
          case 19:
          case "end":
            return u.stop();
        }
      }, e, null, [[2, 15]]);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return ye.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: Fo });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    var t = this, r = e.direction, s = e.iceParameters, c = e.iceCandidates, l = e.dtlsParameters, u = e.sctpParameters, d = e.iceServers, f = e.iceTransportPolicy, p = e.additionalSettings, m = e.proprietaryConstraints, b = e.extendedRtpCapabilities;
    ye.debug("run()"), this._direction = r, this._remoteSdp = new Yh.RemoteSdp({ iceParameters: s, iceCandidates: c, dtlsParameters: l, sctpParameters: u }), this._sendingRtpParametersByKind = { audio: fn.getSendingRtpParameters("audio", b), video: fn.getSendingRtpParameters("video", b) }, this._sendingRemoteRtpParametersByKind = { audio: fn.getSendingRemoteRtpParameters("audio", b), video: fn.getSendingRemoteRtpParameters("video", b) }, l.role && l.role !== "auto" && (this._forcedLocalDtlsRole = l.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection(Re({ iceServers: d ?? [], iceTransportPolicy: f ?? "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "unified-plan" }, p), m), this._pc.addEventListener("icegatheringstatechange", function() {
      t.emit("@icegatheringstatechange", t._pc.iceGatheringState);
    }), this._pc.addEventListener("icecandidateerror", function(h) {
      t.emit("@icecandidateerror", h);
    }), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", function() {
      t.emit("@connectionstatechange", t._pc.connectionState);
    }) : (ye.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), this._pc.addEventListener("iceconnectionstatechange", function() {
      switch (t._pc.iceConnectionState) {
        case "checking":
          t.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          t.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          t.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          t.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          t.emit("@connectionstatechange", "closed");
      }
    }));
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            this.assertNotClosed(), ye.debug("updateIceServers()"), (r = this._pc.getConfiguration()).iceServers = t, this._pc.setConfiguration(r);
          case 5:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (this.assertNotClosed(), ye.debug("restartIce()"), this._remoteSdp.updateIceParameters(t), this._transportReady) {
              d.next = 5;
              break;
            }
            return d.abrupt("return");
          case 5:
            if (this._direction !== "send") {
              d.next = 18;
              break;
            }
            return d.next = 8, this._pc.createOffer({ iceRestart: !0 });
          case 8:
            return r = d.sent, ye.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", r), d.next = 12, this._pc.setLocalDescription(r);
          case 12:
            return s = { type: "answer", sdp: this._remoteSdp.getSdp() }, ye.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), d.next = 16, this._pc.setRemoteDescription(s);
          case 16:
            d.next = 28;
            break;
          case 18:
            return c = { type: "offer", sdp: this._remoteSdp.getSdp() }, ye.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", c), d.next = 22, this._pc.setRemoteDescription(c);
          case 22:
            return d.next = 24, this._pc.createAnswer();
          case 24:
            return l = d.sent, ye.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", l), d.next = 28, this._pc.setLocalDescription(l);
          case 28:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return this.assertNotClosed(), r.abrupt("return", this._pc.getStats());
          case 2:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I;
      return v().wrap(function(x) {
        for (; ; ) switch (x.prev = x.next) {
          case 0:
            return r = t.track, s = t.encodings, c = t.codecOptions, l = t.codec, this.assertNotClosed(), this.assertSendDirection(), ye.debug("send() [kind:%s, track.id:%s]", r.kind, r.id), s && s.length > 1 && s.forEach(function(O, D) {
              O.rid = "r".concat(D);
            }), (u = No.clone(this._sendingRtpParametersByKind[r.kind])).codecs = fn.reduceCodecs(u.codecs, l), (d = No.clone(this._sendingRemoteRtpParametersByKind[r.kind])).codecs = fn.reduceCodecs(d.codecs, l), f = this._remoteSdp.getNextMediaSectionIdx(), p = this._pc.addTransceiver(r, { direction: "sendonly", streams: [this._sendStream], sendEncodings: s }), x.next = 13, this._pc.createOffer();
          case 13:
            if (m = x.sent, b = Jt.parse(m.sdp), this._transportReady) {
              x.next = 18;
              break;
            }
            return x.next = 18, this.setupTransport({ localDtlsRole: (g = this._forcedLocalDtlsRole) !== null && g !== void 0 ? g : "client", localSdpObject: b });
          case 18:
            return w = !1, _ = (0, Wh.parse)((s ?? [{}])[0].scalabilityMode), s && s.length === 1 && _.spatialLayers > 1 && u.codecs[0].mimeType.toLowerCase() === "video/vp9" && (ye.debug("send() | enabling legacy simulcast for VP9 SVC"), w = !0, b = Jt.parse(m.sdp), h = b.media[f.idx], Gi.addLegacySimulcast({ offerMediaObject: h, numStreams: _.spatialLayers }), m = { type: "offer", sdp: Jt.write(b) }), ye.debug("send() | calling pc.setLocalDescription() [offer:%o]", m), x.next = 24, this._pc.setLocalDescription(m);
          case 24:
            if (y = p.mid, u.mid = y, b = Jt.parse(this._pc.localDescription.sdp), h = b.media[f.idx], u.rtcp.cname = Aa.getCname({ offerMediaObject: h }), s ? s.length === 1 ? (C = Gi.getRtpEncodings({ offerMediaObject: h }), Object.assign(C[0], s[0]), w && (C = [C[0]]), u.encodings = C) : u.encodings = s : u.encodings = Gi.getRtpEncodings({ offerMediaObject: h }), u.encodings.length > 1 && (u.codecs[0].mimeType.toLowerCase() === "video/vp8" || u.codecs[0].mimeType.toLowerCase() === "video/h264")) {
              S = U(u.encodings);
              try {
                for (S.s(); !(P = S.n()).done; ) (T = P.value).scalabilityMode ? T.scalabilityMode = "L1T".concat(_.temporalLayers) : T.scalabilityMode = "L1T3";
              } catch (O) {
                S.e(O);
              } finally {
                S.f();
              }
            }
            return this._remoteSdp.send({ offerMediaObject: h, reuseMid: f.reuseMid, offerRtpParameters: u, answerRtpParameters: d, codecOptions: c, extmapAllowMixed: !0 }), I = { type: "answer", sdp: this._remoteSdp.getSdp() }, ye.debug("send() | calling pc.setRemoteDescription() [answer:%o]", I), x.next = 36, this._pc.setRemoteDescription(I);
          case 36:
            return this._mapMidTransceiver.set(y, p), x.abrupt("return", { localId: y, rtpParameters: u, rtpSender: p.sender });
          case 38:
          case "end":
            return x.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), ye.debug("stopSending() [localId:%s]", t), !this._closed) {
              u.next = 4;
              break;
            }
            return u.abrupt("return");
          case 4:
            if (r = this._mapMidTransceiver.get(t)) {
              u.next = 7;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 7:
            if (r.sender.replaceTrack(null), this._pc.removeTrack(r.sender), this._remoteSdp.closeMediaSection(r.mid)) try {
              r.stop();
            } catch {
            }
            return u.next = 13, this._pc.createOffer();
          case 13:
            return s = u.sent, ye.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 17, this._pc.setLocalDescription(s);
          case 17:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, ye.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 21, this._pc.setRemoteDescription(c);
          case 21:
            this._mapMidTransceiver.delete(t);
          case 22:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), ye.debug("pauseSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return r.direction = "inactive", this._remoteSdp.pauseMediaSection(t), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, ye.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, ye.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), ye.debug("resumeSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t), this._remoteSdp.resumeSendingMediaSection(t), r) {
              u.next = 7;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 7:
            return r.direction = "sendonly", u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, ye.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, ye.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r ? ye.debug("replaceTrack() [localId:%s, track.id:%s]", t, r.id) : ye.debug("replaceTrack() [localId:%s, no track]", t), s = this._mapMidTransceiver.get(t)) {
              l.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return l.next = 8, s.sender.replaceTrack(r);
          case 8:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), ye.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              p.active = m <= r;
            }), f.next = 10, s.sender.setParameters(c);
          case 10:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 13, this._pc.createOffer();
          case 13:
            return l = f.sent, ye.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 17, this._pc.setLocalDescription(l);
          case 17:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, ye.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 21, this._pc.setRemoteDescription(u);
          case 21:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), ye.debug("setRtpEncodingParameters() [localId:%s, params:%o]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              c.encodings[m] = Re(Re({}, p), r);
            }), f.next = 10, s.sender.setParameters(c);
          case 10:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 13, this._pc.createOffer();
          case 13:
            return l = f.sent, ye.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 17, this._pc.setLocalDescription(l);
          case 17:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, ye.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 21, this._pc.setRemoteDescription(u);
          case 21:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return c.abrupt("return", r.sender.getStats());
          case 6:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.ordered, s = t.maxPacketLifeTime, c = t.maxRetransmits, l = t.label, u = t.protocol, this.assertNotClosed(), this.assertSendDirection(), d = { negotiated: !0, id: this._nextSendSctpStreamId, ordered: r, maxPacketLifeTime: s, maxRetransmits: c, protocol: u }, ye.debug("sendDataChannel() [options:%o]", d), f = this._pc.createDataChannel(l, d), this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % Fo.MIS, this._hasDataChannelMediaSection) {
              y.next = 25;
              break;
            }
            return y.next = 10, this._pc.createOffer();
          case 10:
            if (p = y.sent, m = Jt.parse(p.sdp), b = m.media.find(function(C) {
              return C.type === "application";
            }), this._transportReady) {
              y.next = 16;
              break;
            }
            return y.next = 16, this.setupTransport({ localDtlsRole: (h = this._forcedLocalDtlsRole) !== null && h !== void 0 ? h : "client", localSdpObject: m });
          case 16:
            return ye.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), y.next = 19, this._pc.setLocalDescription(p);
          case 19:
            return this._remoteSdp.sendSctpAssociation({ offerMediaObject: b }), g = { type: "answer", sdp: this._remoteSdp.getSdp() }, ye.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), y.next = 24, this._pc.setRemoteDescription(g);
          case 24:
            this._hasDataChannelMediaSection = !0;
          case 25:
            return w = { streamId: d.id, ordered: d.ordered, maxPacketLifeTime: d.maxPacketLifeTime, maxRetransmits: d.maxRetransmits }, y.abrupt("return", { dataChannel: f, sctpStreamParameters: w });
          case 27:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k, x = this;
      return v().wrap(function(D) {
        for (; ; ) switch (D.prev = D.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = [], s = /* @__PURE__ */ new Map(), c = U(t);
            try {
              for (c.s(); !(l = c.n()).done; ) d = l.value, f = d.trackId, p = d.kind, m = d.rtpParameters, b = d.streamId, ye.debug("receive() [trackId:%s, kind:%s]", f, p), h = (u = m.mid) !== null && u !== void 0 ? u : String(this._mapMidTransceiver.size), s.set(f, h), this._remoteSdp.receive({ mid: h, kind: p, offerRtpParameters: m, streamId: b ?? m.rtcp.cname, trackId: f });
            } catch (A) {
              c.e(A);
            } finally {
              c.f();
            }
            return g = { type: "offer", sdp: this._remoteSdp.getSdp() }, ye.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", g), D.next = 10, this._pc.setRemoteDescription(g);
          case 10:
            return D.next = 12, this._pc.createAnswer();
          case 12:
            w = D.sent, _ = Jt.parse(w.sdp), y = U(t);
            try {
              for (S = function() {
                var E = C.value, F = E.trackId, B = E.rtpParameters, $ = s.get(F), M = _.media.find(function(j) {
                  return String(j.mid) === $;
                });
                Aa.applyCodecParameters({ offerRtpParameters: B, answerMediaObject: M });
              }, y.s(); !(C = y.n()).done; ) S();
            } catch (A) {
              y.e(A);
            } finally {
              y.f();
            }
            if (w = { type: "answer", sdp: Jt.write(_) }, this._transportReady) {
              D.next = 20;
              break;
            }
            return D.next = 20, this.setupTransport({ localDtlsRole: (P = this._forcedLocalDtlsRole) !== null && P !== void 0 ? P : "client", localSdpObject: _ });
          case 20:
            return ye.debug("receive() | calling pc.setLocalDescription() [answer:%o]", w), D.next = 23, this._pc.setLocalDescription(w);
          case 23:
            T = U(t);
            try {
              for (k = function() {
                var E = I.value.trackId, F = s.get(E), B = x._pc.getTransceivers().find(function($) {
                  return $.mid === F;
                });
                if (!B) throw new Error("new RTCRtpTransceiver not found");
                x._mapMidTransceiver.set(F, B), r.push({ localId: F, track: B.receiver.track, rtpReceiver: B.receiver });
              }, T.s(); !(I = T.n()).done; ) k();
            } catch (A) {
              T.e(A);
            } finally {
              T.f();
            }
            return D.abrupt("return", r);
          case 26:
          case "end":
            return D.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            if (this.assertRecvDirection(), !this._closed) {
              h.next = 3;
              break;
            }
            return h.abrupt("return");
          case 3:
            r = U(t), h.prev = 4, r.s();
          case 6:
            if ((s = r.n()).done) {
              h.next = 15;
              break;
            }
            if (c = s.value, ye.debug("stopReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              h.next = 12;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 12:
            this._remoteSdp.closeMediaSection(l.mid);
          case 13:
            h.next = 6;
            break;
          case 15:
            h.next = 20;
            break;
          case 17:
            h.prev = 17, h.t0 = h.catch(4), r.e(h.t0);
          case 20:
            return h.prev = 20, r.f(), h.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, ye.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), h.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return h.next = 29, this._pc.createAnswer();
          case 29:
            return d = h.sent, ye.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", d), h.next = 33, this._pc.setLocalDescription(d);
          case 33:
            f = U(t);
            try {
              for (f.s(); !(p = f.n()).done; ) m = p.value, this._mapMidTransceiver.delete(m);
            } catch (g) {
              f.e(g);
            } finally {
              f.f();
            }
          case 35:
          case "end":
            return h.stop();
        }
      }, e, this, [[4, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, ye.debug("pauseReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "inactive", this._remoteSdp.pauseMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, ye.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, ye.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, ye.debug("resumeReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "recvonly", this._remoteSdp.resumeReceivingMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, ye.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, ye.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertNotClosed(), this.assertRecvDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return c.abrupt("return", r.receiver.getStats());
          case 6:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.sctpStreamParameters, s = t.label, c = t.protocol, this.assertNotClosed(), this.assertRecvDirection(), l = r.streamId, u = r.ordered, d = r.maxPacketLifeTime, f = r.maxRetransmits, p = { negotiated: !0, id: l, ordered: u, maxPacketLifeTime: d, maxRetransmits: f, protocol: c }, ye.debug("receiveDataChannel() [options:%o]", p), m = this._pc.createDataChannel(s, p), this._hasDataChannelMediaSection) {
              y.next = 24;
              break;
            }
            return this._remoteSdp.receiveSctpAssociation(), b = { type: "offer", sdp: this._remoteSdp.getSdp() }, ye.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", b), y.next = 13, this._pc.setRemoteDescription(b);
          case 13:
            return y.next = 15, this._pc.createAnswer();
          case 15:
            if (h = y.sent, this._transportReady) {
              y.next = 20;
              break;
            }
            return w = Jt.parse(h.sdp), y.next = 20, this.setupTransport({ localDtlsRole: (g = this._forcedLocalDtlsRole) !== null && g !== void 0 ? g : "client", localSdpObject: w });
          case 20:
            return ye.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), y.next = 23, this._pc.setLocalDescription(h);
          case 23:
            this._hasDataChannelMediaSection = !0;
          case 24:
            return y.abrupt("return", { dataChannel: m });
          case 25:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l = this;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return r = t.localDtlsRole, (s = t.localSdpObject) || (s = Jt.parse(this._pc.localDescription.sdp)), (c = Aa.extractDtlsParameters({ sdpObject: s })).role = r, this._remoteSdp.updateDtlsRole(r === "client" ? "server" : "client"), d.next = 7, new Promise(function(f, p) {
              l.safeEmit("@connect", { dtlsParameters: c }, f, p);
            });
          case 7:
            this._transportReady = !0;
          case 8:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "assertNotClosed", value: function() {
    if (this._closed) throw new Kh.InvalidStateError("method called in a closed handler");
  } }, { key: "assertSendDirection", value: function() {
    if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
  } }, { key: "assertRecvDirection", value: function() {
    if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
  } }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
ii.Chrome74 = Xh;
var si = {}, Zh = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), Qh = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), va = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && Zh(i, a, n[e]);
    return Qh(i, a), i;
  };
}();
Object.defineProperty(si, "__esModule", { value: !0 }), si.Chrome70 = void 0;
var Ut = va(tt), Jh = rt, $o = va(ct), hn = va(Ye), La = va(xt), qi = va(or), em = Rt, tm = Mt, rm = dr, xe = new Jh.Logger("Chrome70"), Bo = { OS: 1024, MIS: 1024 }, nm = function(o) {
  Qe(i, em.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._mapMidTransceiver = /* @__PURE__ */ new Map(), n._sendStream = new MediaStream(), n._hasDataChannelMediaSection = !1, n._nextSendSctpStreamId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "Chrome70";
  } }, { key: "close", value: function() {
    if (xe.debug("close()"), this._pc) try {
      this._pc.close();
    } catch {
    }
    this.emit("@close");
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            return xe.debug("getNativeRtpCapabilities()"), t = new RTCPeerConnection({ iceServers: [], iceTransportPolicy: "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "unified-plan" }), u.prev = 2, t.addTransceiver("audio"), t.addTransceiver("video"), u.next = 7, t.createOffer();
          case 7:
            r = u.sent;
            try {
              t.close();
            } catch {
            }
            return s = Ut.parse(r.sdp), c = La.extractRtpCapabilities({ sdpObject: s }), u.abrupt("return", c);
          case 14:
            u.prev = 14, u.t0 = u.catch(2);
            try {
              t.close();
            } catch {
            }
            throw u.t0;
          case 18:
          case "end":
            return u.stop();
        }
      }, e, null, [[2, 14]]);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return xe.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: Bo });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    var t = this, r = e.direction, s = e.iceParameters, c = e.iceCandidates, l = e.dtlsParameters, u = e.sctpParameters, d = e.iceServers, f = e.iceTransportPolicy, p = e.additionalSettings, m = e.proprietaryConstraints, b = e.extendedRtpCapabilities;
    xe.debug("run()"), this._direction = r, this._remoteSdp = new tm.RemoteSdp({ iceParameters: s, iceCandidates: c, dtlsParameters: l, sctpParameters: u }), this._sendingRtpParametersByKind = { audio: hn.getSendingRtpParameters("audio", b), video: hn.getSendingRtpParameters("video", b) }, this._sendingRemoteRtpParametersByKind = { audio: hn.getSendingRemoteRtpParameters("audio", b), video: hn.getSendingRemoteRtpParameters("video", b) }, l.role && l.role !== "auto" && (this._forcedLocalDtlsRole = l.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection(Re({ iceServers: d ?? [], iceTransportPolicy: f ?? "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "unified-plan" }, p), m), this._pc.addEventListener("icegatheringstatechange", function() {
      t.emit("@icegatheringstatechange", t._pc.iceGatheringState);
    }), this._pc.addEventListener("icecandidateerror", function(h) {
      t.emit("@icecandidateerror", h);
    }), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", function() {
      t.emit("@connectionstatechange", t._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", function() {
      switch (xe.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), t._pc.iceConnectionState) {
        case "checking":
          t.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          t.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          t.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          t.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          t.emit("@connectionstatechange", "closed");
      }
    });
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            xe.debug("updateIceServers()"), (r = this._pc.getConfiguration()).iceServers = t, this._pc.setConfiguration(r);
          case 4:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (xe.debug("restartIce()"), this._remoteSdp.updateIceParameters(t), this._transportReady) {
              d.next = 4;
              break;
            }
            return d.abrupt("return");
          case 4:
            if (this._direction !== "send") {
              d.next = 17;
              break;
            }
            return d.next = 7, this._pc.createOffer({ iceRestart: !0 });
          case 7:
            return r = d.sent, xe.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", r), d.next = 11, this._pc.setLocalDescription(r);
          case 11:
            return s = { type: "answer", sdp: this._remoteSdp.getSdp() }, xe.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), d.next = 15, this._pc.setRemoteDescription(s);
          case 15:
            d.next = 27;
            break;
          case 17:
            return c = { type: "offer", sdp: this._remoteSdp.getSdp() }, xe.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", c), d.next = 21, this._pc.setRemoteDescription(c);
          case 21:
            return d.next = 23, this._pc.createAnswer();
          case 23:
            return l = d.sent, xe.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", l), d.next = 27, this._pc.setLocalDescription(l);
          case 27:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", this._pc.getStats());
          case 1:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k, x, O, D;
      return v().wrap(function(E) {
        for (; ; ) switch (E.prev = E.next) {
          case 0:
            return r = t.track, s = t.encodings, c = t.codecOptions, l = t.codec, this.assertSendDirection(), xe.debug("send() [kind:%s, track.id:%s]", r.kind, r.id), (u = $o.clone(this._sendingRtpParametersByKind[r.kind])).codecs = hn.reduceCodecs(u.codecs, l), (d = $o.clone(this._sendingRemoteRtpParametersByKind[r.kind])).codecs = hn.reduceCodecs(d.codecs, l), f = this._remoteSdp.getNextMediaSectionIdx(), p = this._pc.addTransceiver(r, { direction: "sendonly", streams: [this._sendStream] }), E.next = 11, this._pc.createOffer();
          case 11:
            if (m = E.sent, b = Ut.parse(m.sdp), this._transportReady) {
              E.next = 16;
              break;
            }
            return E.next = 16, this.setupTransport({ localDtlsRole: (g = this._forcedLocalDtlsRole) !== null && g !== void 0 ? g : "client", localSdpObject: b });
          case 16:
            return s && s.length > 1 && (xe.debug("send() | enabling legacy simulcast"), b = Ut.parse(m.sdp), h = b.media[f.idx], qi.addLegacySimulcast({ offerMediaObject: h, numStreams: s.length }), m = { type: "offer", sdp: Ut.write(b) }), w = !1, _ = (0, rm.parse)((s ?? [{}])[0].scalabilityMode), s && s.length === 1 && _.spatialLayers > 1 && u.codecs[0].mimeType.toLowerCase() === "video/vp9" && (xe.debug("send() | enabling legacy simulcast for VP9 SVC"), w = !0, b = Ut.parse(m.sdp), h = b.media[f.idx], qi.addLegacySimulcast({ offerMediaObject: h, numStreams: _.spatialLayers }), m = { type: "offer", sdp: Ut.write(b) }), xe.debug("send() | calling pc.setLocalDescription() [offer:%o]", m), E.next = 23, this._pc.setLocalDescription(m);
          case 23:
            if (!s) {
              E.next = 38;
              break;
            }
            xe.debug("send() | applying given encodings"), y = p.sender.getParameters(), C = 0;
          case 27:
            if (!(C < ((S = y.encodings) !== null && S !== void 0 ? S : []).length)) {
              E.next = 36;
              break;
            }
            if (P = y.encodings[C], T = s[C]) {
              E.next = 32;
              break;
            }
            return E.abrupt("break", 36);
          case 32:
            y.encodings[C] = Object.assign(P, T);
          case 33:
            ++C, E.next = 27;
            break;
          case 36:
            return E.next = 38, p.sender.setParameters(y);
          case 38:
            if (I = p.mid, u.mid = I, b = Ut.parse(this._pc.localDescription.sdp), h = b.media[f.idx], u.rtcp.cname = La.getCname({ offerMediaObject: h }), u.encodings = qi.getRtpEncodings({ offerMediaObject: h }), s) for (k = 0; k < u.encodings.length; ++k) s[k] && Object.assign(u.encodings[k], s[k]);
            if (w && (u.encodings = [u.encodings[0]]), u.encodings.length > 1 && (u.codecs[0].mimeType.toLowerCase() === "video/vp8" || u.codecs[0].mimeType.toLowerCase() === "video/h264")) {
              x = U(u.encodings);
              try {
                for (x.s(); !(O = x.n()).done; ) O.value.scalabilityMode = "L1T3";
              } catch (F) {
                x.e(F);
              } finally {
                x.f();
              }
            }
            return this._remoteSdp.send({ offerMediaObject: h, reuseMid: f.reuseMid, offerRtpParameters: u, answerRtpParameters: d, codecOptions: c }), D = { type: "answer", sdp: this._remoteSdp.getSdp() }, xe.debug("send() | calling pc.setRemoteDescription() [answer:%o]", D), E.next = 52, this._pc.setRemoteDescription(D);
          case 52:
            return this._mapMidTransceiver.set(I, p), E.abrupt("return", { localId: I, rtpParameters: u, rtpSender: p.sender });
          case 54:
          case "end":
            return E.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), xe.debug("stopSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            if (r.sender.replaceTrack(null), this._pc.removeTrack(r.sender), this._remoteSdp.closeMediaSection(r.mid)) try {
              r.stop();
            } catch {
            }
            return u.next = 11, this._pc.createOffer();
          case 11:
            return s = u.sent, xe.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 15, this._pc.setLocalDescription(s);
          case 15:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, xe.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 19, this._pc.setRemoteDescription(c);
          case 19:
            this._mapMidTransceiver.delete(t);
          case 20:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (this.assertSendDirection(), r ? xe.debug("replaceTrack() [localId:%s, track.id:%s]", t, r.id) : xe.debug("replaceTrack() [localId:%s, no track]", t), s = this._mapMidTransceiver.get(t)) {
              l.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return l.next = 7, s.sender.replaceTrack(r);
          case 7:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertSendDirection(), xe.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              p.active = m <= r;
            }), f.next = 9, s.sender.setParameters(c);
          case 9:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 12, this._pc.createOffer();
          case 12:
            return l = f.sent, xe.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 16, this._pc.setLocalDescription(l);
          case 16:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, xe.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 20, this._pc.setRemoteDescription(u);
          case 20:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertSendDirection(), xe.debug("setRtpEncodingParameters() [localId:%s, params:%o]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              c.encodings[m] = Re(Re({}, p), r);
            }), f.next = 9, s.sender.setParameters(c);
          case 9:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 12, this._pc.createOffer();
          case 12:
            return l = f.sent, xe.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 16, this._pc.setLocalDescription(l);
          case 16:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, xe.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 20, this._pc.setRemoteDescription(u);
          case 20:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertSendDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 4;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 4:
            return c.abrupt("return", r.sender.getStats());
          case 5:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.ordered, s = t.maxPacketLifeTime, c = t.maxRetransmits, l = t.label, u = t.protocol, this.assertSendDirection(), d = { negotiated: !0, id: this._nextSendSctpStreamId, ordered: r, maxPacketLifeTime: s, maxRetransmitTime: s, maxRetransmits: c, protocol: u }, xe.debug("sendDataChannel() [options:%o]", d), f = this._pc.createDataChannel(l, d), this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % Bo.MIS, this._hasDataChannelMediaSection) {
              y.next = 24;
              break;
            }
            return y.next = 9, this._pc.createOffer();
          case 9:
            if (p = y.sent, m = Ut.parse(p.sdp), b = m.media.find(function(C) {
              return C.type === "application";
            }), this._transportReady) {
              y.next = 15;
              break;
            }
            return y.next = 15, this.setupTransport({ localDtlsRole: (h = this._forcedLocalDtlsRole) !== null && h !== void 0 ? h : "client", localSdpObject: m });
          case 15:
            return xe.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), y.next = 18, this._pc.setLocalDescription(p);
          case 18:
            return this._remoteSdp.sendSctpAssociation({ offerMediaObject: b }), g = { type: "answer", sdp: this._remoteSdp.getSdp() }, xe.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), y.next = 23, this._pc.setRemoteDescription(g);
          case 23:
            this._hasDataChannelMediaSection = !0;
          case 24:
            return w = { streamId: d.id, ordered: d.ordered, maxPacketLifeTime: d.maxPacketLifeTime, maxRetransmits: d.maxRetransmits }, y.abrupt("return", { dataChannel: f, sctpStreamParameters: w });
          case 26:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k, x = this;
      return v().wrap(function(D) {
        for (; ; ) switch (D.prev = D.next) {
          case 0:
            this.assertRecvDirection(), r = [], s = /* @__PURE__ */ new Map(), c = U(t);
            try {
              for (c.s(); !(l = c.n()).done; ) d = l.value, f = d.trackId, p = d.kind, m = d.rtpParameters, b = d.streamId, xe.debug("receive() [trackId:%s, kind:%s]", f, p), h = (u = m.mid) !== null && u !== void 0 ? u : String(this._mapMidTransceiver.size), s.set(f, h), this._remoteSdp.receive({ mid: h, kind: p, offerRtpParameters: m, streamId: b ?? m.rtcp.cname, trackId: f });
            } catch (A) {
              c.e(A);
            } finally {
              c.f();
            }
            return g = { type: "offer", sdp: this._remoteSdp.getSdp() }, xe.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", g), D.next = 9, this._pc.setRemoteDescription(g);
          case 9:
            return D.next = 11, this._pc.createAnswer();
          case 11:
            w = D.sent, _ = Ut.parse(w.sdp), y = U(t);
            try {
              for (S = function() {
                var E = C.value, F = E.trackId, B = E.rtpParameters, $ = s.get(F), M = _.media.find(function(j) {
                  return String(j.mid) === $;
                });
                La.applyCodecParameters({ offerRtpParameters: B, answerMediaObject: M });
              }, y.s(); !(C = y.n()).done; ) S();
            } catch (A) {
              y.e(A);
            } finally {
              y.f();
            }
            if (w = { type: "answer", sdp: Ut.write(_) }, this._transportReady) {
              D.next = 19;
              break;
            }
            return D.next = 19, this.setupTransport({ localDtlsRole: (P = this._forcedLocalDtlsRole) !== null && P !== void 0 ? P : "client", localSdpObject: _ });
          case 19:
            return xe.debug("receive() | calling pc.setLocalDescription() [answer:%o]", w), D.next = 22, this._pc.setLocalDescription(w);
          case 22:
            T = U(t);
            try {
              for (k = function() {
                var E = I.value.trackId, F = s.get(E), B = x._pc.getTransceivers().find(function($) {
                  return $.mid === F;
                });
                if (!B) throw new Error("new RTCRtpTransceiver not found");
                x._mapMidTransceiver.set(F, B), r.push({ localId: F, track: B.receiver.track, rtpReceiver: B.receiver });
              }, T.s(); !(I = T.n()).done; ) k();
            } catch (A) {
              T.e(A);
            } finally {
              T.f();
            }
            return D.abrupt("return", r);
          case 25:
          case "end":
            return D.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            this.assertRecvDirection(), r = U(t), h.prev = 2, r.s();
          case 4:
            if ((s = r.n()).done) {
              h.next = 13;
              break;
            }
            if (c = s.value, xe.debug("stopReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              h.next = 10;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 10:
            this._remoteSdp.closeMediaSection(l.mid);
          case 11:
            h.next = 4;
            break;
          case 13:
            h.next = 18;
            break;
          case 15:
            h.prev = 15, h.t0 = h.catch(2), r.e(h.t0);
          case 18:
            return h.prev = 18, r.f(), h.finish(18);
          case 21:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, xe.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), h.next = 25, this._pc.setRemoteDescription(u);
          case 25:
            return h.next = 27, this._pc.createAnswer();
          case 27:
            return d = h.sent, xe.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", d), h.next = 31, this._pc.setLocalDescription(d);
          case 31:
            f = U(t);
            try {
              for (f.s(); !(p = f.n()).done; ) m = p.value, this._mapMidTransceiver.delete(m);
            } catch (g) {
              f.e(g);
            } finally {
              f.f();
            }
          case 33:
          case "end":
            return h.stop();
        }
      }, e, this, [[2, 15, 18, 21]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertRecvDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 4;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 4:
            return c.abrupt("return", r.receiver.getStats());
          case 5:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.sctpStreamParameters, s = t.label, c = t.protocol, this.assertRecvDirection(), l = r.streamId, u = r.ordered, d = r.maxPacketLifeTime, f = r.maxRetransmits, p = { negotiated: !0, id: l, ordered: u, maxPacketLifeTime: d, maxRetransmitTime: d, maxRetransmits: f, protocol: c }, xe.debug("receiveDataChannel() [options:%o]", p), m = this._pc.createDataChannel(s, p), this._hasDataChannelMediaSection) {
              y.next = 23;
              break;
            }
            return this._remoteSdp.receiveSctpAssociation(), b = { type: "offer", sdp: this._remoteSdp.getSdp() }, xe.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", b), y.next = 12, this._pc.setRemoteDescription(b);
          case 12:
            return y.next = 14, this._pc.createAnswer();
          case 14:
            if (h = y.sent, this._transportReady) {
              y.next = 19;
              break;
            }
            return w = Ut.parse(h.sdp), y.next = 19, this.setupTransport({ localDtlsRole: (g = this._forcedLocalDtlsRole) !== null && g !== void 0 ? g : "client", localSdpObject: w });
          case 19:
            return xe.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), y.next = 22, this._pc.setLocalDescription(h);
          case 22:
            this._hasDataChannelMediaSection = !0;
          case 23:
            return y.abrupt("return", { dataChannel: m });
          case 24:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l = this;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return r = t.localDtlsRole, (s = t.localSdpObject) || (s = Ut.parse(this._pc.localDescription.sdp)), (c = La.extractDtlsParameters({ sdpObject: s })).role = r, this._remoteSdp.updateDtlsRole(r === "client" ? "server" : "client"), d.next = 7, new Promise(function(f, p) {
              l.safeEmit("@connect", { dtlsParameters: c }, f, p);
            });
          case 7:
            this._transportReady = !0;
          case 8:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "assertSendDirection", value: function() {
    if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
  } }, { key: "assertRecvDirection", value: function() {
    if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
  } }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
si.Chrome70 = nm;
var oi = {}, Zr = {};
Object.defineProperty(Zr, "__esModule", { value: !0 }), Zr.getRtpEncodings = function(a) {
  var i, n, e, t, r = a.offerMediaObject, s = a.track, c = /* @__PURE__ */ new Set(), l = U((i = r.ssrcs) !== null && i !== void 0 ? i : []);
  try {
    for (l.s(); !(t = l.n()).done; ) {
      var u = t.value;
      if (u.attribute === "msid" && u.value.split(" ")[1] === s.id) {
        var d = u.id;
        c.add(d), e || (e = d);
      }
    }
  } catch (D) {
    l.e(D);
  } finally {
    l.f();
  }
  if (c.size === 0) throw new Error("a=ssrc line with msid information not found [track.id:".concat(s.id, "]"));
  var f, p = /* @__PURE__ */ new Map(), m = U((n = r.ssrcGroups) !== null && n !== void 0 ? n : []);
  try {
    for (m.s(); !(f = m.n()).done; ) {
      var b = f.value;
      if (b.semantics === "FID") {
        var h = Wr(b.ssrcs.split(/\s+/), 2), g = h[0], w = h[1];
        g = Number(g), w = Number(w), c.has(g) && (c.delete(g), c.delete(w), p.set(g, w));
      }
    }
  } catch (D) {
    m.e(D);
  } finally {
    m.f();
  }
  var _, y = U(c);
  try {
    for (y.s(); !(_ = y.n()).done; ) {
      var C = _.value;
      p.set(C, null);
    }
  } catch (D) {
    y.e(D);
  } finally {
    y.f();
  }
  var S, P = [], T = U(p);
  try {
    for (T.s(); !(S = T.n()).done; ) {
      var I = Wr(S.value, 2), k = I[0], x = I[1], O = { ssrc: k };
      x && (O.rtx = { ssrc: x }), P.push(O);
    }
  } catch (D) {
    T.e(D);
  } finally {
    T.f();
  }
  return P;
}, Zr.addLegacySimulcast = function(a) {
  var i, n, e, t, r, s, c, l = a.offerMediaObject, u = a.track, d = a.numStreams;
  if (d <= 1) throw new TypeError("numStreams must be greater than 1");
  if (!((i = l.ssrcs) !== null && i !== void 0 ? i : []).find(function(P) {
    return P.attribute === "msid" && P.value.split(" ")[1] === u.id && (r = P.id, c = P.value.split(" ")[0], !0);
  })) throw new Error("a=ssrc line with msid information not found [track.id:".concat(u.id, "]"));
  ((n = l.ssrcGroups) !== null && n !== void 0 ? n : []).some(function(P) {
    if (P.semantics !== "FID") return !1;
    var T = P.ssrcs.split(/\s+/);
    return Number(T[0]) === r && (s = Number(T[1]), !0);
  });
  var f = l.ssrcs.find(function(P) {
    return P.attribute === "cname" && P.id === r;
  });
  if (!f) throw new Error("a=ssrc line with cname information not found [track.id:".concat(u.id, "]"));
  for (var p = f.value, m = [], b = [], h = 0; h < d; ++h) m.push(r + h), s && b.push(s + h);
  l.ssrcGroups = (e = l.ssrcGroups) !== null && e !== void 0 ? e : [], l.ssrcs = (t = l.ssrcs) !== null && t !== void 0 ? t : [], l.ssrcGroups.push({ semantics: "SIM", ssrcs: m.join(" ") });
  for (var g = 0, w = m; g < w.length; g++) {
    var _ = w[g];
    l.ssrcs.push({ id: _, attribute: "cname", value: p }), l.ssrcs.push({ id: _, attribute: "msid", value: "".concat(c, " ").concat(u.id) });
  }
  for (var y = 0; y < b.length; ++y) {
    var C = m[y], S = b[y];
    l.ssrcs.push({ id: S, attribute: "cname", value: p }), l.ssrcs.push({ id: S, attribute: "msid", value: "".concat(c, " ").concat(u.id) }), l.ssrcGroups.push({ semantics: "FID", ssrcs: "".concat(C, " ").concat(S) });
  }
};
var am = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), im = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), ga = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && am(i, a, n[e]);
    return im(i, a), i;
  };
}();
Object.defineProperty(oi, "__esModule", { value: !0 }), oi.Chrome67 = void 0;
var er = ga(tt), sm = rt, Vo = ga(ct), mn = ga(Ye), Oa = ga(xt), Uo = ga(Zr), om = Rt, cm = Mt, Ee = new sm.Logger("Chrome67"), zo = { OS: 1024, MIS: 1024 }, um = function(o) {
  Qe(i, om.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._sendStream = new MediaStream(), n._mapSendLocalIdRtpSender = /* @__PURE__ */ new Map(), n._nextSendLocalId = 0, n._mapRecvLocalIdInfo = /* @__PURE__ */ new Map(), n._hasDataChannelMediaSection = !1, n._nextSendSctpStreamId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "Chrome67";
  } }, { key: "close", value: function() {
    if (Ee.debug("close()"), this._pc) try {
      this._pc.close();
    } catch {
    }
    this.emit("@close");
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            return Ee.debug("getNativeRtpCapabilities()"), t = new RTCPeerConnection({ iceServers: [], iceTransportPolicy: "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "plan-b" }), u.prev = 2, u.next = 5, t.createOffer({ offerToReceiveAudio: !0, offerToReceiveVideo: !0 });
          case 5:
            r = u.sent;
            try {
              t.close();
            } catch {
            }
            return s = er.parse(r.sdp), c = Oa.extractRtpCapabilities({ sdpObject: s }), u.abrupt("return", c);
          case 12:
            u.prev = 12, u.t0 = u.catch(2);
            try {
              t.close();
            } catch {
            }
            throw u.t0;
          case 16:
          case "end":
            return u.stop();
        }
      }, e, null, [[2, 12]]);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return Ee.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: zo });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    var t = this, r = e.direction, s = e.iceParameters, c = e.iceCandidates, l = e.dtlsParameters, u = e.sctpParameters, d = e.iceServers, f = e.iceTransportPolicy, p = e.additionalSettings, m = e.proprietaryConstraints, b = e.extendedRtpCapabilities;
    Ee.debug("run()"), this._direction = r, this._remoteSdp = new cm.RemoteSdp({ iceParameters: s, iceCandidates: c, dtlsParameters: l, sctpParameters: u, planB: !0 }), this._sendingRtpParametersByKind = { audio: mn.getSendingRtpParameters("audio", b), video: mn.getSendingRtpParameters("video", b) }, this._sendingRemoteRtpParametersByKind = { audio: mn.getSendingRemoteRtpParameters("audio", b), video: mn.getSendingRemoteRtpParameters("video", b) }, l.role && l.role !== "auto" && (this._forcedLocalDtlsRole = l.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection(Re({ iceServers: d ?? [], iceTransportPolicy: f ?? "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "plan-b" }, p), m), this._pc.addEventListener("icegatheringstatechange", function() {
      t.emit("@icegatheringstatechange", t._pc.iceGatheringState);
    }), this._pc.addEventListener("icecandidateerror", function(h) {
      t.emit("@icecandidateerror", h);
    }), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", function() {
      t.emit("@connectionstatechange", t._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", function() {
      switch (Ee.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), t._pc.iceConnectionState) {
        case "checking":
          t.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          t.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          t.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          t.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          t.emit("@connectionstatechange", "closed");
      }
    });
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            Ee.debug("updateIceServers()"), (r = this._pc.getConfiguration()).iceServers = t, this._pc.setConfiguration(r);
          case 4:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (Ee.debug("restartIce()"), this._remoteSdp.updateIceParameters(t), this._transportReady) {
              d.next = 4;
              break;
            }
            return d.abrupt("return");
          case 4:
            if (this._direction !== "send") {
              d.next = 17;
              break;
            }
            return d.next = 7, this._pc.createOffer({ iceRestart: !0 });
          case 7:
            return r = d.sent, Ee.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", r), d.next = 11, this._pc.setLocalDescription(r);
          case 11:
            return s = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ee.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), d.next = 15, this._pc.setRemoteDescription(s);
          case 15:
            d.next = 27;
            break;
          case 17:
            return c = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ee.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", c), d.next = 21, this._pc.setRemoteDescription(c);
          case 21:
            return d.next = 23, this._pc.createAnswer();
          case 23:
            return l = d.sent, Ee.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", l), d.next = 27, this._pc.setLocalDescription(l);
          case 27:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", this._pc.getStats());
          case 1:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C;
      return v().wrap(function(P) {
        for (; ; ) switch (P.prev = P.next) {
          case 0:
            return r = t.track, s = t.encodings, c = t.codecOptions, l = t.codec, this.assertSendDirection(), Ee.debug("send() [kind:%s, track.id:%s]", r.kind, r.id), l && Ee.warn("send() | codec selection is not available in %s handler", this.name), this._sendStream.addTrack(r), this._pc.addTrack(r, this._sendStream), P.next = 8, this._pc.createOffer();
          case 8:
            if (u = P.sent, d = er.parse(u.sdp), (p = Vo.clone(this._sendingRtpParametersByKind[r.kind])).codecs = mn.reduceCodecs(p.codecs), (m = Vo.clone(this._sendingRemoteRtpParametersByKind[r.kind])).codecs = mn.reduceCodecs(m.codecs), this._transportReady) {
              P.next = 17;
              break;
            }
            return P.next = 17, this.setupTransport({ localDtlsRole: (b = this._forcedLocalDtlsRole) !== null && b !== void 0 ? b : "client", localSdpObject: d });
          case 17:
            return r.kind === "video" && s && s.length > 1 && (Ee.debug("send() | enabling simulcast"), d = er.parse(u.sdp), f = d.media.find(function(T) {
              return T.type === "video";
            }), Uo.addLegacySimulcast({ offerMediaObject: f, track: r, numStreams: s.length }), u = { type: "offer", sdp: er.write(d) }), Ee.debug("send() | calling pc.setLocalDescription() [offer:%o]", u), P.next = 21, this._pc.setLocalDescription(u);
          case 21:
            if (d = er.parse(this._pc.localDescription.sdp), f = d.media.find(function(T) {
              return T.type === r.kind;
            }), p.rtcp.cname = Oa.getCname({ offerMediaObject: f }), p.encodings = Uo.getRtpEncodings({ offerMediaObject: f, track: r }), s) for (h = 0; h < p.encodings.length; ++h) s[h] && Object.assign(p.encodings[h], s[h]);
            if (p.encodings.length > 1 && p.codecs[0].mimeType.toLowerCase() === "video/vp8") {
              g = U(p.encodings);
              try {
                for (g.s(); !(w = g.n()).done; ) w.value.scalabilityMode = "L1T3";
              } catch (T) {
                g.e(T);
              } finally {
                g.f();
              }
            }
            return this._remoteSdp.send({ offerMediaObject: f, offerRtpParameters: p, answerRtpParameters: m, codecOptions: c }), _ = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ee.debug("send() | calling pc.setRemoteDescription() [answer:%o]", _), P.next = 32, this._pc.setRemoteDescription(_);
          case 32:
            return y = String(this._nextSendLocalId), this._nextSendLocalId++, C = this._pc.getSenders().find(function(T) {
              return T.track === r;
            }), this._mapSendLocalIdRtpSender.set(y, C), P.abrupt("return", { localId: y, rtpParameters: p, rtpSender: C });
          case 37:
          case "end":
            return P.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), Ee.debug("stopSending() [localId:%s]", t), r = this._mapSendLocalIdRtpSender.get(t)) {
              u.next = 5;
              break;
            }
            throw new Error("associated RTCRtpSender not found");
          case 5:
            return this._pc.removeTrack(r), r.track && this._sendStream.removeTrack(r.track), this._mapSendLocalIdRtpSender.delete(t), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, Ee.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), u.prev = 12, u.next = 15, this._pc.setLocalDescription(s);
          case 15:
            u.next = 23;
            break;
          case 17:
            if (u.prev = 17, u.t0 = u.catch(12), this._sendStream.getTracks().length !== 0) {
              u.next = 22;
              break;
            }
            return Ee.warn("stopSending() | ignoring expected error due no sending tracks: %s", u.t0.toString()), u.abrupt("return");
          case 22:
            throw u.t0;
          case 23:
            if (this._pc.signalingState !== "stable") {
              u.next = 25;
              break;
            }
            return u.abrupt("return");
          case 25:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ee.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 29, this._pc.setRemoteDescription(c);
          case 29:
          case "end":
            return u.stop();
        }
      }, e, this, [[12, 17]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), r ? Ee.debug("replaceTrack() [localId:%s, track.id:%s]", t, r.id) : Ee.debug("replaceTrack() [localId:%s, no track]", t), s = this._mapSendLocalIdRtpSender.get(t)) {
              u.next = 5;
              break;
            }
            throw new Error("associated RTCRtpSender not found");
          case 5:
            return c = s.track, u.next = 8, s.replaceTrack(r);
          case 8:
            c && this._sendStream.removeTrack(c), r && this._sendStream.addTrack(r);
          case 10:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), Ee.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", t, r), s = this._mapSendLocalIdRtpSender.get(t)) {
              u.next = 5;
              break;
            }
            throw new Error("associated RTCRtpSender not found");
          case 5:
            return (c = s.getParameters()).encodings.forEach(function(d, f) {
              d.active = f <= r;
            }), u.next = 9, s.setParameters(c);
          case 9:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), Ee.debug("setRtpEncodingParameters() [localId:%s, params:%o]", t, r), s = this._mapSendLocalIdRtpSender.get(t)) {
              u.next = 5;
              break;
            }
            throw new Error("associated RTCRtpSender not found");
          case 5:
            return (c = s.getParameters()).encodings.forEach(function(d, f) {
              c.encodings[f] = Re(Re({}, d), r);
            }), u.next = 9, s.setParameters(c);
          case 9:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertSendDirection(), r = this._mapSendLocalIdRtpSender.get(t)) {
              c.next = 4;
              break;
            }
            throw new Error("associated RTCRtpSender not found");
          case 4:
            return c.abrupt("return", r.getStats());
          case 5:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.ordered, s = t.maxPacketLifeTime, c = t.maxRetransmits, l = t.label, u = t.protocol, this.assertSendDirection(), d = { negotiated: !0, id: this._nextSendSctpStreamId, ordered: r, maxPacketLifeTime: s, maxRetransmitTime: s, maxRetransmits: c, protocol: u }, Ee.debug("sendDataChannel() [options:%o]", d), f = this._pc.createDataChannel(l, d), this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % zo.MIS, this._hasDataChannelMediaSection) {
              y.next = 24;
              break;
            }
            return y.next = 9, this._pc.createOffer();
          case 9:
            if (p = y.sent, m = er.parse(p.sdp), b = m.media.find(function(C) {
              return C.type === "application";
            }), this._transportReady) {
              y.next = 15;
              break;
            }
            return y.next = 15, this.setupTransport({ localDtlsRole: (h = this._forcedLocalDtlsRole) !== null && h !== void 0 ? h : "client", localSdpObject: m });
          case 15:
            return Ee.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), y.next = 18, this._pc.setLocalDescription(p);
          case 18:
            return this._remoteSdp.sendSctpAssociation({ offerMediaObject: b }), g = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ee.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), y.next = 23, this._pc.setRemoteDescription(g);
          case 23:
            this._hasDataChannelMediaSection = !0;
          case 24:
            return w = { streamId: d.id, ordered: d.ordered, maxPacketLifeTime: d.maxPacketLifeTime, maxRetransmits: d.maxRetransmits }, y.abrupt("return", { dataChannel: f, sctpStreamParameters: w });
          case 26:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I = this;
      return v().wrap(function(x) {
        for (; ; ) switch (x.prev = x.next) {
          case 0:
            this.assertRecvDirection(), r = [], s = U(t);
            try {
              for (s.s(); !(c = s.n()).done; ) l = c.value, u = l.trackId, d = l.kind, f = l.rtpParameters, p = l.streamId, Ee.debug("receive() [trackId:%s, kind:%s]", u, d), m = d, this._remoteSdp.receive({ mid: m, kind: d, offerRtpParameters: f, streamId: p ?? f.rtcp.cname, trackId: u });
            } catch (O) {
              s.e(O);
            } finally {
              s.f();
            }
            return b = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ee.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", b), x.next = 8, this._pc.setRemoteDescription(b);
          case 8:
            return x.next = 10, this._pc.createAnswer();
          case 10:
            h = x.sent, g = er.parse(h.sdp), w = U(t);
            try {
              for (y = function() {
                var D = _.value, A = D.kind, E = D.rtpParameters, F = A, B = g.media.find(function($) {
                  return String($.mid) === F;
                });
                Oa.applyCodecParameters({ offerRtpParameters: E, answerMediaObject: B });
              }, w.s(); !(_ = w.n()).done; ) y();
            } catch (O) {
              w.e(O);
            } finally {
              w.f();
            }
            if (h = { type: "answer", sdp: er.write(g) }, this._transportReady) {
              x.next = 18;
              break;
            }
            return x.next = 18, this.setupTransport({ localDtlsRole: (C = this._forcedLocalDtlsRole) !== null && C !== void 0 ? C : "client", localSdpObject: g });
          case 18:
            return Ee.debug("receive() | calling pc.setLocalDescription() [answer:%o]", h), x.next = 21, this._pc.setLocalDescription(h);
          case 21:
            S = U(t);
            try {
              for (T = function() {
                var D = P.value, A = D.kind, E = D.trackId, F = D.rtpParameters, B = E, $ = A, M = I._pc.getReceivers().find(function(j) {
                  return j.track && j.track.id === B;
                });
                if (!M) throw new Error("new RTCRtpReceiver not");
                I._mapRecvLocalIdInfo.set(B, { mid: $, rtpParameters: F, rtpReceiver: M }), r.push({ localId: B, track: M.track, rtpReceiver: M });
              }, S.s(); !(P = S.n()).done; ) T();
            } catch (O) {
              S.e(O);
            } finally {
              S.f();
            }
            return x.abrupt("return", r);
          case 24:
          case "end":
            return x.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            this.assertRecvDirection(), r = U(t);
            try {
              for (r.s(); !(s = r.n()).done; ) l = s.value, Ee.debug("stopReceiving() [localId:%s]", l), u = (c = this._mapRecvLocalIdInfo.get(l)) !== null && c !== void 0 ? c : {}, d = u.mid, f = u.rtpParameters, this._mapRecvLocalIdInfo.delete(l), this._remoteSdp.planBStopReceiving({ mid: d, offerRtpParameters: f });
            } catch (g) {
              r.e(g);
            } finally {
              r.f();
            }
            return p = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ee.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", p), h.next = 7, this._pc.setRemoteDescription(p);
          case 7:
            return h.next = 9, this._pc.createAnswer();
          case 9:
            return m = h.sent, Ee.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", m), h.next = 13, this._pc.setLocalDescription(m);
          case 13:
          case "end":
            return h.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertRecvDirection(), s = (r = this._mapRecvLocalIdInfo.get(t)) !== null && r !== void 0 ? r : {}, c = s.rtpReceiver) {
              u.next = 4;
              break;
            }
            throw new Error("associated RTCRtpReceiver not found");
          case 4:
            return u.abrupt("return", c.getStats());
          case 5:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.sctpStreamParameters, s = t.label, c = t.protocol, this.assertRecvDirection(), l = r.streamId, u = r.ordered, d = r.maxPacketLifeTime, f = r.maxRetransmits, p = { negotiated: !0, id: l, ordered: u, maxPacketLifeTime: d, maxRetransmitTime: d, maxRetransmits: f, protocol: c }, Ee.debug("receiveDataChannel() [options:%o]", p), m = this._pc.createDataChannel(s, p), this._hasDataChannelMediaSection) {
              y.next = 23;
              break;
            }
            return this._remoteSdp.receiveSctpAssociation({ oldDataChannelSpec: !0 }), b = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ee.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", b), y.next = 12, this._pc.setRemoteDescription(b);
          case 12:
            return y.next = 14, this._pc.createAnswer();
          case 14:
            if (h = y.sent, this._transportReady) {
              y.next = 19;
              break;
            }
            return w = er.parse(h.sdp), y.next = 19, this.setupTransport({ localDtlsRole: (g = this._forcedLocalDtlsRole) !== null && g !== void 0 ? g : "client", localSdpObject: w });
          case 19:
            return Ee.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), y.next = 22, this._pc.setLocalDescription(h);
          case 22:
            this._hasDataChannelMediaSection = !0;
          case 23:
            return y.abrupt("return", { dataChannel: m });
          case 24:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l = this;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return r = t.localDtlsRole, (s = t.localSdpObject) || (s = er.parse(this._pc.localDescription.sdp)), (c = Oa.extractDtlsParameters({ sdpObject: s })).role = r, this._remoteSdp.updateDtlsRole(r === "client" ? "server" : "client"), d.next = 7, new Promise(function(f, p) {
              l.safeEmit("@connect", { dtlsParameters: c }, f, p);
            });
          case 7:
            this._transportReady = !0;
          case 8:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "assertSendDirection", value: function() {
    if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
  } }, { key: "assertRecvDirection", value: function() {
    if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
  } }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
oi.Chrome67 = um;
var ci = {}, dm = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), lm = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), ya = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && dm(i, a, n[e]);
    return lm(i, a), i;
  };
}();
Object.defineProperty(ci, "__esModule", { value: !0 }), ci.Chrome55 = void 0;
var tr = ya(tt), pm = rt, Qn = ft, Go = ya(ct), vn = ya(Ye), Ma = ya(xt), qo = ya(Zr), fm = Rt, hm = Mt, Ne = new pm.Logger("Chrome55"), Ko = { OS: 1024, MIS: 1024 }, mm = function(o) {
  Qe(i, fm.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._sendStream = new MediaStream(), n._mapSendLocalIdTrack = /* @__PURE__ */ new Map(), n._nextSendLocalId = 0, n._mapRecvLocalIdInfo = /* @__PURE__ */ new Map(), n._hasDataChannelMediaSection = !1, n._nextSendSctpStreamId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "Chrome55";
  } }, { key: "close", value: function() {
    if (Ne.debug("close()"), this._pc) try {
      this._pc.close();
    } catch {
    }
    this.emit("@close");
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            return Ne.debug("getNativeRtpCapabilities()"), t = new RTCPeerConnection({ iceServers: [], iceTransportPolicy: "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "plan-b" }), u.prev = 2, u.next = 5, t.createOffer({ offerToReceiveAudio: !0, offerToReceiveVideo: !0 });
          case 5:
            r = u.sent;
            try {
              t.close();
            } catch {
            }
            return s = tr.parse(r.sdp), c = Ma.extractRtpCapabilities({ sdpObject: s }), u.abrupt("return", c);
          case 12:
            u.prev = 12, u.t0 = u.catch(2);
            try {
              t.close();
            } catch {
            }
            throw u.t0;
          case 16:
          case "end":
            return u.stop();
        }
      }, e, null, [[2, 12]]);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return Ne.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: Ko });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    var t = this, r = e.direction, s = e.iceParameters, c = e.iceCandidates, l = e.dtlsParameters, u = e.sctpParameters, d = e.iceServers, f = e.iceTransportPolicy, p = e.additionalSettings, m = e.proprietaryConstraints, b = e.extendedRtpCapabilities;
    Ne.debug("run()"), this._direction = r, this._remoteSdp = new hm.RemoteSdp({ iceParameters: s, iceCandidates: c, dtlsParameters: l, sctpParameters: u, planB: !0 }), this._sendingRtpParametersByKind = { audio: vn.getSendingRtpParameters("audio", b), video: vn.getSendingRtpParameters("video", b) }, this._sendingRemoteRtpParametersByKind = { audio: vn.getSendingRemoteRtpParameters("audio", b), video: vn.getSendingRemoteRtpParameters("video", b) }, l.role && l.role !== "auto" && (this._forcedLocalDtlsRole = l.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection(Re({ iceServers: d ?? [], iceTransportPolicy: f ?? "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "plan-b" }, p), m), this._pc.addEventListener("icegatheringstatechange", function() {
      t.emit("@icegatheringstatechange", t._pc.iceGatheringState);
    }), this._pc.addEventListener("icecandidateerror", function(h) {
      t.emit("@icecandidateerror", h);
    }), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", function() {
      t.emit("@connectionstatechange", t._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", function() {
      switch (Ne.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), t._pc.iceConnectionState) {
        case "checking":
          t.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          t.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          t.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          t.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          t.emit("@connectionstatechange", "closed");
      }
    });
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            Ne.debug("updateIceServers()"), (r = this._pc.getConfiguration()).iceServers = t, this._pc.setConfiguration(r);
          case 4:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (Ne.debug("restartIce()"), this._remoteSdp.updateIceParameters(t), this._transportReady) {
              d.next = 4;
              break;
            }
            return d.abrupt("return");
          case 4:
            if (this._direction !== "send") {
              d.next = 17;
              break;
            }
            return d.next = 7, this._pc.createOffer({ iceRestart: !0 });
          case 7:
            return r = d.sent, Ne.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", r), d.next = 11, this._pc.setLocalDescription(r);
          case 11:
            return s = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ne.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), d.next = 15, this._pc.setRemoteDescription(s);
          case 15:
            d.next = 27;
            break;
          case 17:
            return c = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ne.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", c), d.next = 21, this._pc.setRemoteDescription(c);
          case 21:
            return d.next = 23, this._pc.createAnswer();
          case 23:
            return l = d.sent, Ne.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", l), d.next = 27, this._pc.setLocalDescription(l);
          case 27:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", this._pc.getStats());
          case 1:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y;
      return v().wrap(function(S) {
        for (; ; ) switch (S.prev = S.next) {
          case 0:
            return r = t.track, s = t.encodings, c = t.codecOptions, l = t.codec, this.assertSendDirection(), Ne.debug("send() [kind:%s, track.id:%s]", r.kind, r.id), l && Ne.warn("send() | codec selection is not available in %s handler", this.name), this._sendStream.addTrack(r), this._pc.addStream(this._sendStream), S.next = 8, this._pc.createOffer();
          case 8:
            if (u = S.sent, d = tr.parse(u.sdp), (p = Go.clone(this._sendingRtpParametersByKind[r.kind])).codecs = vn.reduceCodecs(p.codecs), (m = Go.clone(this._sendingRemoteRtpParametersByKind[r.kind])).codecs = vn.reduceCodecs(m.codecs), this._transportReady) {
              S.next = 17;
              break;
            }
            return S.next = 17, this.setupTransport({ localDtlsRole: (b = this._forcedLocalDtlsRole) !== null && b !== void 0 ? b : "client", localSdpObject: d });
          case 17:
            return r.kind === "video" && s && s.length > 1 && (Ne.debug("send() | enabling simulcast"), d = tr.parse(u.sdp), f = d.media.find(function(P) {
              return P.type === "video";
            }), qo.addLegacySimulcast({ offerMediaObject: f, track: r, numStreams: s.length }), u = { type: "offer", sdp: tr.write(d) }), Ne.debug("send() | calling pc.setLocalDescription() [offer:%o]", u), S.next = 21, this._pc.setLocalDescription(u);
          case 21:
            if (d = tr.parse(this._pc.localDescription.sdp), f = d.media.find(function(P) {
              return P.type === r.kind;
            }), p.rtcp.cname = Ma.getCname({ offerMediaObject: f }), p.encodings = qo.getRtpEncodings({ offerMediaObject: f, track: r }), s) for (h = 0; h < p.encodings.length; ++h) s[h] && Object.assign(p.encodings[h], s[h]);
            if (p.encodings.length > 1 && p.codecs[0].mimeType.toLowerCase() === "video/vp8") {
              g = U(p.encodings);
              try {
                for (g.s(); !(w = g.n()).done; ) w.value.scalabilityMode = "L1T3";
              } catch (P) {
                g.e(P);
              } finally {
                g.f();
              }
            }
            return this._remoteSdp.send({ offerMediaObject: f, offerRtpParameters: p, answerRtpParameters: m, codecOptions: c }), _ = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ne.debug("send() | calling pc.setRemoteDescription() [answer:%o]", _), S.next = 32, this._pc.setRemoteDescription(_);
          case 32:
            return y = String(this._nextSendLocalId), this._nextSendLocalId++, this._mapSendLocalIdTrack.set(y, r), S.abrupt("return", { localId: y, rtpParameters: p });
          case 36:
          case "end":
            return S.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), Ne.debug("stopSending() [localId:%s]", t), r = this._mapSendLocalIdTrack.get(t)) {
              u.next = 5;
              break;
            }
            throw new Error("track not found");
          case 5:
            return this._mapSendLocalIdTrack.delete(t), this._sendStream.removeTrack(r), this._pc.addStream(this._sendStream), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, Ne.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), u.prev = 12, u.next = 15, this._pc.setLocalDescription(s);
          case 15:
            u.next = 23;
            break;
          case 17:
            if (u.prev = 17, u.t0 = u.catch(12), this._sendStream.getTracks().length !== 0) {
              u.next = 22;
              break;
            }
            return Ne.warn("stopSending() | ignoring expected error due no sending tracks: %s", u.t0.toString()), u.abrupt("return");
          case 22:
            throw u.t0;
          case 23:
            if (this._pc.signalingState !== "stable") {
              u.next = 25;
              break;
            }
            return u.abrupt("return");
          case 25:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ne.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 29, this._pc.setRemoteDescription(c);
          case 29:
          case "end":
            return u.stop();
        }
      }, e, this, [[12, 17]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            throw new Qn.UnsupportedError("not implemented");
          case 1:
          case "end":
            return c.stop();
        }
      }, e);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            throw new Qn.UnsupportedError(" not implemented");
          case 1:
          case "end":
            return c.stop();
        }
      }, e);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            throw new Qn.UnsupportedError("not supported");
          case 1:
          case "end":
            return c.stop();
        }
      }, e);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            throw new Qn.UnsupportedError("not implemented");
          case 1:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.ordered, s = t.maxPacketLifeTime, c = t.maxRetransmits, l = t.label, u = t.protocol, this.assertSendDirection(), d = { negotiated: !0, id: this._nextSendSctpStreamId, ordered: r, maxPacketLifeTime: s, maxRetransmitTime: s, maxRetransmits: c, protocol: u }, Ne.debug("sendDataChannel() [options:%o]", d), f = this._pc.createDataChannel(l, d), this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % Ko.MIS, this._hasDataChannelMediaSection) {
              y.next = 24;
              break;
            }
            return y.next = 9, this._pc.createOffer();
          case 9:
            if (p = y.sent, m = tr.parse(p.sdp), b = m.media.find(function(C) {
              return C.type === "application";
            }), this._transportReady) {
              y.next = 15;
              break;
            }
            return y.next = 15, this.setupTransport({ localDtlsRole: (h = this._forcedLocalDtlsRole) !== null && h !== void 0 ? h : "client", localSdpObject: m });
          case 15:
            return Ne.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), y.next = 18, this._pc.setLocalDescription(p);
          case 18:
            return this._remoteSdp.sendSctpAssociation({ offerMediaObject: b }), g = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ne.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), y.next = 23, this._pc.setRemoteDescription(g);
          case 23:
            this._hasDataChannelMediaSection = !0;
          case 24:
            return w = { streamId: d.id, ordered: d.ordered, maxPacketLifeTime: d.maxPacketLifeTime, maxRetransmits: d.maxRetransmits }, y.abrupt("return", { dataChannel: f, sctpStreamParameters: w });
          case 26:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I = this;
      return v().wrap(function(x) {
        for (; ; ) switch (x.prev = x.next) {
          case 0:
            this.assertRecvDirection(), r = [], s = U(t);
            try {
              for (s.s(); !(c = s.n()).done; ) l = c.value, u = l.trackId, d = l.kind, f = l.rtpParameters, p = l.streamId, Ne.debug("receive() [trackId:%s, kind:%s]", u, d), m = d, this._remoteSdp.receive({ mid: m, kind: d, offerRtpParameters: f, streamId: p ?? f.rtcp.cname, trackId: u });
            } catch (O) {
              s.e(O);
            } finally {
              s.f();
            }
            return b = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ne.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", b), x.next = 8, this._pc.setRemoteDescription(b);
          case 8:
            return x.next = 10, this._pc.createAnswer();
          case 10:
            h = x.sent, g = tr.parse(h.sdp), w = U(t);
            try {
              for (y = function() {
                var D = _.value, A = D.kind, E = D.rtpParameters, F = A, B = g.media.find(function($) {
                  return String($.mid) === F;
                });
                Ma.applyCodecParameters({ offerRtpParameters: E, answerMediaObject: B });
              }, w.s(); !(_ = w.n()).done; ) y();
            } catch (O) {
              w.e(O);
            } finally {
              w.f();
            }
            if (h = { type: "answer", sdp: tr.write(g) }, this._transportReady) {
              x.next = 18;
              break;
            }
            return x.next = 18, this.setupTransport({ localDtlsRole: (C = this._forcedLocalDtlsRole) !== null && C !== void 0 ? C : "client", localSdpObject: g });
          case 18:
            return Ne.debug("receive() | calling pc.setLocalDescription() [answer:%o]", h), x.next = 21, this._pc.setLocalDescription(h);
          case 21:
            S = U(t);
            try {
              for (T = function() {
                var D, A = P.value, E = A.kind, F = A.trackId, B = A.rtpParameters, $ = E, M = F, j = (D = A.streamId) !== null && D !== void 0 ? D : B.rtcp.cname, z = I._pc.getRemoteStreams().find(function(ee) {
                  return ee.id === j;
                }), te = z.getTrackById(M);
                if (!te) throw new Error("remote track not found");
                I._mapRecvLocalIdInfo.set(M, { mid: $, rtpParameters: B }), r.push({ localId: M, track: te });
              }, S.s(); !(P = S.n()).done; ) T();
            } catch (O) {
              S.e(O);
            } finally {
              S.f();
            }
            return x.abrupt("return", r);
          case 24:
          case "end":
            return x.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            this.assertRecvDirection(), r = U(t);
            try {
              for (r.s(); !(s = r.n()).done; ) l = s.value, Ne.debug("stopReceiving() [localId:%s]", l), u = (c = this._mapRecvLocalIdInfo.get(l)) !== null && c !== void 0 ? c : {}, d = u.mid, f = u.rtpParameters, this._mapRecvLocalIdInfo.delete(l), this._remoteSdp.planBStopReceiving({ mid: d, offerRtpParameters: f });
            } catch (g) {
              r.e(g);
            } finally {
              r.f();
            }
            return p = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ne.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", p), h.next = 7, this._pc.setRemoteDescription(p);
          case 7:
            return h.next = 9, this._pc.createAnswer();
          case 9:
            return m = h.sent, Ne.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", m), h.next = 13, this._pc.setLocalDescription(m);
          case 13:
          case "end":
            return h.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            throw new Qn.UnsupportedError("not implemented");
          case 1:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.sctpStreamParameters, s = t.label, c = t.protocol, this.assertRecvDirection(), l = r.streamId, u = r.ordered, d = r.maxPacketLifeTime, f = r.maxRetransmits, p = { negotiated: !0, id: l, ordered: u, maxPacketLifeTime: d, maxRetransmitTime: d, maxRetransmits: f, protocol: c }, Ne.debug("receiveDataChannel() [options:%o]", p), m = this._pc.createDataChannel(s, p), this._hasDataChannelMediaSection) {
              y.next = 23;
              break;
            }
            return this._remoteSdp.receiveSctpAssociation({ oldDataChannelSpec: !0 }), b = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ne.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", b), y.next = 12, this._pc.setRemoteDescription(b);
          case 12:
            return y.next = 14, this._pc.createAnswer();
          case 14:
            if (h = y.sent, this._transportReady) {
              y.next = 19;
              break;
            }
            return w = tr.parse(h.sdp), y.next = 19, this.setupTransport({ localDtlsRole: (g = this._forcedLocalDtlsRole) !== null && g !== void 0 ? g : "client", localSdpObject: w });
          case 19:
            return Ne.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), y.next = 22, this._pc.setLocalDescription(h);
          case 22:
            this._hasDataChannelMediaSection = !0;
          case 23:
            return y.abrupt("return", { dataChannel: m });
          case 24:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l = this;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return r = t.localDtlsRole, (s = t.localSdpObject) || (s = tr.parse(this._pc.localDescription.sdp)), (c = Ma.extractDtlsParameters({ sdpObject: s })).role = r, this._remoteSdp.updateDtlsRole(r === "client" ? "server" : "client"), d.next = 7, new Promise(function(f, p) {
              l.safeEmit("@connect", { dtlsParameters: c }, f, p);
            });
          case 7:
            this._transportReady = !0;
          case 8:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "assertSendDirection", value: function() {
    if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
  } }, { key: "assertRecvDirection", value: function() {
    if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
  } }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
ci.Chrome55 = mm;
var ui = {}, vm = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), gm = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), ba = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && vm(i, a, n[e]);
    return gm(i, a), i;
  };
}();
Object.defineProperty(ui, "__esModule", { value: !0 }), ui.Firefox120 = void 0;
var Pr = ba(tt), ym = rt, Ho = ft, Yo = ba(ct), gn = ba(Ye), ja = ba(xt), Wo = ba(or), bm = Rt, _m = Mt, wm = dr, we = new ym.Logger("Firefox120"), Xo = { OS: 16, MIS: 2048 }, Sm = function(o) {
  Qe(i, bm.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._closed = !1, n._mapMidTransceiver = /* @__PURE__ */ new Map(), n._sendStream = new MediaStream(), n._hasDataChannelMediaSection = !1, n._nextSendSctpStreamId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "Firefox120";
  } }, { key: "close", value: function() {
    if (we.debug("close()"), !this._closed) {
      if (this._closed = !0, this._pc) try {
        this._pc.close();
      } catch {
      }
      this.emit("@close");
    }
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            return we.debug("getNativeRtpCapabilities()"), t = new RTCPeerConnection({ iceServers: [], iceTransportPolicy: "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require" }), (r = document.createElement("canvas")).getContext("2d"), s = r.captureStream(), c = s.getVideoTracks()[0], p.prev = 6, t.addTransceiver("audio", { direction: "sendrecv" }), t.addTransceiver(c, { direction: "sendrecv", sendEncodings: [{ rid: "r0", maxBitrate: 1e5 }, { rid: "r1", maxBitrate: 5e5 }] }), p.next = 11, t.createOffer();
          case 11:
            l = p.sent;
            try {
              r.remove();
            } catch {
            }
            try {
              c.stop();
            } catch {
            }
            try {
              t.close();
            } catch {
            }
            return u = Pr.parse(l.sdp), d = ja.extractRtpCapabilities({ sdpObject: u }), p.abrupt("return", d);
          case 20:
            p.prev = 20, p.t0 = p.catch(6);
            try {
              r.remove();
            } catch {
            }
            try {
              c.stop();
            } catch {
            }
            try {
              t.close();
            } catch {
            }
            throw p.t0;
          case 26:
          case "end":
            return p.stop();
        }
      }, e, null, [[6, 20]]);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return we.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: Xo });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    var t = this, r = e.direction, s = e.iceParameters, c = e.iceCandidates, l = e.dtlsParameters, u = e.sctpParameters, d = e.iceServers, f = e.iceTransportPolicy, p = e.additionalSettings, m = e.proprietaryConstraints, b = e.extendedRtpCapabilities;
    this.assertNotClosed(), we.debug("run()"), this._direction = r, this._remoteSdp = new _m.RemoteSdp({ iceParameters: s, iceCandidates: c, dtlsParameters: l, sctpParameters: u }), this._sendingRtpParametersByKind = { audio: gn.getSendingRtpParameters("audio", b), video: gn.getSendingRtpParameters("video", b) }, this._sendingRemoteRtpParametersByKind = { audio: gn.getSendingRemoteRtpParameters("audio", b), video: gn.getSendingRemoteRtpParameters("video", b) }, this._pc = new RTCPeerConnection(Re({ iceServers: d ?? [], iceTransportPolicy: f ?? "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require" }, p), m), this._pc.addEventListener("icegatheringstatechange", function() {
      t.emit("@icegatheringstatechange", t._pc.iceGatheringState);
    }), this._pc.addEventListener("icecandidateerror", function(h) {
      t.emit("@icecandidateerror", h);
    }), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", function() {
      t.emit("@connectionstatechange", t._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", function() {
      switch (we.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), t._pc.iceConnectionState) {
        case "checking":
          t.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          t.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          t.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          t.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          t.emit("@connectionstatechange", "closed");
      }
    });
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            throw this.assertNotClosed(), new Ho.UnsupportedError("not supported");
          case 2:
          case "end":
            return s.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (this.assertNotClosed(), we.debug("restartIce()"), this._remoteSdp.updateIceParameters(t), this._transportReady) {
              d.next = 5;
              break;
            }
            return d.abrupt("return");
          case 5:
            if (this._direction !== "send") {
              d.next = 18;
              break;
            }
            return d.next = 8, this._pc.createOffer({ iceRestart: !0 });
          case 8:
            return r = d.sent, we.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", r), d.next = 12, this._pc.setLocalDescription(r);
          case 12:
            return s = { type: "answer", sdp: this._remoteSdp.getSdp() }, we.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), d.next = 16, this._pc.setRemoteDescription(s);
          case 16:
            d.next = 28;
            break;
          case 18:
            return c = { type: "offer", sdp: this._remoteSdp.getSdp() }, we.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", c), d.next = 22, this._pc.setRemoteDescription(c);
          case 22:
            return d.next = 24, this._pc.createAnswer();
          case 24:
            return l = d.sent, we.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", l), d.next = 28, this._pc.setLocalDescription(l);
          case 28:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return this.assertNotClosed(), r.abrupt("return", this._pc.getStats());
          case 2:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P;
      return v().wrap(function(I) {
        for (; ; ) switch (I.prev = I.next) {
          case 0:
            return r = t.track, s = t.encodings, c = t.codecOptions, l = t.codec, u = t.onRtpSender, this.assertNotClosed(), this.assertSendDirection(), we.debug("send() [kind:%s, track.id:%s]", r.kind, r.id), s && s.length > 1 && s.forEach(function(k, x) {
              k.rid = "r".concat(x);
            }), (d = Yo.clone(this._sendingRtpParametersByKind[r.kind])).codecs = gn.reduceCodecs(d.codecs, l), (f = Yo.clone(this._sendingRemoteRtpParametersByKind[r.kind])).codecs = gn.reduceCodecs(f.codecs, l), p = this._pc.addTransceiver(r, { direction: "sendonly", streams: [this._sendStream], sendEncodings: s }), u && u(p.sender), I.next = 13, this._pc.createOffer();
          case 13:
            if (m = I.sent, b = Pr.parse(m.sdp), this._transportReady) {
              I.next = 18;
              break;
            }
            return I.next = 18, this.setupTransport({ localDtlsRole: "client", localSdpObject: b });
          case 18:
            return h = (0, wm.parse)((s ?? [{}])[0].scalabilityMode), we.debug("send() | calling pc.setLocalDescription() [offer:%o]", m), I.next = 22, this._pc.setLocalDescription(m);
          case 22:
            if (g = p.mid, d.mid = g, b = Pr.parse(this._pc.localDescription.sdp), w = b.media[b.media.length - 1], d.rtcp.cname = ja.getCname({ offerMediaObject: w }), s ? s.length === 1 ? (_ = Wo.getRtpEncodings({ offerMediaObject: w }), Object.assign(_[0], s[0]), d.encodings = _) : d.encodings = s : d.encodings = Wo.getRtpEncodings({ offerMediaObject: w }), d.encodings.length > 1 && (d.codecs[0].mimeType.toLowerCase() === "video/vp8" || d.codecs[0].mimeType.toLowerCase() === "video/h264")) {
              y = U(d.encodings);
              try {
                for (y.s(); !(C = y.n()).done; ) (S = C.value).scalabilityMode ? S.scalabilityMode = "L1T".concat(h.temporalLayers) : S.scalabilityMode = "L1T3";
              } catch (k) {
                y.e(k);
              } finally {
                y.f();
              }
            }
            return this._remoteSdp.send({ offerMediaObject: w, offerRtpParameters: d, answerRtpParameters: f, codecOptions: c, extmapAllowMixed: !0 }), P = { type: "answer", sdp: this._remoteSdp.getSdp() }, we.debug("send() | calling pc.setRemoteDescription() [answer:%o]", P), I.next = 34, this._pc.setRemoteDescription(P);
          case 34:
            return this._mapMidTransceiver.set(g, p), I.abrupt("return", { localId: g, rtpParameters: d, rtpSender: p.sender });
          case 36:
          case "end":
            return I.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), we.debug("stopSending() [localId:%s]", t), !this._closed) {
              u.next = 4;
              break;
            }
            return u.abrupt("return");
          case 4:
            if (r = this._mapMidTransceiver.get(t)) {
              u.next = 7;
              break;
            }
            throw new Error("associated transceiver not found");
          case 7:
            return r.sender.replaceTrack(null), this._pc.removeTrack(r.sender), this._remoteSdp.disableMediaSection(r.mid), u.next = 12, this._pc.createOffer();
          case 12:
            return s = u.sent, we.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 16, this._pc.setLocalDescription(s);
          case 16:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, we.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 20, this._pc.setRemoteDescription(c);
          case 20:
            this._mapMidTransceiver.delete(t);
          case 21:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), we.debug("pauseSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return r.direction = "inactive", this._remoteSdp.pauseMediaSection(t), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, we.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, we.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), we.debug("resumeSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return r.direction = "sendonly", this._remoteSdp.resumeSendingMediaSection(t), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, we.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, we.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r ? we.debug("replaceTrack() [localId:%s, track.id:%s]", t, r.id) : we.debug("replaceTrack() [localId:%s, no track]", t), s = this._mapMidTransceiver.get(t)) {
              l.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return l.next = 8, s.sender.replaceTrack(r);
          case 8:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), we.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated transceiver not found");
          case 6:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              p.active = m <= r;
            }), f.next = 10, s.sender.setParameters(c);
          case 10:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 13, this._pc.createOffer();
          case 13:
            return l = f.sent, we.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 17, this._pc.setLocalDescription(l);
          case 17:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, we.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 21, this._pc.setRemoteDescription(u);
          case 21:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), we.debug("setRtpEncodingParameters() [localId:%s, params:%o]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              c.encodings[m] = Re(Re({}, p), r);
            }), f.next = 10, s.sender.setParameters(c);
          case 10:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 13, this._pc.createOffer();
          case 13:
            return l = f.sent, we.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 17, this._pc.setLocalDescription(l);
          case 17:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, we.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 21, this._pc.setRemoteDescription(u);
          case 21:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return c.abrupt("return", r.sender.getStats());
          case 6:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g;
      return v().wrap(function(_) {
        for (; ; ) switch (_.prev = _.next) {
          case 0:
            if (r = t.ordered, s = t.maxPacketLifeTime, c = t.maxRetransmits, l = t.label, u = t.protocol, this.assertNotClosed(), this.assertSendDirection(), d = { negotiated: !0, id: this._nextSendSctpStreamId, ordered: r, maxPacketLifeTime: s, maxRetransmits: c, protocol: u }, we.debug("sendDataChannel() [options:%o]", d), f = this._pc.createDataChannel(l, d), this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % Xo.MIS, this._hasDataChannelMediaSection) {
              _.next = 25;
              break;
            }
            return _.next = 10, this._pc.createOffer();
          case 10:
            if (p = _.sent, m = Pr.parse(p.sdp), b = m.media.find(function(y) {
              return y.type === "application";
            }), this._transportReady) {
              _.next = 16;
              break;
            }
            return _.next = 16, this.setupTransport({ localDtlsRole: "client", localSdpObject: m });
          case 16:
            return we.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), _.next = 19, this._pc.setLocalDescription(p);
          case 19:
            return this._remoteSdp.sendSctpAssociation({ offerMediaObject: b }), h = { type: "answer", sdp: this._remoteSdp.getSdp() }, we.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), _.next = 24, this._pc.setRemoteDescription(h);
          case 24:
            this._hasDataChannelMediaSection = !0;
          case 25:
            return g = { streamId: d.id, ordered: d.ordered, maxPacketLifeTime: d.maxPacketLifeTime, maxRetransmits: d.maxRetransmits }, _.abrupt("return", { dataChannel: f, sctpStreamParameters: g });
          case 27:
          case "end":
            return _.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k, x, O, D, A, E = this;
      return v().wrap(function(B) {
        for (; ; ) switch (B.prev = B.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = [], s = /* @__PURE__ */ new Map(), c = U(t);
            try {
              for (c.s(); !(l = c.n()).done; ) d = l.value, f = d.trackId, p = d.kind, m = d.rtpParameters, b = d.streamId, we.debug("receive() [trackId:%s, kind:%s]", f, p), h = (u = m.mid) !== null && u !== void 0 ? u : String(this._mapMidTransceiver.size), s.set(f, h), this._remoteSdp.receive({ mid: h, kind: p, offerRtpParameters: m, streamId: b ?? m.rtcp.cname, trackId: f });
            } catch ($) {
              c.e($);
            } finally {
              c.f();
            }
            return g = { type: "offer", sdp: this._remoteSdp.getSdp() }, we.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", g), B.next = 10, this._pc.setRemoteDescription(g);
          case 10:
            w = U(t);
            try {
              for (w.s(); !(_ = w.n()).done; ) y = _.value, C = y.trackId, (S = y.onRtpReceiver) && function() {
                var $ = s.get(C), M = E._pc.getTransceivers().find(function(j) {
                  return j.mid === $;
                });
                if (!M) throw new Error("transceiver not found");
                S(M.receiver);
              }();
            } catch ($) {
              w.e($);
            } finally {
              w.f();
            }
            return B.next = 14, this._pc.createAnswer();
          case 14:
            P = B.sent, T = Pr.parse(P.sdp), I = U(t);
            try {
              for (x = function() {
                var M = k.value, j = M.trackId, z = M.rtpParameters, te = s.get(j), ee = T.media.find(function(Y) {
                  return String(Y.mid) === te;
                });
                ja.applyCodecParameters({ offerRtpParameters: z, answerMediaObject: ee }), P = { type: "answer", sdp: Pr.write(T) };
              }, I.s(); !(k = I.n()).done; ) x();
            } catch ($) {
              I.e($);
            } finally {
              I.f();
            }
            if (this._transportReady) {
              B.next = 21;
              break;
            }
            return B.next = 21, this.setupTransport({ localDtlsRole: "client", localSdpObject: T });
          case 21:
            return we.debug("receive() | calling pc.setLocalDescription() [answer:%o]", P), B.next = 24, this._pc.setLocalDescription(P);
          case 24:
            O = U(t);
            try {
              for (A = function() {
                var M = D.value.trackId, j = s.get(M), z = E._pc.getTransceivers().find(function(te) {
                  return te.mid === j;
                });
                if (!z) throw new Error("new RTCRtpTransceiver not found");
                E._mapMidTransceiver.set(j, z), r.push({ localId: j, track: z.receiver.track, rtpReceiver: z.receiver });
              }, O.s(); !(D = O.n()).done; ) A();
            } catch ($) {
              O.e($);
            } finally {
              O.f();
            }
            return B.abrupt("return", r);
          case 27:
          case "end":
            return B.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            if (this.assertRecvDirection(), !this._closed) {
              h.next = 3;
              break;
            }
            return h.abrupt("return");
          case 3:
            r = U(t), h.prev = 4, r.s();
          case 6:
            if ((s = r.n()).done) {
              h.next = 15;
              break;
            }
            if (c = s.value, we.debug("stopReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              h.next = 12;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 12:
            this._remoteSdp.closeMediaSection(l.mid);
          case 13:
            h.next = 6;
            break;
          case 15:
            h.next = 20;
            break;
          case 17:
            h.prev = 17, h.t0 = h.catch(4), r.e(h.t0);
          case 20:
            return h.prev = 20, r.f(), h.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, we.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), h.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return h.next = 29, this._pc.createAnswer();
          case 29:
            return d = h.sent, we.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", d), h.next = 33, this._pc.setLocalDescription(d);
          case 33:
            f = U(t);
            try {
              for (f.s(); !(p = f.n()).done; ) m = p.value, this._mapMidTransceiver.delete(m);
            } catch (g) {
              f.e(g);
            } finally {
              f.f();
            }
          case 35:
          case "end":
            return h.stop();
        }
      }, e, this, [[4, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, we.debug("pauseReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "inactive", this._remoteSdp.pauseMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, we.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, we.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, we.debug("resumeReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "recvonly", this._remoteSdp.resumeReceivingMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, we.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, we.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertRecvDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 4;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 4:
            return c.abrupt("return", r.receiver.getStats());
          case 5:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g;
      return v().wrap(function(_) {
        for (; ; ) switch (_.prev = _.next) {
          case 0:
            if (r = t.sctpStreamParameters, s = t.label, c = t.protocol, this.assertNotClosed(), this.assertRecvDirection(), l = r.streamId, u = r.ordered, d = r.maxPacketLifeTime, f = r.maxRetransmits, p = { negotiated: !0, id: l, ordered: u, maxPacketLifeTime: d, maxRetransmits: f, protocol: c }, we.debug("receiveDataChannel() [options:%o]", p), m = this._pc.createDataChannel(s, p), this._hasDataChannelMediaSection) {
              _.next = 24;
              break;
            }
            return this._remoteSdp.receiveSctpAssociation(), b = { type: "offer", sdp: this._remoteSdp.getSdp() }, we.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", b), _.next = 13, this._pc.setRemoteDescription(b);
          case 13:
            return _.next = 15, this._pc.createAnswer();
          case 15:
            if (h = _.sent, this._transportReady) {
              _.next = 20;
              break;
            }
            return g = Pr.parse(h.sdp), _.next = 20, this.setupTransport({ localDtlsRole: "client", localSdpObject: g });
          case 20:
            return we.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), _.next = 23, this._pc.setLocalDescription(h);
          case 23:
            this._hasDataChannelMediaSection = !0;
          case 24:
            return _.abrupt("return", { dataChannel: m });
          case 25:
          case "end":
            return _.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l = this;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return r = t.localDtlsRole, (s = t.localSdpObject) || (s = Pr.parse(this._pc.localDescription.sdp)), (c = ja.extractDtlsParameters({ sdpObject: s })).role = r, this._remoteSdp.updateDtlsRole(r === "client" ? "server" : "client"), d.next = 7, new Promise(function(f, p) {
              l.safeEmit("@connect", { dtlsParameters: c }, f, p);
            });
          case 7:
            this._transportReady = !0;
          case 8:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "assertNotClosed", value: function() {
    if (this._closed) throw new Ho.InvalidStateError("method called in a closed handler");
  } }, { key: "assertSendDirection", value: function() {
    if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
  } }, { key: "assertRecvDirection", value: function() {
    if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
  } }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
ui.Firefox120 = Sm;
var di = {}, Cm = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), km = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), _a = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && Cm(i, a, n[e]);
    return km(i, a), i;
  };
}();
Object.defineProperty(di, "__esModule", { value: !0 }), di.Firefox60 = void 0;
var Tr = _a(tt), xm = rt, Zo = ft, Ki = _a(ct), yn = _a(Ye), Na = _a(xt), Qo = _a(or), Rm = Rt, Im = Mt, Pm = dr, Se = new xm.Logger("Firefox60"), Jo = { OS: 16, MIS: 2048 }, Tm = function(o) {
  Qe(i, Rm.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._closed = !1, n._mapMidTransceiver = /* @__PURE__ */ new Map(), n._sendStream = new MediaStream(), n._hasDataChannelMediaSection = !1, n._nextSendSctpStreamId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "Firefox60";
  } }, { key: "close", value: function() {
    if (Se.debug("close()"), !this._closed) {
      if (this._closed = !0, this._pc) try {
        this._pc.close();
      } catch {
      }
      this.emit("@close");
    }
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            return Se.debug("getNativeRtpCapabilities()"), t = new RTCPeerConnection({ iceServers: [], iceTransportPolicy: "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require" }), (r = document.createElement("canvas")).getContext("2d"), s = r.captureStream(), c = s.getVideoTracks()[0], h.prev = 6, t.addTransceiver("audio", { direction: "sendrecv" }), l = t.addTransceiver(c, { direction: "sendrecv" }), u = l.sender.getParameters(), d = [{ rid: "r0", maxBitrate: 1e5 }, { rid: "r1", maxBitrate: 5e5 }], u.encodings = d, h.next = 14, l.sender.setParameters(u);
          case 14:
            return h.next = 16, t.createOffer();
          case 16:
            f = h.sent;
            try {
              r.remove();
            } catch {
            }
            try {
              c.stop();
            } catch {
            }
            try {
              t.close();
            } catch {
            }
            return p = Tr.parse(f.sdp), m = Na.extractRtpCapabilities({ sdpObject: p }), h.abrupt("return", m);
          case 25:
            h.prev = 25, h.t0 = h.catch(6);
            try {
              r.remove();
            } catch {
            }
            try {
              c.stop();
            } catch {
            }
            try {
              t.close();
            } catch {
            }
            throw h.t0;
          case 31:
          case "end":
            return h.stop();
        }
      }, e, null, [[6, 25]]);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return Se.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: Jo });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    var t = this, r = e.direction, s = e.iceParameters, c = e.iceCandidates, l = e.dtlsParameters, u = e.sctpParameters, d = e.iceServers, f = e.iceTransportPolicy, p = e.additionalSettings, m = e.proprietaryConstraints, b = e.extendedRtpCapabilities;
    this.assertNotClosed(), Se.debug("run()"), this._direction = r, this._remoteSdp = new Im.RemoteSdp({ iceParameters: s, iceCandidates: c, dtlsParameters: l, sctpParameters: u }), this._sendingRtpParametersByKind = { audio: yn.getSendingRtpParameters("audio", b), video: yn.getSendingRtpParameters("video", b) }, this._sendingRemoteRtpParametersByKind = { audio: yn.getSendingRemoteRtpParameters("audio", b), video: yn.getSendingRemoteRtpParameters("video", b) }, this._pc = new RTCPeerConnection(Re({ iceServers: d ?? [], iceTransportPolicy: f ?? "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require" }, p), m), this._pc.addEventListener("icegatheringstatechange", function() {
      t.emit("@icegatheringstatechange", t._pc.iceGatheringState);
    }), this._pc.addEventListener("icecandidateerror", function(h) {
      t.emit("@icecandidateerror", h);
    }), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", function() {
      t.emit("@connectionstatechange", t._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", function() {
      switch (Se.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), t._pc.iceConnectionState) {
        case "checking":
          t.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          t.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          t.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          t.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          t.emit("@connectionstatechange", "closed");
      }
    });
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            throw this.assertNotClosed(), new Zo.UnsupportedError("not supported");
          case 2:
          case "end":
            return s.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (this.assertNotClosed(), Se.debug("restartIce()"), this._remoteSdp.updateIceParameters(t), this._transportReady) {
              d.next = 5;
              break;
            }
            return d.abrupt("return");
          case 5:
            if (this._direction !== "send") {
              d.next = 18;
              break;
            }
            return d.next = 8, this._pc.createOffer({ iceRestart: !0 });
          case 8:
            return r = d.sent, Se.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", r), d.next = 12, this._pc.setLocalDescription(r);
          case 12:
            return s = { type: "answer", sdp: this._remoteSdp.getSdp() }, Se.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), d.next = 16, this._pc.setRemoteDescription(s);
          case 16:
            d.next = 28;
            break;
          case 18:
            return c = { type: "offer", sdp: this._remoteSdp.getSdp() }, Se.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", c), d.next = 22, this._pc.setRemoteDescription(c);
          case 22:
            return d.next = 24, this._pc.createAnswer();
          case 24:
            return l = d.sent, Se.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", l), d.next = 28, this._pc.setLocalDescription(l);
          case 28:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return this.assertNotClosed(), r.abrupt("return", this._pc.getStats());
          case 2:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T;
      return v().wrap(function(k) {
        for (; ; ) switch (k.prev = k.next) {
          case 0:
            if (s = t.track, c = t.encodings, l = t.codecOptions, u = t.codec, this.assertNotClosed(), this.assertSendDirection(), Se.debug("send() [kind:%s, track.id:%s]", s.kind, s.id), c && ((c = Ki.clone(c)).forEach(function(x, O) {
              x.rid = "r".concat(O);
            }), c.reverse()), (d = Ki.clone(this._sendingRtpParametersByKind[s.kind])).codecs = yn.reduceCodecs(d.codecs, u), (f = Ki.clone(this._sendingRemoteRtpParametersByKind[s.kind])).codecs = yn.reduceCodecs(f.codecs, u), p = this._pc.addTransceiver(s, { direction: "sendonly", streams: [this._sendStream] }), !c) {
              k.next = 15;
              break;
            }
            return (m = p.sender.getParameters()).encodings = c, k.next = 15, p.sender.setParameters(m);
          case 15:
            return k.next = 17, this._pc.createOffer();
          case 17:
            if (b = k.sent, h = Tr.parse(b.sdp), this._transportReady) {
              k.next = 22;
              break;
            }
            return k.next = 22, this.setupTransport({ localDtlsRole: "client", localSdpObject: h });
          case 22:
            return g = (0, Pm.parse)(((r = c) !== null && r !== void 0 ? r : [{}])[0].scalabilityMode), Se.debug("send() | calling pc.setLocalDescription() [offer:%o]", b), k.next = 26, this._pc.setLocalDescription(b);
          case 26:
            if (w = p.mid, d.mid = w, h = Tr.parse(this._pc.localDescription.sdp), _ = h.media[h.media.length - 1], d.rtcp.cname = Na.getCname({ offerMediaObject: _ }), c ? c.length === 1 ? (y = Qo.getRtpEncodings({ offerMediaObject: _ }), Object.assign(y[0], c[0]), d.encodings = y) : d.encodings = c.reverse() : d.encodings = Qo.getRtpEncodings({ offerMediaObject: _ }), d.encodings.length > 1 && (d.codecs[0].mimeType.toLowerCase() === "video/vp8" || d.codecs[0].mimeType.toLowerCase() === "video/h264")) {
              C = U(d.encodings);
              try {
                for (C.s(); !(S = C.n()).done; ) (P = S.value).scalabilityMode ? P.scalabilityMode = "L1T".concat(g.temporalLayers) : P.scalabilityMode = "L1T3";
              } catch (x) {
                C.e(x);
              } finally {
                C.f();
              }
            }
            return this._remoteSdp.send({ offerMediaObject: _, offerRtpParameters: d, answerRtpParameters: f, codecOptions: l, extmapAllowMixed: !0 }), T = { type: "answer", sdp: this._remoteSdp.getSdp() }, Se.debug("send() | calling pc.setRemoteDescription() [answer:%o]", T), k.next = 38, this._pc.setRemoteDescription(T);
          case 38:
            return this._mapMidTransceiver.set(w, p), k.abrupt("return", { localId: w, rtpParameters: d, rtpSender: p.sender });
          case 40:
          case "end":
            return k.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), Se.debug("stopSending() [localId:%s]", t), !this._closed) {
              u.next = 4;
              break;
            }
            return u.abrupt("return");
          case 4:
            if (r = this._mapMidTransceiver.get(t)) {
              u.next = 7;
              break;
            }
            throw new Error("associated transceiver not found");
          case 7:
            return r.sender.replaceTrack(null), this._pc.removeTrack(r.sender), this._remoteSdp.disableMediaSection(r.mid), u.next = 12, this._pc.createOffer();
          case 12:
            return s = u.sent, Se.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 16, this._pc.setLocalDescription(s);
          case 16:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, Se.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 20, this._pc.setRemoteDescription(c);
          case 20:
            this._mapMidTransceiver.delete(t);
          case 21:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), Se.debug("pauseSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return r.direction = "inactive", this._remoteSdp.pauseMediaSection(t), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, Se.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, Se.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), Se.debug("resumeSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return r.direction = "sendonly", this._remoteSdp.resumeSendingMediaSection(t), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, Se.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, Se.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r ? Se.debug("replaceTrack() [localId:%s, track.id:%s]", t, r.id) : Se.debug("replaceTrack() [localId:%s, no track]", t), s = this._mapMidTransceiver.get(t)) {
              l.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return l.next = 8, s.sender.replaceTrack(r);
          case 8:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), Se.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated transceiver not found");
          case 6:
            return c = s.sender.getParameters(), r = c.encodings.length - 1 - r, c.encodings.forEach(function(p, m) {
              p.active = m >= r;
            }), f.next = 11, s.sender.setParameters(c);
          case 11:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 14, this._pc.createOffer();
          case 14:
            return l = f.sent, Se.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 18, this._pc.setLocalDescription(l);
          case 18:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, Se.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 22, this._pc.setRemoteDescription(u);
          case 22:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), Se.debug("setRtpEncodingParameters() [localId:%s, params:%o]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              c.encodings[m] = Re(Re({}, p), r);
            }), f.next = 10, s.sender.setParameters(c);
          case 10:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 13, this._pc.createOffer();
          case 13:
            return l = f.sent, Se.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 17, this._pc.setLocalDescription(l);
          case 17:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, Se.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 21, this._pc.setRemoteDescription(u);
          case 21:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return c.abrupt("return", r.sender.getStats());
          case 6:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g;
      return v().wrap(function(_) {
        for (; ; ) switch (_.prev = _.next) {
          case 0:
            if (r = t.ordered, s = t.maxPacketLifeTime, c = t.maxRetransmits, l = t.label, u = t.protocol, this.assertNotClosed(), this.assertSendDirection(), d = { negotiated: !0, id: this._nextSendSctpStreamId, ordered: r, maxPacketLifeTime: s, maxRetransmits: c, protocol: u }, Se.debug("sendDataChannel() [options:%o]", d), f = this._pc.createDataChannel(l, d), this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % Jo.MIS, this._hasDataChannelMediaSection) {
              _.next = 25;
              break;
            }
            return _.next = 10, this._pc.createOffer();
          case 10:
            if (p = _.sent, m = Tr.parse(p.sdp), b = m.media.find(function(y) {
              return y.type === "application";
            }), this._transportReady) {
              _.next = 16;
              break;
            }
            return _.next = 16, this.setupTransport({ localDtlsRole: "client", localSdpObject: m });
          case 16:
            return Se.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), _.next = 19, this._pc.setLocalDescription(p);
          case 19:
            return this._remoteSdp.sendSctpAssociation({ offerMediaObject: b }), h = { type: "answer", sdp: this._remoteSdp.getSdp() }, Se.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), _.next = 24, this._pc.setRemoteDescription(h);
          case 24:
            this._hasDataChannelMediaSection = !0;
          case 25:
            return g = { streamId: d.id, ordered: d.ordered, maxPacketLifeTime: d.maxPacketLifeTime, maxRetransmits: d.maxRetransmits }, _.abrupt("return", { dataChannel: f, sctpStreamParameters: g });
          case 27:
          case "end":
            return _.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k = this;
      return v().wrap(function(O) {
        for (; ; ) switch (O.prev = O.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = [], s = /* @__PURE__ */ new Map(), c = U(t);
            try {
              for (c.s(); !(l = c.n()).done; ) d = l.value, f = d.trackId, p = d.kind, m = d.rtpParameters, b = d.streamId, Se.debug("receive() [trackId:%s, kind:%s]", f, p), h = (u = m.mid) !== null && u !== void 0 ? u : String(this._mapMidTransceiver.size), s.set(f, h), this._remoteSdp.receive({ mid: h, kind: p, offerRtpParameters: m, streamId: b ?? m.rtcp.cname, trackId: f });
            } catch (D) {
              c.e(D);
            } finally {
              c.f();
            }
            return g = { type: "offer", sdp: this._remoteSdp.getSdp() }, Se.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", g), O.next = 10, this._pc.setRemoteDescription(g);
          case 10:
            return O.next = 12, this._pc.createAnswer();
          case 12:
            w = O.sent, _ = Tr.parse(w.sdp), y = U(t);
            try {
              for (S = function() {
                var A = C.value, E = A.trackId, F = A.rtpParameters, B = s.get(E), $ = _.media.find(function(M) {
                  return String(M.mid) === B;
                });
                Na.applyCodecParameters({ offerRtpParameters: F, answerMediaObject: $ }), w = { type: "answer", sdp: Tr.write(_) };
              }, y.s(); !(C = y.n()).done; ) S();
            } catch (D) {
              y.e(D);
            } finally {
              y.f();
            }
            if (this._transportReady) {
              O.next = 19;
              break;
            }
            return O.next = 19, this.setupTransport({ localDtlsRole: "client", localSdpObject: _ });
          case 19:
            return Se.debug("receive() | calling pc.setLocalDescription() [answer:%o]", w), O.next = 22, this._pc.setLocalDescription(w);
          case 22:
            P = U(t);
            try {
              for (I = function() {
                var A = T.value.trackId, E = s.get(A), F = k._pc.getTransceivers().find(function(B) {
                  return B.mid === E;
                });
                if (!F) throw new Error("new RTCRtpTransceiver not found");
                k._mapMidTransceiver.set(E, F), r.push({ localId: E, track: F.receiver.track, rtpReceiver: F.receiver });
              }, P.s(); !(T = P.n()).done; ) I();
            } catch (D) {
              P.e(D);
            } finally {
              P.f();
            }
            return O.abrupt("return", r);
          case 25:
          case "end":
            return O.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            if (this.assertRecvDirection(), !this._closed) {
              h.next = 3;
              break;
            }
            return h.abrupt("return");
          case 3:
            r = U(t), h.prev = 4, r.s();
          case 6:
            if ((s = r.n()).done) {
              h.next = 15;
              break;
            }
            if (c = s.value, Se.debug("stopReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              h.next = 12;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 12:
            this._remoteSdp.closeMediaSection(l.mid);
          case 13:
            h.next = 6;
            break;
          case 15:
            h.next = 20;
            break;
          case 17:
            h.prev = 17, h.t0 = h.catch(4), r.e(h.t0);
          case 20:
            return h.prev = 20, r.f(), h.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, Se.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), h.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return h.next = 29, this._pc.createAnswer();
          case 29:
            return d = h.sent, Se.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", d), h.next = 33, this._pc.setLocalDescription(d);
          case 33:
            f = U(t);
            try {
              for (f.s(); !(p = f.n()).done; ) m = p.value, this._mapMidTransceiver.delete(m);
            } catch (g) {
              f.e(g);
            } finally {
              f.f();
            }
          case 35:
          case "end":
            return h.stop();
        }
      }, e, this, [[4, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, Se.debug("pauseReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "inactive", this._remoteSdp.pauseMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, Se.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, Se.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, Se.debug("resumeReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "recvonly", this._remoteSdp.resumeReceivingMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, Se.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, Se.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertRecvDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 4;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 4:
            return c.abrupt("return", r.receiver.getStats());
          case 5:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g;
      return v().wrap(function(_) {
        for (; ; ) switch (_.prev = _.next) {
          case 0:
            if (r = t.sctpStreamParameters, s = t.label, c = t.protocol, this.assertNotClosed(), this.assertRecvDirection(), l = r.streamId, u = r.ordered, d = r.maxPacketLifeTime, f = r.maxRetransmits, p = { negotiated: !0, id: l, ordered: u, maxPacketLifeTime: d, maxRetransmits: f, protocol: c }, Se.debug("receiveDataChannel() [options:%o]", p), m = this._pc.createDataChannel(s, p), this._hasDataChannelMediaSection) {
              _.next = 24;
              break;
            }
            return this._remoteSdp.receiveSctpAssociation(), b = { type: "offer", sdp: this._remoteSdp.getSdp() }, Se.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", b), _.next = 13, this._pc.setRemoteDescription(b);
          case 13:
            return _.next = 15, this._pc.createAnswer();
          case 15:
            if (h = _.sent, this._transportReady) {
              _.next = 20;
              break;
            }
            return g = Tr.parse(h.sdp), _.next = 20, this.setupTransport({ localDtlsRole: "client", localSdpObject: g });
          case 20:
            return Se.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), _.next = 23, this._pc.setLocalDescription(h);
          case 23:
            this._hasDataChannelMediaSection = !0;
          case 24:
            return _.abrupt("return", { dataChannel: m });
          case 25:
          case "end":
            return _.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l = this;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return r = t.localDtlsRole, (s = t.localSdpObject) || (s = Tr.parse(this._pc.localDescription.sdp)), (c = Na.extractDtlsParameters({ sdpObject: s })).role = r, this._remoteSdp.updateDtlsRole(r === "client" ? "server" : "client"), d.next = 7, new Promise(function(f, p) {
              l.safeEmit("@connect", { dtlsParameters: c }, f, p);
            });
          case 7:
            this._transportReady = !0;
          case 8:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "assertNotClosed", value: function() {
    if (this._closed) throw new Zo.InvalidStateError("method called in a closed handler");
  } }, { key: "assertSendDirection", value: function() {
    if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
  } }, { key: "assertRecvDirection", value: function() {
    if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
  } }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
di.Firefox60 = Tm;
var li = {}, Dm = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), Em = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), zn = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && Dm(i, a, n[e]);
    return Em(i, a), i;
  };
}();
Object.defineProperty(li, "__esModule", { value: !0 }), li.Safari12 = void 0;
var rr = zn(tt), Am = rt, ec = zn(ct), bn = zn(Ye), Fa = zn(xt), tc = zn(or), Lm = zn(jn), Om = ft, Mm = Rt, jm = Mt, Nm = dr, be = new Am.Logger("Safari12"), rc = { OS: 1024, MIS: 1024 }, Fm = function(o) {
  Qe(i, Mm.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._closed = !1, n._mapMidTransceiver = /* @__PURE__ */ new Map(), n._sendStream = new MediaStream(), n._hasDataChannelMediaSection = !1, n._nextSendSctpStreamId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "Safari12";
  } }, { key: "close", value: function() {
    if (be.debug("close()"), !this._closed) {
      if (this._closed = !0, this._pc) try {
        this._pc.close();
      } catch {
      }
      this.emit("@close");
    }
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            return be.debug("getNativeRtpCapabilities()"), t = new RTCPeerConnection({ iceServers: [], iceTransportPolicy: "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require" }), u.prev = 2, t.addTransceiver("audio"), t.addTransceiver("video"), u.next = 7, t.createOffer();
          case 7:
            r = u.sent;
            try {
              t.close();
            } catch {
            }
            return s = rr.parse(r.sdp), c = Fa.extractRtpCapabilities({ sdpObject: s }), Lm.addNackSupportForOpus(c), u.abrupt("return", c);
          case 15:
            u.prev = 15, u.t0 = u.catch(2);
            try {
              t.close();
            } catch {
            }
            throw u.t0;
          case 19:
          case "end":
            return u.stop();
        }
      }, e, null, [[2, 15]]);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return be.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: rc });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    var t = this, r = e.direction, s = e.iceParameters, c = e.iceCandidates, l = e.dtlsParameters, u = e.sctpParameters, d = e.iceServers, f = e.iceTransportPolicy, p = e.additionalSettings, m = e.proprietaryConstraints, b = e.extendedRtpCapabilities;
    this.assertNotClosed(), be.debug("run()"), this._direction = r, this._remoteSdp = new jm.RemoteSdp({ iceParameters: s, iceCandidates: c, dtlsParameters: l, sctpParameters: u }), this._sendingRtpParametersByKind = { audio: bn.getSendingRtpParameters("audio", b), video: bn.getSendingRtpParameters("video", b) }, this._sendingRemoteRtpParametersByKind = { audio: bn.getSendingRemoteRtpParameters("audio", b), video: bn.getSendingRemoteRtpParameters("video", b) }, l.role && l.role !== "auto" && (this._forcedLocalDtlsRole = l.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection(Re({ iceServers: d ?? [], iceTransportPolicy: f ?? "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require" }, p), m), this._pc.addEventListener("icegatheringstatechange", function() {
      t.emit("@icegatheringstatechange", t._pc.iceGatheringState);
    }), this._pc.addEventListener("icecandidateerror", function(h) {
      t.emit("@icecandidateerror", h);
    }), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", function() {
      t.emit("@connectionstatechange", t._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", function() {
      switch (be.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), t._pc.iceConnectionState) {
        case "checking":
          t.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          t.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          t.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          t.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          t.emit("@connectionstatechange", "closed");
      }
    });
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            this.assertNotClosed(), be.debug("updateIceServers()"), (r = this._pc.getConfiguration()).iceServers = t, this._pc.setConfiguration(r);
          case 5:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (this.assertNotClosed(), be.debug("restartIce()"), this._remoteSdp.updateIceParameters(t), this._transportReady) {
              d.next = 5;
              break;
            }
            return d.abrupt("return");
          case 5:
            if (this._direction !== "send") {
              d.next = 18;
              break;
            }
            return d.next = 8, this._pc.createOffer({ iceRestart: !0 });
          case 8:
            return r = d.sent, be.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", r), d.next = 12, this._pc.setLocalDescription(r);
          case 12:
            return s = { type: "answer", sdp: this._remoteSdp.getSdp() }, be.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), d.next = 16, this._pc.setRemoteDescription(s);
          case 16:
            d.next = 28;
            break;
          case 18:
            return c = { type: "offer", sdp: this._remoteSdp.getSdp() }, be.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", c), d.next = 22, this._pc.setRemoteDescription(c);
          case 22:
            return d.next = 24, this._pc.createAnswer();
          case 24:
            return l = d.sent, be.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", l), d.next = 28, this._pc.setLocalDescription(l);
          case 28:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return this.assertNotClosed(), r.abrupt("return", this._pc.getStats());
          case 2:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I;
      return v().wrap(function(x) {
        for (; ; ) switch (x.prev = x.next) {
          case 0:
            return r = t.track, s = t.encodings, c = t.codecOptions, l = t.codec, u = t.onRtpSender, this.assertNotClosed(), this.assertSendDirection(), be.debug("send() [kind:%s, track.id:%s]", r.kind, r.id), (d = ec.clone(this._sendingRtpParametersByKind[r.kind])).codecs = bn.reduceCodecs(d.codecs, l), (f = ec.clone(this._sendingRemoteRtpParametersByKind[r.kind])).codecs = bn.reduceCodecs(f.codecs, l), p = this._remoteSdp.getNextMediaSectionIdx(), m = this._pc.addTransceiver(r, { direction: "sendonly", streams: [this._sendStream] }), u && u(m.sender), x.next = 13, this._pc.createOffer();
          case 13:
            if (b = x.sent, h = rr.parse(b.sdp), this._transportReady) {
              x.next = 18;
              break;
            }
            return x.next = 18, this.setupTransport({ localDtlsRole: (w = this._forcedLocalDtlsRole) !== null && w !== void 0 ? w : "client", localSdpObject: h });
          case 18:
            return _ = (0, Nm.parse)((s ?? [{}])[0].scalabilityMode), s && s.length > 1 && (be.debug("send() | enabling legacy simulcast"), h = rr.parse(b.sdp), g = h.media[p.idx], tc.addLegacySimulcast({ offerMediaObject: g, numStreams: s.length }), b = { type: "offer", sdp: rr.write(h) }), be.debug("send() | calling pc.setLocalDescription() [offer:%o]", b), x.next = 23, this._pc.setLocalDescription(b);
          case 23:
            if (y = m.mid, d.mid = y, h = rr.parse(this._pc.localDescription.sdp), g = h.media[p.idx], d.rtcp.cname = Fa.getCname({ offerMediaObject: g }), d.encodings = tc.getRtpEncodings({ offerMediaObject: g }), s) for (C = 0; C < d.encodings.length; ++C) s[C] && Object.assign(d.encodings[C], s[C]);
            if (d.encodings.length > 1 && (d.codecs[0].mimeType.toLowerCase() === "video/vp8" || d.codecs[0].mimeType.toLowerCase() === "video/h264")) {
              S = U(d.encodings);
              try {
                for (S.s(); !(P = S.n()).done; ) (T = P.value).scalabilityMode ? T.scalabilityMode = "L1T".concat(_.temporalLayers) : T.scalabilityMode = "L1T3";
              } catch (O) {
                S.e(O);
              } finally {
                S.f();
              }
            }
            return this._remoteSdp.send({ offerMediaObject: g, reuseMid: p.reuseMid, offerRtpParameters: d, answerRtpParameters: f, codecOptions: c }), I = { type: "answer", sdp: this._remoteSdp.getSdp() }, be.debug("send() | calling pc.setRemoteDescription() [answer:%o]", I), x.next = 36, this._pc.setRemoteDescription(I);
          case 36:
            return this._mapMidTransceiver.set(y, m), x.abrupt("return", { localId: y, rtpParameters: d, rtpSender: m.sender });
          case 38:
          case "end":
            return x.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), !this._closed) {
              u.next = 3;
              break;
            }
            return u.abrupt("return");
          case 3:
            if (be.debug("stopSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 7;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 7:
            if (r.sender.replaceTrack(null), this._pc.removeTrack(r.sender), this._remoteSdp.closeMediaSection(r.mid)) try {
              r.stop();
            } catch {
            }
            return u.next = 13, this._pc.createOffer();
          case 13:
            return s = u.sent, be.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 17, this._pc.setLocalDescription(s);
          case 17:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, be.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 21, this._pc.setRemoteDescription(c);
          case 21:
            this._mapMidTransceiver.delete(t);
          case 22:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), be.debug("pauseSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return r.direction = "inactive", this._remoteSdp.pauseMediaSection(t), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, be.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, be.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), be.debug("resumeSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return r.direction = "sendonly", this._remoteSdp.resumeSendingMediaSection(t), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, be.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, be.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r ? be.debug("replaceTrack() [localId:%s, track.id:%s]", t, r.id) : be.debug("replaceTrack() [localId:%s, no track]", t), s = this._mapMidTransceiver.get(t)) {
              l.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return l.next = 8, s.sender.replaceTrack(r);
          case 8:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), be.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              p.active = m <= r;
            }), f.next = 10, s.sender.setParameters(c);
          case 10:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 13, this._pc.createOffer();
          case 13:
            return l = f.sent, be.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 17, this._pc.setLocalDescription(l);
          case 17:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, be.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 21, this._pc.setRemoteDescription(u);
          case 21:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), be.debug("setRtpEncodingParameters() [localId:%s, params:%o]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              c.encodings[m] = Re(Re({}, p), r);
            }), f.next = 10, s.sender.setParameters(c);
          case 10:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 13, this._pc.createOffer();
          case 13:
            return l = f.sent, be.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 17, this._pc.setLocalDescription(l);
          case 17:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, be.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 21, this._pc.setRemoteDescription(u);
          case 21:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return c.abrupt("return", r.sender.getStats());
          case 6:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.ordered, s = t.maxPacketLifeTime, c = t.maxRetransmits, l = t.label, u = t.protocol, this.assertNotClosed(), this.assertSendDirection(), d = { negotiated: !0, id: this._nextSendSctpStreamId, ordered: r, maxPacketLifeTime: s, maxRetransmits: c, protocol: u }, be.debug("sendDataChannel() [options:%o]", d), f = this._pc.createDataChannel(l, d), this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % rc.MIS, this._hasDataChannelMediaSection) {
              y.next = 25;
              break;
            }
            return y.next = 10, this._pc.createOffer();
          case 10:
            if (p = y.sent, m = rr.parse(p.sdp), b = m.media.find(function(C) {
              return C.type === "application";
            }), this._transportReady) {
              y.next = 16;
              break;
            }
            return y.next = 16, this.setupTransport({ localDtlsRole: (h = this._forcedLocalDtlsRole) !== null && h !== void 0 ? h : "client", localSdpObject: m });
          case 16:
            return be.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), y.next = 19, this._pc.setLocalDescription(p);
          case 19:
            return this._remoteSdp.sendSctpAssociation({ offerMediaObject: b }), g = { type: "answer", sdp: this._remoteSdp.getSdp() }, be.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), y.next = 24, this._pc.setRemoteDescription(g);
          case 24:
            this._hasDataChannelMediaSection = !0;
          case 25:
            return w = { streamId: d.id, ordered: d.ordered, maxPacketLifeTime: d.maxPacketLifeTime, maxRetransmits: d.maxRetransmits }, y.abrupt("return", { dataChannel: f, sctpStreamParameters: w });
          case 27:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k, x, O, D, A, E, F = this;
      return v().wrap(function($) {
        for (; ; ) switch ($.prev = $.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = [], s = /* @__PURE__ */ new Map(), c = U(t);
            try {
              for (c.s(); !(l = c.n()).done; ) d = l.value, f = d.trackId, p = d.kind, m = d.rtpParameters, b = d.streamId, be.debug("receive() [trackId:%s, kind:%s]", f, p), h = (u = m.mid) !== null && u !== void 0 ? u : String(this._mapMidTransceiver.size), s.set(f, h), this._remoteSdp.receive({ mid: h, kind: p, offerRtpParameters: m, streamId: b ?? m.rtcp.cname, trackId: f });
            } catch (M) {
              c.e(M);
            } finally {
              c.f();
            }
            return g = { type: "offer", sdp: this._remoteSdp.getSdp() }, be.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", g), $.next = 10, this._pc.setRemoteDescription(g);
          case 10:
            w = U(t);
            try {
              for (w.s(); !(_ = w.n()).done; ) y = _.value, C = y.trackId, (S = y.onRtpReceiver) && function() {
                var M = s.get(C), j = F._pc.getTransceivers().find(function(z) {
                  return z.mid === M;
                });
                if (!j) throw new Error("transceiver not found");
                S(j.receiver);
              }();
            } catch (M) {
              w.e(M);
            } finally {
              w.f();
            }
            return $.next = 14, this._pc.createAnswer();
          case 14:
            P = $.sent, T = rr.parse(P.sdp), I = U(t);
            try {
              for (x = function() {
                var j = k.value, z = j.trackId, te = j.rtpParameters, ee = s.get(z), Y = T.media.find(function(Z) {
                  return String(Z.mid) === ee;
                });
                Fa.applyCodecParameters({ offerRtpParameters: te, answerMediaObject: Y });
              }, I.s(); !(k = I.n()).done; ) x();
            } catch (M) {
              I.e(M);
            } finally {
              I.f();
            }
            if (P = { type: "answer", sdp: rr.write(T) }, this._transportReady) {
              $.next = 22;
              break;
            }
            return $.next = 22, this.setupTransport({ localDtlsRole: (O = this._forcedLocalDtlsRole) !== null && O !== void 0 ? O : "client", localSdpObject: T });
          case 22:
            return be.debug("receive() | calling pc.setLocalDescription() [answer:%o]", P), $.next = 25, this._pc.setLocalDescription(P);
          case 25:
            D = U(t);
            try {
              for (E = function() {
                var j = A.value.trackId, z = s.get(j), te = F._pc.getTransceivers().find(function(ee) {
                  return ee.mid === z;
                });
                if (!te) throw new Error("new RTCRtpTransceiver not found");
                F._mapMidTransceiver.set(z, te), r.push({ localId: z, track: te.receiver.track, rtpReceiver: te.receiver });
              }, D.s(); !(A = D.n()).done; ) E();
            } catch (M) {
              D.e(M);
            } finally {
              D.f();
            }
            return $.abrupt("return", r);
          case 28:
          case "end":
            return $.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            if (this.assertRecvDirection(), !this._closed) {
              h.next = 3;
              break;
            }
            return h.abrupt("return");
          case 3:
            r = U(t), h.prev = 4, r.s();
          case 6:
            if ((s = r.n()).done) {
              h.next = 15;
              break;
            }
            if (c = s.value, be.debug("stopReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              h.next = 12;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 12:
            this._remoteSdp.closeMediaSection(l.mid);
          case 13:
            h.next = 6;
            break;
          case 15:
            h.next = 20;
            break;
          case 17:
            h.prev = 17, h.t0 = h.catch(4), r.e(h.t0);
          case 20:
            return h.prev = 20, r.f(), h.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, be.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), h.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return h.next = 29, this._pc.createAnswer();
          case 29:
            return d = h.sent, be.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", d), h.next = 33, this._pc.setLocalDescription(d);
          case 33:
            f = U(t);
            try {
              for (f.s(); !(p = f.n()).done; ) m = p.value, this._mapMidTransceiver.delete(m);
            } catch (g) {
              f.e(g);
            } finally {
              f.f();
            }
          case 35:
          case "end":
            return h.stop();
        }
      }, e, this, [[4, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, be.debug("pauseReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "inactive", this._remoteSdp.pauseMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, be.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, be.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, be.debug("resumeReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "recvonly", this._remoteSdp.resumeReceivingMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, be.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, be.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertNotClosed(), this.assertRecvDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return c.abrupt("return", r.receiver.getStats());
          case 6:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.sctpStreamParameters, s = t.label, c = t.protocol, this.assertNotClosed(), this.assertRecvDirection(), l = r.streamId, u = r.ordered, d = r.maxPacketLifeTime, f = r.maxRetransmits, p = { negotiated: !0, id: l, ordered: u, maxPacketLifeTime: d, maxRetransmits: f, protocol: c }, be.debug("receiveDataChannel() [options:%o]", p), m = this._pc.createDataChannel(s, p), this._hasDataChannelMediaSection) {
              y.next = 24;
              break;
            }
            return this._remoteSdp.receiveSctpAssociation(), b = { type: "offer", sdp: this._remoteSdp.getSdp() }, be.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", b), y.next = 13, this._pc.setRemoteDescription(b);
          case 13:
            return y.next = 15, this._pc.createAnswer();
          case 15:
            if (h = y.sent, this._transportReady) {
              y.next = 20;
              break;
            }
            return w = rr.parse(h.sdp), y.next = 20, this.setupTransport({ localDtlsRole: (g = this._forcedLocalDtlsRole) !== null && g !== void 0 ? g : "client", localSdpObject: w });
          case 20:
            return be.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), y.next = 23, this._pc.setLocalDescription(h);
          case 23:
            this._hasDataChannelMediaSection = !0;
          case 24:
            return y.abrupt("return", { dataChannel: m });
          case 25:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l = this;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return r = t.localDtlsRole, (s = t.localSdpObject) || (s = rr.parse(this._pc.localDescription.sdp)), (c = Fa.extractDtlsParameters({ sdpObject: s })).role = r, this._remoteSdp.updateDtlsRole(r === "client" ? "server" : "client"), d.next = 7, new Promise(function(f, p) {
              l.safeEmit("@connect", { dtlsParameters: c }, f, p);
            });
          case 7:
            this._transportReady = !0;
          case 8:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "assertNotClosed", value: function() {
    if (this._closed) throw new Om.InvalidStateError("method called in a closed handler");
  } }, { key: "assertSendDirection", value: function() {
    if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
  } }, { key: "assertRecvDirection", value: function() {
    if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
  } }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
li.Safari12 = Fm;
var pi = {}, $m = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), Bm = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), wa = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && $m(i, a, n[e]);
    return Bm(i, a), i;
  };
}();
Object.defineProperty(pi, "__esModule", { value: !0 }), pi.Safari11 = void 0;
var nr = wa(tt), Vm = rt, nc = wa(ct), _n = wa(Ye), $a = wa(xt), ac = wa(Zr), Um = Rt, zm = Mt, Ae = new Vm.Logger("Safari11"), ic = { OS: 1024, MIS: 1024 }, Gm = function(o) {
  Qe(i, Um.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._sendStream = new MediaStream(), n._mapSendLocalIdRtpSender = /* @__PURE__ */ new Map(), n._nextSendLocalId = 0, n._mapRecvLocalIdInfo = /* @__PURE__ */ new Map(), n._hasDataChannelMediaSection = !1, n._nextSendSctpStreamId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "Safari11";
  } }, { key: "close", value: function() {
    if (Ae.debug("close()"), this._pc) try {
      this._pc.close();
    } catch {
    }
    this.emit("@close");
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            return Ae.debug("getNativeRtpCapabilities()"), t = new RTCPeerConnection({ iceServers: [], iceTransportPolicy: "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "plan-b" }), u.prev = 2, u.next = 5, t.createOffer({ offerToReceiveAudio: !0, offerToReceiveVideo: !0 });
          case 5:
            r = u.sent;
            try {
              t.close();
            } catch {
            }
            return s = nr.parse(r.sdp), c = $a.extractRtpCapabilities({ sdpObject: s }), u.abrupt("return", c);
          case 12:
            u.prev = 12, u.t0 = u.catch(2);
            try {
              t.close();
            } catch {
            }
            throw u.t0;
          case 16:
          case "end":
            return u.stop();
        }
      }, e, null, [[2, 12]]);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return Ae.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: ic });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    var t = this, r = e.direction, s = e.iceParameters, c = e.iceCandidates, l = e.dtlsParameters, u = e.sctpParameters, d = e.iceServers, f = e.iceTransportPolicy, p = e.additionalSettings, m = e.proprietaryConstraints, b = e.extendedRtpCapabilities;
    Ae.debug("run()"), this._direction = r, this._remoteSdp = new zm.RemoteSdp({ iceParameters: s, iceCandidates: c, dtlsParameters: l, sctpParameters: u, planB: !0 }), this._sendingRtpParametersByKind = { audio: _n.getSendingRtpParameters("audio", b), video: _n.getSendingRtpParameters("video", b) }, this._sendingRemoteRtpParametersByKind = { audio: _n.getSendingRemoteRtpParameters("audio", b), video: _n.getSendingRemoteRtpParameters("video", b) }, l.role && l.role !== "auto" && (this._forcedLocalDtlsRole = l.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection(Re({ iceServers: d ?? [], iceTransportPolicy: f ?? "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require" }, p), m), this._pc.addEventListener("icegatheringstatechange", function() {
      t.emit("@icegatheringstatechange", t._pc.iceGatheringState);
    }), this._pc.addEventListener("icecandidateerror", function(h) {
      t.emit("@icecandidateerror", h);
    }), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", function() {
      t.emit("@connectionstatechange", t._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", function() {
      switch (Ae.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), t._pc.iceConnectionState) {
        case "checking":
          t.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          t.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          t.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          t.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          t.emit("@connectionstatechange", "closed");
      }
    });
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            Ae.debug("updateIceServers()"), (r = this._pc.getConfiguration()).iceServers = t, this._pc.setConfiguration(r);
          case 4:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (Ae.debug("restartIce()"), this._remoteSdp.updateIceParameters(t), this._transportReady) {
              d.next = 4;
              break;
            }
            return d.abrupt("return");
          case 4:
            if (this._direction !== "send") {
              d.next = 17;
              break;
            }
            return d.next = 7, this._pc.createOffer({ iceRestart: !0 });
          case 7:
            return r = d.sent, Ae.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", r), d.next = 11, this._pc.setLocalDescription(r);
          case 11:
            return s = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ae.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), d.next = 15, this._pc.setRemoteDescription(s);
          case 15:
            d.next = 27;
            break;
          case 17:
            return c = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ae.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", c), d.next = 21, this._pc.setRemoteDescription(c);
          case 21:
            return d.next = 23, this._pc.createAnswer();
          case 23:
            return l = d.sent, Ae.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", l), d.next = 27, this._pc.setLocalDescription(l);
          case 27:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", this._pc.getStats());
          case 1:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C;
      return v().wrap(function(P) {
        for (; ; ) switch (P.prev = P.next) {
          case 0:
            return r = t.track, s = t.encodings, c = t.codecOptions, l = t.codec, this.assertSendDirection(), Ae.debug("send() [kind:%s, track.id:%s]", r.kind, r.id), l && Ae.warn("send() | codec selection is not available in %s handler", this.name), this._sendStream.addTrack(r), this._pc.addTrack(r, this._sendStream), P.next = 8, this._pc.createOffer();
          case 8:
            if (u = P.sent, d = nr.parse(u.sdp), (p = nc.clone(this._sendingRtpParametersByKind[r.kind])).codecs = _n.reduceCodecs(p.codecs), (m = nc.clone(this._sendingRemoteRtpParametersByKind[r.kind])).codecs = _n.reduceCodecs(m.codecs), this._transportReady) {
              P.next = 17;
              break;
            }
            return P.next = 17, this.setupTransport({ localDtlsRole: (b = this._forcedLocalDtlsRole) !== null && b !== void 0 ? b : "client", localSdpObject: d });
          case 17:
            return r.kind === "video" && s && s.length > 1 && (Ae.debug("send() | enabling simulcast"), d = nr.parse(u.sdp), f = d.media.find(function(T) {
              return T.type === "video";
            }), ac.addLegacySimulcast({ offerMediaObject: f, track: r, numStreams: s.length }), u = { type: "offer", sdp: nr.write(d) }), Ae.debug("send() | calling pc.setLocalDescription() [offer:%o]", u), P.next = 21, this._pc.setLocalDescription(u);
          case 21:
            if (d = nr.parse(this._pc.localDescription.sdp), f = d.media.find(function(T) {
              return T.type === r.kind;
            }), p.rtcp.cname = $a.getCname({ offerMediaObject: f }), p.encodings = ac.getRtpEncodings({ offerMediaObject: f, track: r }), s) for (h = 0; h < p.encodings.length; ++h) s[h] && Object.assign(p.encodings[h], s[h]);
            if (p.encodings.length > 1 && p.codecs[0].mimeType.toLowerCase() === "video/vp8") {
              g = U(p.encodings);
              try {
                for (g.s(); !(w = g.n()).done; ) w.value.scalabilityMode = "L1T3";
              } catch (T) {
                g.e(T);
              } finally {
                g.f();
              }
            }
            return this._remoteSdp.send({ offerMediaObject: f, offerRtpParameters: p, answerRtpParameters: m, codecOptions: c }), _ = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ae.debug("send() | calling pc.setRemoteDescription() [answer:%o]", _), P.next = 32, this._pc.setRemoteDescription(_);
          case 32:
            return y = String(this._nextSendLocalId), this._nextSendLocalId++, C = this._pc.getSenders().find(function(T) {
              return T.track === r;
            }), this._mapSendLocalIdRtpSender.set(y, C), P.abrupt("return", { localId: y, rtpParameters: p, rtpSender: C });
          case 37:
          case "end":
            return P.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), r = this._mapSendLocalIdRtpSender.get(t)) {
              u.next = 4;
              break;
            }
            throw new Error("associated RTCRtpSender not found");
          case 4:
            return r.track && this._sendStream.removeTrack(r.track), this._mapSendLocalIdRtpSender.delete(t), u.next = 8, this._pc.createOffer();
          case 8:
            return s = u.sent, Ae.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), u.prev = 10, u.next = 13, this._pc.setLocalDescription(s);
          case 13:
            u.next = 21;
            break;
          case 15:
            if (u.prev = 15, u.t0 = u.catch(10), this._sendStream.getTracks().length !== 0) {
              u.next = 20;
              break;
            }
            return Ae.warn("stopSending() | ignoring expected error due no sending tracks: %s", u.t0.toString()), u.abrupt("return");
          case 20:
            throw u.t0;
          case 21:
            if (this._pc.signalingState !== "stable") {
              u.next = 23;
              break;
            }
            return u.abrupt("return");
          case 23:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ae.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 27, this._pc.setRemoteDescription(c);
          case 27:
          case "end":
            return u.stop();
        }
      }, e, this, [[10, 15]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), r ? Ae.debug("replaceTrack() [localId:%s, track.id:%s]", t, r.id) : Ae.debug("replaceTrack() [localId:%s, no track]", t), s = this._mapSendLocalIdRtpSender.get(t)) {
              u.next = 5;
              break;
            }
            throw new Error("associated RTCRtpSender not found");
          case 5:
            return c = s.track, u.next = 8, s.replaceTrack(r);
          case 8:
            c && this._sendStream.removeTrack(c), r && this._sendStream.addTrack(r);
          case 10:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), Ae.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", t, r), s = this._mapSendLocalIdRtpSender.get(t)) {
              u.next = 5;
              break;
            }
            throw new Error("associated RTCRtpSender not found");
          case 5:
            return (c = s.getParameters()).encodings.forEach(function(d, f) {
              d.active = f <= r;
            }), u.next = 9, s.setParameters(c);
          case 9:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), Ae.debug("setRtpEncodingParameters() [localId:%s, params:%o]", t, r), s = this._mapSendLocalIdRtpSender.get(t)) {
              u.next = 5;
              break;
            }
            throw new Error("associated RTCRtpSender not found");
          case 5:
            return (c = s.getParameters()).encodings.forEach(function(d, f) {
              c.encodings[f] = Re(Re({}, d), r);
            }), u.next = 9, s.setParameters(c);
          case 9:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertSendDirection(), r = this._mapSendLocalIdRtpSender.get(t)) {
              c.next = 4;
              break;
            }
            throw new Error("associated RTCRtpSender not found");
          case 4:
            return c.abrupt("return", r.getStats());
          case 5:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.ordered, s = t.maxPacketLifeTime, c = t.maxRetransmits, l = t.label, u = t.protocol, this.assertSendDirection(), d = { negotiated: !0, id: this._nextSendSctpStreamId, ordered: r, maxPacketLifeTime: s, maxRetransmits: c, protocol: u }, Ae.debug("sendDataChannel() [options:%o]", d), f = this._pc.createDataChannel(l, d), this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % ic.MIS, this._hasDataChannelMediaSection) {
              y.next = 24;
              break;
            }
            return y.next = 9, this._pc.createOffer();
          case 9:
            if (p = y.sent, m = nr.parse(p.sdp), b = m.media.find(function(C) {
              return C.type === "application";
            }), this._transportReady) {
              y.next = 15;
              break;
            }
            return y.next = 15, this.setupTransport({ localDtlsRole: (h = this._forcedLocalDtlsRole) !== null && h !== void 0 ? h : "client", localSdpObject: m });
          case 15:
            return Ae.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), y.next = 18, this._pc.setLocalDescription(p);
          case 18:
            return this._remoteSdp.sendSctpAssociation({ offerMediaObject: b }), g = { type: "answer", sdp: this._remoteSdp.getSdp() }, Ae.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), y.next = 23, this._pc.setRemoteDescription(g);
          case 23:
            this._hasDataChannelMediaSection = !0;
          case 24:
            return w = { streamId: d.id, ordered: d.ordered, maxPacketLifeTime: d.maxPacketLifeTime, maxRetransmits: d.maxRetransmits }, y.abrupt("return", { dataChannel: f, sctpStreamParameters: w });
          case 26:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I = this;
      return v().wrap(function(x) {
        for (; ; ) switch (x.prev = x.next) {
          case 0:
            this.assertRecvDirection(), r = [], s = U(t);
            try {
              for (s.s(); !(c = s.n()).done; ) l = c.value, u = l.trackId, d = l.kind, f = l.rtpParameters, p = l.streamId, Ae.debug("receive() [trackId:%s, kind:%s]", u, d), m = d, this._remoteSdp.receive({ mid: m, kind: d, offerRtpParameters: f, streamId: p ?? f.rtcp.cname, trackId: u });
            } catch (O) {
              s.e(O);
            } finally {
              s.f();
            }
            return b = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ae.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", b), x.next = 8, this._pc.setRemoteDescription(b);
          case 8:
            return x.next = 10, this._pc.createAnswer();
          case 10:
            h = x.sent, g = nr.parse(h.sdp), w = U(t);
            try {
              for (y = function() {
                var D = _.value, A = D.kind, E = D.rtpParameters, F = A, B = g.media.find(function($) {
                  return String($.mid) === F;
                });
                $a.applyCodecParameters({ offerRtpParameters: E, answerMediaObject: B });
              }, w.s(); !(_ = w.n()).done; ) y();
            } catch (O) {
              w.e(O);
            } finally {
              w.f();
            }
            if (h = { type: "answer", sdp: nr.write(g) }, this._transportReady) {
              x.next = 18;
              break;
            }
            return x.next = 18, this.setupTransport({ localDtlsRole: (C = this._forcedLocalDtlsRole) !== null && C !== void 0 ? C : "client", localSdpObject: g });
          case 18:
            return Ae.debug("receive() | calling pc.setLocalDescription() [answer:%o]", h), x.next = 21, this._pc.setLocalDescription(h);
          case 21:
            S = U(t);
            try {
              for (T = function() {
                var D = P.value, A = D.kind, E = D.trackId, F = D.rtpParameters, B = A, $ = E, M = I._pc.getReceivers().find(function(j) {
                  return j.track && j.track.id === $;
                });
                if (!M) throw new Error("new RTCRtpReceiver not");
                I._mapRecvLocalIdInfo.set($, { mid: B, rtpParameters: F, rtpReceiver: M }), r.push({ localId: $, track: M.track, rtpReceiver: M });
              }, S.s(); !(P = S.n()).done; ) T();
            } catch (O) {
              S.e(O);
            } finally {
              S.f();
            }
            return x.abrupt("return", r);
          case 24:
          case "end":
            return x.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            this.assertRecvDirection(), r = U(t);
            try {
              for (r.s(); !(s = r.n()).done; ) l = s.value, Ae.debug("stopReceiving() [localId:%s]", l), u = (c = this._mapRecvLocalIdInfo.get(l)) !== null && c !== void 0 ? c : {}, d = u.mid, f = u.rtpParameters, this._mapRecvLocalIdInfo.delete(l), this._remoteSdp.planBStopReceiving({ mid: d, offerRtpParameters: f });
            } catch (g) {
              r.e(g);
            } finally {
              r.f();
            }
            return p = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ae.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", p), h.next = 7, this._pc.setRemoteDescription(p);
          case 7:
            return h.next = 9, this._pc.createAnswer();
          case 9:
            return m = h.sent, Ae.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", m), h.next = 13, this._pc.setLocalDescription(m);
          case 13:
          case "end":
            return h.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertRecvDirection(), s = (r = this._mapRecvLocalIdInfo.get(t)) !== null && r !== void 0 ? r : {}, c = s.rtpReceiver) {
              u.next = 4;
              break;
            }
            throw new Error("associated RTCRtpReceiver not found");
          case 4:
            return u.abrupt("return", c.getStats());
          case 5:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.sctpStreamParameters, s = t.label, c = t.protocol, this.assertRecvDirection(), l = r.streamId, u = r.ordered, d = r.maxPacketLifeTime, f = r.maxRetransmits, p = { negotiated: !0, id: l, ordered: u, maxPacketLifeTime: d, maxRetransmits: f, protocol: c }, Ae.debug("receiveDataChannel() [options:%o]", p), m = this._pc.createDataChannel(s, p), this._hasDataChannelMediaSection) {
              y.next = 23;
              break;
            }
            return this._remoteSdp.receiveSctpAssociation({ oldDataChannelSpec: !0 }), b = { type: "offer", sdp: this._remoteSdp.getSdp() }, Ae.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", b), y.next = 12, this._pc.setRemoteDescription(b);
          case 12:
            return y.next = 14, this._pc.createAnswer();
          case 14:
            if (h = y.sent, this._transportReady) {
              y.next = 19;
              break;
            }
            return w = nr.parse(h.sdp), y.next = 19, this.setupTransport({ localDtlsRole: (g = this._forcedLocalDtlsRole) !== null && g !== void 0 ? g : "client", localSdpObject: w });
          case 19:
            return Ae.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), y.next = 22, this._pc.setLocalDescription(h);
          case 22:
            this._hasDataChannelMediaSection = !0;
          case 23:
            return y.abrupt("return", { dataChannel: m });
          case 24:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l = this;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return r = t.localDtlsRole, (s = t.localSdpObject) || (s = nr.parse(this._pc.localDescription.sdp)), (c = $a.extractDtlsParameters({ sdpObject: s })).role = r, this._remoteSdp.updateDtlsRole(r === "client" ? "server" : "client"), d.next = 7, new Promise(function(f, p) {
              l.safeEmit("@connect", { dtlsParameters: c }, f, p);
            });
          case 7:
            this._transportReady = !0;
          case 8:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "assertSendDirection", value: function() {
    if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
  } }, { key: "assertRecvDirection", value: function() {
    if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
  } }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
pi.Safari11 = Gm;
var fi = {}, Ha = {}, qm = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), Km = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), Hm = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && qm(i, a, n[e]);
    return Km(i, a), i;
  };
}();
Object.defineProperty(Ha, "__esModule", { value: !0 }), Ha.getCapabilities = function() {
  var a, i, n = RTCRtpReceiver.getCapabilities(), e = sc.clone(n), t = U((a = e.codecs) !== null && a !== void 0 ? a : []);
  try {
    for (t.s(); !(i = t.n()).done; ) {
      var r, s, c = i.value;
      if (c.channels = c.numChannels, delete c.numChannels, c.mimeType = (r = c.mimeType) !== null && r !== void 0 ? r : "".concat(c.kind, "/").concat(c.name), c.parameters) {
        var l = c.parameters;
        l.apt && (l.apt = Number(l.apt)), l["packetization-mode"] && (l["packetization-mode"] = Number(l["packetization-mode"]));
      }
      var u, d = U((s = c.rtcpFeedback) !== null && s !== void 0 ? s : []);
      try {
        for (d.s(); !(u = d.n()).done; ) {
          var f = u.value;
          f.parameter || (f.parameter = "");
        }
      } catch (p) {
        d.e(p);
      } finally {
        d.f();
      }
    }
  } catch (p) {
    t.e(p);
  } finally {
    t.f();
  }
  return e;
}, Ha.mangleRtpParameters = function(a) {
  var i = sc.clone(a);
  i.mid && (i.muxId = i.mid, delete i.mid);
  var n, e = U(i.codecs);
  try {
    for (e.s(); !(n = e.n()).done; ) {
      var t = n.value;
      t.channels && (t.numChannels = t.channels, delete t.channels), t.mimeType && !t.name && (t.name = t.mimeType.split("/")[1]), delete t.mimeType;
    }
  } catch (r) {
    e.e(r);
  } finally {
    e.f();
  }
  return i;
};
var sc = Hm(ct), Ym = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), Wm = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), Ps = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && Ym(i, a, n[e]);
    return Wm(i, a), i;
  };
}();
Object.defineProperty(fi, "__esModule", { value: !0 }), fi.Edge11 = void 0;
var Xm = rt, Hi = ft, Ba = Ps(ct), Yi = Ps(Ye), Wi = Ps(Ha), Zm = Rt, Be = new Xm.Logger("Edge11"), Qm = function(o) {
  Qe(i, Zm.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._rtpSenders = /* @__PURE__ */ new Map(), n._rtpReceivers = /* @__PURE__ */ new Map(), n._nextSendLocalId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "Edge11";
  } }, { key: "close", value: function() {
    Be.debug("close()");
    try {
      this._iceGatherer.close();
    } catch {
    }
    try {
      this._iceTransport.stop();
    } catch {
    }
    try {
      this._dtlsTransport.stop();
    } catch {
    }
    var e, t = U(this._rtpSenders.values());
    try {
      for (t.s(); !(e = t.n()).done; ) {
        var r = e.value;
        try {
          r.stop();
        } catch {
        }
      }
    } catch (u) {
      t.e(u);
    } finally {
      t.f();
    }
    var s, c = U(this._rtpReceivers.values());
    try {
      for (c.s(); !(s = c.n()).done; ) {
        var l = s.value;
        try {
          l.stop();
        } catch {
        }
      }
    } catch (u) {
      c.e(u);
    } finally {
      c.f();
    }
    this.emit("@close");
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return Be.debug("getNativeRtpCapabilities()"), r.abrupt("return", Wi.getCapabilities());
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return Be.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: { OS: 0, MIS: 0 } });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    e.direction;
    var t = e.iceParameters, r = e.iceCandidates, s = e.dtlsParameters;
    e.sctpParameters;
    var c = e.iceServers, l = e.iceTransportPolicy;
    e.additionalSettings, e.proprietaryConstraints;
    var u = e.extendedRtpCapabilities;
    Be.debug("run()"), this._sendingRtpParametersByKind = { audio: Yi.getSendingRtpParameters("audio", u), video: Yi.getSendingRtpParameters("video", u) }, this._remoteIceParameters = t, this._remoteIceCandidates = r, this._remoteDtlsParameters = s, this._cname = "CNAME-".concat(Ba.generateRandomNumber()), this.setIceGatherer({ iceServers: c, iceTransportPolicy: l }), this.setIceTransport(), this.setDtlsTransport();
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            throw new Hi.UnsupportedError("not supported");
          case 1:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (Be.debug("restartIce()"), this._remoteIceParameters = t, this._transportReady) {
              u.next = 4;
              break;
            }
            return u.abrupt("return");
          case 4:
            Be.debug("restartIce() | calling iceTransport.start()"), this._iceTransport.start(this._iceGatherer, t, "controlling"), r = U(this._remoteIceCandidates);
            try {
              for (r.s(); !(s = r.n()).done; ) c = s.value, this._iceTransport.addRemoteCandidate(c);
            } catch (d) {
              r.e(d);
            } finally {
              r.f();
            }
            this._iceTransport.addRemoteCandidate({});
          case 9:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", this._iceTransport.getStats());
          case 1:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h;
      return v().wrap(function(w) {
        for (; ; ) switch (w.prev = w.next) {
          case 0:
            if (r = t.track, s = t.encodings, t.codecOptions, c = t.codec, Be.debug("send() [kind:%s, track.id:%s]", r.kind, r.id), this._transportReady) {
              w.next = 5;
              break;
            }
            return w.next = 5, this.setupTransport({ localDtlsRole: "server" });
          case 5:
            Be.debug("send() | calling new RTCRtpSender()"), l = new RTCRtpSender(r, this._dtlsTransport), (u = Ba.clone(this._sendingRtpParametersByKind[r.kind])).codecs = Yi.reduceCodecs(u.codecs, c), d = u.codecs.some(function(_) {
              return /.+\/rtx$/i.test(_.mimeType);
            }), s || (s = [{}]), f = U(s);
            try {
              for (f.s(); !(p = f.n()).done; ) (m = p.value).ssrc = Ba.generateRandomNumber(), d && (m.rtx = { ssrc: Ba.generateRandomNumber() });
            } catch (_) {
              f.e(_);
            } finally {
              f.f();
            }
            return u.encodings = s, u.rtcp = { cname: this._cname, reducedSize: !0, mux: !0 }, b = Wi.mangleRtpParameters(u), Be.debug("send() | calling rtpSender.send() [params:%o]", b), w.next = 19, l.send(b);
          case 19:
            return h = String(this._nextSendLocalId), this._nextSendLocalId++, this._rtpSenders.set(h, l), w.abrupt("return", { localId: h, rtpParameters: u, rtpSender: l });
          case 23:
          case "end":
            return w.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (Be.debug("stopSending() [localId:%s]", t), r = this._rtpSenders.get(t)) {
              c.next = 4;
              break;
            }
            throw new Error("RTCRtpSender not found");
          case 4:
            this._rtpSenders.delete(t), c.prev = 5, Be.debug("stopSending() | calling rtpSender.stop()"), r.stop(), c.next = 14;
            break;
          case 10:
            throw c.prev = 10, c.t0 = c.catch(5), Be.warn("stopSending() | rtpSender.stop() failed:%o", c.t0), c.t0;
          case 14:
          case "end":
            return c.stop();
        }
      }, e, this, [[5, 10]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (r ? Be.debug("replaceTrack() [localId:%s, track.id:%s]", t, r.id) : Be.debug("replaceTrack() [localId:%s, no track]", t), s = this._rtpSenders.get(t)) {
              l.next = 4;
              break;
            }
            throw new Error("RTCRtpSender not found");
          case 4:
            s.setTrack(r);
          case 5:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (Be.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", t, r), s = this._rtpSenders.get(t)) {
              u.next = 4;
              break;
            }
            throw new Error("RTCRtpSender not found");
          case 4:
            return (c = s.getParameters()).encodings.forEach(function(d, f) {
              d.active = f <= r;
            }), u.next = 8, s.setParameters(c);
          case 8:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (Be.debug("setRtpEncodingParameters() [localId:%s, params:%o]", t, r), s = this._rtpSenders.get(t)) {
              u.next = 4;
              break;
            }
            throw new Error("RTCRtpSender not found");
          case 4:
            return (c = s.getParameters()).encodings.forEach(function(d, f) {
              c.encodings[f] = Re(Re({}, d), r);
            }), u.next = 8, s.setParameters(c);
          case 8:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (r = this._rtpSenders.get(t)) {
              c.next = 3;
              break;
            }
            throw new Error("RTCRtpSender not found");
          case 3:
            return c.abrupt("return", r.getStats());
          case 4:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            throw new Hi.UnsupportedError("not implemented");
          case 1:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y;
      return v().wrap(function(S) {
        for (; ; ) switch (S.prev = S.next) {
          case 0:
            r = [], s = U(t);
            try {
              for (s.s(); !(c = s.n()).done; ) l = c.value, u = l.trackId, d = l.kind, Be.debug("receive() [trackId:%s, kind:%s]", u, d);
            } catch (P) {
              s.e(P);
            } finally {
              s.f();
            }
            if (this._transportReady) {
              S.next = 6;
              break;
            }
            return S.next = 6, this.setupTransport({ localDtlsRole: "server" });
          case 6:
            f = U(t), S.prev = 7, f.s();
          case 9:
            if ((p = f.n()).done) {
              S.next = 24;
              break;
            }
            return m = p.value, b = m.trackId, h = m.kind, g = m.rtpParameters, Be.debug("receive() | calling new RTCRtpReceiver()"), (w = new RTCRtpReceiver(this._dtlsTransport, h)).addEventListener("error", function(P) {
              Be.error('rtpReceiver "error" event [event:%o]', P);
            }), _ = Wi.mangleRtpParameters(g), Be.debug("receive() | calling rtpReceiver.receive() [params:%o]", _), S.next = 19, w.receive(_);
          case 19:
            y = b, this._rtpReceivers.set(y, w), r.push({ localId: y, track: w.track, rtpReceiver: w });
          case 22:
            S.next = 9;
            break;
          case 24:
            S.next = 29;
            break;
          case 26:
            S.prev = 26, S.t0 = S.catch(7), f.e(S.t0);
          case 29:
            return S.prev = 29, f.f(), S.finish(29);
          case 32:
            return S.abrupt("return", r);
          case 33:
          case "end":
            return S.stop();
        }
      }, e, this, [[7, 26, 29, 32]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            r = U(t), d.prev = 1, r.s();
          case 3:
            if ((s = r.n()).done) {
              d.next = 13;
              break;
            }
            if (c = s.value, Be.debug("stopReceiving() [localId:%s]", c), l = this._rtpReceivers.get(c)) {
              d.next = 9;
              break;
            }
            throw new Error("RTCRtpReceiver not found");
          case 9:
            this._rtpReceivers.delete(c);
            try {
              Be.debug("stopReceiving() | calling rtpReceiver.stop()"), l.stop();
            } catch (f) {
              Be.warn("stopReceiving() | rtpReceiver.stop() failed:%o", f);
            }
          case 11:
            d.next = 3;
            break;
          case 13:
            d.next = 18;
            break;
          case 15:
            d.prev = 15, d.t0 = d.catch(1), r.e(d.t0);
          case 18:
            return d.prev = 18, r.f(), d.finish(18);
          case 21:
          case "end":
            return d.stop();
        }
      }, e, this, [[1, 15, 18, 21]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (r = this._rtpReceivers.get(t)) {
              c.next = 3;
              break;
            }
            throw new Error("RTCRtpReceiver not found");
          case 3:
            return c.abrupt("return", r.getStats());
          case 4:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            throw new Hi.UnsupportedError("not implemented");
          case 1:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setIceGatherer", value: function(e) {
    var t = e.iceServers, r = e.iceTransportPolicy, s = new RTCIceGatherer({ iceServers: t ?? [], gatherPolicy: r ?? "all" });
    s.addEventListener("error", function(c) {
      Be.error('iceGatherer "error" event [event:%o]', c);
    });
    try {
      s.gather();
    } catch (c) {
      Be.debug("setIceGatherer() | iceGatherer.gather() failed: %s", c.toString());
    }
    this._iceGatherer = s;
  } }, { key: "setIceTransport", value: function() {
    var e = this, t = new RTCIceTransport(this._iceGatherer);
    t.addEventListener("statechange", function() {
      switch (t.state) {
        case "checking":
          e.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          e.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          e.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          e.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          e.emit("@connectionstatechange", "closed");
      }
    }), t.addEventListener("icestatechange", function() {
      switch (t.state) {
        case "checking":
          e.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          e.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          e.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          e.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          e.emit("@connectionstatechange", "closed");
      }
    }), t.addEventListener("candidatepairchange", function(r) {
      Be.debug('iceTransport "candidatepairchange" event [pair:%o]', r.pair);
    }), this._iceTransport = t;
  } }, { key: "setDtlsTransport", value: function() {
    var e = this, t = new RTCDtlsTransport(this._iceTransport);
    t.addEventListener("statechange", function() {
      Be.debug('dtlsTransport "statechange" event [state:%s]', t.state);
    }), t.addEventListener("dtlsstatechange", function() {
      Be.debug('dtlsTransport "dtlsstatechange" event [state:%s]', t.state), t.state === "closed" && e.emit("@connectionstatechange", "closed");
    }), t.addEventListener("error", function(r) {
      Be.error('dtlsTransport "error" event [event:%o]', r);
    }), this._dtlsTransport = t;
  } }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d = this;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            return r = t.localDtlsRole, Be.debug("setupTransport()"), (s = this._dtlsTransport.getLocalParameters()).role = r, p.next = 6, new Promise(function(m, b) {
              d.safeEmit("@connect", { dtlsParameters: s }, m, b);
            });
          case 6:
            this._iceTransport.start(this._iceGatherer, this._remoteIceParameters, "controlling"), c = U(this._remoteIceCandidates);
            try {
              for (c.s(); !(l = c.n()).done; ) u = l.value, this._iceTransport.addRemoteCandidate(u);
            } catch (m) {
              c.e(m);
            } finally {
              c.f();
            }
            this._iceTransport.addRemoteCandidate({}), this._remoteDtlsParameters.fingerprints = this._remoteDtlsParameters.fingerprints.filter(function(m) {
              return m.algorithm === "sha-256" || m.algorithm === "sha-384" || m.algorithm === "sha-512";
            }), this._dtlsTransport.start(this._remoteDtlsParameters), this._transportReady = !0;
          case 13:
          case "end":
            return p.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
fi.Edge11 = Qm;
var hi = {}, Jm = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), ev = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), Gn = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && Jm(i, a, n[e]);
    return ev(i, a), i;
  };
}();
Object.defineProperty(hi, "__esModule", { value: !0 }), hi.ReactNativeUnifiedPlan = void 0;
var ar = Gn(tt), tv = rt, oc = Gn(ct), wn = Gn(Ye), Va = Gn(xt), Xi = Gn(or), rv = Gn(jn), nv = ft, av = Rt, iv = Mt, sv = dr, ge = new tv.Logger("ReactNativeUnifiedPlan"), cc = { OS: 1024, MIS: 1024 }, ov = function(o) {
  Qe(i, av.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._closed = !1, n._mapMidTransceiver = /* @__PURE__ */ new Map(), n._sendStream = new MediaStream(), n._hasDataChannelMediaSection = !1, n._nextSendSctpStreamId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "ReactNativeUnifiedPlan";
  } }, { key: "close", value: function() {
    if (ge.debug("close()"), !this._closed) {
      if (this._closed = !0, this._sendStream.release(!1), this._pc) try {
        this._pc.close();
      } catch {
      }
      this.emit("@close");
    }
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            return ge.debug("getNativeRtpCapabilities()"), t = new RTCPeerConnection({ iceServers: [], iceTransportPolicy: "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "unified-plan" }), u.prev = 2, t.addTransceiver("audio"), t.addTransceiver("video"), u.next = 7, t.createOffer();
          case 7:
            r = u.sent;
            try {
              t.close();
            } catch {
            }
            return s = ar.parse(r.sdp), c = Va.extractRtpCapabilities({ sdpObject: s }), rv.addNackSupportForOpus(c), u.abrupt("return", c);
          case 15:
            u.prev = 15, u.t0 = u.catch(2);
            try {
              t.close();
            } catch {
            }
            throw u.t0;
          case 19:
          case "end":
            return u.stop();
        }
      }, e, null, [[2, 15]]);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return ge.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: cc });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    var t = this, r = e.direction, s = e.iceParameters, c = e.iceCandidates, l = e.dtlsParameters, u = e.sctpParameters, d = e.iceServers, f = e.iceTransportPolicy, p = e.additionalSettings, m = e.proprietaryConstraints, b = e.extendedRtpCapabilities;
    this.assertNotClosed(), ge.debug("run()"), this._direction = r, this._remoteSdp = new iv.RemoteSdp({ iceParameters: s, iceCandidates: c, dtlsParameters: l, sctpParameters: u }), this._sendingRtpParametersByKind = { audio: wn.getSendingRtpParameters("audio", b), video: wn.getSendingRtpParameters("video", b) }, this._sendingRemoteRtpParametersByKind = { audio: wn.getSendingRemoteRtpParameters("audio", b), video: wn.getSendingRemoteRtpParameters("video", b) }, l.role && l.role !== "auto" && (this._forcedLocalDtlsRole = l.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection(Re({ iceServers: d ?? [], iceTransportPolicy: f ?? "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "unified-plan" }, p), m), this._pc.addEventListener("icegatheringstatechange", function() {
      t.emit("@icegatheringstatechange", t._pc.iceGatheringState);
    }), this._pc.addEventListener("icecandidateerror", function(h) {
      t.emit("@icecandidateerror", h);
    }), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", function() {
      t.emit("@connectionstatechange", t._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", function() {
      switch (ge.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), t._pc.iceConnectionState) {
        case "checking":
          t.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          t.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          t.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          t.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          t.emit("@connectionstatechange", "closed");
      }
    });
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            this.assertNotClosed(), ge.debug("updateIceServers()"), (r = this._pc.getConfiguration()).iceServers = t, this._pc.setConfiguration(r);
          case 5:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (this.assertNotClosed(), ge.debug("restartIce()"), this._remoteSdp.updateIceParameters(t), this._transportReady) {
              d.next = 5;
              break;
            }
            return d.abrupt("return");
          case 5:
            if (this._direction !== "send") {
              d.next = 18;
              break;
            }
            return d.next = 8, this._pc.createOffer({ iceRestart: !0 });
          case 8:
            return r = d.sent, ge.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", r), d.next = 12, this._pc.setLocalDescription(r);
          case 12:
            return s = { type: "answer", sdp: this._remoteSdp.getSdp() }, ge.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), d.next = 16, this._pc.setRemoteDescription(s);
          case 16:
            d.next = 28;
            break;
          case 18:
            return c = { type: "offer", sdp: this._remoteSdp.getSdp() }, ge.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", c), d.next = 22, this._pc.setRemoteDescription(c);
          case 22:
            return d.next = 24, this._pc.createAnswer();
          case 24:
            return l = d.sent, ge.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", l), d.next = 28, this._pc.setLocalDescription(l);
          case 28:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return this.assertNotClosed(), r.abrupt("return", this._pc.getStats());
          case 2:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k, x;
      return v().wrap(function(D) {
        for (; ; ) switch (D.prev = D.next) {
          case 0:
            return s = t.track, c = t.encodings, l = t.codecOptions, u = t.codec, d = t.onRtpSender, this.assertNotClosed(), this.assertSendDirection(), ge.debug("send() [kind:%s, track.id:%s]", s.kind, s.id), c && c.length > 1 && c.forEach(function(A, E) {
              A.rid = "r".concat(E);
            }), (f = oc.clone(this._sendingRtpParametersByKind[s.kind])).codecs = wn.reduceCodecs(f.codecs, u), (p = oc.clone(this._sendingRemoteRtpParametersByKind[s.kind])).codecs = wn.reduceCodecs(p.codecs, u), m = this._remoteSdp.getNextMediaSectionIdx(), b = this._pc.addTransceiver(s, { direction: "sendonly", streams: [this._sendStream], sendEncodings: c }), d && d(b.sender), D.next = 14, this._pc.createOffer();
          case 14:
            if (h = D.sent, g = ar.parse(h.sdp), this._transportReady) {
              D.next = 19;
              break;
            }
            return D.next = 19, this.setupTransport({ localDtlsRole: (_ = this._forcedLocalDtlsRole) !== null && _ !== void 0 ? _ : "client", localSdpObject: g });
          case 19:
            return y = !1, C = (0, sv.parse)((c ?? [{}])[0].scalabilityMode), c && c.length === 1 && C.spatialLayers > 1 && f.codecs[0].mimeType.toLowerCase() === "video/vp9" && (ge.debug("send() | enabling legacy simulcast for VP9 SVC"), y = !0, g = ar.parse(h.sdp), w = g.media[m.idx], Xi.addLegacySimulcast({ offerMediaObject: w, numStreams: C.spatialLayers }), h = { type: "offer", sdp: ar.write(g) }), ge.debug("send() | calling pc.setLocalDescription() [offer:%o]", h), D.next = 25, this._pc.setLocalDescription(h);
          case 25:
            if ((S = (r = b.mid) !== null && r !== void 0 ? r : void 0) || ge.warn("send() | missing transceiver.mid (bug in react-native-webrtc, using a workaround"), f.mid = S, g = ar.parse(this._pc.localDescription.sdp), w = g.media[m.idx], f.rtcp.cname = Va.getCname({ offerMediaObject: w }), c ? c.length === 1 ? (P = Xi.getRtpEncodings({ offerMediaObject: w }), Object.assign(P[0], c[0]), y && (P = [P[0]]), f.encodings = P) : f.encodings = c : f.encodings = Xi.getRtpEncodings({ offerMediaObject: w }), f.encodings.length > 1 && (f.codecs[0].mimeType.toLowerCase() === "video/vp8" || f.codecs[0].mimeType.toLowerCase() === "video/h264")) {
              T = U(f.encodings);
              try {
                for (T.s(); !(I = T.n()).done; ) (k = I.value).scalabilityMode ? k.scalabilityMode = "L1T".concat(C.temporalLayers) : k.scalabilityMode = "L1T3";
              } catch (A) {
                T.e(A);
              } finally {
                T.f();
              }
            }
            return this._remoteSdp.send({ offerMediaObject: w, reuseMid: m.reuseMid, offerRtpParameters: f, answerRtpParameters: p, codecOptions: l, extmapAllowMixed: !0 }), x = { type: "answer", sdp: this._remoteSdp.getSdp() }, ge.debug("send() | calling pc.setRemoteDescription() [answer:%o]", x), D.next = 38, this._pc.setRemoteDescription(x);
          case 38:
            return S || (S = b.mid, f.mid = S), this._mapMidTransceiver.set(S, b), D.abrupt("return", { localId: S, rtpParameters: f, rtpSender: b.sender });
          case 41:
          case "end":
            return D.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), !this._closed) {
              u.next = 3;
              break;
            }
            return u.abrupt("return");
          case 3:
            if (ge.debug("stopSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 7;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 7:
            if (r.sender.replaceTrack(null), this._pc.removeTrack(r.sender), this._remoteSdp.closeMediaSection(r.mid)) try {
              r.stop();
            } catch {
            }
            return u.next = 13, this._pc.createOffer();
          case 13:
            return s = u.sent, ge.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 17, this._pc.setLocalDescription(s);
          case 17:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, ge.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 21, this._pc.setRemoteDescription(c);
          case 21:
            this._mapMidTransceiver.delete(t);
          case 22:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), ge.debug("pauseSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t)) {
              u.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return r.direction = "inactive", this._remoteSdp.pauseMediaSection(t), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, ge.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, ge.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), ge.debug("resumeSending() [localId:%s]", t), r = this._mapMidTransceiver.get(t), this._remoteSdp.resumeSendingMediaSection(t), r) {
              u.next = 7;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 7:
            return r.direction = "sendonly", u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, ge.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", s), u.next = 14, this._pc.setLocalDescription(s);
          case 14:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, ge.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 18, this._pc.setRemoteDescription(c);
          case 18:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r ? ge.debug("replaceTrack() [localId:%s, track.id:%s]", t, r.id) : ge.debug("replaceTrack() [localId:%s, no track]", t), s = this._mapMidTransceiver.get(t)) {
              l.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return l.next = 8, s.sender.replaceTrack(r);
          case 8:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), ge.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              p.active = m <= r;
            }), f.next = 10, s.sender.setParameters(c);
          case 10:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 13, this._pc.createOffer();
          case 13:
            return l = f.sent, ge.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 17, this._pc.setLocalDescription(l);
          case 17:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, ge.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 21, this._pc.setRemoteDescription(u);
          case 21:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u;
      return v().wrap(function(f) {
        for (; ; ) switch (f.prev = f.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), ge.debug("setRtpEncodingParameters() [localId:%s, params:%o]", t, r), s = this._mapMidTransceiver.get(t)) {
              f.next = 6;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 6:
            return (c = s.sender.getParameters()).encodings.forEach(function(p, m) {
              c.encodings[m] = Re(Re({}, p), r);
            }), f.next = 10, s.sender.setParameters(c);
          case 10:
            return this._remoteSdp.muxMediaSectionSimulcast(t, c.encodings), f.next = 13, this._pc.createOffer();
          case 13:
            return l = f.sent, ge.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", l), f.next = 17, this._pc.setLocalDescription(l);
          case 17:
            return u = { type: "answer", sdp: this._remoteSdp.getSdp() }, ge.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", u), f.next = 21, this._pc.setRemoteDescription(u);
          case 21:
          case "end":
            return f.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertNotClosed(), this.assertSendDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return c.abrupt("return", r.sender.getStats());
          case 6:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.ordered, s = t.maxPacketLifeTime, c = t.maxRetransmits, l = t.label, u = t.protocol, this.assertNotClosed(), this.assertSendDirection(), d = { negotiated: !0, id: this._nextSendSctpStreamId, ordered: r, maxPacketLifeTime: s, maxRetransmits: c, protocol: u }, ge.debug("sendDataChannel() [options:%o]", d), f = this._pc.createDataChannel(l, d), this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % cc.MIS, this._hasDataChannelMediaSection) {
              y.next = 25;
              break;
            }
            return y.next = 10, this._pc.createOffer();
          case 10:
            if (p = y.sent, m = ar.parse(p.sdp), b = m.media.find(function(C) {
              return C.type === "application";
            }), this._transportReady) {
              y.next = 16;
              break;
            }
            return y.next = 16, this.setupTransport({ localDtlsRole: (h = this._forcedLocalDtlsRole) !== null && h !== void 0 ? h : "client", localSdpObject: m });
          case 16:
            return ge.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), y.next = 19, this._pc.setLocalDescription(p);
          case 19:
            return this._remoteSdp.sendSctpAssociation({ offerMediaObject: b }), g = { type: "answer", sdp: this._remoteSdp.getSdp() }, ge.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), y.next = 24, this._pc.setRemoteDescription(g);
          case 24:
            this._hasDataChannelMediaSection = !0;
          case 25:
            return w = { streamId: d.id, ordered: d.ordered, maxPacketLifeTime: d.maxPacketLifeTime, maxRetransmits: d.maxRetransmits }, y.abrupt("return", { dataChannel: f, sctpStreamParameters: w });
          case 27:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k, x, O, D, A, E, F = this;
      return v().wrap(function($) {
        for (; ; ) switch ($.prev = $.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = [], s = /* @__PURE__ */ new Map(), c = U(t);
            try {
              for (c.s(); !(l = c.n()).done; ) d = l.value, f = d.trackId, p = d.kind, m = d.rtpParameters, b = d.streamId, ge.debug("receive() [trackId:%s, kind:%s]", f, p), h = (u = m.mid) !== null && u !== void 0 ? u : String(this._mapMidTransceiver.size), s.set(f, h), this._remoteSdp.receive({ mid: h, kind: p, offerRtpParameters: m, streamId: b ?? m.rtcp.cname, trackId: f });
            } catch (M) {
              c.e(M);
            } finally {
              c.f();
            }
            return g = { type: "offer", sdp: this._remoteSdp.getSdp() }, ge.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", g), $.next = 10, this._pc.setRemoteDescription(g);
          case 10:
            w = U(t);
            try {
              for (w.s(); !(_ = w.n()).done; ) y = _.value, C = y.trackId, (S = y.onRtpReceiver) && function() {
                var M = s.get(C), j = F._pc.getTransceivers().find(function(z) {
                  return z.mid === M;
                });
                if (!j) throw new Error("transceiver not found");
                S(j.receiver);
              }();
            } catch (M) {
              w.e(M);
            } finally {
              w.f();
            }
            return $.next = 14, this._pc.createAnswer();
          case 14:
            P = $.sent, T = ar.parse(P.sdp), I = U(t);
            try {
              for (x = function() {
                var j = k.value, z = j.trackId, te = j.rtpParameters, ee = s.get(z), Y = T.media.find(function(Z) {
                  return String(Z.mid) === ee;
                });
                Va.applyCodecParameters({ offerRtpParameters: te, answerMediaObject: Y });
              }, I.s(); !(k = I.n()).done; ) x();
            } catch (M) {
              I.e(M);
            } finally {
              I.f();
            }
            if (P = { type: "answer", sdp: ar.write(T) }, this._transportReady) {
              $.next = 22;
              break;
            }
            return $.next = 22, this.setupTransport({ localDtlsRole: (O = this._forcedLocalDtlsRole) !== null && O !== void 0 ? O : "client", localSdpObject: T });
          case 22:
            return ge.debug("receive() | calling pc.setLocalDescription() [answer:%o]", P), $.next = 25, this._pc.setLocalDescription(P);
          case 25:
            D = U(t);
            try {
              for (E = function() {
                var j = A.value.trackId, z = s.get(j), te = F._pc.getTransceivers().find(function(ee) {
                  return ee.mid === z;
                });
                if (!te) throw new Error("new RTCRtpTransceiver not found");
                F._mapMidTransceiver.set(z, te), r.push({ localId: z, track: te.receiver.track, rtpReceiver: te.receiver });
              }, D.s(); !(A = D.n()).done; ) E();
            } catch (M) {
              D.e(M);
            } finally {
              D.f();
            }
            return $.abrupt("return", r);
          case 28:
          case "end":
            return $.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            if (this.assertRecvDirection(), !this._closed) {
              h.next = 3;
              break;
            }
            return h.abrupt("return");
          case 3:
            r = U(t), h.prev = 4, r.s();
          case 6:
            if ((s = r.n()).done) {
              h.next = 15;
              break;
            }
            if (c = s.value, ge.debug("stopReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              h.next = 12;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 12:
            this._remoteSdp.closeMediaSection(l.mid);
          case 13:
            h.next = 6;
            break;
          case 15:
            h.next = 20;
            break;
          case 17:
            h.prev = 17, h.t0 = h.catch(4), r.e(h.t0);
          case 20:
            return h.prev = 20, r.f(), h.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, ge.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), h.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return h.next = 29, this._pc.createAnswer();
          case 29:
            return d = h.sent, ge.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", d), h.next = 33, this._pc.setLocalDescription(d);
          case 33:
            f = U(t);
            try {
              for (f.s(); !(p = f.n()).done; ) m = p.value, this._mapMidTransceiver.delete(m);
            } catch (g) {
              f.e(g);
            } finally {
              f.f();
            }
          case 35:
          case "end":
            return h.stop();
        }
      }, e, this, [[4, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, ge.debug("pauseReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "inactive", this._remoteSdp.pauseMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, ge.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, ge.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d;
      return v().wrap(function(p) {
        for (; ; ) switch (p.prev = p.next) {
          case 0:
            this.assertNotClosed(), this.assertRecvDirection(), r = U(t), p.prev = 3, r.s();
          case 5:
            if ((s = r.n()).done) {
              p.next = 15;
              break;
            }
            if (c = s.value, ge.debug("resumeReceiving() [localId:%s]", c), l = this._mapMidTransceiver.get(c)) {
              p.next = 11;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 11:
            l.direction = "recvonly", this._remoteSdp.resumeReceivingMediaSection(c);
          case 13:
            p.next = 5;
            break;
          case 15:
            p.next = 20;
            break;
          case 17:
            p.prev = 17, p.t0 = p.catch(3), r.e(p.t0);
          case 20:
            return p.prev = 20, r.f(), p.finish(20);
          case 23:
            return u = { type: "offer", sdp: this._remoteSdp.getSdp() }, ge.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", u), p.next = 27, this._pc.setRemoteDescription(u);
          case 27:
            return p.next = 29, this._pc.createAnswer();
          case 29:
            return d = p.sent, ge.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", d), p.next = 33, this._pc.setLocalDescription(d);
          case 33:
          case "end":
            return p.stop();
        }
      }, e, this, [[3, 17, 20, 23]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            if (this.assertNotClosed(), this.assertRecvDirection(), r = this._mapMidTransceiver.get(t)) {
              c.next = 5;
              break;
            }
            throw new Error("associated RTCRtpTransceiver not found");
          case 5:
            return c.abrupt("return", r.receiver.getStats());
          case 6:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.sctpStreamParameters, s = t.label, c = t.protocol, this.assertNotClosed(), this.assertRecvDirection(), l = r.streamId, u = r.ordered, d = r.maxPacketLifeTime, f = r.maxRetransmits, p = { negotiated: !0, id: l, ordered: u, maxPacketLifeTime: d, maxRetransmits: f, protocol: c }, ge.debug("receiveDataChannel() [options:%o]", p), m = this._pc.createDataChannel(s, p), this._hasDataChannelMediaSection) {
              y.next = 24;
              break;
            }
            return this._remoteSdp.receiveSctpAssociation(), b = { type: "offer", sdp: this._remoteSdp.getSdp() }, ge.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", b), y.next = 13, this._pc.setRemoteDescription(b);
          case 13:
            return y.next = 15, this._pc.createAnswer();
          case 15:
            if (h = y.sent, this._transportReady) {
              y.next = 20;
              break;
            }
            return w = ar.parse(h.sdp), y.next = 20, this.setupTransport({ localDtlsRole: (g = this._forcedLocalDtlsRole) !== null && g !== void 0 ? g : "client", localSdpObject: w });
          case 20:
            return ge.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), y.next = 23, this._pc.setLocalDescription(h);
          case 23:
            this._hasDataChannelMediaSection = !0;
          case 24:
            return y.abrupt("return", { dataChannel: m });
          case 25:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l = this;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return r = t.localDtlsRole, (s = t.localSdpObject) || (s = ar.parse(this._pc.localDescription.sdp)), (c = Va.extractDtlsParameters({ sdpObject: s })).role = r, this._remoteSdp.updateDtlsRole(r === "client" ? "server" : "client"), d.next = 7, new Promise(function(f, p) {
              l.safeEmit("@connect", { dtlsParameters: c }, f, p);
            });
          case 7:
            this._transportReady = !0;
          case 8:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "assertNotClosed", value: function() {
    if (this._closed) throw new nv.InvalidStateError("method called in a closed handler");
  } }, { key: "assertSendDirection", value: function() {
    if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
  } }, { key: "assertRecvDirection", value: function() {
    if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
  } }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
hi.ReactNativeUnifiedPlan = ov;
var mi = {}, cv = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), uv = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), Sa = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && cv(i, a, n[e]);
    return uv(i, a), i;
  };
}();
Object.defineProperty(mi, "__esModule", { value: !0 }), mi.ReactNative = void 0;
var ir = Sa(tt), dv = rt, Jn = ft, Zi = Sa(ct), Sn = Sa(Ye), Ua = Sa(xt), uc = Sa(Zr), lv = Rt, pv = Mt, Me = new dv.Logger("ReactNative"), dc = { OS: 1024, MIS: 1024 }, fv = function(o) {
  Qe(i, lv.HandlerInterface);
  var a = Je(i);
  function i() {
    var n;
    return Pe(this, i), (n = a.call(this))._sendStream = new MediaStream(), n._mapSendLocalIdTrack = /* @__PURE__ */ new Map(), n._nextSendLocalId = 0, n._mapRecvLocalIdInfo = /* @__PURE__ */ new Map(), n._hasDataChannelMediaSection = !1, n._nextSendSctpStreamId = 0, n._transportReady = !1, n;
  }
  return Te(i, [{ key: "name", get: function() {
    return "ReactNative";
  } }, { key: "close", value: function() {
    if (Me.debug("close()"), this._sendStream.release(!1), this._pc) try {
      this._pc.close();
    } catch {
    }
    this.emit("@close");
  } }, { key: "getNativeRtpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      var t, r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            return Me.debug("getNativeRtpCapabilities()"), t = new RTCPeerConnection({ iceServers: [], iceTransportPolicy: "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "plan-b" }), u.prev = 2, u.next = 5, t.createOffer({ offerToReceiveAudio: !0, offerToReceiveVideo: !0 });
          case 5:
            r = u.sent;
            try {
              t.close();
            } catch {
            }
            return s = ir.parse(r.sdp), c = Ua.extractRtpCapabilities({ sdpObject: s }), u.abrupt("return", c);
          case 12:
            u.prev = 12, u.t0 = u.catch(2);
            try {
              t.close();
            } catch {
            }
            throw u.t0;
          case 16:
          case "end":
            return u.stop();
        }
      }, e, null, [[2, 12]]);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "getNativeSctpCapabilities", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return Me.debug("getNativeSctpCapabilities()"), r.abrupt("return", { numStreams: dc });
          case 2:
          case "end":
            return r.stop();
        }
      }, e);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "run", value: function(e) {
    var t = this, r = e.direction, s = e.iceParameters, c = e.iceCandidates, l = e.dtlsParameters, u = e.sctpParameters, d = e.iceServers, f = e.iceTransportPolicy, p = e.additionalSettings, m = e.proprietaryConstraints, b = e.extendedRtpCapabilities;
    Me.debug("run()"), this._direction = r, this._remoteSdp = new pv.RemoteSdp({ iceParameters: s, iceCandidates: c, dtlsParameters: l, sctpParameters: u, planB: !0 }), this._sendingRtpParametersByKind = { audio: Sn.getSendingRtpParameters("audio", b), video: Sn.getSendingRtpParameters("video", b) }, this._sendingRemoteRtpParametersByKind = { audio: Sn.getSendingRemoteRtpParameters("audio", b), video: Sn.getSendingRemoteRtpParameters("video", b) }, l.role && l.role !== "auto" && (this._forcedLocalDtlsRole = l.role === "server" ? "client" : "server"), this._pc = new RTCPeerConnection(Re({ iceServers: d ?? [], iceTransportPolicy: f ?? "all", bundlePolicy: "max-bundle", rtcpMuxPolicy: "require", sdpSemantics: "plan-b" }, p), m), this._pc.addEventListener("icegatheringstatechange", function() {
      t.emit("@icegatheringstatechange", t._pc.iceGatheringState);
    }), this._pc.addEventListener("icecandidateerror", function(h) {
      t.emit("@icecandidateerror", h);
    }), this._pc.connectionState ? this._pc.addEventListener("connectionstatechange", function() {
      t.emit("@connectionstatechange", t._pc.connectionState);
    }) : this._pc.addEventListener("iceconnectionstatechange", function() {
      switch (Me.warn("run() | pc.connectionState not supported, using pc.iceConnectionState"), t._pc.iceConnectionState) {
        case "checking":
          t.emit("@connectionstatechange", "connecting");
          break;
        case "connected":
        case "completed":
          t.emit("@connectionstatechange", "connected");
          break;
        case "failed":
          t.emit("@connectionstatechange", "failed");
          break;
        case "disconnected":
          t.emit("@connectionstatechange", "disconnected");
          break;
        case "closed":
          t.emit("@connectionstatechange", "closed");
      }
    });
  } }, { key: "updateIceServers", value: function() {
    var n = R(v().mark(function e(t) {
      var r;
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            Me.debug("updateIceServers()"), (r = this._pc.getConfiguration()).iceServers = t, this._pc.setConfiguration(r);
          case 4:
          case "end":
            return c.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "restartIce", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (Me.debug("restartIce()"), this._remoteSdp.updateIceParameters(t), this._transportReady) {
              d.next = 4;
              break;
            }
            return d.abrupt("return");
          case 4:
            if (this._direction !== "send") {
              d.next = 17;
              break;
            }
            return d.next = 7, this._pc.createOffer({ iceRestart: !0 });
          case 7:
            return r = d.sent, Me.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", r), d.next = 11, this._pc.setLocalDescription(r);
          case 11:
            return s = { type: "answer", sdp: this._remoteSdp.getSdp() }, Me.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", s), d.next = 15, this._pc.setRemoteDescription(s);
          case 15:
            d.next = 27;
            break;
          case 17:
            return c = { type: "offer", sdp: this._remoteSdp.getSdp() }, Me.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", c), d.next = 21, this._pc.setRemoteDescription(c);
          case 21:
            return d.next = 23, this._pc.createAnswer();
          case 23:
            return l = d.sent, Me.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", l), d.next = 27, this._pc.setLocalDescription(l);
          case 27:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getTransportStats", value: function() {
    var n = R(v().mark(function e() {
      return v().wrap(function(r) {
        for (; ; ) switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", this._pc.getStats());
          case 1:
          case "end":
            return r.stop();
        }
      }, e, this);
    }));
    return function() {
      return n.apply(this, arguments);
    };
  }() }, { key: "send", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y;
      return v().wrap(function(S) {
        for (; ; ) switch (S.prev = S.next) {
          case 0:
            return r = t.track, s = t.encodings, c = t.codecOptions, l = t.codec, this.assertSendDirection(), Me.debug("send() [kind:%s, track.id:%s]", r.kind, r.id), l && Me.warn("send() | codec selection is not available in %s handler", this.name), this._sendStream.addTrack(r), this._pc.addStream(this._sendStream), S.next = 8, this._pc.createOffer();
          case 8:
            if (u = S.sent, d = ir.parse(u.sdp), (p = Zi.clone(this._sendingRtpParametersByKind[r.kind])).codecs = Sn.reduceCodecs(p.codecs), (m = Zi.clone(this._sendingRemoteRtpParametersByKind[r.kind])).codecs = Sn.reduceCodecs(m.codecs), this._transportReady) {
              S.next = 17;
              break;
            }
            return S.next = 17, this.setupTransport({ localDtlsRole: (b = this._forcedLocalDtlsRole) !== null && b !== void 0 ? b : "client", localSdpObject: d });
          case 17:
            return r.kind === "video" && s && s.length > 1 && (Me.debug("send() | enabling simulcast"), d = ir.parse(u.sdp), f = d.media.find(function(P) {
              return P.type === "video";
            }), uc.addLegacySimulcast({ offerMediaObject: f, track: r, numStreams: s.length }), u = { type: "offer", sdp: ir.write(d) }), Me.debug("send() | calling pc.setLocalDescription() [offer:%o]", u), S.next = 21, this._pc.setLocalDescription(u);
          case 21:
            if (d = ir.parse(this._pc.localDescription.sdp), f = d.media.find(function(P) {
              return P.type === r.kind;
            }), p.rtcp.cname = Ua.getCname({ offerMediaObject: f }), p.encodings = uc.getRtpEncodings({ offerMediaObject: f, track: r }), s) for (h = 0; h < p.encodings.length; ++h) s[h] && Object.assign(p.encodings[h], s[h]);
            if (p.encodings.length > 1 && (p.codecs[0].mimeType.toLowerCase() === "video/vp8" || p.codecs[0].mimeType.toLowerCase() === "video/h264")) {
              g = U(p.encodings);
              try {
                for (g.s(); !(w = g.n()).done; ) w.value.scalabilityMode = "L1T3";
              } catch (P) {
                g.e(P);
              } finally {
                g.f();
              }
            }
            return this._remoteSdp.send({ offerMediaObject: f, offerRtpParameters: p, answerRtpParameters: m, codecOptions: c }), _ = { type: "answer", sdp: this._remoteSdp.getSdp() }, Me.debug("send() | calling pc.setRemoteDescription() [answer:%o]", _), S.next = 32, this._pc.setRemoteDescription(_);
          case 32:
            return y = String(this._nextSendLocalId), this._nextSendLocalId++, this._mapSendLocalIdTrack.set(y, r), S.abrupt("return", { localId: y, rtpParameters: p });
          case 36:
          case "end":
            return S.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopSending", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (this.assertSendDirection(), Me.debug("stopSending() [localId:%s]", t), r = this._mapSendLocalIdTrack.get(t)) {
              u.next = 5;
              break;
            }
            throw new Error("track not found");
          case 5:
            return this._mapSendLocalIdTrack.delete(t), this._sendStream.removeTrack(r), this._pc.addStream(this._sendStream), u.next = 10, this._pc.createOffer();
          case 10:
            return s = u.sent, Me.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", s), u.prev = 12, u.next = 15, this._pc.setLocalDescription(s);
          case 15:
            u.next = 23;
            break;
          case 17:
            if (u.prev = 17, u.t0 = u.catch(12), this._sendStream.getTracks().length !== 0) {
              u.next = 22;
              break;
            }
            return Me.warn("stopSending() | ignoring expected error due no sending tracks: %s", u.t0.toString()), u.abrupt("return");
          case 22:
            throw u.t0;
          case 23:
            if (this._pc.signalingState !== "stable") {
              u.next = 25;
              break;
            }
            return u.abrupt("return");
          case 25:
            return c = { type: "answer", sdp: this._remoteSdp.getSdp() }, Me.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", c), u.next = 29, this._pc.setRemoteDescription(c);
          case 29:
          case "end":
            return u.stop();
        }
      }, e, this, [[12, 17]]);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeSending", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "replaceTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            throw new Jn.UnsupportedError("not implemented");
          case 1:
          case "end":
            return c.stop();
        }
      }, e);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setMaxSpatialLayer", value: function() {
    var n = R(v().mark(function e(t, r) {
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            throw new Jn.UnsupportedError("not implemented");
          case 1:
          case "end":
            return c.stop();
        }
      }, e);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setRtpEncodingParameters", value: function() {
    var n = R(v().mark(function e(t, r) {
      return v().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            throw new Jn.UnsupportedError("not implemented");
          case 1:
          case "end":
            return c.stop();
        }
      }, e);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getSenderStats", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            throw new Jn.UnsupportedError("not implemented");
          case 1:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "sendDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.ordered, s = t.maxPacketLifeTime, c = t.maxRetransmits, l = t.label, u = t.protocol, this.assertSendDirection(), d = { negotiated: !0, id: this._nextSendSctpStreamId, ordered: r, maxPacketLifeTime: s, maxRetransmitTime: s, maxRetransmits: c, protocol: u }, Me.debug("sendDataChannel() [options:%o]", d), f = this._pc.createDataChannel(l, d), this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % dc.MIS, this._hasDataChannelMediaSection) {
              y.next = 24;
              break;
            }
            return y.next = 9, this._pc.createOffer();
          case 9:
            if (p = y.sent, m = ir.parse(p.sdp), b = m.media.find(function(C) {
              return C.type === "application";
            }), this._transportReady) {
              y.next = 15;
              break;
            }
            return y.next = 15, this.setupTransport({ localDtlsRole: (h = this._forcedLocalDtlsRole) !== null && h !== void 0 ? h : "client", localSdpObject: m });
          case 15:
            return Me.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", p), y.next = 18, this._pc.setLocalDescription(p);
          case 18:
            return this._remoteSdp.sendSctpAssociation({ offerMediaObject: b }), g = { type: "answer", sdp: this._remoteSdp.getSdp() }, Me.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", g), y.next = 23, this._pc.setRemoteDescription(g);
          case 23:
            this._hasDataChannelMediaSection = !0;
          case 24:
            return w = { streamId: d.id, ordered: d.ordered, maxPacketLifeTime: d.maxPacketLifeTime, maxRetransmits: d.maxRetransmits }, y.abrupt("return", { dataChannel: f, sctpStreamParameters: w });
          case 26:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receive", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w, _, y, C, S, P, T, I, k, x = this;
      return v().wrap(function(D) {
        for (; ; ) switch (D.prev = D.next) {
          case 0:
            this.assertRecvDirection(), r = [], s = /* @__PURE__ */ new Map(), c = U(t);
            try {
              for (c.s(); !(l = c.n()).done; ) d = l.value, f = d.trackId, p = d.kind, m = d.rtpParameters, Me.debug("receive() [trackId:%s, kind:%s]", f, p), b = p, h = (u = d.streamId) !== null && u !== void 0 ? u : m.rtcp.cname, Me.debug("receive() | forcing a random remote streamId to avoid well known bug in react-native-webrtc"), h += "-hack-".concat(Zi.generateRandomNumber()), s.set(f, h), this._remoteSdp.receive({ mid: b, kind: p, offerRtpParameters: m, streamId: h, trackId: f });
            } catch (A) {
              c.e(A);
            } finally {
              c.f();
            }
            return g = { type: "offer", sdp: this._remoteSdp.getSdp() }, Me.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", g), D.next = 9, this._pc.setRemoteDescription(g);
          case 9:
            return D.next = 11, this._pc.createAnswer();
          case 11:
            w = D.sent, _ = ir.parse(w.sdp), y = U(t);
            try {
              for (S = function() {
                var E = C.value, F = E.kind, B = E.rtpParameters, $ = F, M = _.media.find(function(j) {
                  return String(j.mid) === $;
                });
                Ua.applyCodecParameters({ offerRtpParameters: B, answerMediaObject: M });
              }, y.s(); !(C = y.n()).done; ) S();
            } catch (A) {
              y.e(A);
            } finally {
              y.f();
            }
            if (w = { type: "answer", sdp: ir.write(_) }, this._transportReady) {
              D.next = 19;
              break;
            }
            return D.next = 19, this.setupTransport({ localDtlsRole: (P = this._forcedLocalDtlsRole) !== null && P !== void 0 ? P : "client", localSdpObject: _ });
          case 19:
            return Me.debug("receive() | calling pc.setLocalDescription() [answer:%o]", w), D.next = 22, this._pc.setLocalDescription(w);
          case 22:
            T = U(t);
            try {
              for (k = function() {
                var E = I.value, F = E.kind, B = E.trackId, $ = E.rtpParameters, M = B, j = F, z = s.get(B), te = x._pc.getRemoteStreams().find(function(Y) {
                  return Y.id === z;
                }), ee = te.getTrackById(M);
                if (!ee) throw new Error("remote track not found");
                x._mapRecvLocalIdInfo.set(M, { mid: j, rtpParameters: $ }), r.push({ localId: M, track: ee });
              }, T.s(); !(I = T.n()).done; ) k();
            } catch (A) {
              T.e(A);
            } finally {
              T.f();
            }
            return D.abrupt("return", r);
          case 25:
          case "end":
            return D.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "stopReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            this.assertRecvDirection(), r = U(t);
            try {
              for (r.s(); !(s = r.n()).done; ) l = s.value, Me.debug("stopReceiving() [localId:%s]", l), u = (c = this._mapRecvLocalIdInfo.get(l)) !== null && c !== void 0 ? c : {}, d = u.mid, f = u.rtpParameters, this._mapRecvLocalIdInfo.delete(l), this._remoteSdp.planBStopReceiving({ mid: d, offerRtpParameters: f });
            } catch (g) {
              r.e(g);
            } finally {
              r.f();
            }
            return p = { type: "offer", sdp: this._remoteSdp.getSdp() }, Me.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", p), h.next = 7, this._pc.setRemoteDescription(p);
          case 7:
            return h.next = 9, this._pc.createAnswer();
          case 9:
            return m = h.sent, Me.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", m), h.next = 13, this._pc.setLocalDescription(m);
          case 13:
          case "end":
            return h.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "pauseReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "resumeReceiving", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "getReceiverStats", value: function() {
    var n = R(v().mark(function e(t) {
      return v().wrap(function(s) {
        for (; ; ) switch (s.prev = s.next) {
          case 0:
            throw new Jn.UnsupportedError("not implemented");
          case 1:
          case "end":
            return s.stop();
        }
      }, e);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "receiveDataChannel", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l, u, d, f, p, m, b, h, g, w;
      return v().wrap(function(y) {
        for (; ; ) switch (y.prev = y.next) {
          case 0:
            if (r = t.sctpStreamParameters, s = t.label, c = t.protocol, this.assertRecvDirection(), l = r.streamId, u = r.ordered, d = r.maxPacketLifeTime, f = r.maxRetransmits, p = { negotiated: !0, id: l, ordered: u, maxPacketLifeTime: d, maxRetransmitTime: d, maxRetransmits: f, protocol: c }, Me.debug("receiveDataChannel() [options:%o]", p), m = this._pc.createDataChannel(s, p), this._hasDataChannelMediaSection) {
              y.next = 23;
              break;
            }
            return this._remoteSdp.receiveSctpAssociation({ oldDataChannelSpec: !0 }), b = { type: "offer", sdp: this._remoteSdp.getSdp() }, Me.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", b), y.next = 12, this._pc.setRemoteDescription(b);
          case 12:
            return y.next = 14, this._pc.createAnswer();
          case 14:
            if (h = y.sent, this._transportReady) {
              y.next = 19;
              break;
            }
            return w = ir.parse(h.sdp), y.next = 19, this.setupTransport({ localDtlsRole: (g = this._forcedLocalDtlsRole) !== null && g !== void 0 ? g : "client", localSdpObject: w });
          case 19:
            return Me.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", h), y.next = 22, this._pc.setLocalDescription(h);
          case 22:
            this._hasDataChannelMediaSection = !0;
          case 23:
            return y.abrupt("return", { dataChannel: m });
          case 24:
          case "end":
            return y.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setupTransport", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c, l = this;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return r = t.localDtlsRole, (s = t.localSdpObject) || (s = ir.parse(this._pc.localDescription.sdp)), (c = Ua.extractDtlsParameters({ sdpObject: s })).role = r, this._remoteSdp.updateDtlsRole(r === "client" ? "server" : "client"), d.next = 7, new Promise(function(f, p) {
              l.safeEmit("@connect", { dtlsParameters: c }, f, p);
            });
          case 7:
            this._transportReady = !0;
          case 8:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "assertSendDirection", value: function() {
    if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
  } }, { key: "assertRecvDirection", value: function() {
    if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
  } }], [{ key: "createFactory", value: function() {
    return function() {
      return new i();
    };
  } }]), i;
}();
mi.ReactNative = fv;
var hv = K && K.__createBinding || (Object.create ? function(o, a, i, n) {
  n === void 0 && (n = i);
  var e = Object.getOwnPropertyDescriptor(a, i);
  e && !("get" in e ? !a.__esModule : e.writable || e.configurable) || (e = { enumerable: !0, get: function() {
    return a[i];
  } }), Object.defineProperty(o, n, e);
} : function(o, a, i, n) {
  n === void 0 && (n = i), o[n] = a[i];
}), mv = K && K.__setModuleDefault || (Object.create ? function(o, a) {
  Object.defineProperty(o, "default", { enumerable: !0, value: a });
} : function(o, a) {
  o.default = a;
}), Bu = K && K.__importStar || /* @__PURE__ */ function() {
  var o = function(i) {
    return o = Object.getOwnPropertyNames || function(n) {
      var e = [];
      for (var t in n) Object.prototype.hasOwnProperty.call(n, t) && (e[e.length] = t);
      return e;
    }, o(i);
  };
  return function(a) {
    if (a && a.__esModule) return a;
    var i = {};
    if (a != null) for (var n = o(a), e = 0; e < n.length; e++) n[e] !== "default" && hv(i, a, n[e]);
    return mv(i, a), i;
  };
}();
Object.defineProperty(Dn, "__esModule", { value: !0 }), Dn.Device = void 0, Dn.detectDevice = Vu;
var vv = ts.exports, gv = rt, yv = ur, Cn = ft, lc = Bu(ct), Dr = Bu(Ye), bv = ca, _v = ai, wv = ii, Sv = si, Cv = oi, kv = ci, xv = ui, Rv = di, Iv = li, Pv = pi, Tv = fi, Dv = hi, Ev = mi, yt = new gv.Logger("Device");
function Vu(o) {
  if (!o && typeof navigator == "object" && navigator.product === "ReactNative") return yt.debug("detectDevice() | React-Native detected"), typeof RTCPeerConnection > "u" ? void yt.warn("detectDevice() | unsupported react-native-webrtc without RTCPeerConnection, forgot to call registerGlobals()?") : typeof RTCRtpTransceiver < "u" ? (yt.debug("detectDevice() | ReactNative UnifiedPlan handler chosen"), "ReactNativeUnifiedPlan") : (yt.debug("detectDevice() | ReactNative PlanB handler chosen"), "ReactNative");
  if (o || typeof navigator == "object" && typeof navigator.userAgent == "string") {
    var a, i, n, e, t, r, s;
    (a = o) !== null && a !== void 0 || (o = navigator.userAgent);
    var c = new vv.UAParser(o);
    yt.debug("detectDevice() | browser detected [userAgent:%s, parsed:%o]", o, c.getResult());
    var l = c.getBrowser(), u = (i = l.name) === null || i === void 0 ? void 0 : i.toLowerCase(), d = parseInt((n = l.major) !== null && n !== void 0 ? n : "0"), f = (e = c.getEngine().name) === null || e === void 0 ? void 0 : e.toLowerCase(), p = c.getOS(), m = (t = p.name) === null || t === void 0 ? void 0 : t.toLowerCase(), b = parseFloat((r = p.version) !== null && r !== void 0 ? r : "0"), h = (s = c.getDevice().model) === null || s === void 0 ? void 0 : s.toLowerCase(), g = m === "ios" || h === "ipad", w = u && ["chrome", "chromium", "mobile chrome", "chrome webview", "chrome headless"].includes(u), _ = u && ["firefox", "mobile firefox", "mobile focus"].includes(u), y = u && ["safari", "mobile safari"].includes(u), C = u && ["edge"].includes(u);
    if ((w || C) && !g && d >= 111) return "Chrome111";
    if (w && !g && d >= 74 || C && !g && d >= 88) return "Chrome74";
    if (w && !g && d >= 70) return "Chrome70";
    if (w && !g && d >= 67) return "Chrome67";
    if (w && !g && d >= 55) return "Chrome55";
    if (_ && !g && d >= 120) return "Firefox120";
    if (_ && !g && d >= 60) return "Firefox60";
    if (_ && g && b >= 14.3 || y && d >= 12 && typeof RTCRtpTransceiver < "u" && RTCRtpTransceiver.prototype.hasOwnProperty("currentDirection")) return "Safari12";
    if (y && d >= 11) return "Safari11";
    if (C && !g && d >= 11 && d <= 18) return "Edge11";
    if (f === "webkit" && g && typeof RTCRtpTransceiver < "u" && RTCRtpTransceiver.prototype.hasOwnProperty("currentDirection")) return "Safari12";
    if (f === "blink") {
      var S = o.match(/(?:(?:Chrome|Chromium))[ /](\w+)/i);
      if (S) {
        var P = Number(S[1]);
        return P >= 111 ? "Chrome111" : P >= 74 ? "Chrome74" : P >= 70 ? "Chrome70" : P >= 67 ? "Chrome67" : "Chrome55";
      }
      return "Chrome111";
    }
    yt.warn("detectDevice() | browser not supported [name:%s, version:%s]", u, d);
  } else yt.warn("detectDevice() | unknown device");
}
var Av = function() {
  function o() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = a.handlerName, n = a.handlerFactory;
    if (Pe(this, o), this._loaded = !1, this._observer = new yv.EnhancedEventEmitter(), yt.debug("constructor()"), i && n) throw new TypeError("just one of handlerName or handlerInterface can be given");
    if (n) this._handlerFactory = n;
    else {
      if (i) yt.debug("constructor() | handler given: %s", i);
      else {
        if (!(i = Vu())) throw new Cn.UnsupportedError("device not supported");
        yt.debug("constructor() | detected handler: %s", i);
      }
      switch (i) {
        case "Chrome111":
          this._handlerFactory = _v.Chrome111.createFactory();
          break;
        case "Chrome74":
          this._handlerFactory = wv.Chrome74.createFactory();
          break;
        case "Chrome70":
          this._handlerFactory = Sv.Chrome70.createFactory();
          break;
        case "Chrome67":
          this._handlerFactory = Cv.Chrome67.createFactory();
          break;
        case "Chrome55":
          this._handlerFactory = kv.Chrome55.createFactory();
          break;
        case "Firefox120":
          this._handlerFactory = xv.Firefox120.createFactory();
          break;
        case "Firefox60":
          this._handlerFactory = Rv.Firefox60.createFactory();
          break;
        case "Safari12":
          this._handlerFactory = Iv.Safari12.createFactory();
          break;
        case "Safari11":
          this._handlerFactory = Pv.Safari11.createFactory();
          break;
        case "Edge11":
          this._handlerFactory = Tv.Edge11.createFactory();
          break;
        case "ReactNativeUnifiedPlan":
          this._handlerFactory = Dv.ReactNativeUnifiedPlan.createFactory();
          break;
        case "ReactNative":
          this._handlerFactory = Ev.ReactNative.createFactory();
          break;
        default:
          throw new TypeError('unknown handlerName "'.concat(i, '"'));
      }
    }
    var e = this._handlerFactory();
    this._handlerName = e.name, e.close(), this._extendedRtpCapabilities = void 0, this._recvRtpCapabilities = void 0, this._canProduceByKind = { audio: !1, video: !1 }, this._sctpCapabilities = void 0;
  }
  return Te(o, [{ key: "handlerName", get: function() {
    return this._handlerName;
  } }, { key: "loaded", get: function() {
    return this._loaded;
  } }, { key: "rtpCapabilities", get: function() {
    if (!this._loaded) throw new Cn.InvalidStateError("not loaded");
    return this._recvRtpCapabilities;
  } }, { key: "sctpCapabilities", get: function() {
    if (!this._loaded) throw new Cn.InvalidStateError("not loaded");
    return this._sctpCapabilities;
  } }, { key: "observer", get: function() {
    return this._observer;
  } }, { key: "load", value: function() {
    var a = R(v().mark(function i(n) {
      var e, t, r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (e = n.routerRtpCapabilities, yt.debug("load() [routerRtpCapabilities:%o]", e), u.prev = 2, !this._loaded) {
              u.next = 5;
              break;
            }
            throw new Cn.InvalidStateError("already loaded");
          case 5:
            return r = lc.clone(e), Dr.validateRtpCapabilities(r), t = this._handlerFactory(), u.next = 10, t.getNativeRtpCapabilities();
          case 10:
            return s = u.sent, yt.debug("load() | got native RTP capabilities:%o", s), c = lc.clone(s), Dr.validateRtpCapabilities(c), this._extendedRtpCapabilities = Dr.getExtendedRtpCapabilities(c, r), yt.debug("load() | got extended RTP capabilities:%o", this._extendedRtpCapabilities), this._canProduceByKind.audio = Dr.canSend("audio", this._extendedRtpCapabilities), this._canProduceByKind.video = Dr.canSend("video", this._extendedRtpCapabilities), this._recvRtpCapabilities = Dr.getRecvRtpCapabilities(this._extendedRtpCapabilities), Dr.validateRtpCapabilities(this._recvRtpCapabilities), yt.debug("load() | got receiving RTP capabilities:%o", this._recvRtpCapabilities), u.next = 23, t.getNativeSctpCapabilities();
          case 23:
            this._sctpCapabilities = u.sent, yt.debug("load() | got native SCTP capabilities:%o", this._sctpCapabilities), Dr.validateSctpCapabilities(this._sctpCapabilities), yt.debug("load() succeeded"), this._loaded = !0, t.close(), u.next = 35;
            break;
          case 31:
            throw u.prev = 31, u.t0 = u.catch(2), t && t.close(), u.t0;
          case 35:
          case "end":
            return u.stop();
        }
      }, i, this, [[2, 31]]);
    }));
    return function(n) {
      return a.apply(this, arguments);
    };
  }() }, { key: "canProduce", value: function(i) {
    if (!this._loaded) throw new Cn.InvalidStateError("not loaded");
    if (i !== "audio" && i !== "video") throw new TypeError('invalid kind "'.concat(i, '"'));
    return this._canProduceByKind[i];
  } }, { key: "createSendTransport", value: function(i) {
    var n = i.id, e = i.iceParameters, t = i.iceCandidates, r = i.dtlsParameters, s = i.sctpParameters, c = i.iceServers, l = i.iceTransportPolicy, u = i.additionalSettings, d = i.proprietaryConstraints, f = i.appData;
    return yt.debug("createSendTransport()"), this.createTransport({ direction: "send", id: n, iceParameters: e, iceCandidates: t, dtlsParameters: r, sctpParameters: s, iceServers: c, iceTransportPolicy: l, additionalSettings: u, proprietaryConstraints: d, appData: f });
  } }, { key: "createRecvTransport", value: function(i) {
    var n = i.id, e = i.iceParameters, t = i.iceCandidates, r = i.dtlsParameters, s = i.sctpParameters, c = i.iceServers, l = i.iceTransportPolicy, u = i.additionalSettings, d = i.proprietaryConstraints, f = i.appData;
    return yt.debug("createRecvTransport()"), this.createTransport({ direction: "recv", id: n, iceParameters: e, iceCandidates: t, dtlsParameters: r, sctpParameters: s, iceServers: c, iceTransportPolicy: l, additionalSettings: u, proprietaryConstraints: d, appData: f });
  } }, { key: "createTransport", value: function(i) {
    var n = i.direction, e = i.id, t = i.iceParameters, r = i.iceCandidates, s = i.dtlsParameters, c = i.sctpParameters, l = i.iceServers, u = i.iceTransportPolicy, d = i.additionalSettings, f = i.proprietaryConstraints, p = i.appData;
    if (!this._loaded) throw new Cn.InvalidStateError("not loaded");
    if (typeof e != "string") throw new TypeError("missing id");
    if (typeof t != "object") throw new TypeError("missing iceParameters");
    if (!Array.isArray(r)) throw new TypeError("missing iceCandidates");
    if (typeof s != "object") throw new TypeError("missing dtlsParameters");
    if (c && typeof c != "object") throw new TypeError("wrong sctpParameters");
    if (p && typeof p != "object") throw new TypeError("if given, appData must be an object");
    var m = new bv.Transport({ direction: n, id: e, iceParameters: t, iceCandidates: r, dtlsParameters: s, sctpParameters: c, iceServers: l, iceTransportPolicy: u, additionalSettings: d, proprietaryConstraints: f, appData: p, handlerFactory: this._handlerFactory, extendedRtpCapabilities: this._extendedRtpCapabilities, canProduceByKind: this._canProduceByKind });
    return this._observer.safeEmit("newtransport", m), m;
  } }]), o;
}();
Dn.Device = Av;
var vi = {}, Uu = {};
Object.defineProperty(Uu, "__esModule", { value: !0 });
var pc = {};
Object.defineProperty(pc, "__esModule", { value: !0 }), function(o) {
  var a = K && K.__createBinding || (Object.create ? function(n, e, t, r) {
    r === void 0 && (r = t);
    var s = Object.getOwnPropertyDescriptor(e, t);
    s && !("get" in s ? !e.__esModule : s.writable || s.configurable) || (s = { enumerable: !0, get: function() {
      return e[t];
    } }), Object.defineProperty(n, r, s);
  } : function(n, e, t, r) {
    r === void 0 && (r = t), n[r] = e[t];
  }), i = K && K.__exportStar || function(n, e) {
    for (var t in n) t === "default" || Object.prototype.hasOwnProperty.call(e, t) || a(e, n, t);
  };
  Object.defineProperty(o, "__esModule", { value: !0 }), i(Dn, o), i(ca, o), i(ua, o), i(da, o), i(la, o), i(pa, o), i(Uu, o), i(pc, o), i(Rt, o), i(ft, o);
}(vi), function(o) {
  var a = K && K.__createBinding || (Object.create ? function(l, u, d, f) {
    f === void 0 && (f = d);
    var p = Object.getOwnPropertyDescriptor(u, d);
    p && !("get" in p ? !u.__esModule : p.writable || p.configurable) || (p = { enumerable: !0, get: function() {
      return u[d];
    } }), Object.defineProperty(l, f, p);
  } : function(l, u, d, f) {
    f === void 0 && (f = d), l[f] = u[d];
  }), i = K && K.__setModuleDefault || (Object.create ? function(l, u) {
    Object.defineProperty(l, "default", { enumerable: !0, value: u });
  } : function(l, u) {
    l.default = u;
  }), n = K && K.__importStar || /* @__PURE__ */ function() {
    var l = function(d) {
      return l = Object.getOwnPropertyNames || function(f) {
        var p = [];
        for (var m in f) Object.prototype.hasOwnProperty.call(f, m) && (p[p.length] = m);
        return p;
      }, l(d);
    };
    return function(u) {
      if (u && u.__esModule) return u;
      var d = {};
      if (u != null) for (var f = l(u), p = 0; p < f.length; p++) f[p] !== "default" && a(d, u, f[p]);
      return i(d, u), d;
    };
  }(), e = K && K.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(o, "__esModule", { value: !0 }), o.debug = o.parseScalabilityMode = o.detectDevice = o.Device = o.version = o.types = void 0;
  var t = e(oa.exports);
  o.debug = t.default;
  var r = Dn;
  Object.defineProperty(o, "Device", { enumerable: !0, get: function() {
    return r.Device;
  } }), Object.defineProperty(o, "detectDevice", { enumerable: !0, get: function() {
    return r.detectDevice;
  } });
  var s = n(vi);
  o.types = s, o.version = "3.9.2";
  var c = dr;
  Object.defineProperty(o, "parseScalabilityMode", { enumerable: !0, get: function() {
    return c.parse;
  } });
}(Rs);
var zu, ss = { exports: {} }, An = typeof Reflect == "object" ? Reflect : null, fc = An && typeof An.apply == "function" ? An.apply : function(a, i, n) {
  return Function.prototype.apply.call(a, i, n);
};
zu = An && typeof An.ownKeys == "function" ? An.ownKeys : Object.getOwnPropertySymbols ? function(a) {
  return Object.getOwnPropertyNames(a).concat(Object.getOwnPropertySymbols(a));
} : function(a) {
  return Object.getOwnPropertyNames(a);
};
var hc = Number.isNaN || function(a) {
  return a !== a;
};
function He() {
  He.init.call(this);
}
ss.exports = He, ss.exports.once = function(a, i) {
  return new Promise(function(n, e) {
    function t(s) {
      a.removeListener(i, r), e(s);
    }
    function r() {
      typeof a.removeListener == "function" && a.removeListener("error", t), n([].slice.call(arguments));
    }
    _c(a, i, r, { once: !0 }), i !== "error" && function(c, l, u) {
      typeof c.on == "function" && _c(c, "error", l, u);
    }(a, t, { once: !0 });
  });
}, He.EventEmitter = He, He.prototype._events = void 0, He.prototype._eventsCount = 0, He.prototype._maxListeners = void 0;
var mc = 10;
function Ya(o) {
  if (typeof o != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof o);
}
function Gu(o) {
  return o._maxListeners === void 0 ? He.defaultMaxListeners : o._maxListeners;
}
function vc(o, a, i, n) {
  var e, t, r;
  if (Ya(i), (t = o._events) === void 0 ? (t = o._events = /* @__PURE__ */ Object.create(null), o._eventsCount = 0) : (t.newListener !== void 0 && (o.emit("newListener", a, i.listener ? i.listener : i), t = o._events), r = t[a]), r === void 0) r = t[a] = i, ++o._eventsCount;
  else if (typeof r == "function" ? r = t[a] = n ? [i, r] : [r, i] : n ? r.unshift(i) : r.push(i), (e = Gu(o)) > 0 && r.length > e && !r.warned) {
    r.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + r.length + " " + String(a) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = o, s.type = a, s.count = r.length, function(l) {
      console && console.warn && console.warn(l);
    }(s);
  }
  return o;
}
function Lv() {
  if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function gc(o, a, i) {
  var n = { fired: !1, wrapFn: void 0, target: o, type: a, listener: i }, e = Lv.bind(n);
  return e.listener = i, n.wrapFn = e, e;
}
function yc(o, a, i) {
  var n = o._events;
  if (n === void 0) return [];
  var e = n[a];
  return e === void 0 ? [] : typeof e == "function" ? i ? [e.listener || e] : [e] : i ? function(r) {
    for (var s = new Array(r.length), c = 0; c < s.length; ++c) s[c] = r[c].listener || r[c];
    return s;
  }(e) : qu(e, e.length);
}
function bc(o) {
  var a = this._events;
  if (a !== void 0) {
    var i = a[o];
    if (typeof i == "function") return 1;
    if (i !== void 0) return i.length;
  }
  return 0;
}
function qu(o, a) {
  for (var i = new Array(a), n = 0; n < a; ++n) i[n] = o[n];
  return i;
}
function _c(o, a, i, n) {
  if (typeof o.on == "function") n.once ? o.once(a, i) : o.on(a, i);
  else {
    if (typeof o.addEventListener != "function") throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof o);
    o.addEventListener(a, function e(t) {
      n.once && o.removeEventListener(a, e), i(t);
    });
  }
}
Object.defineProperty(He, "defaultMaxListeners", { enumerable: !0, get: function() {
  return mc;
}, set: function(a) {
  if (typeof a != "number" || a < 0 || hc(a)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + a + ".");
  mc = a;
} }), He.init = function() {
  this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
}, He.prototype.setMaxListeners = function(a) {
  if (typeof a != "number" || a < 0 || hc(a)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + a + ".");
  return this._maxListeners = a, this;
}, He.prototype.getMaxListeners = function() {
  return Gu(this);
}, He.prototype.emit = function(a) {
  for (var i = [], n = 1; n < arguments.length; n++) i.push(arguments[n]);
  var e = a === "error", t = this._events;
  if (t !== void 0) e = e && t.error === void 0;
  else if (!e) return !1;
  if (e) {
    var r;
    if (i.length > 0 && (r = i[0]), r instanceof Error) throw r;
    var s = new Error("Unhandled error." + (r ? " (" + r.message + ")" : ""));
    throw s.context = r, s;
  }
  var c = t[a];
  if (c === void 0) return !1;
  if (typeof c == "function") fc(c, this, i);
  else {
    var l = c.length, u = qu(c, l);
    for (n = 0; n < l; ++n) fc(u[n], this, i);
  }
  return !0;
}, He.prototype.addListener = function(a, i) {
  return vc(this, a, i, !1);
}, He.prototype.on = He.prototype.addListener, He.prototype.prependListener = function(a, i) {
  return vc(this, a, i, !0);
}, He.prototype.once = function(a, i) {
  return Ya(i), this.on(a, gc(this, a, i)), this;
}, He.prototype.prependOnceListener = function(a, i) {
  return Ya(i), this.prependListener(a, gc(this, a, i)), this;
}, He.prototype.removeListener = function(a, i) {
  var n, e, t, r, s;
  if (Ya(i), (e = this._events) === void 0) return this;
  if ((n = e[a]) === void 0) return this;
  if (n === i || n.listener === i) --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete e[a], e.removeListener && this.emit("removeListener", a, n.listener || i));
  else if (typeof n != "function") {
    for (t = -1, r = n.length - 1; r >= 0; r--) if (n[r] === i || n[r].listener === i) {
      s = n[r].listener, t = r;
      break;
    }
    if (t < 0) return this;
    t === 0 ? n.shift() : function(l, u) {
      for (; u + 1 < l.length; u++) l[u] = l[u + 1];
      l.pop();
    }(n, t), n.length === 1 && (e[a] = n[0]), e.removeListener !== void 0 && this.emit("removeListener", a, s || i);
  }
  return this;
}, He.prototype.off = He.prototype.removeListener, He.prototype.removeAllListeners = function(a) {
  var i, n, e;
  if ((n = this._events) === void 0) return this;
  if (n.removeListener === void 0) return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[a] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[a]), this;
  if (arguments.length === 0) {
    var t, r = Object.keys(n);
    for (e = 0; e < r.length; ++e) (t = r[e]) !== "removeListener" && this.removeAllListeners(t);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (typeof (i = n[a]) == "function") this.removeListener(a, i);
  else if (i !== void 0) for (e = i.length - 1; e >= 0; e--) this.removeListener(a, i[e]);
  return this;
}, He.prototype.listeners = function(a) {
  return yc(this, a, !0);
}, He.prototype.rawListeners = function(a) {
  return yc(this, a, !1);
}, He.listenerCount = function(o, a) {
  return typeof o.listenerCount == "function" ? o.listenerCount(a) : bc.call(o, a);
}, He.prototype.listenerCount = bc, He.prototype.eventNames = function() {
  return this._eventsCount > 0 ? zu(this._events) : [];
};
var Ov = ss.exports, os = { exports: {} }, Rn = 1e3, In = 60 * Rn, Pn = 60 * In, Yr = 24 * Pn, Mv = 7 * Yr, jv = 365.25 * Yr, Nv = function(a, i) {
  i = i || {};
  var n = typeof a;
  if (n === "string" && a.length > 0) return function(t) {
    if (!((t = String(t)).length > 100)) {
      var r = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(t);
      if (r) {
        var s = parseFloat(r[1]);
        switch ((r[2] || "ms").toLowerCase()) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return s * jv;
          case "weeks":
          case "week":
          case "w":
            return s * Mv;
          case "days":
          case "day":
          case "d":
            return s * Yr;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return s * Pn;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return s * In;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return s * Rn;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return s;
          default:
            return;
        }
      }
    }
  }(a);
  if (n === "number" && isFinite(a)) return i.long ? function(t) {
    var r = Math.abs(t);
    return r >= Yr ? za(t, r, Yr, "day") : r >= Pn ? za(t, r, Pn, "hour") : r >= In ? za(t, r, In, "minute") : r >= Rn ? za(t, r, Rn, "second") : t + " ms";
  }(a) : function(t) {
    var r = Math.abs(t);
    return r >= Yr ? Math.round(t / Yr) + "d" : r >= Pn ? Math.round(t / Pn) + "h" : r >= In ? Math.round(t / In) + "m" : r >= Rn ? Math.round(t / Rn) + "s" : t + "ms";
  }(a);
  throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(a));
};
function za(o, a, i, n) {
  var e = a >= 1.5 * i;
  return Math.round(o / i) + " " + n + (e ? "s" : "");
}
var Fv = function(a) {
  function i(t) {
    var r, s, c, l = null;
    function u() {
      for (var d = arguments.length, f = new Array(d), p = 0; p < d; p++) f[p] = arguments[p];
      if (u.enabled) {
        var m = u, b = Number(/* @__PURE__ */ new Date()), h = b - (r || b);
        m.diff = h, m.prev = r, m.curr = b, r = b, f[0] = i.coerce(f[0]), typeof f[0] != "string" && f.unshift("%O");
        var g = 0;
        f[0] = f[0].replace(/%([a-zA-Z%])/g, function(_, y) {
          if (_ === "%%") return "%";
          g++;
          var C = i.formatters[y];
          if (typeof C == "function") {
            var S = f[g];
            _ = C.call(m, S), f.splice(g, 1), g--;
          }
          return _;
        }), i.formatArgs.call(m, f);
        var w = m.log || i.log;
        w.apply(m, f);
      }
    }
    return u.namespace = t, u.useColors = i.useColors(), u.color = i.selectColor(t), u.extend = n, u.destroy = i.destroy, Object.defineProperty(u, "enabled", { enumerable: !0, configurable: !1, get: function() {
      return l !== null ? l : (s !== i.namespaces && (s = i.namespaces, c = i.enabled(t)), c);
    }, set: function(f) {
      l = f;
    } }), typeof i.init == "function" && i.init(u), u;
  }
  function n(t, r) {
    var s = i(this.namespace + (typeof r > "u" ? ":" : r) + t);
    return s.log = this.log, s;
  }
  function e(t) {
    return t.toString().substring(2, t.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  return i.debug = i, i.default = i, i.coerce = function(r) {
    return r instanceof Error ? r.stack || r.message : r;
  }, i.disable = function() {
    var r = [].concat(Or(i.names.map(e)), Or(i.skips.map(e).map(function(s) {
      return "-" + s;
    }))).join(",");
    return i.enable(""), r;
  }, i.enable = function(r) {
    var s;
    i.save(r), i.namespaces = r, i.names = [], i.skips = [];
    var c = (typeof r == "string" ? r : "").split(/[\s,]+/), l = c.length;
    for (s = 0; s < l; s++) c[s] && ((r = c[s].replace(/\*/g, ".*?"))[0] === "-" ? i.skips.push(new RegExp("^" + r.slice(1) + "$")) : i.names.push(new RegExp("^" + r + "$")));
  }, i.enabled = function(r) {
    if (r[r.length - 1] === "*") return !0;
    var s, c;
    for (s = 0, c = i.skips.length; s < c; s++) if (i.skips[s].test(r)) return !1;
    for (s = 0, c = i.names.length; s < c; s++) if (i.names[s].test(r)) return !0;
    return !1;
  }, i.humanize = Nv, i.destroy = function() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }, Object.keys(a).forEach(function(t) {
    i[t] = a[t];
  }), i.names = [], i.skips = [], i.formatters = {}, i.selectColor = function(r) {
    for (var s = 0, c = 0; c < r.length; c++) s = (s << 5) - s + r.charCodeAt(c), s |= 0;
    return i.colors[Math.abs(s) % i.colors.length];
  }, i.enable(i.load()), i;
};
(function(o, a) {
  a.formatArgs = function(n) {
    if (n[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + n[0] + (this.useColors ? "%c " : " ") + "+" + o.exports.humanize(this.diff), !!this.useColors) {
      var e = "color: " + this.color;
      n.splice(1, 0, e, "color: inherit");
      var t = 0, r = 0;
      n[0].replace(/%[a-zA-Z%]/g, function(s) {
        s !== "%%" && (t++, s === "%c" && (r = t));
      }), n.splice(r, 0, e);
    }
  }, a.save = function(n) {
    try {
      n ? a.storage.setItem("debug", n) : a.storage.removeItem("debug");
    } catch {
    }
  }, a.load = function() {
    var n;
    try {
      n = a.storage.getItem("debug");
    } catch {
    }
    return !n && typeof process < "u" && "env" in process && (n = process.env.DEBUG), n;
  }, a.useColors = function() {
    return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }, a.storage = function() {
    try {
      return localStorage;
    } catch {
    }
  }(), a.destroy = /* @__PURE__ */ function() {
    var i = !1;
    return function() {
      i || (i = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  }(), a.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], a.log = console.debug || console.log || function() {
  }, o.exports = Fv(a), o.exports.formatters.j = function(i) {
    try {
      return JSON.stringify(i);
    } catch (n) {
      return "[UnexpectedJSONParseError]: " + n.message;
    }
  };
})(os, os.exports);
var Ge = (0, os.exports)("soup:session");
function $v(o) {
  return Ku.apply(this, arguments);
}
function Ku() {
  return (Ku = R(v().mark(function o(a) {
    var i;
    return v().wrap(function(e) {
      for (; ; ) switch (e.prev = e.next) {
        case 0:
          return i = new Rs.Device(), e.next = 3, i.load({ routerRtpCapabilities: a });
        case 3:
          return e.abrupt("return", i);
        case 4:
        case "end":
          return e.stop();
      }
    }, o);
  }))).apply(this, arguments);
}
var Bv = function(o) {
  Qe(i, Ov);
  var a = Je(i);
  function i(n) {
    var e, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Pe(this, i), (e = a.call(this)).onDisconnect = function() {
      var r = R(v().mark(function s(c) {
        return v().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              Ge("[onDisconnect, reason: ".concat(c)), Array.from(e.soupServers.keys()).forEach(function(d) {
                e.onSoupDisconnected({ roomId: d });
              });
            case 3:
            case "end":
              return u.stop();
          }
        }, s);
      }));
      return function(s) {
        return r.apply(this, arguments);
      };
    }(), e.onReconnect = function() {
      var r = R(v().mark(function s(c) {
        return v().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              Ge("[onReconnect, attemptNumber: ".concat(c)), Array.from(e.soupServers.keys()).forEach(function(d) {
                e.onSoupDisconnected({ roomId: d }), e.joinSoupRoom(d);
              });
            case 3:
            case "end":
              return u.stop();
          }
        }, s);
      }));
      return function(s) {
        return r.apply(this, arguments);
      };
    }(), e.start = function() {
      Ge("[start]"), e.removeSoupSignalingListeners(), e.removeSoupConnectionListeners(), e.removeSignalingConnectionListeners(), e.addSignalingConnectionListeners(), e.addSoupConnectionListeners(), e.addSoupSignalingListeners();
    }, e.addSignalingConnectionListeners = function() {
      e.signaling.on("disconnect", e.onDisconnect), e.signaling.on("reconnect", e.onReconnect);
    }, e.removeSignalingConnectionListeners = function() {
      e.signaling.off("disconnect", e.onDisconnect), e.signaling.off("reconnect", e.onReconnect);
    }, e.addSoupConnectionListeners = function() {
      e.signaling.on("event.soup.connected", e.onSoupConnected), e.signaling.on("event.soup.disconnected", e.onSoupDisconnected);
    }, e.removeSoupConnectionListeners = function() {
      e.signaling.off("event.soup.connected", e.onSoupConnected), e.signaling.off("event.soup.disconnected", e.onSoupDisconnected);
    }, e.joinSoupServer = function() {
      var r = R(v().mark(function s(c) {
        var l;
        return v().wrap(function(d) {
          for (; ; ) switch (d.prev = d.next) {
            case 0:
              if (Ge("[join#".concat(c, "]")), (l = e.getSoupServer(c)) || (l = { roomId: c, device: void 0, recvTransport: void 0, sendTransport: void 0, status: "idle" }, e.soupServers.set(c, l)), l.status !== "connected") {
                d.next = 5;
                break;
              }
              return d.abrupt("return");
            case 5:
              return d.next = 7, e.joinSoupRoom(c);
            case 7:
            case "end":
              return d.stop();
          }
        }, s);
      }));
      return function(s) {
        return r.apply(this, arguments);
      };
    }(), e.leaveSoupServer = function(r) {
      Ge("[leave#".concat(r, "]")), e.leaveSoupRoom(r), e.destroyTransports(r), e.soupServers.delete(r);
    }, e.joinSoupRoom = function() {
      var r = R(v().mark(function s(c) {
        return v().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.next = 2, e.call(c, "join");
            case 2:
            case "end":
              return u.stop();
          }
        }, s);
      }));
      return function(s) {
        return r.apply(this, arguments);
      };
    }(), e.leaveSoupRoom = function() {
      var r = R(v().mark(function s(c) {
        return v().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.next = 2, e.call(c, "leave");
            case 2:
            case "end":
              return u.stop();
          }
        }, s);
      }));
      return function(s) {
        return r.apply(this, arguments);
      };
    }(), e.addSoupSignalingListeners = function() {
      e.signaling.on("event.consumer.closed", e.onConsumerClosed), e.signaling.on("event.consumer.paused", e.onConsumerPaused), e.signaling.on("event.consumer.resumed", e.onConsumerResumed), e.signaling.on("event.producer", e.onProducer), e.signaling.on("event.producer.closed", e.onProducerClosed), e.signaling.on("event.producer.updated", e.onProducerUpdated), e.signaling.on("event.transport.closed", e.onTransportClosed);
    }, e.removeSoupSignalingListeners = function() {
      e.signaling.off("event.consumer.closed", e.onConsumerClosed), e.signaling.off("event.consumer.paused", e.onConsumerPaused), e.signaling.off("event.consumer.resumed", e.onConsumerResumed), e.signaling.off("event.producer", e.onProducer), e.signaling.off("event.producer.closed", e.onProducerClosed), e.signaling.off("event.producer.updated", e.onProducerUpdated);
    }, e.getSoupServer = function(r) {
      return e.soupServers.get(r);
    }, e.getSoupServerStatus = function(r) {
      var s = e.getSoupServer(r);
      if (s) return s.status;
    }, e.destroyTransports = function(r) {
      Ge("[destroyTransports#".concat(r, "]"));
      var s = e.getSoupServer(r);
      s && (s.recvTransport && e.closeTransport(r, s.recvTransport), s.sendTransport && e.closeTransport(r, s.sendTransport));
    }, e.onSoupConnected = function() {
      var r = R(v().mark(function s(c) {
        var l, u, d, f, p, m, b, h, g, w, _, y, C;
        return v().wrap(function(P) {
          for (; ; ) switch (P.prev = P.next) {
            case 0:
              if (l = c.roomId, ((u = e.getSoupServer(l)) === null || u === void 0 ? void 0 : u.status) === "idle") {
                P.next = 4;
                break;
              }
              return P.abrupt("return");
            case 4:
              return Ge("[onSoupConnected#".concat(l, "] peerId: ").concat(e.peerId)), u.status = "pending", e.destroyTransports(l), P.next = 9, e.call(u.roomId, "call.capabilities");
            case 9:
              return d = P.sent, f = d.rtpCapabilities, P.next = 13, $v(f);
            case 13:
              return u.device = P.sent, P.next = 16, e.call(u.roomId, "call.transport.create");
            case 16:
              return p = P.sent, m = p.params, P.next = 20, e.call(u.roomId, "call.transport.create");
            case 20:
              return b = P.sent, h = b.params, g = u.device.createSendTransport(m), w = u.device.createRecvTransport(h), u.recvTransport = w, u.sendTransport = g, Ge("[transports.created#".concat(u.roomId, "]")), _ = Mr(e), y = function(I) {
                return function() {
                  var k = R(v().mark(function x(O) {
                    var D;
                    return v().wrap(function(E) {
                      for (; ; ) switch (E.prev = E.next) {
                        case 0:
                          (D = O.target).connectionState === "failed" && _.emit("transport:failed", { direction: I.direction, rtcPeerConnection: D, connectionState: D.connectionState, transport: I });
                        case 2:
                        case "end":
                          return E.stop();
                      }
                    }, x);
                  }));
                  return function(O) {
                    return k.apply(this, arguments);
                  };
                }();
              }, w.handler._pc.addEventListener("connectionstatechange", y(w)), g.handler._pc.addEventListener("connectionstatechange", y(g)), w.on("connect", function() {
                var T = R(v().mark(function I(k, x, O) {
                  var D;
                  return v().wrap(function(E) {
                    for (; ; ) switch (E.prev = E.next) {
                      case 0:
                        return D = k.dtlsParameters, E.prev = 1, E.next = 4, e.call(u.roomId, "call.transport.connect", { transportId: h.id, dtlsParameters: D });
                      case 4:
                        x(), E.next = 10;
                        break;
                      case 7:
                        E.prev = 7, E.t0 = E.catch(1), O(E.t0);
                      case 10:
                      case "end":
                        return E.stop();
                    }
                  }, I, null, [[1, 7]]);
                }));
                return function(I, k, x) {
                  return T.apply(this, arguments);
                };
              }()), g.on("connect", function() {
                var T = R(v().mark(function I(k, x, O) {
                  var D;
                  return v().wrap(function(E) {
                    for (; ; ) switch (E.prev = E.next) {
                      case 0:
                        return D = k.dtlsParameters, E.prev = 1, E.next = 4, e.call(u.roomId, "call.transport.connect", { transportId: m.id, dtlsParameters: D });
                      case 4:
                        x(), E.next = 11;
                        break;
                      case 7:
                        E.prev = 7, E.t0 = E.catch(1), console.error(E.t0), O(E.t0);
                      case 11:
                      case "end":
                        return E.stop();
                    }
                  }, I, null, [[1, 7]]);
                }));
                return function(I, k, x) {
                  return T.apply(this, arguments);
                };
              }()), e.addTransportListeners(u.roomId, w), e.addTransportListeners(u.roomId, g), g.on("produce", function() {
                var T = R(v().mark(function I(k, x, O) {
                  var D, A, E, F, B;
                  return v().wrap(function(M) {
                    for (; ; ) switch (M.prev = M.next) {
                      case 0:
                        return D = k.appData, A = k.kind, E = k.rtpParameters, M.prev = 1, M.next = 4, e.call(u.roomId, "call.produce", { appData: D, kind: A, rtpParameters: E, transportId: g.id });
                      case 4:
                        F = M.sent, B = F.producerId, x({ id: B }), M.next = 13;
                        break;
                      case 9:
                        M.prev = 9, M.t0 = M.catch(1), console.error(M.t0), O(M.t0);
                      case 13:
                      case "end":
                        return M.stop();
                    }
                  }, I, null, [[1, 9]]);
                }));
                return function(I, k, x) {
                  return T.apply(this, arguments);
                };
              }()), C = [], P.next = 39, e.call(u.roomId, "call.producers");
            case 39:
              P.sent.forEach(function(T) {
                e.publications.get(T.producerId) || (C.push(T), e.publications.set(T.producerId, T));
              }), u.status = "connected", e.emit("soup:connected", { roomId: l }), C.forEach(function(T) {
                console.log("trackPublished", l, T), e.emit("trackPublished", T);
              });
            case 44:
            case "end":
              return P.stop();
          }
        }, s);
      }));
      return function(s) {
        return r.apply(this, arguments);
      };
    }(), e.onSoupDisconnected = function(r) {
      var s = r.roomId;
      Ge("[onSoupDisconnected#".concat(s, "]"));
      var c = e.getSoupServer(s);
      c && (e.cleanAllPublications(s), e.destroyTransports(s), c.status = "idle", e.emit("soup:disconnected", { roomId: s }));
    }, e.onConsumerClosed = function(r) {
      var s = r.consumerId, c = r.roomId;
      if (e.soupServers.has(c)) {
        Ge("[onConsumerClosed#".concat(c, "] ").concat(s));
        var l = e.consumers.get(s);
        l && l.close();
      }
    }, e.onConsumerPaused = function(r) {
      var s = r.consumerId, c = r.roomId;
      if (e.soupServers.has(c)) {
        Ge("[onConsumerPaused#".concat(c, "] ").concat(s));
        var l = e.consumers.get(s);
        l && l.pause();
      }
    }, e.onConsumerResumed = function(r) {
      var s = r.consumerId, c = r.roomId;
      if (e.soupServers.has(c)) {
        Ge("[onConsumerResumed#".concat(c, "] ").concat(s));
        var l = e.consumers.get(s);
        l && l.resume();
      }
    }, e.onProducer = function(r) {
      if (e.soupServers.has(r.roomId)) {
        var s = r.kind, c = r.peerId, l = r.producerId;
        Ge("[onProducer#".concat(r.roomId, "] ").concat(s, "#").concat(l, " from ").concat(c)), e.publications.set(l, r), e.emit("trackPublished", r);
      }
    }, e.onProducerClosed = function(r) {
      if (e.soupServers.has(r.roomId)) {
        var s = r.kind, c = r.peerId, l = r.producerId;
        Ge("[onProducerClosed#".concat(r.roomId, "] ").concat(s, "#").concat(l, " from ").concat(c)), e.publications.delete(l), e.emit("trackUnpublished", r);
      }
    }, e.onProducerUpdated = function() {
      var r = R(v().mark(function s(c) {
        var l, u, d, f, p, m;
        return v().wrap(function(h) {
          for (; ; ) switch (h.prev = h.next) {
            case 0:
              if (e.soupServers.has(c.roomId)) {
                h.next = 2;
                break;
              }
              return h.abrupt("return");
            case 2:
              if (l = c.appData, u = c.kind, d = c.peerId, f = c.producerId, Ge("[onProducerUpdated#".concat(c.roomId, "] ").concat(u, "#").concat(f, " from ").concat(d)), e.publications.set(f, c), !(p = e.consumptions.get(f))) {
                h.next = 11;
                break;
              }
              return h.next = 9, p.consumerPromise;
            case 9:
              m = h.sent, Object.assign(m.appData, l || {});
            case 11:
              e.emit("trackUpdated", { appData: l, roomId: c.roomId, kind: c.kind, peerId: c.peerId, producerId: f });
            case 12:
            case "end":
              return h.stop();
          }
        }, s);
      }));
      return function(s) {
        return r.apply(this, arguments);
      };
    }(), e.onTransportClosed = function(r) {
      var s = r.roomId, c = r.peerId, l = r.transportId;
      if (c === e.peerId) {
        Ge("[onTransportClosed#".concat(s, "] ").concat(l));
        var u = e.getTransportById(s, l);
        u && e.closeTransport(s, u);
      }
    }, e.settings = Re({}, t), e.signaling = n, e.soupServers = /* @__PURE__ */ new Map(), e.publications = /* @__PURE__ */ new Map(), e.consumers = /* @__PURE__ */ new Map(), e.producers = /* @__PURE__ */ new Map(), e.productions = /* @__PURE__ */ new Map(), e.consumptions = /* @__PURE__ */ new Map(), e;
  }
  return Te(i, [{ key: "call", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c = this, l = arguments;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            return s = l.length > 2 && l[2] !== void 0 ? l[2] : {}, d.abrupt("return", new Promise(function(f, p) {
              c.signaling.emit(r, Re(Re({}, s), {}, { roomId: t }), function(m) {
                var b = m.error, h = m.data;
                b ? p(b) : f(h);
              });
            }));
          case 2:
          case "end":
            return d.stop();
        }
      }, e);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "publish", value: function(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.signaling.emit("publish.".concat(t), Re(Re({}, r), {}, { roomId: e }));
  } }, { key: "peerId", get: function() {
    return this.signaling.id;
  } }, { key: "removeConsumerListeners", value: function(e) {
    e.removeAllListeners(), e.observer.removeAllListeners(), e.kind === "video" && this.settings.logWebrtcStats && (clearTimeout(e.statsTimeout), delete e.statsTimeout);
  } }, { key: "addConsumerListeners", value: function(e, t) {
    var r = this;
    if (t.observer.on("close", function() {
      Ge("[consumer.close#".concat(e, "] ").concat(t.id)), r.removeConsumerListeners(t), r.consumers.delete(t.id);
      var c = r.consumptions.get(t.producerId);
      c && r.cleanConsumption(c, t), r.publish(e, "consumer.closed", { consumerId: t.id });
    }), t.observer.on("pause", function() {
      Ge("[consumer.pause#".concat(e, "] ").concat(t.id)), r.publish(e, "consumer.paused", { consumerId: t.id });
    }), t.observer.on("resume", function() {
      Ge("[consumer.resume#".concat(e, "] ").concat(t.id)), r.publish(e, "consumer.resumed", { consumerId: t.id });
    }), t.kind === "video" && this.settings.logWebrtcStats) {
      var s = function() {
        var c = R(v().mark(function l() {
          return v().wrap(function(d) {
            for (; ; ) switch (d.prev = d.next) {
              case 0:
                return d.t0 = console, d.t1 = "consumer ".concat(t.kind, "#").concat(t.id, " stats"), d.t2 = Object, d.next = 5, t.getStats();
              case 5:
                d.t3 = d.sent, d.t4 = d.t2.fromEntries.call(d.t2, d.t3), d.t0.log.call(d.t0, d.t1, d.t4), t.statsTimeout = setTimeout(s, 1e4);
              case 9:
              case "end":
                return d.stop();
            }
          }, l);
        }));
        return function() {
          return c.apply(this, arguments);
        };
      }();
      s();
    }
  } }, { key: "removeProducerListeners", value: function(e) {
    e.removeAllListeners(), e.observer.removeAllListeners(), e.kind === "video" && this.settings.logWebrtcStats && (clearTimeout(e.statsTimeout), delete e.statsTimeout);
  } }, { key: "addProducerListeners", value: function(e, t) {
    var r = this;
    if (t.on("trackended", function() {
      t.close();
    }), t.observer.on("close", function() {
      Ge("[producer.close#".concat(e, "] ").concat(t.id)), r.removeProducerListeners(t);
      var c = t.track;
      if (c) {
        r.producers.delete(t.id);
        var l = r.productions.get(c.id);
        l && r.cleanProduction(l, t), r.publish(e, "producer.closed", { producerId: t.id });
      } else console.warn("Producer#".concat(t.id, " track is null"));
    }), t.observer.on("pause", function() {
      Ge("[producer.pause#".concat(e, "] ").concat(t.id)), r.publish(e, "producer.paused", { producerId: t.id });
    }), t.observer.on("resume", function() {
      Ge("[producer.resume#".concat(e, "] ").concat(t.id)), r.publish(e, "producer.resumed", { producerId: t.id });
    }), t.kind === "video" && this.settings.logWebrtcStats) {
      var s = function() {
        var c = R(v().mark(function l() {
          return v().wrap(function(d) {
            for (; ; ) switch (d.prev = d.next) {
              case 0:
                return d.t0 = console, d.t1 = "producer ".concat(t.kind, "#").concat(t.id, " stats"), d.t2 = Object, d.next = 5, t.getStats();
              case 5:
                d.t3 = d.sent, d.t4 = d.t2.fromEntries.call(d.t2, d.t3), d.t0.log.call(d.t0, d.t1, d.t4), t.statsTimeout = setTimeout(s, 1e4);
              case 9:
              case "end":
                return d.stop();
            }
          }, l);
        }));
        return function() {
          return c.apply(this, arguments);
        };
      }();
      s();
    }
  } }, { key: "removeTransportListeners", value: function(e) {
    e.removeAllListeners(), e.observer.removeAllListeners();
  } }, { key: "addTransportListeners", value: function(e, t) {
    var r = this;
    t.observer.on("close", function() {
      Ge("[transport.close#".concat(e, "] ").concat(t.id)), r.removeTransportListeners(t), r.closeTransport(e, t), r.publish(e, "transport.closed", { transportId: t.id });
    });
  } }, { key: "closeTransport", value: function(e, t) {
    var r, s, c = this.getSoupServer(e);
    c && (((r = c.recvTransport) === null || r === void 0 ? void 0 : r.id) === t.id && (c.recvTransport = void 0), ((s = c.sendTransport) === null || s === void 0 ? void 0 : s.id) === t.id && (c.sendTransport = void 0), t.closed || t.close());
  } }, { key: "getTransportById", value: function(e, t) {
    var r, s, c = this.getSoupServer(e);
    if (c) return ((r = c.recvTransport) === null || r === void 0 ? void 0 : r.id) === t ? c.recvTransport : ((s = c.sendTransport) === null || s === void 0 ? void 0 : s.id) === t ? c.sendTransport : void 0;
  } }, { key: "cleanConsumption", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            return l.next = 2, t.consumerPromise;
          case 2:
            if (s = l.sent, r === s) {
              l.next = 5;
              break;
            }
            return l.abrupt("return");
          case 5:
            this.consumptions.delete(t.producerId), this.emit("trackUnsubscribed", { appData: r.appData, consumerId: r.id, kind: r.kind, mediaStreamTrack: r.track, peerId: t.peerId, producerId: t.producerId, roomId: t.roomId });
          case 7:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "cleanProduction", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            return l.next = 2, t.producerPromise;
          case 2:
            if (s = l.sent, r === s) {
              l.next = 5;
              break;
            }
            return l.abrupt("return");
          case 5:
            this.productions.delete(t.track.id);
          case 6:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "cleanAllPublications", value: function(e) {
    var t = this;
    Array.from(this.publications.values()).filter(function(r) {
      return r.roomId === e;
    }).forEach(function(r) {
      t.publications.delete(r.producerId);
    });
  } }, { key: "subscribe", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l, u, d, f, p, m, b, h, g = this;
      return v().wrap(function(_) {
        for (; ; ) switch (_.prev = _.next) {
          case 0:
            return s = t.appData, c = t.kind, l = t.peerId, u = t.producerId, d = t.roomId, f = this.consumptions.get(u), p = !!f, f || (Ge("[subscribe#".concat(d, "] ").concat(c, "#").concat(u, " from ").concat(l)), m = function() {
              var y = R(v().mark(function C() {
                var S, P, T, I, k, x;
                return v().wrap(function(D) {
                  for (; ; ) switch (D.prev = D.next) {
                    case 0:
                      if (S = g.getSoupServer(d)) {
                        D.next = 3;
                        break;
                      }
                      throw new Error("soupServer is not ready");
                    case 3:
                      if (P = S.device, T = S.recvTransport, P) {
                        D.next = 6;
                        break;
                      }
                      throw new Error("device is not ready");
                    case 6:
                      if (T) {
                        D.next = 8;
                        break;
                      }
                      throw new Error("recvTransport is not ready");
                    case 8:
                      return D.next = 10, g.call(d, "call.consume", { kind: c, preferredLayers: r, producerId: u, rtpCapabilities: P.rtpCapabilities, transportId: T.id });
                    case 10:
                      return I = D.sent, k = I.params, D.next = 14, T.consume(Re(Re({}, k), {}, { appData: Re(Re({}, s), k.appData) }));
                    case 14:
                      return x = D.sent, g.addConsumerListeners(d, x), g.consumers.set(x.id, x), D.next = 19, g.call(d, "call.consumer.resume", { consumerId: x.id });
                    case 19:
                      return D.abrupt("return", x);
                    case 20:
                    case "end":
                      return D.stop();
                  }
                }, C);
              }));
              return function() {
                return y.apply(this, arguments);
              };
            }(), f = { consumerPromise: m(), peerId: l, producerId: u, roomId: d }, this.consumptions.set(u, f)), _.prev = 4, _.next = 7, f.consumerPromise;
          case 7:
            b = _.sent, _.next = 17;
            break;
          case 10:
            if (_.prev = 10, _.t0 = _.catch(4), this.consumptions.delete(u), !(this.getSoupServerStatus(d) !== "connected" && _.t0 instanceof vi.InvalidStateError)) {
              _.next = 16;
              break;
            }
            return console.warn("Cannot publish track ".concat(c, "#").concat(u, ". #").concat(d, ` is disconnected.
`).concat(_.t0.stack)), _.abrupt("return", void 0);
          case 16:
            throw _.t0;
          case 17:
            return h = { appData: b.appData, consumerId: b.id, kind: b.kind, mediaStreamTrack: b.track, peerId: l, producerId: u, roomId: d }, p || this.emit("trackSubscribed", h), _.abrupt("return", h);
          case 20:
          case "end":
            return _.stop();
        }
      }, e, this, [[4, 10]]);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "unsubscribe", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (r = t.producerId, s = this.consumptions.get(r)) {
              u.next = 4;
              break;
            }
            return u.abrupt("return");
          case 4:
            return this.consumptions.delete(r), u.next = 7, s.consumerPromise;
          case 7:
            c = u.sent, Ge("[unsubscribe#".concat(s.roomId, "] ").concat(c.kind, "#").concat(c.producerId, " from ").concat(s.peerId)), c.close();
          case 10:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "setPreferredLayers", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c, l;
      return v().wrap(function(d) {
        for (; ; ) switch (d.prev = d.next) {
          case 0:
            if (s = t.producerId, c = this.consumptions.get(s)) {
              d.next = 4;
              break;
            }
            return d.abrupt("return");
          case 4:
            return d.next = 6, c.consumerPromise;
          case 6:
            return l = d.sent, Ge("[setPreferredLayers#".concat(c.roomId, "] ").concat(l.kind, "#").concat(l.producerId, " from ").concat(c.peerId)), d.next = 10, this.call(c.roomId, "call.consumer.preferredlayer.change", { preferredLayers: r, consumerId: l.id });
          case 10:
          case "end":
            return d.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "publishTrack", value: function() {
    var n = R(v().mark(function e(t, r, s, c) {
      var l, u, d, f, p, m = this;
      return v().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            if (l = this.productions.get(r.id)) {
              h.next = 34;
              break;
            }
            return Ge("[publishTrack#".concat(t, "] ").concat(r.kind, "#").concat(r.id)), console.log({ encodings: c, track: r }), d = function() {
              var g = R(v().mark(function w() {
                var _, y;
                return v().wrap(function(S) {
                  for (; ; ) switch (S.prev = S.next) {
                    case 0:
                      if (_ = m.getSoupServer(t)) {
                        S.next = 3;
                        break;
                      }
                      throw new Error("soupServer is not ready");
                    case 3:
                      if (y = _.sendTransport) {
                        S.next = 6;
                        break;
                      }
                      throw new Error("sendTransport is not ready");
                    case 6:
                      return S.abrupt("return", y.produce({ appData: s, encodings: c, stopTracks: !1, track: r, codecOptions: { opusStereo: !0 } }));
                    case 7:
                    case "end":
                      return S.stop();
                  }
                }, w);
              }));
              return function() {
                return g.apply(this, arguments);
              };
            }(), l = { producerPromise: d(), roomId: t, track: r }, this.productions.set(r.id, l), h.prev = 7, h.next = 10, l.producerPromise;
          case 10:
            u = h.sent, h.next = 30;
            break;
          case 13:
            if (h.prev = 13, h.t0 = h.catch(7), this.productions.delete(r.id), !(this.getSoupServerStatus(t) !== "connected" && h.t0 instanceof vi.InvalidStateError)) {
              h.next = 19;
              break;
            }
            return console.warn("Cannot publish track ".concat(r.kind, "#").concat(r.id, ". #").concat(t, ` is disconnected.
`).concat(h.t0.stack)), h.abrupt("return", void 0);
          case 19:
            return h.prev = 19, h.next = 22, new Rs.Device()._handlerFactory().getNativeRtpCapabilities();
          case 22:
            f = h.sent, console.error({ nativeRtpCapabilities: f }), h.next = 29;
            break;
          case 26:
            h.prev = 26, h.t1 = h.catch(19), console.error(h.t1);
          case 29:
            throw h.t0;
          case 30:
            this.addProducerListeners(t, u), this.producers.set(u.id, u), h.next = 37;
            break;
          case 34:
            return h.next = 36, l.producerPromise;
          case 36:
            u = h.sent;
          case 37:
            return p = { appData: s, kind: r.kind, peerId: this.peerId, producerId: u.id, roomId: t }, h.abrupt("return", p);
          case 39:
          case "end":
            return h.stop();
        }
      }, e, this, [[7, 13], [19, 26]]);
    }));
    return function(t, r, s, c) {
      return n.apply(this, arguments);
    };
  }() }, { key: "unpublishTrack", value: function() {
    var n = R(v().mark(function e(t) {
      var r, s;
      return v().wrap(function(l) {
        for (; ; ) switch (l.prev = l.next) {
          case 0:
            if (r = this.productions.get(t.id)) {
              l.next = 3;
              break;
            }
            return l.abrupt("return");
          case 3:
            return this.productions.delete(t.id), l.next = 6, r.producerPromise;
          case 6:
            s = l.sent, Ge("[unpublishTrack#".concat(r.roomId, "] ").concat(s.kind, "#").concat(s.id)), s.close();
          case 9:
          case "end":
            return l.stop();
        }
      }, e, this);
    }));
    return function(t) {
      return n.apply(this, arguments);
    };
  }() }, { key: "updateTrack", value: function() {
    var n = R(v().mark(function e(t, r) {
      var s, c;
      return v().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (s = this.productions.get(t.id)) {
              u.next = 3;
              break;
            }
            return u.abrupt("return");
          case 3:
            return u.next = 5, s.producerPromise;
          case 5:
            return c = u.sent, Ge("[updateTrack#".concat(s.roomId, "] ").concat(c.kind, "#").concat(c.id)), Object.assign(c.appData, r || {}), u.next = 10, this.call(s.roomId, "call.producer.update", { producerId: c.id, appData: r });
          case 10:
          case "end":
            return u.stop();
        }
      }, e, this);
    }));
    return function(t, r) {
      return n.apply(this, arguments);
    };
  }() }, { key: "destroy", value: function() {
    var e = this;
    this.soupServers.forEach(function(t) {
      e.onSoupDisconnected({ roomId: t.roomId }), e.soupServers.delete(t.roomId);
    }), this.removeSoupSignalingListeners(), this.removeSoupConnectionListeners(), this.removeSignalingConnectionListeners(), this.removeAllListeners();
  } }]), i;
}();
const Vv = "/signaling";
let gi;
const Uv = async ({ baseUrl: o, options: a }) => (gi = `${o}${Vv}`, Rc(gi, a)), zv = () => {
  gi && Ic(gi);
};
async function Gv(o) {
  const a = await Uv(o), i = new Bv(a);
  return i.start(), i;
}
function qv(o) {
  o.destroy(), zv();
}
const Kv = ({ children: o }) => {
  const { getConnectionConfig: a } = $n(), [i, n] = re(
    /** @type {string[]} */
    []
  ), e = i.length > 0, [t, r] = re(
    /** @type {SoupSession | undefined} */
    void 0
  ), s = ne(
    /** @type {boolean} */
    !1
  );
  Q(() => {
    if (!e) return;
    function m() {
      r(this);
    }
    const b = () => {
      r(void 0);
    }, h = async ({ rtcPeerConnection: _, transport: y }) => {
      const C = Object.fromEntries(await y.getStats());
      console.error("Soup transport failed", { rtcPeerConnection: _, transport: y, stats: C });
    };
    let g;
    const w = () => {
      s.current = !0;
      try {
        b(), g && (g.off("connected", m), g.off("disconnected", b), g.off("transportFailed", h), qv(g));
      } catch (_) {
        console.error(_);
      }
    };
    return (async () => {
      try {
        s.current = !1, console.log("[joinSoup]");
        const _ = await a();
        if (s.current || (g = await Gv(_), s.current)) return;
        g.on("connected", m), g.on("disconnected", b), g.on("transportFailed", h), m.call(g);
      } catch (_) {
        console.error(_), w();
      }
    })(), w;
  }, [e, a]);
  const c = ne(
    /** @type {string[]} */
    i
  );
  Q(() => {
    if (!t) return;
    const m = i.filter((h) => !c.current.includes(h)), b = c.current.filter((h) => !i.includes(h));
    m.map(t.joinSoupServer), b.map(t.leaveSoupServer);
  }, [i, t]);
  const l = q(
    /**
    * @param {string[]} roomIds0
    * @returns {void}
    */
    (m) => {
      n((b) => {
        const h = m.filter((g) => !b.includes(g));
        return h.length === 0 ? b : Array.from(/* @__PURE__ */ new Set([...b, ...h]));
      });
    },
    []
  ), u = q(
    /**
    * @param {string[]} [roomIds0]
    * @returns {void}
    */
    (m) => {
      if (!m) {
        n((b) => b.length < 1 ? b : []);
        return;
      }
      n((b) => {
        if (m.length < 1) return b;
        const h = b.filter((g) => !m.includes(g));
        return h.length === b.length ? b : h;
      });
    },
    []
  ), [d, f] = re(
    /** @type {ISoupContext['publications']} */
    []
  );
  Q(() => {
    if (!t) return;
    const m = (_) => {
      f((y) => {
        const C = y.findIndex((S) => S.producerId === _.producerId);
        return C < 0 ? [...y, _] : [...y.slice(0, C), _, ...y.slice(C + 1)];
      });
    }, b = (_) => {
      f((y) => y.filter((C) => C.producerId !== _.producerId));
    }, h = (_) => {
      f((y) => y.map((C) => C.producerId === _.producerId ? _ : C));
    }, g = () => {
      t.publications.forEach(m);
    }, w = ({ roomId: _ }) => {
      f((y) => {
        const C = y.filter((S) => S.roomId !== _);
        return C.length === y.length ? y : C;
      });
    };
    return t.on("trackPublished", m), t.on("trackUnpublished", b), t.on("trackUpdated", h), t.on("soup:connected", g), t.on("soup:disconnected", w), function() {
      t.off("trackPublished", m), t.off("trackUnpublished", b), t.off("trackUpdated", h), t.off("soup:connected", g), t.off("soup:disconnected", w);
    };
  }, [t]);
  const p = W(() => ({ join: l, leave: u, publications: d, roomIds: i, soupSession: t }), [l, u, d, i, t]);
  return /* @__PURE__ */ V.jsx(cu.Provider, { value: p, children: o });
}, Hu = Xe(
  /** @type {IStudioSourceSettingsContext | undefined} */
  void 0
), Yu = () => {
  const o = Ze(Hu);
  if (!o)
    throw new Error("useStudioSources must be used within a StudioSourceSettingsProvider");
  return o;
}, iy = "default", sy = "ad", oy = "image", cy = "gfx", uy = "gfxvideo", fa = "participant", dy = "playlist", ly = "stream", py = "text", fy = "video", hy = "live", my = "participant", wc = pt(), Hv = ({ isController: o = !1 }) => {
  const { roomId: a, user: i } = $n(), { publications: n, soupSession: e } = Bn(), { screenshareActiveTracks: t } = fs(), { audioshareActiveTracks: r } = ms(), { videoshareActiveTracks: s } = Ci(), { imageshareActiveTracks: c } = Wc(), { enabledSourceOfferIds: l, config: u, configOverride: d } = Nn(), { userActiveTracks: f } = Fn(), { recipientUsers: p, talkbackActiveTrack: m } = vs(), b = Oi(u), h = Oi(d), g = Oi(p), { getSettingsBySource: w } = Yu(), _ = W(() => {
    const S = f.filter((I) => !!I).filter((I) => (m == null ? void 0 : m.originalTrackId) !== I.id).map((I) => {
      const k = { id: I.id, mediaStreamTrack: I };
      return l.includes(I.sourceOffer.id) && (k.isKeyTrack = !0, k.keyConfig = u, k.keyConfigOverride = d), k;
    }), P = m ? { id: m.id, mediaStreamTrack: m, talkback: { senderUserId: i.sub, receiverUserIds: p.map((I) => I._id) } } : null, T = (I) => ({ id: I.id, mediaStreamTrack: I });
    return [...S, ...P ? [P] : [], ...r.map(T), ...s.map(T), ...c.map(T), ...t.map(T)].map((I) => {
      var E, F;
      if ("talkback" in I || I.mediaStreamTrack.kind !== "audio") return I;
      const { mediaStreamTrack: k } = I, { sourceOffer: x } = k, O = !((F = (E = w({ id: x.id, type: fa })) == null ? void 0 : E.settings) != null && F.monitor), D = n.find((B) => B.appData.trackId === k.id), A = D ? D.appData.preventLarsens : O;
      return { ...I, preventLarsens: O, previousPreventLarsens: A };
    });
  }, [w, u, d, l, t, f, r, s, c, n, p, m, i]), [y, C] = re(
    /** @type {string | undefined} */
    void 0
  );
  return Q(() => {
    if (!e) return;
    const S = (I) => {
      I.roomId === a && C(a);
    }, P = (I) => {
      I.roomId === a && C(a);
    };
    e.on("soup:connected", S), e.on("soup:disconnected", P);
    const T = e.soupServers.get(a);
    return C((T == null ? void 0 : T.status) === "connected" ? a : void 0), () => {
      C(void 0), e.off("soup:connected", S), e.off("soup:disconnected", P);
    };
  }, [a, e]), Q(() => {
    if (!e || !y) return;
    const S = Array.from(e.productions.keys() || []), P = _.map(({ id: A }) => A), T = _.filter((A) => {
      var E;
      return S.includes(A.id) && (A.isKeyTrack && (A.keyConfig !== b || A.keyConfigOverride !== h) || A.preventLarsens !== A.previousPreventLarsens || A.talkback && ((E = A.talkback) == null ? void 0 : E.receiverUserIds) !== (g == null ? void 0 : g.map((F) => F._id)));
    }), I = P.filter((A) => !S.includes(A)), k = (A) => {
      if (A.kind !== "video" || ["videofile", "videoscreen"].includes(A.device.kind)) return;
      const { height: E } = A.firefoxFixCaptureSettings || A.getSettings();
      return vf(E);
    };
    console.log({ idsTracksToPublish: I });
    const x = (A) => !A || A.replacement.mode !== Lr.TRANSPARENT ? null : { color: A.replacement.transparentColor, sensitivity: A.replacement.transparentColorSensitivity }, O = (A, E) => A.kind === "video" ? !1 : !!E;
    I.forEach((A) => {
      const E = _.find(({ id: ke }) => ke === A);
      if (!E) return;
      const { keyConfig: F, keyConfigOverride: B, preventLarsens: $, talkback: M } = E, j = E.mediaStreamTrack, z = "sourceOffer" in j, te = z ? j.configId : void 0, ee = z ? j.device : void 0, Y = z ? j.sourceOffer.subType : void 0, Z = z ? O(j, $) : $, ae = z ? k(j) : void 0, oe = x(B || F), ce = { avatar: i.picture, nickname: i.nickname, userId: i.sub };
      console.log("PUBLISH", { alphaColor: oe, computerId: wc, configId: te, device: ee, preventLarsens: Z, talkback: M, sourceStreamType: Y, user: ce, mediaStreamTrack: j }), e.publishTrack(y, j, { alphaColor: oe, computerId: wc, configId: te, device: ee, preventLarsens: Z, sourceStreamType: Y, trackId: j.id, talkback: M, user: ce }, ae);
    }), T.forEach((A) => {
      const { keyConfig: E, keyConfigOverride: F, preventLarsens: B, talkback: $ } = A, M = (
        /** @type {SourceParticipantOfferTrack} */
        A.mediaStreamTrack
      ), j = O(M, B), z = x(F || E);
      console.log("UPDATE", { preventLarsens: j, alphaColor: z, talkback: $, mediaStreamTrack: M }), e.updateTrack(M, { preventLarsens: j, alphaColor: z, talkback: $ });
    }), S.filter((A) => !P.includes(A)).forEach((A) => {
      console.log("UNPUBLISH", { trackId: A }), e.unpublishTrack({ id: A });
    });
  }, [o, u, b, h, _, t, i, s, c, r, m, g, y, e]), null;
}, Wu = "beeyou_studioSourceSettings", Xu = 1, Yv = () => {
  const o = localStorage.getItem(Wu);
  if (o)
    try {
      const a = JSON.parse(o);
      return a.__version !== Xu ? void 0 : a.studioSourceSettings;
    } catch (a) {
      console.error("Error parsing local storage value", a);
      return;
    }
}, Wv = () => Yv() || { sourceSettings: [] }, Ga = Wv(), Xv = (o) => {
  localStorage.setItem(Wu, JSON.stringify({ studioSourceSettings: o, __version: Xu }));
}, Zv = (o) => o === Ot.CONFIG || o === Ot.SCREENSHARE ? { monitor: !1 } : { monitor: !0 }, Qv = ({ children: o }) => {
  const [a, i] = re(
    /** @type {() => IStudioSourceSettingsContext['sourceSettings']} */
    () => Ga == null ? void 0 : Ga.sourceSettings
  ), { sources: n } = en(), e = q(
    /** @type {IStudioSourceSettingsContext['getSettingsBySource']} */
    (s) => {
      const c = a.find((u) => u.id === s.id && u.type === s.type), l = s.type === fa ? n.find((u) => u.id === s.id) : void 0;
      return l ? { id: s.id, type: s.type, settings: { ...Zv(l.subType), ...c == null ? void 0 : c.settings } } : c;
    },
    [n, a]
  ), t = q(
    /** @type {IStudioSourceSettingsContext['updateSettingsBySource']} */
    (s, c) => {
      i((l) => {
        const u = l.findIndex((f) => f.id === s.id && f.type === s.type);
        if (u === -1)
          return [...l, { id: s.id, type: s.type, settings: c }];
        const d = l[u];
        return [...l.slice(0, u), { ...d, settings: { ...d.settings, ...c } }, ...l.slice(u + 1)];
      });
    },
    []
  );
  Q(() => {
    Ga.sourceSettings !== a && Xv({ sourceSettings: a });
  }, [a]);
  const r = W(() => ({ getSettingsBySource: e, sourceSettings: a, updateSettingsBySource: t }), [e, a, t]);
  return console.log({ StudioSourceSettingsContext: r }), /* @__PURE__ */ V.jsx(Hu.Provider, { value: r, children: o });
}, Jv = ({ children: o, Component: a, isController: i, ...n }) => i ? /* @__PURE__ */ V.jsx(a, { ...n, children: o }) : o, vy = ({ children: o, getConnectionConfig: a, hashtag: i, isController: n = !1, roomId: e, user: t }) => /* @__PURE__ */ V.jsx(Dp, { getConnectionConfig: a, isController: n, roomId: e, user: t, children: /* @__PURE__ */ V.jsx(Qv, { children: /* @__PURE__ */ V.jsxs(Kv, { children: [
  /* @__PURE__ */ V.jsx(Hv, { isController: n }),
  /* @__PURE__ */ V.jsx(gs, { isController: n, children: /* @__PURE__ */ V.jsx(yu, { children: /* @__PURE__ */ V.jsx(au, { children: /* @__PURE__ */ V.jsx(ys, { children: /* @__PURE__ */ V.jsx(mu, { children: /* @__PURE__ */ V.jsx(_u, { children: /* @__PURE__ */ V.jsx(xu, { children: /* @__PURE__ */ V.jsx(Kp, { children: /* @__PURE__ */ V.jsx(pu, { children: /* @__PURE__ */ V.jsx(du, { hashtag: i, children: /* @__PURE__ */ V.jsx(Jv, { Component: df, isController: n, children: /* @__PURE__ */ V.jsx(Cu, { children: o }) }) }) }) }) }) }) }) }) }) }) })
] }) }) });
var Zu = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Sc = yr.createContext && /* @__PURE__ */ yr.createContext(Zu), eg = ["attr", "size", "title"];
function tg(o, a) {
  if (o == null) return {};
  var i = rg(o, a), n, e;
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(o);
    for (e = 0; e < t.length; e++)
      n = t[e], !(a.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(o, n) && (i[n] = o[n]);
  }
  return i;
}
function rg(o, a) {
  if (o == null) return {};
  var i = {};
  for (var n in o)
    if (Object.prototype.hasOwnProperty.call(o, n)) {
      if (a.indexOf(n) >= 0) continue;
      i[n] = o[n];
    }
  return i;
}
function yi() {
  return yi = Object.assign ? Object.assign.bind() : function(o) {
    for (var a = 1; a < arguments.length; a++) {
      var i = arguments[a];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (o[n] = i[n]);
    }
    return o;
  }, yi.apply(this, arguments);
}
function Cc(o, a) {
  var i = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(o);
    a && (n = n.filter(function(e) {
      return Object.getOwnPropertyDescriptor(o, e).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function bi(o) {
  for (var a = 1; a < arguments.length; a++) {
    var i = arguments[a] != null ? arguments[a] : {};
    a % 2 ? Cc(Object(i), !0).forEach(function(n) {
      ng(o, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(i)) : Cc(Object(i)).forEach(function(n) {
      Object.defineProperty(o, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return o;
}
function ng(o, a, i) {
  return a = ag(a), a in o ? Object.defineProperty(o, a, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : o[a] = i, o;
}
function ag(o) {
  var a = ig(o, "string");
  return typeof a == "symbol" ? a : a + "";
}
function ig(o, a) {
  if (typeof o != "object" || !o) return o;
  var i = o[Symbol.toPrimitive];
  if (i !== void 0) {
    var n = i.call(o, a || "default");
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (a === "string" ? String : Number)(o);
}
function Qu(o) {
  return o && o.map((a, i) => /* @__PURE__ */ yr.createElement(a.tag, bi({
    key: i
  }, a.attr), Qu(a.child)));
}
function Ca(o) {
  return (a) => /* @__PURE__ */ yr.createElement(sg, yi({
    attr: bi({}, o.attr)
  }, a), Qu(o.child));
}
function sg(o) {
  var a = (i) => {
    var {
      attr: n,
      size: e,
      title: t
    } = o, r = tg(o, eg), s = e || i.size || "1em", c;
    return i.className && (c = i.className), o.className && (c = (c ? c + " " : "") + o.className), /* @__PURE__ */ yr.createElement("svg", yi({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, i.attr, n, r, {
      className: c,
      style: bi(bi({
        color: o.color || i.color
      }, i.style), o.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), t && /* @__PURE__ */ yr.createElement("title", null, t), o.children);
  };
  return Sc !== void 0 ? /* @__PURE__ */ yr.createElement(Sc.Consumer, null, (i) => a(i)) : a(Zu);
}
function og(o) {
  return Ca({ tag: "svg", attr: { viewBox: "0 0 352 512" }, child: [{ tag: "path", attr: { d: "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z" }, child: [] }] })(o);
}
function cg(o) {
  return Ca({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" }, child: [] }] })(o);
}
function ug(o) {
  return Ca({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z" }, child: [] }] })(o);
}
function dg(o) {
  return Ca({ tag: "svg", attr: { viewBox: "0 0 576 512" }, child: [{ tag: "path", attr: { d: "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z" }, child: [] }] })(o);
}
const Ce = { width: 1920, height: 1080 }, lg = (o) => o === "main" || /^pip\d$/.test(o), Pi = ({ layers: o, layerBounds: a, showLabels: i }) => {
  const n = o.map((e) => {
    const { x: t, y: r, width: s, height: c } = e.layerConfig;
    return { ...e, x: t / a.width * 100, y: r / a.height * 100, width: s / a.width * 100, height: c / a.height * 100 };
  });
  return /* @__PURE__ */ V.jsx("div", { className: "PipLayout position-relative w-100 h-100", children: n.map((e) => /* @__PURE__ */ V.jsx("div", { className: "position-absolute opacity-8 bg-second content-second d-flex justify-content-center align-items-center border border-dark rounded rounded-1", style: { left: `${e.x}%`, top: `${e.y}%`, width: `${e.width}%`, height: `${e.height}%` }, children: i && e.layer }, e.layer)) });
};
Pi.propTypes = { layerBounds: N.shape({ width: N.number.isRequired, height: N.number.isRequired }), layers: N.arrayOf(N.shape({ layer: N.string.isRequired, layerConfig: N.shape({ x: N.number.isRequired, y: N.number.isRequired, width: N.number.isRequired, height: N.number.isRequired }).isRequired })), showLabels: N.bool };
Pi.defaultProps = { layerBounds: Ce, layers: [], showLabels: !1 };
const Ts = ({ layerBounds: o, layersOverrides: a, layoutDefaults: i, showLabels: n }) => {
  const t = W(() => {
    const { layers: r } = i;
    return r.map((s, c) => ({ layer: c === 0 ? "main" : `pip${c}`, layerConfig: { x: s.x, y: s.y, width: s.width, height: s.height } }));
  }, [i]).map((r) => {
    const s = a.find((c) => c.layer === r.layer);
    return s || r;
  });
  return /* @__PURE__ */ V.jsx(Pi, { layerBounds: o, layers: t, showLabels: n });
};
Ts.propTypes = { layerBounds: N.shape({ width: N.number.isRequired, height: N.number.isRequired }), layersOverrides: N.arrayOf(N.shape({ layer: N.string.isRequired, layerConfig: N.shape({ x: N.number.isRequired, y: N.number.isRequired, width: N.number.isRequired, height: N.number.isRequired }).isRequired })), layoutDefaults: N.shape({ layers: N.arrayOf(N.shape({ x: N.number.isRequired, y: N.number.isRequired, width: N.number.isRequired, height: N.number.isRequired })).isRequired }).isRequired, showLabels: N.bool };
Ts.defaultProps = { layerBounds: Ce, layersOverrides: [], showLabels: !1 };
const pg = (o) => {
  const { channelMixerStatus: a } = lr(), i = (a == null ? void 0 : a.displayMode) ?? Tn, n = iu[(a == null ? void 0 : a.orientation) || "LANDSCAPE"], e = W(() => Op(n)[i], [n, i]), t = W(() => {
    const { layers: r } = e, s = r.map((u, d) => ({ layer: d === 0 ? "main" : `pip${d}`, layerConfig: { x: u.x, y: u.y, width: u.width, height: u.height } })), c = Object.entries((a == null ? void 0 : a.layersConfig) || {}).filter(([u]) => lg(u)).map(([u, d]) => ({ layer: u, layerConfig: d })).filter((u) => {
      const d = s.find((f) => f.layer === u.layer);
      return d ? d.layerConfig.x !== u.layerConfig.x || d.layerConfig.y !== u.layerConfig.y || d.layerConfig.width !== u.layerConfig.width || d.layerConfig.height !== u.layerConfig.height : !1;
    });
    return s.map((u) => c.find((f) => f.layer === u.layer) || void 0).filter(Boolean);
  }, [a == null ? void 0 : a.layersConfig, e]);
  return /* @__PURE__ */ V.jsx(Ts, { ...o, layerBounds: n, layersOverrides: t, layoutDefaults: e });
}, fg = () => /* @__PURE__ */ V.jsx("div", { className: "PipLayout position-relative w-100", style: { aspectRatio: "16/9" }, children: /* @__PURE__ */ V.jsx("div", { className: "position-absolute opacity-8 bg-second content-second d-flex justify-content-center align-items-center border border-dark rounded rounded-1", style: { left: "0%", top: "0%", width: "100%", height: "100%" }, children: /* @__PURE__ */ V.jsx(og, { size: "2em" }) }) }), Er = na(Ce.width, Ce.height), hg = [{ layer: "TOP_LEFT", layerConfig: { x: Er.horizontal, y: Er.vertical, width: Math.floor(Ce.width * (1 / 3.5)), height: Math.floor(Ce.height * (1 / 3.5)) } }, { layer: "TOP_RIGHT", layerConfig: { x: Ce.width - Math.floor(Ce.width * (1 / 3.5)) - Er.horizontal, y: Er.vertical, width: Math.floor(Ce.width * (1 / 3.5)), height: Math.floor(Ce.height * (1 / 3.5)) } }, { layer: "CENTER", layerConfig: { x: Ce.width / 2 - Math.floor(Ce.width * (1 / 3.5) / 2), y: Ce.height / 2 - Math.floor(Ce.height * (1 / 3.5) / 2), width: Math.floor(Ce.width * (1 / 3.5)), height: Math.floor(Ce.height * (1 / 3.5)) } }, { layer: "BOTTOM_LEFT", layerConfig: { x: Er.horizontal, y: Ce.height - Math.floor(Ce.height * (1 / 3.5)) - Er.vertical, width: Math.floor(Ce.width * (1 / 3.5)), height: Math.floor(Ce.height * (1 / 3.5)) } }, { layer: "BOTTOM_RIGHT", layerConfig: { x: Ce.width - Math.floor(Ce.width * (1 / 3.5)) - Er.horizontal, y: Ce.height - Math.floor(Ce.height * (1 / 3.5)) - Er.vertical, width: Math.floor(Ce.width * (1 / 3.5)), height: Math.floor(Ce.height * (1 / 3.5)) } }], mg = () => /* @__PURE__ */ V.jsx(Pi, { layers: hg }), vg = /(?:pip)(\d+)$/, Ju = (o) => {
  if (o === "main" || o === "audioShare") return 0;
  const a = vg.exec(o);
  return (a == null ? void 0 : a.length) === 2 ? parseInt(a[1], 10) : null;
}, gg = 4 * 1e3, yg = 100, Yt = (o) => {
  const a = ["main"];
  for (let i = 1; i < o; i += 1)
    a.push(`pip${i}`);
  return a;
}, bg = { DEFAULT_MODE: { layers: Yt(3) }, HALF_RATIO: { layers: Yt(2) }, HALF_THIRD_THIRD: { layers: Yt(3) }, CENTER_ALL_BOTTOM: { layers: Yt(6) }, CENTER_ALL_RIGHT: { layers: Yt(5) }, MOSAIC_QUAD: { layers: Yt(4) }, MOSAIC_SIX: { layers: Yt(6) }, MOSAIC_TWELVE: { layers: Yt(12) }, MOSAIC_SIXTEEN: { layers: Yt(16) }, FULL_CANVAS: { layers: Yt(1) }, AUCTION: { layers: Yt(5) } }, ed = ({ alwaysShowButtons: o, displayMode: a, isAudio: i, liveLayerOfSource: n, onHover: e, setSourceOnLayer: t }) => {
  const [r, s] = re(o), c = ne(), l = ne(), u = W(() => bg[a], [a]), d = q((g, w) => {
    g.stopPropagation(), t(w), Pt && (s(o), e(!1));
  }, [o, e, t]);
  Q(() => {
    if (c.current) {
      const g = (C) => {
        const { target: { index: S } } = C;
        d(C, u.layers[S]);
      }, w = c.current;
      if (!w) return;
      const y = w.querySelector(".PipLayout").childNodes;
      return y.forEach((C, S) => {
        Ju(n) === S ? C.classList.add("pipActive") : C.classList.remove("pipActive"), a === Tn && S > 0 && (C.style.opacity = 0.75), C.index = S, C.classList.add("SourceCardPipSelectorInMode"), C.addEventListener("click", g);
      }), () => {
        y.forEach((C) => {
          C.removeEventListener("click", g);
        });
      };
    }
  }, [d, n, u, a, r]), Q(() => () => {
    clearTimeout(l.current);
  }, []);
  const f = ne(), p = () => {
    e(!0), s(!0);
  }, m = () => {
    clearTimeout(f.current), f.current = setTimeout(() => {
      p();
    }, yg);
  };
  Q(() => () => {
    clearTimeout(f.current);
  }, []);
  const b = () => {
    clearTimeout(f.current), e(!1), s(o);
  }, h = (g) => {
    g.stopPropagation(), clearTimeout(l.current), clearTimeout(f.current), l.current = setTimeout(() => {
      s(o), e(!1);
    }, gg), s(!0), e(!0);
  };
  return /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
    /* @__PURE__ */ V.jsx("div", { className: "position-absolute h-100 w-100" }),
    a && /* @__PURE__ */ V.jsx("div", { className: "SourceCardPipSelectorWrapper position-absolute overflow-hidden h-100 w-100", onClick: h, onMouseLeave: Pt ? void 0 : b, onMouseOverCapture: Pt ? void 0 : m, children: r && /* @__PURE__ */ V.jsx("div", { className: St("d-flex p-1 w-100 h-100 align-items-center justify-content-center"), ref: c, children: /* @__PURE__ */ V.jsx("div", { className: "h-100", style: { aspectRatio: "16/9" }, children: i ? /* @__PURE__ */ V.jsx(fg, {}) : a === "AUCTION" ? /* @__PURE__ */ V.jsx(mg, {}) : /* @__PURE__ */ V.jsx(pg, { layout: a }) }) }) })
  ] });
};
ed.propTypes = { alwaysShowButtons: N.bool, displayMode: N.string, isAudio: N.bool, liveLayerOfSource: N.string, onHover: N.func.isRequired, setSourceOnLayer: N.func.isRequired };
ed.defaultProps = { alwaysShowButtons: !1, displayMode: void 0, isAudio: !1, liveLayerOfSource: void 0 };
const gy = (o) => {
  const { join: a, leave: i } = Bn();
  Q(() => () => {
    i();
  }, [i]), Q(() => {
    o && a([o]);
  }, [a, o]);
}, td = ({ videoRef: o, onClick: a }) => {
  const i = ne(null), n = ne(null), e = W(() => ({ x: 15, y: -15 }), []);
  return Q(() => {
    i.current || (i.current = document.createElement("canvas"));
    let t, r, s = [0, 0, 0], c;
    const l = o.current, u = i.current, d = n.current;
    if (l) {
      u.width = l.offsetWidth, u.height = l.offsetHeight;
      const f = () => {
        const p = u.getContext("2d");
        p.drawImage(l, 0, 0, u.width, u.height), s = p.getImageData((c == null ? void 0 : c.x) || 0, (c == null ? void 0 : c.y) || 0, 1, 1).data, p.clearRect(0, 0, u.width, u.height);
      };
      t = () => {
        f(), a(s[0], s[1], s[2]);
      }, r = ({ layerX: p, layerY: m }) => {
        f(), c = { x: p, y: m }, d.style.left = `${p - e.x}px`, d.style.top = `${m - e.y}px`;
        const b = d.getContext("2d");
        b.fillStyle = `rgb(${s[0]}, ${s[1]}, ${s[2]})`, b.fillRect(0, 0, d.width, d.height), b.lineWidth = 2, b.strokeStyle = "black", b.strokeRect(0, 0, d.width, d.height);
      }, l.addEventListener("mousemove", r), l.addEventListener("click", t);
    }
    return () => {
      t && l.removeEventListener("click", t), r && l.removeEventListener("mousemove", r), u && (u.remove(), i.current = void 0);
    };
  }, [a, o, e]), /* @__PURE__ */ V.jsx("canvas", { className: "position-absolute", ref: n, width: 10, height: 10 });
};
td.propTypes = { videoRef: N.shape({ current: N.instanceOf(Element) }).isRequired, onClick: N.func.isRequired };
const ka = ({ children: o, className: a }) => /* @__PURE__ */ V.jsx("div", { className: St("ratio ratio-16x9 overflow-hidden zIndex-0", a), children: o }), rd = ({ className: o, text: a }) => {
  const i = ne(), n = W(() => {
    const { layerConfig: e } = a, t = e.width / Ce.width, r = e.height / Ce.height, s = e.x / Ce.width, c = e.y / Ce.height;
    return { left: `${s * 100}%`, top: `${c * 100}%`, width: `${t * 100}%`, height: `${r * 100}%` };
  }, [a]);
  return Q(() => {
    const e = i.current.getContext("2d");
    i.current.width = a.layerConfig.width, i.current.height = a.layerConfig.height, vu(a, e);
  }, [a]), /* @__PURE__ */ V.jsx("div", { className: o, style: { zIndex: -1 }, children: /* @__PURE__ */ V.jsx(ka, { children: /* @__PURE__ */ V.jsx("canvas", { style: { zIndex: 1, maxWidth: "100%", maxHeight: "100%", ...n }, className: "position-absolute", ref: i }) }) });
};
rd.propTypes = { className: N.string, text: N.shape({ text: N.string, backgroundColor: N.string, backgroundTransparency: N.number, layerConfig: N.shape({ width: N.number, height: N.number, x: N.number, y: N.number }) }).isRequired };
rd.defaultProps = { className: void 0 };
const nd = (o) => `00${Math.floor(o / 60)}`.slice(-2), ad = (o) => `00${Math.floor(o) % 60}`.slice(-2), yy = ({ className: o = "", duration: a, imageLayerConfig: i = { x: 0, y: 0, width: Ce.width, height: Ce.height }, noDuration: n = !1, src: e, ...t }) => {
  const [r, s] = re(!!e);
  Q(() => {
    e && s(!0);
  }, [e]);
  const c = W(() => {
    const l = i.width / Ce.width, u = i.height / Ce.height, d = i.x / Ce.width, f = i.y / Ce.height;
    return { left: `${d * 100}%`, top: `${f * 100}%`, width: `${l * 100}%`, height: `${u * 100}%` };
  }, [i]);
  return /* @__PURE__ */ V.jsx("div", { className: St("PreviewImage", o), children: /* @__PURE__ */ V.jsxs(ka, { children: [
    r && /* @__PURE__ */ V.jsx("img", { className: "position-absolute", onError: () => s(!1), style: { zIndex: 1, maxWidth: "100%", maxHeight: "100%", objectFit: "contain", ...c }, src: e, ...t }),
    Number.isFinite(a) && !n && /* @__PURE__ */ V.jsxs("span", { className: "Preview_duration", children: [
      nd(a),
      ":",
      ad(a)
    ] })
  ] }) });
}, { MediaStream: cs } = window, _g = { autoPlay: N.bool, className: N.string, controls: N.bool, cover: N.bool, duration: N.number, muted: N.bool, noDuration: N.bool, noTimeline: N.bool, preload: N.oneOf(["auto", "metadata", "none"]), src: N.oneOfType([N.string, N.instanceOf(cs)]), volume: N.number, allowColorPicking: N.bool, onPickColor: N.func, videoLayerConfig: N.shape({ x: N.number, y: N.number, width: N.number, height: N.number }) }, wg = { autoPlay: !1, className: "", controls: !1, cover: !1, duration: void 0, muted: !1, noDuration: !1, noTimeline: !1, preload: "metadata", src: null, volume: 100, allowColorPicking: !1, onPickColor: void 0, videoLayerConfig: { x: 0, y: 0, width: Ce.width, height: Ce.height } }, Ds = ({ autoPlay: o, className: a, controls: i, cover: n, duration: e, muted: t, noDuration: r, noTimeline: s, preload: c, src: l, volume: u, allowColorPicking: d, onPickColor: f, videoLayerConfig: p, ...m }) => {
  const [b, h] = re(), [g, w] = re(!1), _ = ne(null);
  typeof l == "string" && (l = `${l}#t=0.1`), Q(() => {
    l instanceof cs ? _.current.srcObject !== l && (_.current.srcObject = l) : _.current.srcObject = void 0, l || w(!1);
  }, [l]);
  const y = q((D) => {
    h(D.target.duration);
  }, []), C = q(() => {
    w(!1);
  }, []), S = q(() => {
    w(!0);
  }, []), P = l && l instanceof cs;
  Q(() => {
    const D = _.current;
    return () => {
      D && (D.srcObject = void 0);
    };
  }, []);
  const T = ne(l);
  Q(() => {
    T.current = l;
  }), Q(() => {
    o && T.current && _.current.play().catch((D) => console.warn(D));
  }, [o]);
  const I = ne(t);
  ta(() => {
    I.current = t;
  }, [t]);
  const k = ne(i);
  ta(() => {
    k.current = i;
  }, [i]), Q(() => {
    if (P) {
      const D = () => {
        _.current && (_.current.controls = !1, _.current.muted = !0, setTimeout(() => {
          _.current && (_.current.controls = !!k.current, _.current.muted = !!I.current);
        }));
      };
      return l.addEventListener("addtrack", D), l.addEventListener("removetrack", D), () => {
        l.removeEventListener("addtrack", D), l.removeEventListener("removetrack", D);
      };
    }
  }, [P, l]), Q(() => {
    _.current && (_.current.volume = (u > 100 ? 100 : u) / 100);
  }, [u]);
  const x = W(() => {
    const D = p.width / Ce.width, A = p.height / Ce.height, E = p.x / Ce.width, F = p.y / Ce.height;
    return { left: `${E * 100}%`, top: `${F * 100}%`, width: `${D * 100}%`, height: `${A * 100}%` };
  }, [p]), O = Math.floor(e ?? b ?? 0);
  return /* @__PURE__ */ V.jsxs(ka, { className: St("Preview", { cover: n, isPlaying: g, noTimeline: s, paused: !g }, a), ...m, children: [
    d && /* @__PURE__ */ V.jsx(td, { videoRef: _, onClick: f }),
    /* @__PURE__ */ V.jsxs("div", { className: "Preview_container", children: [
      /* @__PURE__ */ V.jsx("video", { className: "position-absolute", style: x, autoPlay: o, controls: i, muted: t, controlsList: "nodownload", onLoadedMetadata: y, onPause: C, onPlaying: S, playsInline: !0, preload: c, ref: _, src: P ? null : l }),
      !i && !r && Number.isFinite(O) && O > 0 && /* @__PURE__ */ V.jsxs("span", { className: "Preview_duration", children: [
        nd(O),
        ":",
        ad(O)
      ] })
    ] })
  ] });
};
Ds.propTypes = _g;
Ds.defaultProps = wg;
const id = xc(Ds), sd = ({ className: o, src: a, ...i }) => {
  const n = ne(
    /** @type {HTMLVideoElement?} */
    null
  );
  return Q(() => {
    const e = n.current;
    if (!e || !a) return;
    if (!Ti.isSupported()) {
      console.error(new Error("Hls not supported."));
      return;
    }
    const t = new Ti({
      autoStartLoad: !0,
      // TODO: Check if live config is used or not
      live: !0,
      liveSyncDurationCount: 2,
      liveMaxLatencyDurationCount: 5,
      maxLiveSyncPlaybackRate: 1.5,
      lowLatencyMode: !0,
      startPosition: -1
    });
    return t.on(Ti.Events.MEDIA_ATTACHED, () => {
      t.loadSource(a);
    }), t.attachMedia(e), () => {
      t.destroy();
    };
  }, [a]), /* @__PURE__ */ V.jsx(ka, { className: St("PlayerStream", o), children: /* @__PURE__ */ V.jsx("video", { className: "w-100 h-100", ref: n, ...i }) });
};
sd.propTypes = { className: N.string, src: N.string.isRequired };
sd.defaultProps = { className: void 0 };
const Sg = ({ publication: o }) => {
  const a = ne(
    /** @type {HTMLAudioElement | null} */
    null
  ), i = W(() => o ? [{ publication: o }] : [], [o]), n = xi(i);
  return ta(() => {
    !a.current || !n || (a.current.srcObject = n, a.current.play());
  }, [n]), /* @__PURE__ */ V.jsx("audio", { autoPlay: !0, className: "d-none", ref: a });
}, by = () => {
  const { talkbackReceivingSources: o } = _s();
  return o.map((a) => /* @__PURE__ */ V.jsx(Sg, { publication: a }, a.producerId));
}, _y = ({ userOnly: o }) => {
  const { userMediastreams: a } = Fn(), i = W(() => a.filter((c) => c.getVideoTracks().length > 0), [a]), { screenshareMediastream: n } = fs(), { videoshareMediastream: e } = Ci(), { imageshareMediastream: t } = Wc(), { audioshareMediastream: r } = ms(), s = W(() => o ? i.find(({ configId: c }) => c === 0) : n || e || t || r || i.find(({ configId: c }) => c === 0), [i, n, e, t, r, o]);
  return W(() => ({ previewMediastrearm: s }), [s]);
}, Cg = (o, a) => {
  const [i, n] = re(""), e = ne(null);
  return Q(() => {
    if (o < 0 || o > 999) return;
    const t = ({ code: r, key: s, target: { tagName: c } }) => {
      if (c === "INPUT" || c === "TEXTAREA") return;
      let l;
      r.startsWith("Digit") || r.startsWith("Numpad") ? l = parseInt(r.replace(/^(Digit|Numpad)/, ""), 10) : /^[0-9]$/.test(s) && (l = parseInt(s, 10)), !(Number.isNaN(l) || !Number.isFinite(l)) && (l >= 0 && l <= 9 && n((u) => {
        const d = u + l, f = parseInt(d, 10);
        return e.current && clearTimeout(e.current), e.current = setTimeout(() => {
          n(""), f === o && a();
        }, 500), d;
      }), r === "Escape" && (n(""), e.current && clearTimeout(e.current)));
    };
    return document.addEventListener("keydown", t), () => {
      document.removeEventListener("keydown", t), e.current && clearTimeout(e.current);
    };
  }, [o, a]), i;
}, kc = (o, a) => o !== void 0 && a !== void 0 && o !== a, kg = (o) => o.kind === "audiofile" || o.kind === "audioinput" || o.kind === "audioscreen", xg = (o) => o.kind === "videofile" || o.kind === "videoinput" || o.kind === "videoscreen", wy = ({ avatarAssetId: o, defaultSpeed: a, defaultVideoLooping: i, defaultProgressTime: n, duration: e, handleVideoShareTimeCodes: t, isAudio: r, isGfx: s, isVideo: c, shortCutIndex: l, source: u, sourceObject: d, text: f }) => {
  var fr, $r, kr, Br;
  const { clearLayer: p, isConnected: m, setSource: b, setSourceMuted: h, setSourceVolume: g, channelMixerStatus: w, setSourceTimecodes: _, setSourceSpeed: y, setSourceProgresstime: C, notifyToggleLoopVideoSource: S } = lr(), { displayMode: P } = ou(), [T, I] = re(!1), [k, x] = re(), [O, D] = re(!1), { updateSourceProperties: A } = Iu(), [E, F] = re(a);
  Q(() => {
    F(a);
  }, [a]);
  const [B, $] = re(n);
  Q(() => {
    $(n);
  }, [n]);
  const [M, j] = re(i);
  Q(() => {
    j(i);
  }, [i]);
  const [z, te] = re([0, e]), ee = w == null ? void 0 : w.sources, Y = u == null ? void 0 : u.sourceId, Z = u == null ? void 0 : u.type, ae = W(() => {
    if (!(!ee || !Y))
      return ee.find(({ id: he }) => he === Y);
  }, [ee, Y]), oe = ae == null ? void 0 : ae.layer, ce = cf(Y && { id: Y, type: Z }), ke = oe === `overlay_${Y}`, Oe = oe === "main", nt = oe == null ? void 0 : oe.includes("pip"), et = oe == null ? void 0 : oe.includes("audioShare"), Fe = oe && Ju(oe), $e = c && (ae == null ? void 0 : ae.isOnLive) || !1, at = m && (ae == null ? void 0 : ae.isAudioOnLive) || !1, vt = Oe || nt || r && at, gt = q(() => {
    j((he) => !he), S(u);
  }, [S, u]), it = q((he) => {
    const Ue = [parseFloat(he[0]), parseFloat(he[1])];
    Number.isFinite(Ue[0]) && Number.isFinite(Ue[1]) && (te(Ue), t && t(Ue[0], Ue[1]));
  }, [t]), Ie = ne();
  Q(() => () => {
    clearTimeout(Ie.current);
  }, []);
  const ut = q((he) => {
    Ie.current && clearTimeout(Ie.current), Ie.current = setTimeout(() => {
      x(void 0);
    }, 1e4), x(he);
  }, []), qe = ((fr = ce == null ? void 0 : ce.properties) == null ? void 0 : fr.muted) ?? !1, H = (($r = ce == null ? void 0 : ce.properties) == null ? void 0 : $r.volume) ?? 100, ue = q(async (he) => {
    if (k) return;
    const Ue = he === "overlay" ? `overlay_${Y}` : he;
    if (he === `pip${Fe}` && nt || he === "overlay" && ke || he === "main" && Oe) {
      const Kt = Ue === `pip${Fe}` ? "pip" : Ue;
      ut(`clear_${Kt}`), await p(Ue);
      return;
    }
    ut(`set_${Ue}`), await b({ id: Y, type: Z, layerConfig: u.layerConfig, avatarAssetId: o, options: { groupId: u.groupId, isVideoLooping: M, muted: qe, sourceObject: d, timeCodes: z, videoSpeed: E, volume: H } }, Ue);
  }, [o, p, nt, ke, Oe, qe, Fe, d, b, ut, Y, Z, z, H, u, k, M, E]);
  Q(() => {
    k && (k === "set_main" && Oe || k === `set_pip${Fe}` && nt || k === `set_overlay_${Y}` && ke || k === "clear_main" && !Oe || k === "clear_pip" && !nt || k === `clear_overlay_${Y}` && !ke || Fe === 0 && !k.includes("set")) && (Ie.current && clearTimeout(Ie.current), x(void 0));
  }, [Oe, nt, k, ke, Fe, Y, f]), Q(() => {
    if (!O && (w != null && w.sources) && $e) {
      const he = w == null ? void 0 : w.sources.find((Ue) => Ue.id === Y);
      he && (D(!0), he.sourceVideo && te(he.sourceVideo.timecodes));
    }
  }, [w == null ? void 0 : w.sources, m, c, $e, O, Y]);
  const Ve = ae, Tt = Ve == null ? void 0 : Ve.muted, It = Ve == null ? void 0 : Ve.volume, Ct = ne(Tt), br = ne(It);
  Q(() => {
    Ct.current = Tt, br.current = It;
  }, [Tt, It]);
  const dt = W(() => us((he) => {
    if (!Ve) return;
    const Ue = kc(Ct.current, he.muted), Kt = kc(br.current, he.volume);
    if (!Ue && !Kt) return;
    const ve = { sourceId: Y, type: Z };
    Ue && (Ct.current = he.muted, h(ve, he.muted)), Kt && (br.current = he.volume, g(ve, he.volume));
  }, 200), [Ve, h, g, Y, Z]);
  Q(() => {
    dt({ muted: qe, volume: H });
  }, [qe, H, dt]);
  const kt = q(
    /**
    * @param {{
    * 	muted?: boolean,
    * 	volume?: number,
    * }} properties
    */
    (he) => {
      A({ id: Y, type: Z, ...he });
    },
    [Y, Z, A]
  ), zt = q(() => {
    kt({ muted: !qe });
  }, [qe, kt]), _r = q((he) => {
    const Ue = { volume: he };
    he > 0 && (Ue.muted = !1), kt(Ue);
  }, [kt]), wr = q(() => {
    !$e && P && P !== Tn && !c || _({ sourceId: Y, type: Z }, z);
  }, [P, c, $e, _, Y, Z, z]), Gt = q((he) => {
    !$e && P && P !== Tn && !c || (F(he), y({ sourceId: Y, type: Z }, he));
  }, [P, c, $e, y, Y, Z]), Sr = q((he) => {
    !$e && P && P !== Tn && !c || ($(he), C({ sourceId: Y, type: Z }, he));
  }, [P, c, $e, C, Y, Z]), Dt = q((he) => {
    he.stopPropagation(), s && ue("overlay");
  }, [s, ue]), jr = (he) => {
    I(he);
  }, jt = q(() => {
    ue("main");
  }, [ue]);
  Cg(l, jt);
  const Nt = !!k, qt = Y && m, Et = ((kr = u.devices) == null ? void 0 : kr.filter(kg).map(({ deviceId: he }) => he)) || [], pr = ((Br = u.devices) == null ? void 0 : Br.filter(xg).map(({ deviceId: he }) => he)) || [], At = On({ deviceIds: Et }), Nr = On({ deviceIds: pr }), Fr = u.type === fa && !At.length, Cr = u.type === fa && !Nr.length;
  return W(() => ({ audioUnset: Fr, channelMixerStatus: w, displayMode: P, handleChangeVideoClip: it, handleClick: Dt, handleHover: jr, handleMute: zt, handleVolumeChange: _r, isAudioOnLive: at, isInLive: vt, isInAudio: et, isInMain: Oe, isInOverlay: ke, isMuted: qe, liveLayerOfSource: oe, loading: Nt, pipHover: T, readyToPlay: qt, setSourceOnLayer: ue, updateLiveSourceSpeed: Gt, updateLiveSourceProgressTime: Sr, timeCodes: z, updateLiveSourceTimecode: wr, videoUnset: Cr, volume: H, videoSpeed: E, progressTime: B, isVideoOnLive: $e, handleToggleLoopVideo: gt, setTimeCodes: te, setVideoSpeed: F, setProgressTime: $, setIsVideoLooping: j, isVideoLooping: M }), [Fr, w, P, it, Dt, gt, zt, _r, at, et, vt, Oe, ke, qe, $e, oe, Nt, T, qt, ue, Gt, Sr, z, wr, Cr, H, E, B, j, M]);
}, Sy = ({ isLocalVideo: o, source: a }) => {
  const { notifyTogglePlayPauseVideoSource: i } = lr(), { pauseVideo: n, playVideo: e, isVideoPaused: t } = Ci(), r = q(() => {
    o ? t ? e() : n() : i(a);
  }, [o, t, i, n, e, a]);
  return W(() => ({ handleTogglePlayPauseVideo: r, isVideoPaused: t }), [r, t]);
}, Cy = ({ guestsHandRaised: o, removeRaisedHand: a }) => {
  const [i, n] = re(0), e = (r) => {
    n(r);
  }, t = q((r) => {
    o.find(({ guestId: s }) => s === r) && a(r);
  }, [o, a]);
  return W(() => ({ currentPage: i, handleClickPageButton: e, handleRemoveHand: t }), [i, t]);
}, Rg = () => {
  const { channelMixerStatus: o } = lr();
  return (o == null ? void 0 : o.sources) || [];
}, Ig = (o) => o.type === fa, Pg = () => Rg().filter(Ig), ky = () => {
  const { channelMixerStatus: o, startRecording: a, stopRecording: i } = lr(), n = !!(o != null && o.isRecording);
  return W(() => ({ isRecording: n, startRecording: a, stopRecording: i }), [n, a, i]);
};
function Tg(o) {
  return Ca({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M24 24H0V0h24v24z" }, child: [] }, { tag: "circle", attr: { cx: "12", cy: "12", r: "8" }, child: [] }] })(o);
}
const Dg = () => {
  const { t: o } = ds(), { channelMixerStatus: a } = lr();
  return a != null && a.isRecording ? /* @__PURE__ */ V.jsxs("div", { className: "position-absolute left-0 top-0 p-2 d-flex align-items-center text-danger font-size-sm", style: { zIndex: 1 }, children: [
    /* @__PURE__ */ V.jsx(Tg, { className: "font-size-xl" }),
    /* @__PURE__ */ V.jsx("span", { className: "ml-1 RecordingState_text", title: o("RecordingState.RecordingState.liveCurrentlyRecorded"), children: o("RecordingState.RecordingState.recording") })
  ] }) : null;
}, Es = ({ children: o, className: a, loading: i }) => {
  const { t: n } = ds();
  return i ? /* @__PURE__ */ V.jsx(ka, { className: St(a), children: /* @__PURE__ */ V.jsxs("div", { className: "ChannelLoading", children: [
    /* @__PURE__ */ V.jsx("p", { children: /* @__PURE__ */ V.jsx("span", { className: "ChannelLoading_icon", children: /* @__PURE__ */ V.jsx(cg, { className: "icon-spin" }) }) }),
    /* @__PURE__ */ V.jsx("p", { children: n("ChannelLoading.Loading.connection") })
  ] }) }) : o;
};
Es.propTypes = { children: N.node, className: N.string, loading: N.bool };
Es.defaultProps = { children: null, className: "", loading: !0 };
const Eg = "data:image/jpeg;base64,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", Ag = 100, As = ({ className: o, disabled: a, handleMute: i, isMuted: n, isOnLive: e, isParticipant: t, mediastream: r, onVolumeChange: s, showSlider: c, volume: l }) => {
  const [u, d] = re(!1), [f, p] = re(l);
  Q(() => {
    p(l);
  }, [l]);
  const m = ne(), b = ne(), h = ne(), [g, w] = re(
    /** @type {MediaStreamTrack | undefined} */
    r == null ? void 0 : r.getAudioTracks()[0]
  );
  Q(() => {
    w(r == null ? void 0 : r.getAudioTracks()[0]);
    const k = () => {
      w(r == null ? void 0 : r.getAudioTracks()[0]);
    };
    return r == null || r.addEventListener("addtrack", k), r == null || r.addEventListener("removetrack", k), () => {
      w(void 0), r == null || r.removeEventListener("addtrack", k), r == null || r.removeEventListener("removetrack", k);
    };
  }, [r]);
  const _ = 100 - f / 150 * 100, y = q(us((k) => {
    t && Number.isFinite(k) && s(k);
  }, 1e3), [s]), C = q((k) => {
    Xa && k.cancelable && k.preventDefault();
    const x = Xa ? k.touches[0].clientY : k.clientY, { y: O, height: D } = h.current.getBoundingClientRect();
    let A = (x - O) / D * 100, E = 150 - A * 150 / 100;
    A <= 0 ? A = 0 : A > 100 && (A = 100), E = Math.max(0, Math.min(E, 150)), y(E), p(E);
  }, [y]), S = q(() => {
    d(!1), document.removeEventListener("mousemove", C), document.removeEventListener("mouseup", S), document.removeEventListener("touchmove", C), document.removeEventListener("touchend", S);
  }, [C]), P = q(() => {
    d(!0), document.addEventListener("mousemove", C), document.addEventListener("mouseup", S), document.addEventListener("touchmove", C, { passive: !1 }), document.addEventListener("touchend", S);
  }, [C, S]);
  Q(() => () => {
    document.removeEventListener("mousemove", C), document.removeEventListener("touchmove", C);
  }, [C]);
  const T = q((k) => {
    const x = (O) => a ? 0 : O > 100 - _ && t ? 100 - _ : O < 0 ? 0 : O > 100 ? 100 : O;
    m.current && (m.current.style.height = `${100 - x(k.left)}%`), b.current && (b.current.style.height = `${100 - x(k.right)}%`);
  }, [a, t, _]);
  Q(() => {
    if (!g) return;
    const k = () => {
      const M = m.current, j = b.current;
      M && (M.style.height = "100%"), j && (j.style.height = "100%");
    };
    g.addEventListener("ended", k);
    const x = new MediaStream([g]), O = new (window.AudioContext || window.webkitAudioContext)(), D = O.createMediaStreamSource(x);
    D.channelCount = 2, D.channelCountMode = "explicit";
    const A = O.createChannelSplitter(2);
    D.connect(A);
    const E = O.createAnalyser(), F = O.createAnalyser();
    E.fftSize = 256, F.fftSize = 256, A.connect(E, 0), A.connect(F, 1);
    const B = (M) => {
      const j = M.frequencyBinCount, z = new Uint8Array(j);
      M.getByteFrequencyData(z);
      let te = 0;
      for (let ee = 0; ee < j; ee += 1)
        te += z[ee];
      return te / j;
    }, $ = setInterval(() => {
      const M = B(E), j = B(F);
      T({ left: M, right: j });
    }, Ag);
    return () => {
      g.removeEventListener("ended", k), clearInterval($), O.state !== "closed" && O.close().catch((M) => {
        console.error("Error closing AudioContext:", M);
      });
    };
  }, [t, g, T]);
  let I = e ? "neutral-danger" : "neutral-secondary";
  return a && (I = "black"), /* @__PURE__ */ V.jsxs("div", { className: St("d-flex flex-column", o), children: [
    /* @__PURE__ */ V.jsxs("div", { className: "d-flex h-100 position-relative", children: [
      /* @__PURE__ */ V.jsxs("div", { className: "d-flex", children: [
        /* @__PURE__ */ V.jsx("div", { className: St("PlayerLiveVuMeter_bar", { PlayerLiveVuMeter_meter: !a }) }),
        /* @__PURE__ */ V.jsx("div", { className: St("PlayerLiveVuMeter_bar position-absolute bg-black", { "opacity-3": a }), ref: m, style: { height: "100%" } })
      ] }),
      /* @__PURE__ */ V.jsx("div", { className: "border border-transparent" }),
      /* @__PURE__ */ V.jsxs("div", { className: "d-flex", children: [
        /* @__PURE__ */ V.jsx("div", { className: St("PlayerLiveVuMeter_bar", { PlayerLiveVuMeter_meter: !a }) }),
        /* @__PURE__ */ V.jsx("div", { className: St("PlayerLiveVuMeter_bar position-absolute bg-black", { "opacity-3": a }), ref: b, style: { height: "100%" } })
      ] }),
      c && !a && /* @__PURE__ */ V.jsx("div", { className: St("position-absolute w-50 h-100", f === 0 ? "mb-4" : "mb-1"), ref: h, onMouseDown: P, onTouchStart: P, children: /* @__PURE__ */ V.jsx("img", { src: Eg, alt: "Volume Slider", className: "position-absolute cursor-pointer", style: { top: `${_}%`, left: "100%", transform: "translate(-50%, -50%)", width: "15px", height: "30px" }, draggable: "false" }) })
    ] }),
    i && /* @__PURE__ */ V.jsx(bd, { className: St("p-0 btn-no-focus d-25 d-flex flex-column shadow-none", { "opacity-3": a }, a ? "mt-1" : "mt-2"), color: I, onClick: i, disabled: a, children: u ? /* @__PURE__ */ V.jsxs(V.Fragment, { children: [
      /* @__PURE__ */ V.jsx("div", { className: "content-light fw-bold", style: { fontSize: "0.85rem", lineHeight: "0.9rem" }, children: Math.ceil(f) }),
      /* @__PURE__ */ V.jsx("div", { className: "content-light", style: { fontSize: "0.7rem", lineHeight: "0.7rem" }, children: "%" })
    ] }) : /* @__PURE__ */ V.jsx("span", { className: "btn-wrapper--icon", children: n || a ? /* @__PURE__ */ V.jsx(ug, {}) : /* @__PURE__ */ V.jsx(dg, {}) }) })
  ] });
};
As.propTypes = { className: N.string, disabled: N.bool, handleMute: N.func, isMuted: N.bool, isOnLive: N.bool, isParticipant: N.bool, mediastream: N.instanceOf(MediaStream), onVolumeChange: N.func, showSlider: N.bool, volume: N.number };
As.defaultProps = { className: "", disabled: !1, handleMute: void 0, isMuted: !1, isOnLive: !1, isParticipant: !1, mediastream: void 0, onVolumeChange: void 0, showSlider: !1, volume: 100 };
const od = ({ children: o, className: a, handleClickFullScreen: i, isFullscreen: n, safeZoneComponent: e, isHost: t }) => {
  const { roomId: r } = $n(), { soupSession: s } = Bn(), { isEnabled: c } = of(), l = On({ roomId: r }), u = W(() => l.find((p) => p.appData.streamType === "live" && p.kind === "audio" && !p.appData.peerReceiver), [l]), d = W(() => u ? [{ publication: u }] : [], [u]), f = xi(d);
  return /* @__PURE__ */ V.jsx(Es, { loading: !s, children: /* @__PURE__ */ V.jsxs("div", { className: St(a, "position-relative d-flex flex-column justify-content-center overflow-hidden align-items-center h-100 w-100"), onDoubleClick: i, children: [
    /* @__PURE__ */ V.jsx(Dg, {}),
    /* @__PURE__ */ V.jsx(
      ks,
      {
        handleClickFullScreen: i,
        isFullscreen: n,
        safeZoneComponent: e,
        children: o
      }
    ),
    c && t && /* @__PURE__ */ V.jsx(As, { className: "position-absolute bottom-0 right-0 h-50 me-1", mediastream: f })
  ] }) });
};
od.propTypes = { children: N.node, className: N.string, handleClickFullScreen: N.func.isRequired, isFullscreen: N.bool, safeZoneComponent: N.elementType, isHost: N.bool };
od.defaultProps = { children: null, className: "", isFullscreen: !1, safeZoneComponent: null, isHost: !1 };
const Ls = ({ className: o, config: a }) => {
  const { t: i } = ds(), { tracks: n, addTrack: e, clearTracks: t } = Jr(), { userVideoOriginalTracks: r } = Fn(), { isKeyEnabled: s, setTempLocalConfig: c, setMainCamTrackSourceOfferId: l } = Nn(), u = W(() => n.length > 0 ? new MediaStream(n) : null, [n]);
  return Q(() => {
    if (r.length > 0) {
      const d = r[0];
      return e(d, { video: { original: { stopOnRemove: !1 }, controllable: { fps: 12 } } }), () => t();
    }
  }, [r, e, t]), Q(() => {
    c(a);
  }, [c, a]), Q(() => {
    const d = r.find((f) => f.configId === 0);
    d && l(d.sourceOffer.id);
  }, [l, r]), /* @__PURE__ */ V.jsx("div", { className: "w-100 d-flex flex-shrink-1", children: u ? /* @__PURE__ */ V.jsx(id, { autoPlay: !0, className: `MediaKeySourcePreview w-100 ${o}`, muted: !0, src: u }) : /* @__PURE__ */ V.jsx("span", { className: "d-flex mx-auto my-auto", children: i("Media.MediaKeyPreview.Status", { context: s ? "loading" : "disabled" }) }) });
};
Ls.propTypes = { className: N.string, config: N.shape({ detection: N.shape({ mode: N.oneOf(Object.values($t)) }) }) };
Ls.defaultProps = { className: "", config: void 0 };
const cd = (o) => {
  const { isHost: a } = Nn();
  return /* @__PURE__ */ V.jsx(Qc, { isHost: a, children: /* @__PURE__ */ V.jsx(Ls, { ...o }) });
};
cd.propTypes = { className: N.string, config: N.shape({ detection: N.shape({ mode: N.oneOf(Object.values($t)) }) }) };
cd.defaultProps = { className: "", config: void 0 };
const ud = ({ className: o, eyeDropperEnabled: a, onPickColor: i }) => {
  const [n] = re(() => new MediaStream()), { userVideoOriginalTracks: e } = Fn();
  return Q(() => {
    if (e.length > 0) {
      const t = e[0];
      return n.addTrack(t), () => {
        n.removeTrack(t);
      };
    }
  }, [n, e]), /* @__PURE__ */ V.jsx("div", { className: "w-100 d-flex flex-shrink-1", style: { boxShadow: a ? "0 0 0 3px #FEC82E" : "none" }, children: /* @__PURE__ */ V.jsx(id, { allowColorPicking: a, autoPlay: !0, className: `MediaKeySourcePreview w-100 ${o}`, muted: !0, onPickColor: i, src: n }) });
};
ud.propTypes = { className: N.string, eyeDropperEnabled: N.bool, onPickColor: N.func };
ud.defaultProps = { className: "", eyeDropperEnabled: !1, onPickColor: void 0 };
const Lg = (
  /** @type {const} */
  [Ot.AUDIOSHARE, Ot.CONFIG, Ot.SCREENSHARE, Ot.VIDEOSHARE]
), Og = (o) => !!Lg.some((a) => a === o.subType), dd = ({ mediastream: o }) => {
  const a = ne(
    /** @type {HTMLAudioElement | null} */
    null
  );
  return ta(() => {
    !a.current || !o || (a.current.srcObject = o, a.current.play());
  }, [o]), /* @__PURE__ */ V.jsx("audio", { autoPlay: !0, ref: a });
}, ld = (o) => o === "audiofile" || o === "audioinput" || o === "audioscreen", Mg = ({ source: o }) => {
  const a = W(() => o.devices.filter(({ kind: c }) => ld(c)).map(({ deviceId: c }) => c), [o.devices]), { audioshareActiveTracks: i = [] } = ms(), { screenshareActiveTracks: n = [] } = fs(), { videoshareActiveTracks: e = [] } = Ci(), { userAudioActiveTracks: t = [] } = Fn(), r = [...i, ...n, ...e, ...t].find(({ device: c }) => c.deviceId === a[0]), s = W(() => r ? new MediaStream([r]) : null, [r]);
  return s ? /* @__PURE__ */ V.jsx(dd, { mediastream: s }) : null;
}, jg = ({ source: o }) => {
  const a = W(() => o.devices.filter(({ kind: t }) => ld(t)).map(({ deviceId: t }) => t), [o.devices]), i = On({ deviceIds: a }), n = W(() => i.map((t) => ({ publication: t })), [i]), e = xi(n);
  return e ? /* @__PURE__ */ V.jsx(dd, { mediastream: e }) : null;
}, Ng = ({ source: o }) => o.computerId === pt() ? /* @__PURE__ */ V.jsx(Mg, { source: o }) : /* @__PURE__ */ V.jsx(jg, { source: o }), xy = () => {
  const o = Pg(), a = W(() => o.filter(Og), [o]), { getSettingsBySource: i } = Yu();
  return W(() => a.map((e) => {
    const t = i(e);
    return { source: e, settings: t == null ? void 0 : t.settings };
  }).filter((e) => {
    var t;
    return !!((t = e.settings) != null && t.monitor) && !e.source.isAudioOnLive;
  }), [i, a]).map((e) => /* @__PURE__ */ V.jsx(Ng, { ...e }, e.source.id));
};
export {
  Wt as AVAILABLE_MOBILE_CAMS,
  od as ChannelPlayer,
  Tn as DEFAULT_MODE,
  yu as GfxProvider,
  $d as Inputs,
  Pc as InputsContext,
  $t as KeyDetectionMode,
  cd as KeyEffectPreviewOutput,
  ud as KeyEffectPreviewSource,
  Lr as KeyReplacementMode,
  Ce as LayerBounds,
  eo as MIXING_CONNECTING_STATE_CONNECTED,
  Ni as MIXING_CONNECTING_STATE_DISCONNECTED,
  Mp as MIXING_CONNECTING_STATE_PENDING,
  ry as Media,
  Jc as MediaContext,
  il as MediaEffectVideoKeyProvider,
  Ul as MediaShareImage,
  ey as MediaShareImageParams,
  hs as MediaShareScreen,
  jl as MediaShareVideo,
  Jg as MediaShareVideoParams,
  Tl as MediaUser,
  Gc as MediaUserContext,
  uu as MixingContext,
  du as MixingProvider,
  iu as OrientationBaseSizes,
  Ts as PipLayout,
  mg as PipLayoutAuction,
  fg as PipLayoutAudio,
  pg as PipLayoutConnected,
  Pi as PipLayoutDisplay,
  td as PlayerColorPicker,
  Ss as PlayerLivePiPOverlay,
  As as PlayerLiveVuMeter,
  sr as PlayerModes,
  sd as PlayerStream,
  yy as PreviewImage,
  rd as PreviewText,
  id as PreviewVideo,
  vy as ReactVideo,
  eu as ReactVideoContext,
  Dp as ReactVideoProvider,
  sy as SOURCE_TYPE_AD,
  iy as SOURCE_TYPE_DEFAULT,
  cy as SOURCE_TYPE_GFX,
  uy as SOURCE_TYPE_GFX_VIDEO,
  oy as SOURCE_TYPE_IMAGE,
  fa as SOURCE_TYPE_PARTICIPANT,
  dy as SOURCE_TYPE_PLAYLIST,
  ly as SOURCE_TYPE_STREAM,
  py as SOURCE_TYPE_TEXT,
  fy as SOURCE_TYPE_VIDEO,
  hy as STREAM_TYPE_LIVE,
  my as STREAM_TYPE_PREVIEW,
  ed as SourceCardPipSelector,
  Ot as SourceParticipantOfferType,
  jc as SourceParticipantOffersContext,
  xy as StudioSourceSettingsParticipantAudios,
  el as TRANSPARENT_KEY_DEFAULT_COLOR,
  tl as TRANSPARENT_KEY_DEFAULT_COLOR_SENSITIVITY,
  by as TalkbackAudio,
  nn as TalkbackStatus,
  Xs as contain,
  rl as defaultForcedKeyConfig,
  Mi as defaultKeyConfig,
  pt as getComputerId,
  Op as getLayoutsDefaults,
  na as getSafeZoneMargin,
  Vd as getTypeFilter,
  Zg as getVirtualDeviceById,
  Qp as useCrop,
  Il as useDeviceStatusFromConfig,
  nu as useDrawer,
  Ud as useFilteredSourceParticipantOffers,
  Xp as useGfx,
  ha as useInputs,
  ty as useMedia,
  Nn as useMediaEffectVideoKey,
  Kd as useMediaEffectVideoZoom,
  ms as useMediaShareAudio,
  Wc as useMediaShareImage,
  fs as useMediaShareScreen,
  Ci as useMediaShareVideo,
  Fn as useMediaUser,
  Up as useMediastream,
  lr as useMixing,
  Yp as usePiP,
  ou as usePipLayout,
  Sy as usePlayPause,
  qp as usePlayerLiveVolume,
  of as usePlayerLiveVuMeter,
  ki as usePlayerMode,
  ef as usePlayerSize,
  _y as usePreview,
  On as usePublications,
  $n as useReactVideo,
  ky as useRecording,
  Fp as useScreenshot,
  wy as useSourceCard,
  en as useSourceParticipantOffers,
  gy as useStudioJoinSoup,
  Pg as useStudioSourceParticipants,
  Yu as useStudioSourceSettings,
  Rg as useStudioSources,
  Vp as useSubscribe,
  xi as useSubscribeMediastream,
  _s as useTalkbackReceiver,
  ny as useTalkbackSender,
  ay as useTalkbackStatus,
  Cy as useViewControlGuests
};
